/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 117);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(129);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mode", function() { return Mode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ClassGroups__ = __webpack_require__(151);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClassGroups", function() { return __WEBPACK_IMPORTED_MODULE_0__ClassGroups__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClassGroup", function() { return __WEBPACK_IMPORTED_MODULE_0__ClassGroups__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Clubs__ = __webpack_require__(152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Clubs", function() { return __WEBPACK_IMPORTED_MODULE_1__Clubs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Competition__ = __webpack_require__(68);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Competition", function() { return __WEBPACK_IMPORTED_MODULE_2__Competition__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Permissions", function() { return __WEBPACK_IMPORTED_MODULE_2__Competition__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Status", function() { return __WEBPACK_IMPORTED_MODULE_2__Competition__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Operations", function() { return __WEBPACK_IMPORTED_MODULE_2__Competition__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CompetitionGroup__ = __webpack_require__(154);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CompetitionGroup", function() { return __WEBPACK_IMPORTED_MODULE_3__CompetitionGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Discipline__ = __webpack_require__(69);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Discipline", function() { return __WEBPACK_IMPORTED_MODULE_4__Discipline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DivisionGroups__ = __webpack_require__(155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DivisionGroups", function() { return __WEBPACK_IMPORTED_MODULE_5__DivisionGroups__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DivisionGroup", function() { return __WEBPACK_IMPORTED_MODULE_5__DivisionGroups__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Event__ = __webpack_require__(156);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Event", function() { return __WEBPACK_IMPORTED_MODULE_6__Event__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return __WEBPACK_IMPORTED_MODULE_7__logic__["Events"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Participant__ = __webpack_require__(238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Participant", function() { return __WEBPACK_IMPORTED_MODULE_8__Participant__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ParticipantScore__ = __webpack_require__(103);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ParticipantScore", function() { return __WEBPACK_IMPORTED_MODULE_9__ParticipantScore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Person__ = __webpack_require__(102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Person", function() { return __WEBPACK_IMPORTED_MODULE_10__Person__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Registration__ = __webpack_require__(239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Registration", function() { return __WEBPACK_IMPORTED_MODULE_11__Registration__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Registry__ = __webpack_require__(240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Registry", function() { return __WEBPACK_IMPORTED_MODULE_12__Registry__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Results__ = __webpack_require__(241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Results", function() { return __WEBPACK_IMPORTED_MODULE_13__Results__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Schedule__ = __webpack_require__(242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Schedule", function() { return __WEBPACK_IMPORTED_MODULE_14__Schedule__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ScoringModels__ = __webpack_require__(243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScoringModels", function() { return __WEBPACK_IMPORTED_MODULE_15__ScoringModels__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Squad__ = __webpack_require__(244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Squad", function() { return __WEBPACK_IMPORTED_MODULE_16__Squad__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__StageDef__ = __webpack_require__(245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StageDef", function() { return __WEBPACK_IMPORTED_MODULE_17__StageDef__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TabInfo__ = __webpack_require__(246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabInfo", function() { return __WEBPACK_IMPORTED_MODULE_18__TabInfo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TeamRegistration__ = __webpack_require__(247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TeamRegistration", function() { return __WEBPACK_IMPORTED_MODULE_19__TeamRegistration__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Team__ = __webpack_require__(104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Team", function() { return __WEBPACK_IMPORTED_MODULE_20__Team__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__TeamDef__ = __webpack_require__(248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TeamDef", function() { return __WEBPACK_IMPORTED_MODULE_21__TeamDef__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Tokens__ = __webpack_require__(249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tokens", function() { return __WEBPACK_IMPORTED_MODULE_22__Tokens__["a"]; });
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Mode=function Mode(){_classCallCheck(this,Mode);};Mode.computer="computer";Mode.mobile="mobile";

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(136)();
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = __extends;
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["d"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["f"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* harmony export (immutable) */ __webpack_exports__["i"] = __values;
/* harmony export (immutable) */ __webpack_exports__["g"] = __read;
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* harmony export (immutable) */ __webpack_exports__["h"] = __spreadArray;
/* harmony export (immutable) */ __webpack_exports__["c"] = __await;
/* harmony export (immutable) */ __webpack_exports__["a"] = __asyncGenerator;
/* unused harmony export __asyncDelegator */
/* harmony export (immutable) */ __webpack_exports__["b"] = __asyncValues;
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Observable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Subscriber__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_observable__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_pipe__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_isFunction__ = __webpack_require__(5);






var Observable = (function () {
    function Observable(subscribe) {
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function (observerOrNext, error, complete) {
        var subscriber = isSubscriber(observerOrNext) ? observerOrNext : new __WEBPACK_IMPORTED_MODULE_0__Subscriber__["a" /* SafeSubscriber */](observerOrNext, error, complete);
        if (__WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
            this._deprecatedSyncErrorSubscribe(subscriber);
        }
        else {
            var _a = this, operator = _a.operator, source = _a.source;
            subscriber.add(operator
                ?
                    operator.call(subscriber, source)
                : source
                    ?
                        this._subscribe(subscriber)
                    :
                        this._trySubscribe(subscriber));
        }
        return subscriber;
    };
    Observable.prototype._deprecatedSyncErrorSubscribe = function (subscriber) {
        var localSubscriber = subscriber;
        localSubscriber._syncErrorHack_isSubscribing = true;
        var operator = this.operator;
        if (operator) {
            subscriber.add(operator.call(subscriber, this.source));
        }
        else {
            try {
                subscriber.add(this._subscribe(subscriber));
            }
            catch (err) {
                localSubscriber.__syncError = err;
            }
        }
        var dest = localSubscriber;
        while (dest) {
            if ('__syncError' in dest) {
                try {
                    throw dest.__syncError;
                }
                finally {
                    subscriber.unsubscribe();
                }
            }
            dest = dest.destination;
        }
        localSubscriber._syncErrorHack_isSubscribing = false;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var subscription;
            subscription = _this.subscribe(function (value) {
                try {
                    next(value);
                }
                catch (err) {
                    reject(err);
                    subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
                }
            }, reject, resolve);
        });
    };
    Observable.prototype._subscribe = function (subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[__WEBPACK_IMPORTED_MODULE_2__symbol_observable__["a" /* observable */]] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        return operations.length ? Object(__WEBPACK_IMPORTED_MODULE_3__util_pipe__["a" /* pipeFromArray */])(operations)(this) : this;
    };
    Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
            var value;
            _this.subscribe(function (x) { return (value = x); }, function (err) { return reject(err); }, function () { return resolve(value); });
        });
    };
    Observable.create = function (subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}());

function getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : __WEBPACK_IMPORTED_MODULE_4__config__["a" /* config */].Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value) {
    return value && Object(__WEBPACK_IMPORTED_MODULE_5__util_isFunction__["a" /* isFunction */])(value.next) && Object(__WEBPACK_IMPORTED_MODULE_5__util_isFunction__["a" /* isFunction */])(value.error) && Object(__WEBPACK_IMPORTED_MODULE_5__util_isFunction__["a" /* isFunction */])(value.complete);
}
function isSubscriber(value) {
    return (value && value instanceof __WEBPACK_IMPORTED_MODULE_0__Subscriber__["b" /* Subscriber */]) || (isObserver(value) && Object(__WEBPACK_IMPORTED_MODULE_1__Subscription__["c" /* isSubscription */])(value));
}
//# sourceMappingURL=Observable.js.map

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isFunction;
function isFunction(value) {
    return typeof value === 'function';
}
//# sourceMappingURL=isFunction.js.map

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getYear"] = getYear;
/* harmony export (immutable) */ __webpack_exports__["getMonth"] = getMonth;
/* harmony export (immutable) */ __webpack_exports__["getMonthHuman"] = getMonthHuman;
/* harmony export (immutable) */ __webpack_exports__["getDate"] = getDate;
/* harmony export (immutable) */ __webpack_exports__["getHours"] = getHours;
/* harmony export (immutable) */ __webpack_exports__["getMinutes"] = getMinutes;
/* harmony export (immutable) */ __webpack_exports__["getSeconds"] = getSeconds;
/* harmony export (immutable) */ __webpack_exports__["getCenturyStart"] = getCenturyStart;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousCenturyStart", function() { return getPreviousCenturyStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNextCenturyStart", function() { return getNextCenturyStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCenturyEnd", function() { return getCenturyEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousCenturyEnd", function() { return getPreviousCenturyEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNextCenturyEnd", function() { return getNextCenturyEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCenturyRange", function() { return getCenturyRange; });
/* harmony export (immutable) */ __webpack_exports__["getDecadeStart"] = getDecadeStart;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousDecadeStart", function() { return getPreviousDecadeStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNextDecadeStart", function() { return getNextDecadeStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDecadeEnd", function() { return getDecadeEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousDecadeEnd", function() { return getPreviousDecadeEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNextDecadeEnd", function() { return getNextDecadeEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDecadeRange", function() { return getDecadeRange; });
/* harmony export (immutable) */ __webpack_exports__["getYearStart"] = getYearStart;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousYearStart", function() { return getPreviousYearStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNextYearStart", function() { return getNextYearStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getYearEnd", function() { return getYearEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousYearEnd", function() { return getPreviousYearEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNextYearEnd", function() { return getNextYearEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getYearRange", function() { return getYearRange; });
/* harmony export (immutable) */ __webpack_exports__["getMonthStart"] = getMonthStart;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousMonthStart", function() { return getPreviousMonthStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNextMonthStart", function() { return getNextMonthStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMonthEnd", function() { return getMonthEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousMonthEnd", function() { return getPreviousMonthEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNextMonthEnd", function() { return getNextMonthEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMonthRange", function() { return getMonthRange; });
/* harmony export (immutable) */ __webpack_exports__["getDayStart"] = getDayStart;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousDayStart", function() { return getPreviousDayStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNextDayStart", function() { return getNextDayStart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDayEnd", function() { return getDayEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPreviousDayEnd", function() { return getPreviousDayEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getNextDayEnd", function() { return getNextDayEnd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDayRange", function() { return getDayRange; });
/* harmony export (immutable) */ __webpack_exports__["getDaysInMonth"] = getDaysInMonth;
/* harmony export (immutable) */ __webpack_exports__["getHoursMinutes"] = getHoursMinutes;
/* harmony export (immutable) */ __webpack_exports__["getHoursMinutesSeconds"] = getHoursMinutesSeconds;
/* harmony export (immutable) */ __webpack_exports__["getISOLocalMonth"] = getISOLocalMonth;
/* harmony export (immutable) */ __webpack_exports__["getISOLocalDate"] = getISOLocalDate;
/* harmony export (immutable) */ __webpack_exports__["getISOLocalDateTime"] = getISOLocalDateTime;
/**
 * Utils
 */
function makeGetEdgeOfNeighbor(getPeriod, getEdgeOfPeriod, defaultOffset) {
  return function makeGetEdgeOfNeighborInternal(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
    var previousPeriod = getPeriod(date) + offset;
    return getEdgeOfPeriod(previousPeriod);
  };
}

function makeGetEnd(getBeginOfNextPeriod) {
  return function makeGetEndInternal(date) {
    return new Date(getBeginOfNextPeriod(date).getTime() - 1);
  };
}

function makeGetRange(functions) {
  return function makeGetRangeInternal(date) {
    return functions.map(function (fn) {
      return fn(date);
    });
  };
}
/**
 * Simple getters - getting a property of a given point in time
 */

/**
 * Gets year from date.
 *
 * @param {Date|number|string} date Date to get year from.
 */


function getYear(date) {
  if (date instanceof Date) {
    return date.getFullYear();
  }

  if (typeof date === 'number') {
    return date;
  }

  var year = parseInt(date, 10);

  if (typeof date === 'string' && !isNaN(year)) {
    return year;
  }

  throw new Error("Failed to get year from date: ".concat(date, "."));
}
/**
 * Gets month from date.
 *
 * @param {Date} date Date to get month from.
 */

function getMonth(date) {
  if (date instanceof Date) {
    return date.getMonth();
  }

  throw new Error("Failed to get month from date: ".concat(date, "."));
}
/**
 * Gets human-readable month from date.
 *
 * @param {Date} date Date to get human-readable month from.
 */

function getMonthHuman(date) {
  if (date instanceof Date) {
    return date.getMonth() + 1;
  }

  throw new Error("Failed to get human-readable month from date: ".concat(date, "."));
}
/**
 * Gets human-readable day of the month from date.
 *
 * @param {Date} date Date to get day of the month from.
 */

function getDate(date) {
  if (date instanceof Date) {
    return date.getDate();
  }

  throw new Error("Failed to get year from date: ".concat(date, "."));
}
/**
 * Gets hours from date.
 *
 * @param {Date|string} date Date to get hours from.
 */

function getHours(date) {
  if (date instanceof Date) {
    return date.getHours();
  }

  if (typeof date === 'string') {
    var datePieces = date.split(':');

    if (datePieces.length >= 2) {
      var hoursString = datePieces[0];
      var hours = parseInt(hoursString, 10);

      if (!isNaN(hours)) {
        return hours;
      }
    }
  }

  throw new Error("Failed to get hours from date: ".concat(date, "."));
}
/**
 * Gets minutes from date.
 *
 * @param {Date|string} date Date to get minutes from.
 */

function getMinutes(date) {
  if (date instanceof Date) {
    return date.getMinutes();
  }

  if (typeof date === 'string') {
    var datePieces = date.split(':');

    if (datePieces.length >= 2) {
      var minutesString = datePieces[1] || 0;
      var minutes = parseInt(minutesString, 10);

      if (!isNaN(minutes)) {
        return minutes;
      }
    }
  }

  throw new Error("Failed to get minutes from date: ".concat(date, "."));
}
/**
 * Gets seconds from date.
 *
 * @param {Date|string} date Date to get seconds from.
 */

function getSeconds(date) {
  if (date instanceof Date) {
    return date.getSeconds();
  }

  if (typeof date === 'string') {
    var datePieces = date.split(':');

    if (datePieces.length >= 2) {
      var secondsString = datePieces[2] || 0;
      var seconds = parseInt(secondsString, 10);

      if (!isNaN(seconds)) {
        return seconds;
      }
    }
  }

  throw new Error("Failed to get seconds from date: ".concat(date, "."));
}
/**
 * Century
 */

function getCenturyStart(date) {
  var year = getYear(date);
  var centuryStartYear = year + (-year + 1) % 100;
  var centuryStartDate = new Date();
  centuryStartDate.setFullYear(centuryStartYear, 0, 1);
  centuryStartDate.setHours(0, 0, 0, 0);
  return centuryStartDate;
}
var getPreviousCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, -100);
var getNextCenturyStart = makeGetEdgeOfNeighbor(getYear, getCenturyStart, 100);
var getCenturyEnd = makeGetEnd(getNextCenturyStart);
var getPreviousCenturyEnd = makeGetEdgeOfNeighbor(getYear, getCenturyEnd, -100);
var getNextCenturyEnd = makeGetEdgeOfNeighbor(getYear, getCenturyEnd, 100);
var getCenturyRange = makeGetRange([getCenturyStart, getCenturyEnd]);
/**
 * Decade
 */

function getDecadeStart(date) {
  var year = getYear(date);
  var decadeStartYear = year + (-year + 1) % 10;
  var decadeStartDate = new Date();
  decadeStartDate.setFullYear(decadeStartYear, 0, 1);
  decadeStartDate.setHours(0, 0, 0, 0);
  return decadeStartDate;
}
var getPreviousDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, -10);
var getNextDecadeStart = makeGetEdgeOfNeighbor(getYear, getDecadeStart, 10);
var getDecadeEnd = makeGetEnd(getNextDecadeStart);
var getPreviousDecadeEnd = makeGetEdgeOfNeighbor(getYear, getDecadeEnd, -10);
var getNextDecadeEnd = makeGetEdgeOfNeighbor(getYear, getDecadeEnd, 10);
var getDecadeRange = makeGetRange([getDecadeStart, getDecadeEnd]);
/**
 * Year
 */

function getYearStart(date) {
  var year = getYear(date);
  var yearStartDate = new Date();
  yearStartDate.setFullYear(year, 0, 1);
  yearStartDate.setHours(0, 0, 0, 0);
  return yearStartDate;
}
var getPreviousYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, -1);
var getNextYearStart = makeGetEdgeOfNeighbor(getYear, getYearStart, 1);
var getYearEnd = makeGetEnd(getNextYearStart);
var getPreviousYearEnd = makeGetEdgeOfNeighbor(getYear, getYearEnd, -1);
var getNextYearEnd = makeGetEdgeOfNeighbor(getYear, getYearEnd, 1);
var getYearRange = makeGetRange([getYearStart, getYearEnd]);
/**
 * Month
 */

function makeGetEdgeOfNeighborMonth(getEdgeOfPeriod, defaultOffset) {
  return function makeGetEdgeOfNeighborMonthInternal(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
    var year = getYear(date);
    var month = getMonth(date) + offset;
    var previousPeriod = new Date();
    previousPeriod.setFullYear(year, month, 1);
    previousPeriod.setHours(0, 0, 0, 0);
    return getEdgeOfPeriod(previousPeriod);
  };
}

function getMonthStart(date) {
  var year = getYear(date);
  var month = getMonth(date);
  var monthStartDate = new Date();
  monthStartDate.setFullYear(year, month, 1);
  monthStartDate.setHours(0, 0, 0, 0);
  return monthStartDate;
}
var getPreviousMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, -1);
var getNextMonthStart = makeGetEdgeOfNeighborMonth(getMonthStart, 1);
var getMonthEnd = makeGetEnd(getNextMonthStart);
var getPreviousMonthEnd = makeGetEdgeOfNeighborMonth(getMonthEnd, -1);
var getNextMonthEnd = makeGetEdgeOfNeighborMonth(getMonthEnd, 1);
var getMonthRange = makeGetRange([getMonthStart, getMonthEnd]);
/**
 * Day
 */

function makeGetEdgeOfNeighborDay(getEdgeOfPeriod, defaultOffset) {
  return function makeGetEdgeOfNeighborDayInternal(date) {
    var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOffset;
    var year = getYear(date);
    var month = getMonth(date);
    var day = getDate(date) + offset;
    var previousPeriod = new Date();
    previousPeriod.setFullYear(year, month, day);
    previousPeriod.setHours(0, 0, 0, 0);
    return getEdgeOfPeriod(previousPeriod);
  };
}

function getDayStart(date) {
  var year = getYear(date);
  var month = getMonth(date);
  var day = getDate(date);
  var dayStartDate = new Date();
  dayStartDate.setFullYear(year, month, day);
  dayStartDate.setHours(0, 0, 0, 0);
  return dayStartDate;
}
var getPreviousDayStart = makeGetEdgeOfNeighborDay(getDayStart, -1);
var getNextDayStart = makeGetEdgeOfNeighborDay(getDayStart, 1);
var getDayEnd = makeGetEnd(getNextDayStart);
var getPreviousDayEnd = makeGetEdgeOfNeighborDay(getDayEnd, -1);
var getNextDayEnd = makeGetEdgeOfNeighborDay(getDayEnd, 1);
var getDayRange = makeGetRange([getDayStart, getDayEnd]);
/**
 * Other
 */

/**
 * Returns a number of days in a month of a given date.
 *
 * @param {Date} date Date.
 */

function getDaysInMonth(date) {
  return getDate(getMonthEnd(date));
}

function padStart(num) {
  var val = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var numStr = "".concat(num);

  if (numStr.length >= val) {
    return num;
  }

  return "0000".concat(numStr).slice(-val);
}
/**
 * Returns local hours and minutes (hh:mm).
 */


function getHoursMinutes(date) {
  var hours = padStart(getHours(date));
  var minutes = padStart(getMinutes(date));
  return "".concat(hours, ":").concat(minutes);
}
/**
 * Returns local hours, minutes and seconds (hh:mm:ss).
 */

function getHoursMinutesSeconds(date) {
  var hours = padStart(getHours(date));
  var minutes = padStart(getMinutes(date));
  var seconds = padStart(getSeconds(date));
  return "".concat(hours, ":").concat(minutes, ":").concat(seconds);
}
/**
 * Returns local month in ISO-like format (YYYY-MM).
 */

function getISOLocalMonth(date) {
  var year = padStart(getYear(date), 4);
  var month = padStart(getMonthHuman(date));
  return "".concat(year, "-").concat(month);
}
/**
 * Returns local date in ISO-like format (YYYY-MM-DD).
 */

function getISOLocalDate(date) {
  var year = padStart(getYear(date), 4);
  var month = padStart(getMonthHuman(date));
  var day = padStart(getDate(date));
  return "".concat(year, "-").concat(month, "-").concat(day);
}
/**
 * Returns local date & time in ISO-like format (YYYY-MM-DDThh:mm:ss).
 */

function getISOLocalDateTime(date) {
  return "".concat(getISOLocalDate(date), "T").concat(getHoursMinutesSeconds(date));
}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserRouter; });
/* unused harmony export HashRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Link; });
/* unused harmony export NavLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(63);
/* unused harmony reexport MemoryRouter */
/* unused harmony reexport Prompt */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["b"]; });
/* unused harmony reexport Router */
/* unused harmony reexport StaticRouter */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["d"]; });
/* unused harmony reexport generatePath */
/* unused harmony reexport matchPath */
/* unused harmony reexport useHistory */
/* unused harmony reexport useLocation */
/* unused harmony reexport useParams */
/* unused harmony reexport useRouteMatch */
/* unused harmony reexport withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(46);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }
  /* eslint-disable-next-line jsx-a11y/anchor-has-content */


  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a", props);
});

if (false) {
  LinkAnchor.displayName = "LinkAnchor";
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["component", "replace", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var method = replace ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props);
  });
});

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.func]);
  var refType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.displayName = "Link";
  Link.propTypes = {
    innerRef: refType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


var NavLink = forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      sensitive = _ref.sensitive,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "sensitive", "strict", "style", "to", "innerRef"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <NavLink> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? Object(__WEBPACK_IMPORTED_MODULE_0_react_router__["f" /* matchPath */])(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      sensitive: sensitive,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, {}, activeStyle) : styleProp;

    var props = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Link, props);
  });
});

if (false) {
  NavLink.displayName = "NavLink";
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: PropTypes.bool,
    isActive: PropTypes.func,
    location: PropTypes.object,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool,
    style: PropTypes.object
  });
}


//# sourceMappingURL=react-router-dom.js.map


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = from;
/* harmony export (immutable) */ __webpack_exports__["c"] = innerFrom;
/* harmony export (immutable) */ __webpack_exports__["b"] = fromArrayLike;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isArrayLike__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isPromise__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_observable__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scheduled_scheduled__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_reportUnhandledError__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_isInteropObservable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_isAsyncIterable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_throwUnobservableError__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_isIterable__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__util_isReadableStreamLike__ = __webpack_require__(50);













function from(input, scheduler) {
    return scheduler ? Object(__WEBPACK_IMPORTED_MODULE_5__scheduled_scheduled__["a" /* scheduled */])(input, scheduler) : innerFrom(input);
}
function innerFrom(input) {
    if (input instanceof __WEBPACK_IMPORTED_MODULE_4__Observable__["a" /* Observable */]) {
        return input;
    }
    if (input != null) {
        if (Object(__WEBPACK_IMPORTED_MODULE_8__util_isInteropObservable__["a" /* isInteropObservable */])(input)) {
            return fromInteropObservable(input);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isArrayLike__["a" /* isArrayLike */])(input)) {
            return fromArrayLike(input);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isPromise__["a" /* isPromise */])(input)) {
            return fromPromise(input);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_9__util_isAsyncIterable__["a" /* isAsyncIterable */])(input)) {
            return fromAsyncIterable(input);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_11__util_isIterable__["a" /* isIterable */])(input)) {
            return fromIterable(input);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_12__util_isReadableStreamLike__["a" /* isReadableStreamLike */])(input)) {
            return fromReadableStreamLike(input);
        }
    }
    throw Object(__WEBPACK_IMPORTED_MODULE_10__util_throwUnobservableError__["a" /* createInvalidObservableTypeError */])(input);
}
function fromInteropObservable(obj) {
    return new __WEBPACK_IMPORTED_MODULE_4__Observable__["a" /* Observable */](function (subscriber) {
        var obs = obj[__WEBPACK_IMPORTED_MODULE_3__symbol_observable__["a" /* observable */]]();
        if (Object(__WEBPACK_IMPORTED_MODULE_6__util_isFunction__["a" /* isFunction */])(obs.subscribe)) {
            return obs.subscribe(subscriber);
        }
        throw new TypeError('Provided object does not correctly implement Symbol.observable');
    });
}
function fromArrayLike(array) {
    return new __WEBPACK_IMPORTED_MODULE_4__Observable__["a" /* Observable */](function (subscriber) {
        for (var i = 0; i < array.length && !subscriber.closed; i++) {
            subscriber.next(array[i]);
        }
        subscriber.complete();
    });
}
function fromPromise(promise) {
    return new __WEBPACK_IMPORTED_MODULE_4__Observable__["a" /* Observable */](function (subscriber) {
        promise
            .then(function (value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function (err) { return subscriber.error(err); })
            .then(null, __WEBPACK_IMPORTED_MODULE_7__util_reportUnhandledError__["a" /* reportUnhandledError */]);
    });
}
function fromIterable(iterable) {
    return new __WEBPACK_IMPORTED_MODULE_4__Observable__["a" /* Observable */](function (subscriber) {
        var e_1, _a;
        try {
            for (var iterable_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __values */])(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) {
                    return;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        subscriber.complete();
    });
}
function fromAsyncIterable(asyncIterable) {
    return new __WEBPACK_IMPORTED_MODULE_4__Observable__["a" /* Observable */](function (subscriber) {
        process(asyncIterable, subscriber).catch(function (err) { return subscriber.error(err); });
    });
}
function fromReadableStreamLike(readableStream) {
    return fromAsyncIterable(Object(__WEBPACK_IMPORTED_MODULE_12__util_isReadableStreamLike__["b" /* readableStreamLikeToAsyncGenerator */])(readableStream));
}
function process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __awaiter */])(this, void 0, void 0, function () {
        var value, e_2_1;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __generator */])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, 6, 11]);
                    asyncIterable_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __asyncValues */])(asyncIterable);
                    _b.label = 1;
                case 1: return [4, asyncIterable_1.next()];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) {
                        return [2];
                    }
                    _b.label = 3;
                case 3: return [3, 1];
                case 4: return [3, 11];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = { error: e_2_1 };
                    return [3, 11];
                case 6:
                    _b.trys.push([6, , 9, 10]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
                    return [4, _a.call(asyncIterable_1)];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8: return [3, 10];
                case 9:
                    if (e_2) throw e_2.error;
                    return [7];
                case 10: return [7];
                case 11:
                    subscriber.complete();
                    return [2];
            }
        });
    });
}
//# sourceMappingURL=from.js.map

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isCalendarType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isClassName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isMinDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isMaxDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isViews; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return tileGroupProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return tileProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(53);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }



var calendarTypes = Object.values(__WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */]);
var allViews = ['century', 'decade', 'year', 'month'];
var isCalendarType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(calendarTypes);
var isClassName = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string)]);
var isMinDate = function isMinDate(props, propName, componentName) {
  var minDate = props[propName];

  if (!minDate) {
    return null;
  }

  if (!(minDate instanceof Date)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
  }

  var maxDate = props.maxDate;

  if (maxDate && minDate > maxDate) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
  }

  return null;
};
var isMaxDate = function isMaxDate(props, propName, componentName) {
  var maxDate = props[propName];

  if (!maxDate) {
    return null;
  }

  if (!(maxDate instanceof Date)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
  }

  var minDate = props.minDate;

  if (minDate && maxDate < minDate) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
  }

  return null;
};
var isRef = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  // eslint-disable-next-line react/forbid-prop-types
  current: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any
})]);
var isValue = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(Date), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(Date))]);
var isViews = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(allViews));
var isView = function isView(props, propName, componentName) {
  var view = props[propName];
  var views = props.views;
  var allowedViews = views || allViews;

  if (view !== undefined && allowedViews.indexOf(view) === -1) {
    return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function (a) {
      return "\"".concat(a, "\"");
    }).join(', '), "]."));
  } // Everything is fine


  return null;
};

isView.isRequired = function (props, propName, componentName) {
  var view = props[propName];

  if (!view) {
    return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
  }

  return isView(props, propName, componentName);
};

var tileGroupProps = {
  activeStartDate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(Date).isRequired,
  hover: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(Date),
  locale: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onMouseOver: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  tileClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, isClassName]),
  tileContent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node]),
  value: isValue,
  valueType: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
};
var tileProps = {
  activeStartDate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(Date).isRequired,
  classes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string).isRequired,
  date: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.instanceOf(Date).isRequired,
  locale: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onMouseOver: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number])),
  tileClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, isClassName]),
  tileContent: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node]),
  tileDisabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppHeader__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AppHeader", function() { return __WEBPACK_IMPORTED_MODULE_0__AppHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BusyIndicator__ = __webpack_require__(145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BusyIndicator", function() { return __WEBPACK_IMPORTED_MODULE_1__BusyIndicator__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Busy", function() { return __WEBPACK_IMPORTED_MODULE_1__BusyIndicator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClubSelector__ = __webpack_require__(146);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClubSelector", function() { return __WEBPACK_IMPORTED_MODULE_2__ClubSelector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Inputs__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClubSelectorInput", function() { return __WEBPACK_IMPORTED_MODULE_3__Inputs__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextInput", function() { return __WEBPACK_IMPORTED_MODULE_3__Inputs__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NewRegistrationContact", function() { return __WEBPACK_IMPORTED_MODULE_3__Inputs__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dropdown", function() { return __WEBPACK_IMPORTED_MODULE_3__Inputs__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Spinner", function() { return __WEBPACK_IMPORTED_MODULE_3__Inputs__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CompetitionProperties__ = __webpack_require__(149);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CompetitionProperties", function() { return __WEBPACK_IMPORTED_MODULE_4__CompetitionProperties__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Description__ = __webpack_require__(250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Description", function() { return __WEBPACK_IMPORTED_MODULE_5__Description__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EventProperties__ = __webpack_require__(251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EventProperties", function() { return __WEBPACK_IMPORTED_MODULE_6__EventProperties__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Results__ = __webpack_require__(284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ParticipantResult", function() { return __WEBPACK_IMPORTED_MODULE_7__Results__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TeamResult", function() { return __WEBPACK_IMPORTED_MODULE_7__Results__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Footer__ = __webpack_require__(291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Footer", function() { return __WEBPACK_IMPORTED_MODULE_8__Footer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Footers", function() { return __WEBPACK_IMPORTED_MODULE_8__Footer__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GroupProperties__ = __webpack_require__(292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GroupProperties", function() { return __WEBPACK_IMPORTED_MODULE_9__GroupProperties__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LoginControl__ = __webpack_require__(293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LoginControl", function() { return __WEBPACK_IMPORTED_MODULE_10__LoginControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GlobalTools__ = __webpack_require__(294);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LoginLogout", function() { return __WEBPACK_IMPORTED_MODULE_11__GlobalTools__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DeleteCookies", function() { return __WEBPACK_IMPORTED_MODULE_11__GlobalTools__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LocalToggle", function() { return __WEBPACK_IMPORTED_MODULE_11__GlobalTools__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModeSelector", function() { return __WEBPACK_IMPORTED_MODULE_11__GlobalTools__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ParticipantPicker__ = __webpack_require__(296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ParticipantPicker", function() { return __WEBPACK_IMPORTED_MODULE_12__ParticipantPicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ParticipantToolbar__ = __webpack_require__(300);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ParticipantToolbar", function() { return __WEBPACK_IMPORTED_MODULE_13__ParticipantToolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__RegistrationForm__ = __webpack_require__(301);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RegistrationForm", function() { return __WEBPACK_IMPORTED_MODULE_14__RegistrationForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__RegistrationRow__ = __webpack_require__(114);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RegistrationRow", function() { return __WEBPACK_IMPORTED_MODULE_15__RegistrationRow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__RegistrationToolbar__ = __webpack_require__(303);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RegistrationToolbar", function() { return __WEBPACK_IMPORTED_MODULE_16__RegistrationToolbar__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonToolbar", function() { return __WEBPACK_IMPORTED_MODULE_16__RegistrationToolbar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return __WEBPACK_IMPORTED_MODULE_16__RegistrationToolbar__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ReportIndicator__ = __webpack_require__(304);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReportIndicator", function() { return __WEBPACK_IMPORTED_MODULE_17__ReportIndicator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ReportTable__ = __webpack_require__(306);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReportTable", function() { return __WEBPACK_IMPORTED_MODULE_18__ReportTable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ResultsTable__ = __webpack_require__(311);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ResultsTable", function() { return __WEBPACK_IMPORTED_MODULE_19__ResultsTable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ScheduleProperties__ = __webpack_require__(312);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScheduleProperties", function() { return __WEBPACK_IMPORTED_MODULE_20__ScheduleProperties__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Scorecard__ = __webpack_require__(314);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scorecard", function() { return __WEBPACK_IMPORTED_MODULE_21__Scorecard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SquadPicker__ = __webpack_require__(321);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SquadPicker", function() { return __WEBPACK_IMPORTED_MODULE_22__SquadPicker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__SquadProperties__ = __webpack_require__(323);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SquadProperties", function() { return __WEBPACK_IMPORTED_MODULE_23__SquadProperties__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__StageProperties__ = __webpack_require__(324);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StageProperties", function() { return __WEBPACK_IMPORTED_MODULE_24__StageProperties__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__StoreQuestion__ = __webpack_require__(326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StoreQuestion", function() { return __WEBPACK_IMPORTED_MODULE_25__StoreQuestion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Summary__ = __webpack_require__(327);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Summary", function() { return __WEBPACK_IMPORTED_MODULE_26__Summary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__TeamForm__ = __webpack_require__(329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TeamForm", function() { return __WEBPACK_IMPORTED_MODULE_27__TeamForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__TeamProperties__ = __webpack_require__(330);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TeamProperties", function() { return __WEBPACK_IMPORTED_MODULE_28__TeamProperties__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__YesNoDialog__ = __webpack_require__(331);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "YesNoDialog", function() { return __WEBPACK_IMPORTED_MODULE_29__YesNoDialog__["a"]; });


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Time__ = __webpack_require__(157);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Time", function() { return __WEBPACK_IMPORTED_MODULE_0__Time__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Injector__ = __webpack_require__(62);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AutoInjector", function() { return __WEBPACK_IMPORTED_MODULE_1__Injector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EventBus__ = __webpack_require__(158);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return __WEBPACK_IMPORTED_MODULE_2__EventBus__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EventBus", function() { return __WEBPACK_IMPORTED_MODULE_2__EventBus__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Validation__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Validation", function() { return __WEBPACK_IMPORTED_MODULE_3__Validation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TeamValidation__ = __webpack_require__(219);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TeamValidation", function() { return __WEBPACK_IMPORTED_MODULE_4__TeamValidation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Server__ = __webpack_require__(220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Server", function() { return __WEBPACK_IMPORTED_MODULE_5__Server__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Storage__ = __webpack_require__(224);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Storage", function() { return __WEBPACK_IMPORTED_MODULE_6__Storage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Cookies__ = __webpack_require__(225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setCookie", function() { return __WEBPACK_IMPORTED_MODULE_7__Cookies__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getCookie", function() { return __WEBPACK_IMPORTED_MODULE_7__Cookies__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deleteCookie", function() { return __WEBPACK_IMPORTED_MODULE_7__Cookies__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__LocalScheduleService__ = __webpack_require__(226);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LocalScheduleService", function() { return __WEBPACK_IMPORTED_MODULE_8__LocalScheduleService__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LocalCompetitionService__ = __webpack_require__(227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LocalCompetitionService", function() { return __WEBPACK_IMPORTED_MODULE_9__LocalCompetitionService__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LocalResultService__ = __webpack_require__(228);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LocalResultService", function() { return __WEBPACK_IMPORTED_MODULE_10__LocalResultService__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LocalRegistrationService__ = __webpack_require__(229);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LocalRegistrationService", function() { return __WEBPACK_IMPORTED_MODULE_11__LocalRegistrationService__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Configuration__ = __webpack_require__(230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Configuration", function() { return __WEBPACK_IMPORTED_MODULE_12__Configuration__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CompetitionGroups__ = __webpack_require__(231);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CompetitionGroups", function() { return __WEBPACK_IMPORTED_MODULE_13__CompetitionGroups__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Session__ = __webpack_require__(235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Session", function() { return __WEBPACK_IMPORTED_MODULE_14__Session__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__StdFieldScore__ = __webpack_require__(236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StdFieldScore", function() { return __WEBPACK_IMPORTED_MODULE_15__StdFieldScore__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PointFieldScore__ = __webpack_require__(237);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PointFieldScore", function() { return __WEBPACK_IMPORTED_MODULE_16__PointFieldScore__["a"]; });


/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OperatorSubscriber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(33);


var OperatorSubscriber = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this._next = onNext
            ? function (value) {
                try {
                    onNext(value);
                }
                catch (err) {
                    destination.error(err);
                }
            }
            : _super.prototype._next;
        _this._error = onError
            ? function (err) {
                try {
                    onError(err);
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._error;
        _this._complete = onComplete
            ? function () {
                try {
                    onComplete();
                }
                catch (err) {
                    destination.error(err);
                }
                finally {
                    this.unsubscribe();
                }
            }
            : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function () {
        var _a;
        var closed = this.closed;
        _super.prototype.unsubscribe.call(this);
        !closed && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
    };
    return OperatorSubscriber;
}(__WEBPACK_IMPORTED_MODULE_1__Subscriber__["b" /* Subscriber */]));

//# sourceMappingURL=OperatorSubscriber.js.map

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Subscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMPTY_SUBSCRIPTION; });
/* harmony export (immutable) */ __webpack_exports__["c"] = isSubscription;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_UnsubscriptionError__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_arrRemove__ = __webpack_require__(47);




var Subscription = (function () {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._teardowns = null;
    }
    Subscription.prototype.unsubscribe = function () {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) {
                    try {
                        for (var _parentage_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __values */])(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
                            var parent_1 = _parentage_1_1.value;
                            parent_1.remove(this);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                }
                else {
                    _parentage.remove(this);
                }
            }
            var initialTeardown = this.initialTeardown;
            if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(initialTeardown)) {
                try {
                    initialTeardown();
                }
                catch (e) {
                    errors = e instanceof __WEBPACK_IMPORTED_MODULE_2__util_UnsubscriptionError__["a" /* UnsubscriptionError */] ? e.errors : [e];
                }
            }
            var _teardowns = this._teardowns;
            if (_teardowns) {
                this._teardowns = null;
                try {
                    for (var _teardowns_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __values */])(_teardowns), _teardowns_1_1 = _teardowns_1.next(); !_teardowns_1_1.done; _teardowns_1_1 = _teardowns_1.next()) {
                        var teardown_1 = _teardowns_1_1.value;
                        try {
                            execTeardown(teardown_1);
                        }
                        catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof __WEBPACK_IMPORTED_MODULE_2__util_UnsubscriptionError__["a" /* UnsubscriptionError */]) {
                                errors = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])([], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(errors)), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(err.errors));
                            }
                            else {
                                errors.push(err);
                            }
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (_teardowns_1_1 && !_teardowns_1_1.done && (_b = _teardowns_1.return)) _b.call(_teardowns_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
            if (errors) {
                throw new __WEBPACK_IMPORTED_MODULE_2__util_UnsubscriptionError__["a" /* UnsubscriptionError */](errors);
            }
        }
    };
    Subscription.prototype.add = function (teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) {
                execTeardown(teardown);
            }
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) {
                        return;
                    }
                    teardown._addParent(this);
                }
                (this._teardowns = (_a = this._teardowns) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function (parent) {
        var _parentage = this._parentage;
        return _parentage === parent || (Array.isArray(_parentage) && _parentage.includes(parent));
    };
    Subscription.prototype._addParent = function (parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [_parentage, parent] : parent;
    };
    Subscription.prototype._removeParent = function (parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) {
            this._parentage = null;
        }
        else if (Array.isArray(_parentage)) {
            Object(__WEBPACK_IMPORTED_MODULE_3__util_arrRemove__["a" /* arrRemove */])(_parentage, parent);
        }
    };
    Subscription.prototype.remove = function (teardown) {
        var _teardowns = this._teardowns;
        _teardowns && Object(__WEBPACK_IMPORTED_MODULE_3__util_arrRemove__["a" /* arrRemove */])(_teardowns, teardown);
        if (teardown instanceof Subscription) {
            teardown._removeParent(this);
        }
    };
    Subscription.EMPTY = (function () {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    })();
    return Subscription;
}());

var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value) {
    return (value instanceof Subscription ||
        (value && 'closed' in value && Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(value.remove) && Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(value.add) && Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(value.unsubscribe)));
}
function execTeardown(teardown) {
    if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(teardown)) {
        teardown();
    }
    else {
        teardown.unsubscribe();
    }
}
//# sourceMappingURL=Subscription.js.map

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = getDayOfWeek;
/* harmony export (immutable) */ __webpack_exports__["d"] = getBeginOfCenturyYear;
/* harmony export (immutable) */ __webpack_exports__["e"] = getBeginOfDecadeYear;
/* harmony export (immutable) */ __webpack_exports__["f"] = getBeginOfWeek;
/* harmony export (immutable) */ __webpack_exports__["q"] = getWeekNumber;
/* harmony export (immutable) */ __webpack_exports__["a"] = getBegin;
/* harmony export (immutable) */ __webpack_exports__["g"] = getBeginPrevious;
/* harmony export (immutable) */ __webpack_exports__["b"] = getBeginNext;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return getBeginPrevious2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getBeginNext2; });
/* harmony export (immutable) */ __webpack_exports__["l"] = getEnd;
/* harmony export (immutable) */ __webpack_exports__["m"] = getEndPrevious;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getEndPrevious2; });
/* harmony export (immutable) */ __webpack_exports__["o"] = getRange;
/* harmony export (immutable) */ __webpack_exports__["p"] = getValueRange;
/* harmony export (immutable) */ __webpack_exports__["i"] = getCenturyLabel;
/* harmony export (immutable) */ __webpack_exports__["k"] = getDecadeLabel;
/* harmony export (immutable) */ __webpack_exports__["r"] = isWeekend;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__const__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dateFormatter__ = __webpack_require__(18);



var SUNDAY = __WEBPACK_IMPORTED_MODULE_1__const__["c" /* WEEKDAYS */][0];
var FRIDAY = __WEBPACK_IMPORTED_MODULE_1__const__["c" /* WEEKDAYS */][5];
var SATURDAY = __WEBPACK_IMPORTED_MODULE_1__const__["c" /* WEEKDAYS */][6];
/* Simple getters - getting a property of a given point in time */

function getDayOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].ISO_8601;
  var weekday = date.getDay();

  switch (calendarType) {
    case __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].ISO_8601:
      // Shifts days of the week so that Monday is 0, Sunday is 6
      return (weekday + 6) % 7;

    case __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].ARABIC:
      return (weekday + 1) % 7;

    case __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].HEBREW:
    case __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].US:
      return weekday;

    default:
      throw new Error('Unsupported calendar type.');
  }
}
/**
 * Century
 */

function getBeginOfCenturyYear(date) {
  var beginOfCentury = Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getCenturyStart"])(date);
  return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getYear"])(beginOfCentury);
}
/**
 * Decade
 */

function getBeginOfDecadeYear(date) {
  var beginOfDecade = Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getDecadeStart"])(date);
  return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getYear"])(beginOfDecade);
}
/**
 * Week
 */

/**
 * Returns the beginning of a given week.
 *
 * @param {Date} date Date.
 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
 */

function getBeginOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].ISO_8601;
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getYear"])(date);
  var monthIndex = Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getMonth"])(date);
  var day = date.getDate() - getDayOfWeek(date, calendarType);
  return new Date(year, monthIndex, day);
}
/**
 * Gets week number according to ISO 8601 or US standard.
 * In ISO 8601, Arabic and Hebrew week 1 is the one with January 4.
 * In US calendar week 1 is the one with January 1.
 *
 * @param {Date} date Date.
 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
 */

function getWeekNumber(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].ISO_8601;
  var calendarTypeForWeekNumber = calendarType === __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].US ? __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].US : __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].ISO_8601;
  var beginOfWeek = getBeginOfWeek(date, calendarTypeForWeekNumber);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getYear"])(date) + 1;
  var dayInWeekOne;
  var beginOfFirstWeek; // Look for the first week one that does not come after a given date

  do {
    dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].ISO_8601 ? 4 : 1);
    beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarTypeForWeekNumber);
    year -= 1;
  } while (date - beginOfFirstWeek < 0);

  return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
}
/**
 * Others
 */

/**
 * Returns the beginning of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */

function getBegin(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getCenturyStart"])(date);

    case 'decade':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getDecadeStart"])(date);

    case 'year':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getYearStart"])(date);

    case 'month':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getMonthStart"])(date);

    case 'day':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getDayStart"])(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getBeginPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousCenturyStart"])(date);

    case 'decade':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousDecadeStart"])(date);

    case 'year':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousYearStart"])(date);

    case 'month':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousMonthStart"])(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getBeginNext(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getNextCenturyStart"])(date);

    case 'decade':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getNextDecadeStart"])(date);

    case 'year':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getNextYearStart"])(date);

    case 'month':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getNextMonthStart"])(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
var getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousDecadeStart"])(date, -100);

    case 'year':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousYearStart"])(date, -10);

    case 'month':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousMonthStart"])(date, -12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
var getBeginNext2 = function getBeginNext2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getNextDecadeStart"])(date, 100);

    case 'year':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getNextYearStart"])(date, 10);

    case 'month':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getNextMonthStart"])(date, 12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
/**
 * Returns the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */

function getEnd(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getCenturyEnd"])(date);

    case 'decade':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getDecadeEnd"])(date);

    case 'year':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getYearEnd"])(date);

    case 'month':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getMonthEnd"])(date);

    case 'day':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getDayEnd"])(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
function getEndPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousCenturyEnd"])(date);

    case 'decade':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousDecadeEnd"])(date);

    case 'year':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousYearEnd"])(date);

    case 'month':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousMonthEnd"])(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
var getEndPrevious2 = function getEndPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousDecadeEnd"])(date, -100);

    case 'year':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousYearEnd"])(date, -10);

    case 'month':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getPreviousMonthEnd"])(date, -12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
/**
 * Returns an array with the beginning and the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */

function getRange(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getCenturyRange"])(date);

    case 'decade':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getDecadeRange"])(date);

    case 'year':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getYearRange"])(date);

    case 'month':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getMonthRange"])(date);

    case 'day':
      return Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getDayRange"])(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
/**
 * Creates a range out of two values, ensuring they are in order and covering entire period ranges.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date1 First date.
 * @param {Date} date2 Second date.
 */

function getValueRange(rangeType, date1, date2) {
  var rawNextValue = [date1, date2].sort(function (a, b) {
    return a - b;
  });
  return [getBegin(rangeType, rawNextValue[0]), getEnd(rangeType, rawNextValue[1])];
}

function toYearLabel(locale) {
  var formatYear = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_2__dateFormatter__["f" /* formatYear */];
  var dates = arguments.length > 2 ? arguments[2] : undefined;
  return dates.map(function (date) {
    return formatYear(locale, date);
  }).join(' – ');
}
/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2001-2100.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */


function getCenturyLabel(locale, formatYear, date) {
  return toYearLabel(locale, formatYear, Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getCenturyRange"])(date));
}
/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2011-2020.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */

function getDecadeLabel(locale, formatYear, date) {
  return toYearLabel(locale, formatYear, Object(__WEBPACK_IMPORTED_MODULE_0__wojtekmaj_date_utils__["getDecadeRange"])(date));
}
/**
 * Returns a boolean determining whether a given date is on Saturday or Sunday.
 *
 * @param {Date} date Date.
 */

function isWeekend(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].ISO_8601;
  var weekday = date.getDay();

  switch (calendarType) {
    case __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].ARABIC:
    case __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].HEBREW:
      return weekday === FRIDAY || weekday === SATURDAY;

    case __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].ISO_8601:
    case __WEBPACK_IMPORTED_MODULE_1__const__["a" /* CALENDAR_TYPES */].US:
      return weekday === SATURDAY || weekday === SUNDAY;

    default:
      throw new Error('Unsupported calendar type.');
  }
}

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasLift;
/* harmony export (immutable) */ __webpack_exports__["b"] = operate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction__ = __webpack_require__(5);

function hasLift(source) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__isFunction__["a" /* isFunction */])(source === null || source === void 0 ? void 0 : source.lift);
}
function operate(init) {
    return function (source) {
        if (hasLift(source)) {
            return source.lift(function (liftedSource) {
                try {
                    return init(liftedSource, this);
                }
                catch (err) {
                    this.error(err);
                }
            });
        }
        throw new TypeError('Unable to lift unknown Observable type');
    };
}
//# sourceMappingURL=lift.js.map

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMPTY; });
/* unused harmony export empty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);

var EMPTY = new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return subscriber.complete(); });
function empty(scheduler) {
    return scheduler ? emptyScheduled(scheduler) : EMPTY;
}
function emptyScheduled(scheduler) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) { return scheduler.schedule(function () { return subscriber.complete(); }); });
}
//# sourceMappingURL=empty.js.map

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createErrorClass;
function createErrorClass(createImpl) {
    var _super = function (instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}
//# sourceMappingURL=createErrorClass.js.map

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatDate */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return formatLongDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatMonth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatMonthYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return formatYear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatShortWeekday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formatWeekday; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_get_user_locale__ = __webpack_require__(52);


function getFormatter(options) {
  return function (locale, date) {
    return date.toLocaleString(locale || Object(__WEBPACK_IMPORTED_MODULE_0_get_user_locale__["default"])(), options);
  };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 */


function toSafeHour(date) {
  var safeDate = new Date(date);
  return new Date(safeDate.setHours(12));
}

function getSafeFormatter(options) {
  return function (locale, date) {
    return getFormatter(options)(locale, toSafeHour(date));
  };
}

var formatDateOptions = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric'
};
var formatLongDateOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric'
};
var formatMonthOptions = {
  month: 'long'
};
var formatMonthYearOptions = {
  month: 'long',
  year: 'numeric'
};
var formatYearOptions = {
  year: 'numeric'
};
var formatShortWeekdayOptions = {
  weekday: 'short'
};
var formatWeekdayOptions = {
  weekday: 'long'
};
var formatDate = getSafeFormatter(formatDateOptions);
var formatLongDate = getSafeFormatter(formatLongDateOptions);
var formatMonth = getSafeFormatter(formatMonthOptions);
var formatMonthYear = getSafeFormatter(formatMonthYearOptions);
var formatYear = getSafeFormatter(formatYearOptions);
var formatShortWeekday = getSafeFormatter(formatShortWeekdayOptions);
var formatWeekday = getSafeFormatter(formatWeekdayOptions);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isMaxDate = exports.isMinDate = exports.isValueType = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var allViews = ['century', 'decade', 'year', 'month'];
var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);

var isValueType = _propTypes["default"].oneOf(allValueTypes);

exports.isValueType = isValueType;

var isMinDate = function isMinDate(props, propName, componentName) {
  var minDate = props[propName];

  if (!minDate) {
    return null;
  }

  if (!(minDate instanceof Date)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
  }

  var maxDate = props.maxDate;

  if (maxDate && minDate > maxDate) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
  }

  return null;
};

exports.isMinDate = isMinDate;

var isMaxDate = function isMaxDate(props, propName, componentName) {
  var maxDate = props[propName];

  if (!maxDate) {
    return null;
  }

  if (!(maxDate instanceof Date)) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
  }

  var minDate = props.minDate;

  if (minDate && maxDate < minDate) {
    return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
  }

  return null;
};

exports.isMaxDate = isMaxDate;

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = popResultSelector;
/* harmony export (immutable) */ __webpack_exports__["c"] = popScheduler;
/* harmony export (immutable) */ __webpack_exports__["a"] = popNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isScheduler__ = __webpack_require__(38);


function last(arr) {
    return arr[arr.length - 1];
}
function popResultSelector(args) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__isFunction__["a" /* isFunction */])(last(args)) ? args.pop() : undefined;
}
function popScheduler(args) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__isScheduler__["a" /* isScheduler */])(last(args)) ? args.pop() : undefined;
}
function popNumber(args, defaultValue) {
    return typeof last(args) === 'number' ? args.pop() : defaultValue;
}
//# sourceMappingURL=args.js.map

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return observable; });
var observable = (function () { return (typeof Symbol === 'function' && Symbol.observable) || '@@observable'; })();
//# sourceMappingURL=observable.js.map

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identity;
function identity(x) {
    return x;
}
//# sourceMappingURL=identity.js.map

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subject; });
/* unused harmony export AnonymousSubject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_ObjectUnsubscribedError__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_arrRemove__ = __webpack_require__(47);





var Subject = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function () {
        if (this.closed) {
            throw new __WEBPACK_IMPORTED_MODULE_3__util_ObjectUnsubscribedError__["a" /* ObjectUnsubscribedError */]();
        }
    };
    Subject.prototype.next = function (value) {
        var e_1, _a;
        this._throwIfClosed();
        if (!this.isStopped) {
            var copy = this.observers.slice();
            try {
                for (var copy_1 = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["i" /* __values */])(copy), copy_1_1 = copy_1.next(); !copy_1_1.done; copy_1_1 = copy_1.next()) {
                    var observer = copy_1_1.value;
                    observer.next(value);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (copy_1_1 && !copy_1_1.done && (_a = copy_1.return)) _a.call(copy_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    Subject.prototype.error = function (err) {
        this._throwIfClosed();
        if (!this.isStopped) {
            this.hasError = this.isStopped = true;
            this.thrownError = err;
            var observers = this.observers;
            while (observers.length) {
                observers.shift().error(err);
            }
        }
    };
    Subject.prototype.complete = function () {
        this._throwIfClosed();
        if (!this.isStopped) {
            this.isStopped = true;
            var observers = this.observers;
            while (observers.length) {
                observers.shift().complete();
            }
        }
    };
    Subject.prototype.unsubscribe = function () {
        this.isStopped = this.closed = true;
        this.observers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function () {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function (subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function (subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function (subscriber) {
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        return hasError || isStopped
            ? __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* EMPTY_SUBSCRIPTION */]
            : (observers.push(subscriber), new __WEBPACK_IMPORTED_MODULE_2__Subscription__["b" /* Subscription */](function () { return Object(__WEBPACK_IMPORTED_MODULE_4__util_arrRemove__["a" /* arrRemove */])(observers, subscriber); }));
    };
    Subject.prototype._checkFinalizedStatuses = function (subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) {
            subscriber.error(thrownError);
        }
        else if (isStopped) {
            subscriber.complete();
        }
    };
    Subject.prototype.asObservable = function () {
        var observable = new __WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */]();
        observable.source = this;
        return observable;
    };
    Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
    };
    return Subject;
}(__WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */]));

var AnonymousSubject = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function (value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function (err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function () {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function (subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : __WEBPACK_IMPORTED_MODULE_2__Subscription__["a" /* EMPTY_SUBSCRIPTION */];
    };
    return AnonymousSubject;
}(Subject));

//# sourceMappingURL=Subject.js.map

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Action__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__intervalProvider__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_arrRemove__ = __webpack_require__(47);




var AsyncAction = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (this.closed) {
            return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id = this.id || this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function (scheduler, _id, delay) {
        if (delay === void 0) { delay = 0; }
        return __WEBPACK_IMPORTED_MODULE_2__intervalProvider__["a" /* intervalProvider */].setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function (_scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay != null && this.delay === delay && this.pending === false) {
            return id;
        }
        __WEBPACK_IMPORTED_MODULE_2__intervalProvider__["a" /* intervalProvider */].clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
            return new Error('executing a cancelled action');
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
            return error;
        }
        else if (this.pending === false && this.id != null) {
            this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
    };
    AsyncAction.prototype._execute = function (state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        }
        catch (e) {
            errored = true;
            errorValue = (!!e && e) || new Error(e);
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function () {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            Object(__WEBPACK_IMPORTED_MODULE_3__util_arrRemove__["a" /* arrRemove */])(actions, this);
            if (id != null) {
                this.id = this.recycleAsyncId(scheduler, id, null);
            }
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}(__WEBPACK_IMPORTED_MODULE_1__Action__["a" /* Action */]));

//# sourceMappingURL=AsyncAction.js.map

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Scheduler__ = __webpack_require__(79);


var AsyncScheduler = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) { now = __WEBPACK_IMPORTED_MODULE_1__Scheduler__["a" /* Scheduler */].now; }
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        _this._scheduled = undefined;
        return _this;
    }
    AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        } while ((action = actions.shift()));
        this._active = false;
        if (error) {
            while ((action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsyncScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__Scheduler__["a" /* Scheduler */]));

//# sourceMappingURL=AsyncScheduler.js.map

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapOneOrManyArgs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__operators_map__ = __webpack_require__(94);


var isArray = Array.isArray;
function callOrApply(fn, args) {
    return isArray(args) ? fn.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])([], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(args))) : fn(args);
}
function mapOneOrManyArgs(fn) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__operators_map__["a" /* map */])(function (args) { return callOrApply(fn, args); });
}
//# sourceMappingURL=mapOneOrManyArgs.js.map

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = mergeClassNames;
function mergeClassNames() {
  return Array.prototype.slice.call(arguments).reduce(function (classList, arg) {
    return typeof arg === 'string' || Array.isArray(arg) ? classList.concat(arg) : classList;
  }, []).filter(Boolean).join(' ');
}

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.between = between;
exports.safeMin = safeMin;
exports.safeMax = safeMax;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Returns a value no smaller than min and no larger than max.
 *
 * @param {*} value Value to return.
 * @param {*} min Minimum return value.
 * @param {*} max Maximum return value.
 */
function between(value, min, max) {
  if (min && min > value) {
    return min;
  }

  if (max && max < value) {
    return max;
  }

  return value;
}

function isValidNumber(num) {
  return num !== null && num !== false && !Number.isNaN(Number(num));
}

function safeMin() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Math.min.apply(Math, _toConsumableArray(args.filter(isValidNumber)));
}

function safeMax() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return Math.max.apply(Math, _toConsumableArray(args.filter(isValidNumber)));
}

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(298);
/* unused harmony reexport Modal */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logic__ = __webpack_require__(11);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Events", function() { return __WEBPACK_IMPORTED_MODULE_0__logic__["Events"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LoginView__ = __webpack_require__(333);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WithLogin", function() { return __WEBPACK_IMPORTED_MODULE_1__LoginView__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LoginView", function() { return __WEBPACK_IMPORTED_MODULE_1__LoginView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CompetitionListView__ = __webpack_require__(335);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CompetitionList", function() { return __WEBPACK_IMPORTED_MODULE_2__CompetitionListView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CompetitionView__ = __webpack_require__(337);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CompetitionView", function() { return __WEBPACK_IMPORTED_MODULE_3__CompetitionView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreateCompetition__ = __webpack_require__(356);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CreateCompetition", function() { return __WEBPACK_IMPORTED_MODULE_4__CreateCompetition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ComponentTest__ = __webpack_require__(358);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentTest", function() { return __WEBPACK_IMPORTED_MODULE_5__ComponentTest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AboutView__ = __webpack_require__(359);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AboutView", function() { return __WEBPACK_IMPORTED_MODULE_6__AboutView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Diagnostics__ = __webpack_require__(360);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Diagnostics", function() { return __WEBPACK_IMPORTED_MODULE_7__Diagnostics__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HelpView__ = __webpack_require__(366);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HelpView", function() { return __WEBPACK_IMPORTED_MODULE_8__HelpView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AdminView__ = __webpack_require__(367);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AdminView", function() { return __WEBPACK_IMPORTED_MODULE_9__AdminView__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__admintabs__ = __webpack_require__(368);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ListAdminTab", function() { return __WEBPACK_IMPORTED_MODULE_10__admintabs__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "GroupAdminTab", function() { return __WEBPACK_IMPORTED_MODULE_10__admintabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__competitiontabs__ = __webpack_require__(57);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "competitionTabs", function() { return __WEBPACK_IMPORTED_MODULE_11__competitiontabs__["competitionTabs"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ExcelView", function() { return __WEBPACK_IMPORTED_MODULE_11__competitiontabs__["ExcelView"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RegAdminTab", function() { return __WEBPACK_IMPORTED_MODULE_11__competitiontabs__["RegAdminTab"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RegistrationTab", function() { return __WEBPACK_IMPORTED_MODULE_11__competitiontabs__["RegistrationTab"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ReportTab", function() { return __WEBPACK_IMPORTED_MODULE_11__competitiontabs__["ReportTab"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "ResultTab", function() { return __WEBPACK_IMPORTED_MODULE_11__competitiontabs__["ResultTab"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RosterTab", function() { return __WEBPACK_IMPORTED_MODULE_11__competitiontabs__["RosterTab"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TeamAdminTab", function() { return __WEBPACK_IMPORTED_MODULE_11__competitiontabs__["TeamAdminTab"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TeamTab", function() { return __WEBPACK_IMPORTED_MODULE_11__competitiontabs__["TeamTab"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "TiebreakerTab", function() { return __WEBPACK_IMPORTED_MODULE_11__competitiontabs__["TiebreakerTab"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "CompetitionAdminTab", function() { return __WEBPACK_IMPORTED_MODULE_11__competitiontabs__["CompetitionAdminTab"]; });


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Spinner; });
/* harmony export (immutable) */ __webpack_exports__["e"] = TextInput;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClubSelectorInput; });
/* harmony export (immutable) */ __webpack_exports__["c"] = NewRegistrationContact;
/* harmony export (immutable) */ __webpack_exports__["b"] = Dropdown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Inputs_css__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Inputs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Inputs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner_css__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinner_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Spinner_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function maskOK(mask,value){if(mask===undefined){return true;}for(var i=0;i<value.length;i++){if(!mask.includes(value[i])){return false;}}return true;}function TextInput(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'input-wrapper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',{htmlFor:props.id},props.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',Object.assign({type:'text'},props,{onChange:function onChange(e){return maskOK(props.mask,e.target.value)&&props.onChange(e);}})));}function Spinner(_ref){var className=_ref.className,value=_ref.value,_onChange=_ref.onChange,size=_ref.size;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'spinner'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'spinner button-previous',tabIndex:'-1',style:{backgroundColor:"inherit"},onClick:function onClick(e){return _onChange(value-1);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{className:"spinner "+className,value:value,size:size||1,onChange:function onChange(e){return _onChange(e.target.value,10);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'spinner button-next',tabIndex:'-1',style:{backgroundColor:"inherit"},onClick:function onClick(e){return _onChange(value+1);}}));}var ClubSelectorInput=function(_React$Component){_inherits(ClubSelectorInput,_React$Component);function ClubSelectorInput(){_classCallCheck(this,ClubSelectorInput);return _possibleConstructorReturn(this,(ClubSelectorInput.__proto__||Object.getPrototypeOf(ClubSelectorInput)).apply(this,arguments));}_createClass(ClubSelectorInput,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'input-wrapper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',{htmlFor:this.props.id},this.props.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(this.ClubSelector,this.props));}}]);return ClubSelectorInput;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);ClubSelectorInput.wire=["ClubSelector"];function NewRegistrationContact(props){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:'registration-contact',className:'content'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'registration-header'},'Anm\xE4lare\xA0',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'super'},'(* = obligatoriskt f\xE4lt)')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'registration-contact-inputs'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TextInput,{name:'Namn*',id:'name',placeholder:'Namn',value:props.name,onChange:function onChange(e){return props.onChange("name",e.target.value);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ClubSelectorInput,{name:'F\xF6rening*',id:'organization',placeholder:'F\xF6rening',value:props.organization,onChange:function onChange(e){return props.onChange("organization",e.target.value);}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TextInput,{name:'Email*',id:'email',placeholder:'Email',value:props.email,onChange:function onChange(e){return props.onChange("email",e.target.value);}}),props.showAccount&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TextInput,{name:'Konto',id:'account',placeholder:'Kontonummer',value:props.account,mask:'0123456789-',onChange:function onChange(e){return props.onChange("account",e.target.value);}})));}function Dropdown(props){var placeholder=props.placeholder,value=props.value,list=props.list;try{list=list.map(function(li){return typeof li==="string"?{id:li,description:li}:li;});if(placeholder===undefined){var def=list.find(function(v){return v.description.charAt(0)==='!';});if(def!==undefined){placeholder=def.description.replace(/^!/,"");}}list=list.filter(function(v){return v.description.charAt(0)!=='!';});if(value===undefined){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'input-wrapper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',{htmlFor:props.id},props.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('select',Object.assign({},props,{className:props.className+" default",value:"default"}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option',{className:'default',value:'default',disabled:true},placeholder),list&&list.filter(function(i){return!i.empty;}).map(function(i){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option',{key:i.id,value:i.id},i.description);})));}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'input-wrapper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('label',{htmlFor:props.id},props.name),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('select',props,list&&list.map(function(i){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('option',{key:i.id,value:i.id},i.description);})));}catch(e){console.log("ERROR",e);console.log("Properties",props);return null;}}

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Subscriber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SafeSubscriber; });
/* unused harmony export EMPTY_OBSERVER */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_reportUnhandledError__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_noop__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotificationFactories__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__scheduler_timeoutProvider__ = __webpack_require__(73);








var Subscriber = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if (Object(__WEBPACK_IMPORTED_MODULE_2__Subscription__["c" /* isSubscription */])(destination)) {
                destination.add(_this);
            }
        }
        else {
            _this.destination = EMPTY_OBSERVER;
        }
        return _this;
    }
    Subscriber.create = function (next, error, complete) {
        return new SafeSubscriber(next, error, complete);
    };
    Subscriber.prototype.next = function (value) {
        if (this.isStopped) {
            handleStoppedNotification(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationFactories__["c" /* nextNotification */])(value), this);
        }
        else {
            this._next(value);
        }
    };
    Subscriber.prototype.error = function (err) {
        if (this.isStopped) {
            handleStoppedNotification(Object(__WEBPACK_IMPORTED_MODULE_6__NotificationFactories__["b" /* errorNotification */])(err), this);
        }
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function () {
        if (this.isStopped) {
            handleStoppedNotification(__WEBPACK_IMPORTED_MODULE_6__NotificationFactories__["a" /* COMPLETE_NOTIFICATION */], this);
        }
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function (value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function (err) {
        try {
            this.destination.error(err);
        }
        finally {
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function () {
        try {
            this.destination.complete();
        }
        finally {
            this.unsubscribe();
        }
    };
    return Subscriber;
}(__WEBPACK_IMPORTED_MODULE_2__Subscription__["b" /* Subscription */]));

var SafeSubscriber = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var next;
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(observerOrNext)) {
            next = observerOrNext;
        }
        else if (observerOrNext) {
            (next = observerOrNext.next, error = observerOrNext.error, complete = observerOrNext.complete);
            var context_1;
            if (_this && __WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function () { return _this.unsubscribe(); };
            }
            else {
                context_1 = observerOrNext;
            }
            next = next === null || next === void 0 ? void 0 : next.bind(context_1);
            error = error === null || error === void 0 ? void 0 : error.bind(context_1);
            complete = complete === null || complete === void 0 ? void 0 : complete.bind(context_1);
        }
        _this.destination = {
            next: next ? wrapForErrorHandling(next, _this) : __WEBPACK_IMPORTED_MODULE_5__util_noop__["a" /* noop */],
            error: wrapForErrorHandling(error !== null && error !== void 0 ? error : defaultErrorHandler, _this),
            complete: complete ? wrapForErrorHandling(complete, _this) : __WEBPACK_IMPORTED_MODULE_5__util_noop__["a" /* noop */],
        };
        return _this;
    }
    return SafeSubscriber;
}(Subscriber));

function wrapForErrorHandling(handler, instance) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        try {
            handler.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])([], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(args)));
        }
        catch (err) {
            if (__WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].useDeprecatedSynchronousErrorHandling) {
                if (instance._syncErrorHack_isSubscribing) {
                    instance.__syncError = err;
                }
                else {
                    throw err;
                }
            }
            else {
                Object(__WEBPACK_IMPORTED_MODULE_4__util_reportUnhandledError__["a" /* reportUnhandledError */])(err);
            }
        }
    };
}
function defaultErrorHandler(err) {
    throw err;
}
function handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = __WEBPACK_IMPORTED_MODULE_3__config__["a" /* config */].onStoppedNotification;
    onStoppedNotification && __WEBPACK_IMPORTED_MODULE_7__scheduler_timeoutProvider__["a" /* timeoutProvider */].setTimeout(function () { return onStoppedNotification(notification, subscriber); });
}
var EMPTY_OBSERVER = {
    closed: true,
    next: __WEBPACK_IMPORTED_MODULE_5__util_noop__["a" /* noop */],
    error: defaultErrorHandler,
    complete: __WEBPACK_IMPORTED_MODULE_5__util_noop__["a" /* noop */],
};
//# sourceMappingURL=Subscriber.js.map

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
var config = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false,
};
//# sourceMappingURL=config.js.map

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = noop;
function noop() { }
//# sourceMappingURL=noop.js.map

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return asyncScheduler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return async; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncAction__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = __webpack_require__(25);


var asyncScheduler = new __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */](__WEBPACK_IMPORTED_MODULE_0__AsyncAction__["a" /* AsyncAction */]);
var async = asyncScheduler;
//# sourceMappingURL=async.js.map

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = internalFromArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduled_scheduleArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from__ = __webpack_require__(8);


function internalFromArray(input, scheduler) {
    return scheduler ? Object(__WEBPACK_IMPORTED_MODULE_0__scheduled_scheduleArray__["a" /* scheduleArray */])(input, scheduler) : Object(__WEBPACK_IMPORTED_MODULE_1__from__["b" /* fromArrayLike */])(input);
}
//# sourceMappingURL=fromArray.js.map

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isScheduler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction__ = __webpack_require__(5);

function isScheduler(value) {
    return value && Object(__WEBPACK_IMPORTED_MODULE_0__isFunction__["a" /* isFunction */])(value.schedule);
}
//# sourceMappingURL=isScheduler.js.map

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from__ = __webpack_require__(8);


function defer(observableFactory) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        Object(__WEBPACK_IMPORTED_MODULE_1__from__["c" /* innerFrom */])(observableFactory()).subscribe(subscriber);
    });
}
//# sourceMappingURL=defer.js.map

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = argsOrArgArray;
var isArray = Array.isArray;
function argsOrArgArray(args) {
    return args.length === 1 && isArray(args[0]) ? args[0] : args;
}
//# sourceMappingURL=argsOrArgArray.js.map

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TileGroup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Flex__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_utils__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_propTypes__ = __webpack_require__(9);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }






function TileGroup(_ref) {
  var className = _ref.className,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 3 : _ref$count,
      dateTransform = _ref.dateTransform,
      dateType = _ref.dateType,
      end = _ref.end,
      hover = _ref.hover,
      offset = _ref.offset,
      start = _ref.start,
      _ref$step = _ref.step,
      step = _ref$step === void 0 ? 1 : _ref$step,
      Tile = _ref.tile,
      value = _ref.value,
      valueType = _ref.valueType,
      tileProps = _objectWithoutProperties(_ref, ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"]);

  var tiles = [];

  for (var point = start; point <= end; point += step) {
    var date = dateTransform(point);
    tiles.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tile, _extends({
      key: date.getTime(),
      classes: Object(__WEBPACK_IMPORTED_MODULE_3__shared_utils__["b" /* getTileClasses */])({
        value: value,
        valueType: valueType,
        date: date,
        dateType: dateType,
        hover: hover
      }),
      date: date,
      point: point
    }, tileProps)));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Flex__["a" /* default */], {
    className: className,
    count: count,
    offset: offset,
    wrap: true
  }, tiles);
}
TileGroup.propTypes = _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__shared_propTypes__["i" /* tileGroupProps */]), {}, {
  activeStartDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date),
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  dateTransform: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  step: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  tile: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_merge_class_names__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_propTypes__ = __webpack_require__(9);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function getValue(nextProps, prop) {
  var activeStartDate = nextProps.activeStartDate,
      date = nextProps.date,
      view = nextProps.view;
  return typeof prop === 'function' ? prop({
    activeStartDate: activeStartDate,
    date: date,
    view: view
  }) : prop;
}

var Tile = /*#__PURE__*/function (_Component) {
  _inherits(Tile, _Component);

  var _super = _createSuper(Tile);

  function Tile() {
    var _this;

    _classCallCheck(this, Tile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    return _this;
  }

  _createClass(Tile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeStartDate = _this$props.activeStartDate,
          children = _this$props.children,
          classes = _this$props.classes,
          date = _this$props.date,
          formatAbbr = _this$props.formatAbbr,
          locale = _this$props.locale,
          maxDate = _this$props.maxDate,
          maxDateTransform = _this$props.maxDateTransform,
          minDate = _this$props.minDate,
          minDateTransform = _this$props.minDateTransform,
          onClick = _this$props.onClick,
          onMouseOver = _this$props.onMouseOver,
          style = _this$props.style,
          tileDisabled = _this$props.tileDisabled,
          view = _this$props.view;
      var _this$state = this.state,
          tileClassName = _this$state.tileClassName,
          tileContent = _this$state.tileContent;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
        className: Object(__WEBPACK_IMPORTED_MODULE_2_merge_class_names__["default"])(classes, tileClassName),
        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
          activeStartDate: activeStartDate,
          date: date,
          view: view
        }),
        onClick: onClick && function (event) {
          return onClick(date, event);
        },
        onFocus: onMouseOver && function () {
          return onMouseOver(date);
        },
        onMouseOver: onMouseOver && function () {
          return onMouseOver(date);
        },
        style: style,
        type: "button"
      }, formatAbbr ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
        "aria-label": formatAbbr(locale, date)
      }, children) : children, tileContent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var tileClassName = nextProps.tileClassName,
          tileContent = nextProps.tileContent;
      var nextState = {};

      if (tileClassName !== prevState.tileClassNameProps) {
        nextState.tileClassName = getValue(nextProps, tileClassName);
        nextState.tileClassNameProps = tileClassName;
      }

      if (tileContent !== prevState.tileContentProps) {
        nextState.tileContent = getValue(nextProps, tileContent);
        nextState.tileContentProps = tileContent;
      }

      return nextState;
    }
  }]);

  return Tile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


Tile.propTypes = _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_3__shared_propTypes__["j" /* tileProps */]), {}, {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired,
  formatAbbr: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  maxDateTransform: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  minDateTransform: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
});

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gpk_logo_wht.f31df84b.png";

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = arrRemove;
function arrRemove(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}
//# sourceMappingURL=arrRemove.js.map

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scheduleArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);

function scheduleArray(input, scheduler) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var i = 0;
        return scheduler.schedule(function () {
            if (i === input.length) {
                subscriber.complete();
            }
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) {
                    this.schedule();
                }
            }
        });
    });
}
//# sourceMappingURL=scheduleArray.js.map

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArrayLike; });
var isArrayLike = (function (x) { return x && typeof x.length === 'number' && typeof x !== 'function'; });
//# sourceMappingURL=isArrayLike.js.map

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = readableStreamLikeToAsyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["a"] = isReadableStreamLike;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction__ = __webpack_require__(5);


function readableStreamLikeToAsyncGenerator(readableStream) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __asyncGenerator */])(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __generator */])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, , 9, 10]);
                    _b.label = 2;
                case 2:
                    if (false) return [3, 8];
                    return [4, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __await */])(reader.read())];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [3, 5];
                    return [4, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __await */])(void 0)];
                case 4: return [2, _b.sent()];
                case 5: return [4, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __await */])(value)];
                case 6: return [4, _b.sent()];
                case 7:
                    _b.sent();
                    return [3, 2];
                case 8: return [3, 10];
                case 9:
                    reader.releaseLock();
                    return [7];
                case 10: return [2];
            }
        });
    });
}
function isReadableStreamLike(obj) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__isFunction__["a" /* isFunction */])(obj === null || obj === void 0 ? void 0 : obj.getReader);
}
//# sourceMappingURL=isReadableStreamLike.js.map

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EmptyError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createErrorClass__ = __webpack_require__(17);

var EmptyError = Object(__WEBPACK_IMPORTED_MODULE_0__createErrorClass__["a" /* createErrorClass */])(function (_super) { return function EmptyErrorImpl() {
    _super(this);
    this.name = 'EmptyError';
    this.message = 'no elements in sequence';
}; });
//# sourceMappingURL=EmptyError.js.map

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserLocales", function() { return getUserLocales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserLocale", function() { return getUserLocale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_once__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_once___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_once__);


function filterDuplicates(arr) {
  return arr.filter(function (el, index, self) {
    return self.indexOf(el) === index;
  });
}

function fixLowercaseProperties(arr) {
  return arr.map(function (el) {
    if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) {
      return el;
    }

    var splitEl = el.split('-');
    return "".concat(splitEl[0], "-").concat(splitEl[1].toUpperCase());
  });
}

function getUserLocalesInternal() {
  var languageList = [];

  if (typeof window !== 'undefined') {
    if (window.navigator.languages) {
      languageList = languageList.concat(window.navigator.languages);
    }

    if (window.navigator.language) {
      languageList.push(window.navigator.language);
    }

    if (window.navigator.userLanguage) {
      languageList.push(window.navigator.userLanguage);
    }

    if (window.navigator.browserLanguage) {
      languageList.push(window.navigator.browserLanguage);
    }

    if (window.navigator.systemLanguage) {
      languageList.push(window.navigator.systemLanguage);
    }
  }

  languageList.push('en-US'); // Fallback

  return fixLowercaseProperties(filterDuplicates(languageList));
}

var getUserLocales = __WEBPACK_IMPORTED_MODULE_0_lodash_once___default()(getUserLocalesInternal);

function getUserLocaleInternal() {
  return getUserLocales()[0];
}

var getUserLocale = __WEBPACK_IMPORTED_MODULE_0_lodash_once___default()(getUserLocaleInternal);
/* harmony default export */ __webpack_exports__["default"] = (getUserLocale);

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CALENDAR_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALENDAR_TYPE_LOCALES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WEEKDAYS; });
var _CALENDAR_TYPE_LOCALE;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CALENDAR_TYPES = {
  ARABIC: 'Arabic',
  HEBREW: 'Hebrew',
  ISO_8601: 'ISO 8601',
  US: 'US'
};
var CALENDAR_TYPE_LOCALES = (_CALENDAR_TYPE_LOCALE = {}, _defineProperty(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.US, ['en-CA', 'en-US', 'es-AR', 'es-BO', 'es-CL', 'es-CO', 'es-CR', 'es-DO', 'es-EC', 'es-GT', 'es-HN', 'es-MX', 'es-NI', 'es-PA', 'es-PE', 'es-PR', 'es-SV', 'es-VE', 'pt-BR']), _defineProperty(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.ARABIC, [// ar-LB, ar-MA intentionally missing
'ar', 'ar-AE', 'ar-BH', 'ar-DZ', 'ar-EG', 'ar-IQ', 'ar-JO', 'ar-KW', 'ar-LY', 'ar-OM', 'ar-QA', 'ar-SA', 'ar-SD', 'ar-SY', 'ar-YE', 'dv', 'dv-MV', 'ps', 'ps-AR']), _defineProperty(_CALENDAR_TYPE_LOCALE, CALENDAR_TYPES.HEBREW, ['he', 'he-IL']), _CALENDAR_TYPE_LOCALE);
var WEEKDAYS = _toConsumableArray(Array(7)).map(function (el, index) {
  return index;
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Flex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




function toPercent(num) {
  return "".concat(num, "%");
}

function Flex(_ref) {
  var children = _ref.children,
      className = _ref.className,
      direction = _ref.direction,
      count = _ref.count,
      offset = _ref.offset,
      style = _ref.style,
      wrap = _ref.wrap,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "direction", "count", "offset", "style", "wrap"]);

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({
    className: className,
    style: _objectSpread({
      display: 'flex',
      flexDirection: direction,
      flexWrap: wrap ? 'wrap' : 'no-wrap'
    }, style)
  }, otherProps), __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child, index) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, _objectSpread(_objectSpread({}, child.props), {}, {
      style: {
        flexBasis: toPercent(100 / count),
        maxWidth: toPercent(100 / count),
        overflow: 'hidden',
        marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
      }
    }));
  }));
}
Flex.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  count: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  direction: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  offset: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number])),
  wrap: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Input;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _mergeClassNames = _interopRequireDefault(__webpack_require__(27));

var _updateInputWidth = _interopRequireWildcard(__webpack_require__(277));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/* eslint-disable jsx-a11y/no-autofocus */
var isEdgeLegacy = typeof window !== 'undefined' && 'navigator' in window && navigator.userAgent.match(/ Edge\/1/);

function onFocus(event) {
  var target = event.target;

  if (isEdgeLegacy) {
    requestAnimationFrame(function () {
      return target.select();
    });
  } else {
    target.select();
  }
}

function updateInputWidthOnFontLoad(element) {
  if (!document.fonts) {
    return;
  }

  var font = (0, _updateInputWidth.getFontShorthand)(element);

  if (!font) {
    return;
  }

  var isFontLoaded = document.fonts.check(font);

  if (isFontLoaded) {
    return;
  }

  function onLoadingDone() {
    (0, _updateInputWidth["default"])(element);
  }

  document.fonts.addEventListener('loadingdone', onLoadingDone);
}

function getSelectionString() {
  if (typeof window === 'undefined') {
    return null;
  }

  return window.getSelection().toString();
}

function makeOnKeyPress(maxLength) {
  return function onKeyPress(event) {
    var key = event.key,
        input = event.target;
    var value = input.value;
    var isNumberKey = !isNaN(parseInt(key, 10));
    var selection = getSelectionString();

    if (isNumberKey && (selection || value.length < maxLength)) {
      return;
    }

    event.preventDefault();
  };
}

function Input(_ref) {
  var ariaLabel = _ref.ariaLabel,
      autoFocus = _ref.autoFocus,
      className = _ref.className,
      disabled = _ref.disabled,
      itemRef = _ref.itemRef,
      max = _ref.max,
      min = _ref.min,
      name = _ref.name,
      nameForClass = _ref.nameForClass,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown,
      _onKeyUp = _ref.onKeyUp,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '--' : _ref$placeholder,
      required = _ref.required,
      showLeadingZeros = _ref.showLeadingZeros,
      step = _ref.step,
      value = _ref.value;
  var hasLeadingZero = showLeadingZeros && value !== null && value < 10;
  var maxLength = max.toString().length;
  return [hasLeadingZero && /*#__PURE__*/_react["default"].createElement("span", {
    key: "leadingZero",
    className: "".concat(className, "__leadingZero")
  }, "0"), /*#__PURE__*/_react["default"].createElement("input", {
    key: "input",
    "aria-label": ariaLabel,
    autoComplete: "off",
    autoFocus: autoFocus,
    className: (0, _mergeClassNames["default"])("".concat(className, "__input"), "".concat(className, "__").concat(nameForClass || name), hasLeadingZero && "".concat(className, "__input--hasLeadingZero")),
    "data-input": "true",
    disabled: disabled,
    inputMode: "numeric",
    max: max,
    min: min,
    name: name,
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onKeyPress: makeOnKeyPress(maxLength),
    onKeyUp: function onKeyUp(event) {
      (0, _updateInputWidth["default"])(event.target);

      if (_onKeyUp) {
        _onKeyUp(event);
      }
    },
    placeholder: placeholder,
    ref: function ref(_ref2) {
      if (_ref2) {
        (0, _updateInputWidth["default"])(_ref2);
        updateInputWidthOnFontLoad(_ref2);
      }

      if (itemRef) {
        itemRef(_ref2, name);
      }
    },
    required: required,
    step: step,
    type: "number",
    value: value !== null ? value : ''
  })];
}

Input.propTypes = {
  ariaLabel: _propTypes["default"].string,
  autoFocus: _propTypes["default"].bool,
  className: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  itemRef: _propTypes["default"].func,
  max: _propTypes["default"].number,
  min: _propTypes["default"].number,
  name: _propTypes["default"].string,
  nameForClass: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  showLeadingZeros: _propTypes["default"].bool,
  step: _propTypes["default"].number,
  value: _propTypes["default"].number
};

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompetitionTabs__ = __webpack_require__(339);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "competitionTabs", function() { return __WEBPACK_IMPORTED_MODULE_0__CompetitionTabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ExcelTab__ = __webpack_require__(340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ExcelView", function() { return __WEBPACK_IMPORTED_MODULE_1__ExcelTab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegAdminTab__ = __webpack_require__(341);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RegAdminTab", function() { return __WEBPACK_IMPORTED_MODULE_2__RegAdminTab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RegistrationTab__ = __webpack_require__(343);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RegistrationTab", function() { return __WEBPACK_IMPORTED_MODULE_3__RegistrationTab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ReportTab__ = __webpack_require__(345);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ReportTab", function() { return __WEBPACK_IMPORTED_MODULE_4__ReportTab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ResultTab__ = __webpack_require__(347);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ResultTab", function() { return __WEBPACK_IMPORTED_MODULE_5__ResultTab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RosterTab__ = __webpack_require__(349);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RosterTab", function() { return __WEBPACK_IMPORTED_MODULE_6__RosterTab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TeamAdminTab__ = __webpack_require__(351);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TeamAdminTab", function() { return __WEBPACK_IMPORTED_MODULE_7__TeamAdminTab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TeamTab__ = __webpack_require__(352);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TeamTab", function() { return __WEBPACK_IMPORTED_MODULE_8__TeamTab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TiebreakerTab__ = __webpack_require__(354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TiebreakerTab", function() { return __WEBPACK_IMPORTED_MODULE_9__TiebreakerTab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CompetitionAdminTab__ = __webpack_require__(355);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CompetitionAdminTab", function() { return __WEBPACK_IMPORTED_MODULE_10__CompetitionAdminTab__["a"]; });


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(120);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 59 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(130);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AutoInjector; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var _INJECTOR_LOGLEVEL="errors";// _INJECTOR_LOGLEVEL = "details";
var AutoInjector=function(){function AutoInjector(){_classCallCheck(this,AutoInjector);this.injectList=[];}_createClass(AutoInjector,[{key:"registerModule",value:function registerModule(module){for(var c in module){if(module[c]){this.register(module[c]);}}}},{key:"addToInjectList",value:function addToInjectList(c){var _this=this;if(c.wire){this.injectList.push(c);c.wire.forEach(function(i){if(i.wire){_this.addToInjectList(i);}});}}},{key:"register",value:function register(c){this.addToInjectList(c);if(c.register){if(c.register.name===undefined){console.log("WARNING: name not set on class "+c.name);}var name=c.register.name||c.name;if(c.register.createInstance){if(_INJECTOR_LOGLEVEL==="details"){console.log("Registering resource "+name);}this[name]=new c();return;}if(_INJECTOR_LOGLEVEL==="details"){console.log("Registering component/method "+name);}this[name]=c;}}},{key:"inject",value:function inject(){var _this2=this;this.injectList.forEach(function(c){c.wire.forEach(function(i){if(typeof i!=="string"){return;}if(_this2[i]){if(_INJECTOR_LOGLEVEL==="details"){console.log("Injecting "+i+" into "+c.name+(c.register&&c.register.name?" ("+c.register.name+")":""));}c.prototype[i]=_this2[i];}else{console.log("ERROR: Cannot inject entity "+i+" into "+c.name);}});});// Initialize objects only after all injections have been done
this.injectList.forEach(function(c){if(c.register&&c.register.createInstance){if(_INJECTOR_LOGLEVEL==="details"){console.log("Creating instance for class "+c.name);}var i=_this2[c.register.name||c.name];try{if(i.initialize&&typeof i.initialize==="function"){i.initialize();}}catch(e){console.log("Error: Unable to initialize class",e,i);}}});}}],[{key:"wrapComponentRegistration",value:function wrapComponentRegistration(component){return component.register?Object.assign({},component.register,{name:component.register.name||component.name}):component.register;}}]);return AutoInjector;}();

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Switch; });
/* unused harmony export __HistoryContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return context; });
/* unused harmony export generatePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return matchPath; });
/* unused harmony export useHistory */
/* unused harmony export useLocation */
/* unused harmony export useParams */
/* unused harmony export useRouteMatch */
/* unused harmony export withRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var historyContext =
/*#__PURE__*/
createNamedContext("Router-History");

// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext$1 = function createNamedContext(name) {
  var context = Object(__WEBPACK_IMPORTED_MODULE_5_mini_create_react_context__["a" /* default */])();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext$1("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(historyContext.Provider, {
      children: this.props.children || null,
      value: this.props.history
    }));
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context.staticContext) return null;
    var method = context.history.block;
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
    !context ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(prevProps.to);

        if (!Object(__WEBPACK_IMPORTED_MODULE_3_history__["f" /* locationsAreEqual */])(prevLocation, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_8_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.count(children) === 0;
}

function evalChildrenDev(children, props, path) {
  var value = children(props);
   false ? warning(value !== undefined, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
  return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context$1) {
      !context$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : children : component ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(component, props) : render ? render(props) : null : typeof children === "function" ?  false ? evalChildrenDev(children, props, _this.props.path) : children(props) : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_3_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
      false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";

  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(context.Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <" + displayName + " /> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, context, {
        ref: wrappedComponentRef
      }));
    });
  };

  C.displayName = displayName;
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.object])
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

var useContext = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext;
function useHistory() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useHistory()") : invariant(false) : void 0;
  }

  return useContext(historyContext);
}
function useLocation() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useLocation()") : invariant(false) : void 0;
  }

  return useContext(context).location;
}
function useParams() {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useParams()") : invariant(false) : void 0;
  }

  var match = useContext(context).match;
  return match ? match.params : {};
}
function useRouteMatch(path) {
  if (false) {
    !(typeof useContext === "function") ? process.env.NODE_ENV !== "production" ? invariant(false, "You must use React >= 16.8 in order to use useRouteMatch()") : invariant(false) : void 0;
  }

  var location = useLocation();
  var match = useContext(context).match;
  return path ? matchPath(location.pathname, path) : match;
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}


//# sourceMappingURL=react-router.js.map


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(46);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(143);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValueList; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ValueList=function(){function ValueList(listName,id,description,values){_classCallCheck(this,ValueList);this.listName=listName;this.id=id;this.description=description||"Ny lista";this[listName]=values||[];}_createClass(ValueList,[{key:"jsonList",value:function jsonList(){return this.header?this[this.listName].concat(["#"+this.header]):this[this.listName];}},{key:"toJson",value:function toJson(){var l={id:this.id,description:this.description,index:this.index};l[this.listName]=this.jsonList();return l;}}],[{key:"fromJson",value:function fromJson(json,listName){var nl=new ValueList(listName);nl.id=parseInt(json.id,10);nl.description=json.description;nl[listName]=json[listName].filter(function(c){return!c.startsWith("#");});nl.index=parseInt(json.index.toString(),10);nl.header=json[listName].find(function(c){return c.startsWith("#");});if(nl.header)nl.header=nl.header.replace(/^#/,'');return nl;}}]);return ValueList;}();

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Permissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Status; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Operations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Competition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventGroup__ = __webpack_require__(153);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Permissions=function Permissions(){_classCallCheck(this,Permissions);};Permissions.Any=0;Permissions.Admin=1;Permissions.Own=2;var Status=function Status(){_classCallCheck(this,Status);};Status.Hidden=0;Status.Open=1;Status.Closed=2;var Operations=[{name:"Anmälan",path:"register",permission:Permissions.Any,status:Status.Open},{name:"Laganmälan",path:"teams",permission:Permissions.Admin,status:Status.Open},{name:"Startlista",path:"roster",permission:Permissions.Any},{name:"Resultat",path:"results",permission:Permissions.Any,status:Status.Closed},{name:"Rapportera",path:"report",permission:Permissions.Admin},{name:"Administrera anmälningar",path:"registrations",permission:Permissions.Admin,status:Status.Open},{name:"Inställningar",path:"admin",permission:Permissions.Admin}];var Competition=function(){function Competition(){var _this=this;_classCallCheck(this,Competition);this.initialize=function(){_this.id=0;_this.name="";_this.shortDesc="";_this.description="";_this.group="";_this.permissions=Permissions.Own;_this.status=Status.Hidden;_this.eventGroups=[];_this.events=[new __WEBPACK_IMPORTED_MODULE_0____["Event"](1,"",new Date())];_this.rules=[];_this.nextNewEvent=2;_this.dirty=false;if(!_this.serverSub){_this.serverSub=_this.subscribe(_this.Events.serverChanged,function(){return _this.changeServer();});}if(!_this.userSub){_this.userSub=_this.subscribe(_this.Events.userChanged,function(){return _this.refresh();});}if(!_this.dirtySub){_this.dirtySub=_this.subscribe(_this.Events.updateCompetition,function(){_this.dirty=true;_this.fire(_this.Events.competitionUpdated);});}};this.load=function(id){if(id===0)return;if(_this.id!==id){if(_this.ClassGroups.classGroups.length===0){_this.ClassGroups.load(function(){return _this.fire(_this.Events.competitionUpdated);});}if(_this.DivisionGroups.divisionGroups.length===0){_this.DivisionGroups.load(function(){return _this.fire(_this.Events.competitionUpdated);});}_this.Server.loadCompetition(id,function(obj){// Prevent multiple requests from screwing up the state
if(obj!==undefined&&obj.id!==_this.id){_this.initialize();_this.fromJson(obj);_this.fire(_this.Events.competitionUpdated);}},_this.Footers.errorHandler("Kan inte hämta tävling"));}else{_this.fire(_this.Events.competitionUpdated);}};}_createClass(Competition,[{key:'changeServer',value:function changeServer(){var id=this.id;this.id=0;this.load(id);}},{key:'saveCompetition',value:function saveCompetition(){var _this2=this;this.Server.updateCompetition(this.toJson(),function(s){_this2.refresh();_this2.fire(_this2.Events.competitionUpdated);_this2.Footers.addFooter("Ändringarna har sparats","info");},this.Footers.errorHandler("Kan inte spara tävling"));}},{key:'refresh',value:function refresh(){var _this3=this;if(this.id===0)return;this.Server.loadCompetition(this.id,function(obj){if(obj!==undefined){_this3.initialize();_this3.fromJson(obj);_this3.fire(_this3.Events.competitionUpdated);}},this.Footers.errorHandler("Kan inte hämta tävling"));}},{key:'fromJson',value:function fromJson(obj){if(obj){this.id=obj.id||obj.competition_id||this.id;this.name=obj.name||this.name;this.shortDesc=obj.subtitle||this.shortDesc;this.group=obj.group||this.group;this.rules=obj.rules||this.rules;if(obj.name.includes("$")){// Compatibility
var parts=obj.name.split("$");if(parts.length>2){this.group=parts[0];this.name=parts[1];this.shortDesc=parts[2];}else{this.name=parts[0];this.shortDesc=parts[1];}}if(obj.description.includes("<desc>")){// Compatibility
this.description=obj.description.match(/<desc>(.*)<\/desc>/)[1];this.group=obj.description.match(/<group>(.*)<\/group>/)[1];this.shortDesc=obj.description.match(/<sub>(.*)<\/sub>/)[1];var rules=obj.description.match(/<rules>(.*)<\/rules>/);if(null!==rules){this.rules=rules[1].split(',');}}else if(obj.description.includes("#desc#")){this.description=obj.description.match(/#desc#([\s\S]*?)##/)[1];this.group=obj.description.match(/#group#(.*?)##/)[1];this.shortDesc=obj.description.match(/#sub#(.*?)##/)[1];var _rules=obj.description.match(/#rules#(.*?)##/);if(null!==_rules){this.rules=_rules[1].split(',');}}else{this.description=obj.description||this.description;}this.eventGroups=obj.eventGroups?obj.eventGroups.map(function(eg){return __WEBPACK_IMPORTED_MODULE_1__EventGroup__["a" /* EventGroup */].fromJson(eg);}):this.eventGroups;this.events=obj.events?obj.events.map(function(e){return __WEBPACK_IMPORTED_MODULE_0____["Event"].fromJson(e);}):this.events;this.nextNewEvent=Math.max.apply(Math,_toConsumableArray(this.events.filter(function(e){return e.id<1000;}).map(function(e){return e.id;})).concat([0]))+1;this.permissions=obj.permissions?parseInt(obj.permissions.toString(),10):this.Session.user===""||this.Session.user===undefined?Permissions.Any:Permissions.Own;this.status=obj.status!==undefined?parseInt(obj.status.toString(),10):Status.Open;this.dirty=false;this.fire(this.Events.competitionUpdated);}}// Necessary to avoid trying to serialize methods & more
},{key:'toJson',value:function toJson(){return{id:this.id,name:''+this.name,subtitle:''+this.shortDesc,group:''+this.group,description:'#desc#'+this.description+'##group#'+this.group+'##sub#'+this.shortDesc+'##rules#'+this.rules.join(',')+'##',status:this.status,mailTemplate:1,// TODO: Implement!
events:this.events.map(function(e){return e.toJson();}),eventGroups:this.eventGroups,rules:this.rules.filter(function(r){return r==='50pct';})};}/*** Methods*********************************************************************************************************//**
	 * Gets the event with the given ID
	 * @param id - Event ID
	 * @return {object} The event object or undefined if no event with the given ID exists
	 */},{key:'event',value:function event(id){return this.events.find(function(e){return e.id===id;});}},{key:'eventList',value:function eventList(eventGroup){var _this4=this;if(this.eventGroups.length===0)return this.events;var events=[];this.eventGroups.forEach(function(eg){if(eventGroup===undefined||eg.id===eventGroup){eg.events.forEach(function(e){return events.push(_this4.event(e));});}});return events;}},{key:'participantHeaders',value:function participantHeaders(){return[{name:'Namn*',field:'name',placeholder:'Namn',width:200,type:'text'},{name:'Pistolskyttekort*',field:'competitionId',size:'5',placeholder:'00000',width:40,type:'number'},{name:'Förening',field:'organization',width:200,type:'clubs'}];}},{key:'classes',value:function classes(classGroupId){// Hack to handle nonexisting classGroup
var classGroup=this.ClassGroups.find(function(c){return c.id===classGroupId;});return classGroup&&classGroup.classes;}},{key:'divisions',value:function divisions(divisionGroupId){// Hack to handle nonexisting divisionGroup
var divisionGroup=this.DivisionGroups.find(function(d){return d.id===divisionGroupId;});return divisionGroup&&divisionGroup.divisions;}/*** Properties *****************************************************************************************************/},{key:'addEvent',value:function addEvent(){if(this.events.length===1){this.events[0].name="Deltävling 1";}this.events.push(new __WEBPACK_IMPORTED_MODULE_0____["Event"](this.nextNewEvent++,"Deltävling "+(this.events.length+1),new Date()));this.dirty=true;this.fire(this.Events.competitionUpdated);}},{key:'removeEvent',value:function removeEvent(event){this.events=this.events.filter(function(e){return e.id!==event.id;});if(this.events.length===1){this.events[0].name="";}this.dirty=true;this.fire(this.Events.competitionUpdated);}},{key:'updateEvent',value:function updateEvent(event,prop,value){this.events.forEach(function(e){if(e.id===event.id){if(prop){e[prop]=value;e.adjustStages();}else{Object.keys(e).forEach(function(k,i){return e[k]=event[k];});// WTF?
}}});this.dirty=true;this.fire(this.Events.competitionUpdated);}},{key:'setProperty',value:function setProperty(prop,value){this[prop]=value;this.dirty=true;this.fire(this.Events.competitionUpdated);}},{key:'addRule',value:function addRule(rule){this.rules.push(rule);this.dirty=true;this.fire(this.Events.competitionUpdated);}},{key:'removeRule',value:function removeRule(rule){this.rules=this.rules.filter(function(r){return r!==rule;});this.dirty=true;this.fire(this.Events.competitionUpdated);}}]);return Competition;}();Competition.register={name:"Competition",createInstance:true};Competition.wire=["fire","subscribe","Events","Server","ClassGroups","DivisionGroups","Session","Footers"];

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Discipline; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Discipline=function(){function Discipline(){_classCallCheck(this,Discipline);}_createClass(Discipline,null,[{key:"fromJson",value:function fromJson(json){json=parseInt(json,10);return isNaN(json)||json===0?Discipline.none:json;}},{key:"toJson",value:function toJson(d){return d===Discipline.none?0:d;}}]);return Discipline;}();Discipline.none=-1;Discipline.target=1;Discipline.fieldP=2;Discipline.fieldK=3;Discipline.scoredP=4;Discipline.scoredK=5;Discipline.PPC=6;Discipline.list=[{id:Discipline.none,description:"Ingen gren vald"},{id:Discipline.target,description:"Precision/Bana"},{id:Discipline.fieldP,description:"Fält (Pistol)"},{id:Discipline.fieldK,description:"Fält (K-pist & Karbin)"},{id:Discipline.scoredP,description:"Poängfält (Pistol)"},{id:Discipline.scoredK,description:"Poängfält (K-pist & Karbin)"},{id:Discipline.PPC,description:"PPC"}];Discipline.hasStages=[Discipline.fieldP,Discipline.fieldK,Discipline.scoredP,Discipline.scoredK];

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_Observable__ = __webpack_require__(4);
/* unused harmony reexport Observable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_observable_ConnectableObservable__ = __webpack_require__(160);
/* unused harmony reexport ConnectableObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_symbol_observable__ = __webpack_require__(21);
/* unused harmony reexport observable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_observable_dom_animationFrames__ = __webpack_require__(162);
/* unused harmony reexport animationFrames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_Subject__ = __webpack_require__(23);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__internal_Subject__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_BehaviorSubject__ = __webpack_require__(164);
/* unused harmony reexport BehaviorSubject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_ReplaySubject__ = __webpack_require__(165);
/* unused harmony reexport ReplaySubject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internal_AsyncSubject__ = __webpack_require__(78);
/* unused harmony reexport AsyncSubject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_scheduler_asap__ = __webpack_require__(166);
/* unused harmony reexport asap */
/* unused harmony reexport asapScheduler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_scheduler_async__ = __webpack_require__(36);
/* unused harmony reexport async */
/* unused harmony reexport asyncScheduler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internal_scheduler_queue__ = __webpack_require__(173);
/* unused harmony reexport queue */
/* unused harmony reexport queueScheduler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__internal_scheduler_animationFrame__ = __webpack_require__(176);
/* unused harmony reexport animationFrame */
/* unused harmony reexport animationFrameScheduler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__internal_scheduler_VirtualTimeScheduler__ = __webpack_require__(179);
/* unused harmony reexport VirtualTimeScheduler */
/* unused harmony reexport VirtualAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__internal_Scheduler__ = __webpack_require__(79);
/* unused harmony reexport Scheduler */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__internal_Subscription__ = __webpack_require__(13);
/* unused harmony reexport Subscription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__internal_Subscriber__ = __webpack_require__(33);
/* unused harmony reexport Subscriber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__internal_Notification__ = __webpack_require__(180);
/* unused harmony reexport Notification */
/* unused harmony reexport NotificationKind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__internal_util_pipe__ = __webpack_require__(74);
/* unused harmony reexport pipe */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__internal_util_noop__ = __webpack_require__(35);
/* unused harmony reexport noop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__internal_util_identity__ = __webpack_require__(22);
/* unused harmony reexport identity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__internal_util_isObservable__ = __webpack_require__(184);
/* unused harmony reexport isObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__internal_lastValueFrom__ = __webpack_require__(185);
/* unused harmony reexport lastValueFrom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__internal_firstValueFrom__ = __webpack_require__(186);
/* unused harmony reexport firstValueFrom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__internal_util_ArgumentOutOfRangeError__ = __webpack_require__(187);
/* unused harmony reexport ArgumentOutOfRangeError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__internal_util_EmptyError__ = __webpack_require__(51);
/* unused harmony reexport EmptyError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__internal_util_NotFoundError__ = __webpack_require__(188);
/* unused harmony reexport NotFoundError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__internal_util_ObjectUnsubscribedError__ = __webpack_require__(76);
/* unused harmony reexport ObjectUnsubscribedError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__internal_util_SequenceError__ = __webpack_require__(189);
/* unused harmony reexport SequenceError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__internal_operators_timeout__ = __webpack_require__(190);
/* unused harmony reexport TimeoutError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__internal_util_UnsubscriptionError__ = __webpack_require__(71);
/* unused harmony reexport UnsubscriptionError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__internal_observable_bindCallback__ = __webpack_require__(191);
/* unused harmony reexport bindCallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__internal_observable_bindNodeCallback__ = __webpack_require__(194);
/* unused harmony reexport bindNodeCallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__internal_observable_combineLatest__ = __webpack_require__(195);
/* unused harmony reexport combineLatest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__internal_observable_concat__ = __webpack_require__(196);
/* unused harmony reexport concat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__internal_observable_connectable__ = __webpack_require__(199);
/* unused harmony reexport connectable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__internal_observable_defer__ = __webpack_require__(39);
/* unused harmony reexport defer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__internal_observable_empty__ = __webpack_require__(16);
/* unused harmony reexport empty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__internal_observable_forkJoin__ = __webpack_require__(200);
/* unused harmony reexport forkJoin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__internal_observable_from__ = __webpack_require__(8);
/* unused harmony reexport from */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__internal_observable_fromEvent__ = __webpack_require__(201);
/* unused harmony reexport fromEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__internal_observable_fromEventPattern__ = __webpack_require__(202);
/* unused harmony reexport fromEventPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__internal_observable_generate__ = __webpack_require__(203);
/* unused harmony reexport generate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__internal_observable_iif__ = __webpack_require__(204);
/* unused harmony reexport iif */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__internal_observable_interval__ = __webpack_require__(205);
/* unused harmony reexport interval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__internal_observable_merge__ = __webpack_require__(206);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__internal_observable_never__ = __webpack_require__(100);
/* unused harmony reexport never */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__internal_observable_of__ = __webpack_require__(80);
/* unused harmony reexport of */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__internal_observable_onErrorResumeNext__ = __webpack_require__(207);
/* unused harmony reexport onErrorResumeNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__internal_observable_pairs__ = __webpack_require__(209);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__internal_observable_partition__ = __webpack_require__(210);
/* unused harmony reexport partition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__internal_observable_race__ = __webpack_require__(213);
/* unused harmony reexport race */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__internal_observable_range__ = __webpack_require__(214);
/* unused harmony reexport range */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__internal_observable_throwError__ = __webpack_require__(91);
/* unused harmony reexport throwError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__internal_observable_timer__ = __webpack_require__(99);
/* unused harmony reexport timer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__internal_observable_using__ = __webpack_require__(215);
/* unused harmony reexport using */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__internal_observable_zip__ = __webpack_require__(216);
/* unused harmony reexport zip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__internal_scheduled_scheduled__ = __webpack_require__(82);
/* unused harmony reexport scheduled */
/* unused harmony reexport EMPTY */
/* unused harmony reexport NEVER */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__internal_types__ = __webpack_require__(217);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__internal_config__ = __webpack_require__(34);
/* unused harmony reexport config */





























































//# sourceMappingURL=index.js.map

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnsubscriptionError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createErrorClass__ = __webpack_require__(17);

var UnsubscriptionError = Object(__WEBPACK_IMPORTED_MODULE_0__createErrorClass__["a" /* createErrorClass */])(function (_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors
            ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function (err, i) { return i + 1 + ") " + err.toString(); }).join('\n  ')
            : '';
        this.name = 'UnsubscriptionError';
        this.errors = errors;
    };
});
//# sourceMappingURL=UnsubscriptionError.js.map

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reportUnhandledError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_timeoutProvider__ = __webpack_require__(73);


function reportUnhandledError(err) {
    __WEBPACK_IMPORTED_MODULE_1__scheduler_timeoutProvider__["a" /* timeoutProvider */].setTimeout(function () {
        var onUnhandledError = __WEBPACK_IMPORTED_MODULE_0__config__["a" /* config */].onUnhandledError;
        if (onUnhandledError) {
            onUnhandledError(err);
        }
        else {
            throw err;
        }
    });
}
//# sourceMappingURL=reportUnhandledError.js.map

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeoutProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);

var timeoutProvider = {
    setTimeout: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var delegate = timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) || setTimeout).apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])([], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(args)));
    },
    clearTimeout: function (handle) {
        var delegate = timeoutProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined,
};
//# sourceMappingURL=timeoutProvider.js.map

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pipe */
/* harmony export (immutable) */ __webpack_exports__["a"] = pipeFromArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity__ = __webpack_require__(22);

function pipe() {
    var fns = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        fns[_i] = arguments[_i];
    }
    return pipeFromArray(fns);
}
function pipeFromArray(fns) {
    if (fns.length === 0) {
        return __WEBPACK_IMPORTED_MODULE_0__identity__["a" /* identity */];
    }
    if (fns.length === 1) {
        return fns[0];
    }
    return function piped(input) {
        return fns.reduce(function (prev, fn) { return fn(prev); }, input);
    };
}
//# sourceMappingURL=pipe.js.map

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animationFrameProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(13);


var animationFrameProvider = {
    schedule: function (callback) {
        var request = requestAnimationFrame;
        var cancel = cancelAnimationFrame;
        var delegate = animationFrameProvider.delegate;
        if (delegate) {
            request = delegate.requestAnimationFrame;
            cancel = delegate.cancelAnimationFrame;
        }
        var handle = request(function (timestamp) {
            cancel = undefined;
            callback(timestamp);
        });
        return new __WEBPACK_IMPORTED_MODULE_1__Subscription__["b" /* Subscription */](function () { return cancel === null || cancel === void 0 ? void 0 : cancel(handle); });
    },
    requestAnimationFrame: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var delegate = animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])([], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(args)));
    },
    cancelAnimationFrame: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var delegate = animationFrameProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])([], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(args)));
    },
    delegate: undefined,
};
//# sourceMappingURL=animationFrameProvider.js.map

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObjectUnsubscribedError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createErrorClass__ = __webpack_require__(17);

var ObjectUnsubscribedError = Object(__WEBPACK_IMPORTED_MODULE_0__createErrorClass__["a" /* createErrorClass */])(function (_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = 'ObjectUnsubscribedError';
        this.message = 'object unsubscribed';
    };
});
//# sourceMappingURL=ObjectUnsubscribedError.js.map

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dateTimestampProvider; });
var dateTimestampProvider = {
    now: function () {
        return (dateTimestampProvider.delegate || Date).now();
    },
    delegate: undefined,
};
//# sourceMappingURL=dateTimestampProvider.js.map

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsyncSubject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(23);


var AsyncSubject = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(AsyncSubject, _super);
    function AsyncSubject() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._value = null;
        _this._hasValue = false;
        _this._isComplete = false;
        return _this;
    }
    AsyncSubject.prototype._checkFinalizedStatuses = function (subscriber) {
        var _a = this, hasError = _a.hasError, _hasValue = _a._hasValue, _value = _a._value, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) {
            subscriber.error(thrownError);
        }
        else if (isStopped) {
            _hasValue && subscriber.next(_value);
            subscriber.complete();
        }
    };
    AsyncSubject.prototype.next = function (value) {
        if (!this.isStopped) {
            this._value = value;
            this._hasValue = true;
        }
    };
    AsyncSubject.prototype.complete = function () {
        var _a = this, _hasValue = _a._hasValue, _value = _a._value, _isComplete = _a._isComplete;
        if (!_isComplete) {
            this._isComplete = true;
            _hasValue && _super.prototype.next.call(this, _value);
            _super.prototype.complete.call(this);
        }
    };
    return AsyncSubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]));

//# sourceMappingURL=AsyncSubject.js.map

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_dateTimestampProvider__ = __webpack_require__(77);

var Scheduler = (function () {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) { now = Scheduler.now; }
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) { delay = 0; }
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = __WEBPACK_IMPORTED_MODULE_0__scheduler_dateTimestampProvider__["a" /* dateTimestampProvider */].now;
    return Scheduler;
}());

//# sourceMappingURL=Scheduler.js.map

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = of;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fromArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduled_scheduleArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_args__ = __webpack_require__(20);



function of() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = Object(__WEBPACK_IMPORTED_MODULE_2__util_args__["c" /* popScheduler */])(args);
    return scheduler ? Object(__WEBPACK_IMPORTED_MODULE_1__scheduled_scheduleArray__["a" /* scheduleArray */])(args, scheduler) : Object(__WEBPACK_IMPORTED_MODULE_0__fromArray__["a" /* internalFromArray */])(args);
}
//# sourceMappingURL=of.js.map

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction__ = __webpack_require__(5);

function isPromise(value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__isFunction__["a" /* isFunction */])(value === null || value === void 0 ? void 0 : value.then);
}
//# sourceMappingURL=isPromise.js.map

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scheduled;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduleObservable__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__schedulePromise__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduleArray__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scheduleIterable__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scheduleAsyncIterable__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_isInteropObservable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_isPromise__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_isArrayLike__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_isIterable__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util_isAsyncIterable__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_throwUnobservableError__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_isReadableStreamLike__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__scheduleReadableStreamLike__ = __webpack_require__(183);













function scheduled(input, scheduler) {
    if (input != null) {
        if (Object(__WEBPACK_IMPORTED_MODULE_5__util_isInteropObservable__["a" /* isInteropObservable */])(input)) {
            return Object(__WEBPACK_IMPORTED_MODULE_0__scheduleObservable__["a" /* scheduleObservable */])(input, scheduler);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_7__util_isArrayLike__["a" /* isArrayLike */])(input)) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__scheduleArray__["a" /* scheduleArray */])(input, scheduler);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_6__util_isPromise__["a" /* isPromise */])(input)) {
            return Object(__WEBPACK_IMPORTED_MODULE_1__schedulePromise__["a" /* schedulePromise */])(input, scheduler);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_9__util_isAsyncIterable__["a" /* isAsyncIterable */])(input)) {
            return Object(__WEBPACK_IMPORTED_MODULE_4__scheduleAsyncIterable__["a" /* scheduleAsyncIterable */])(input, scheduler);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_8__util_isIterable__["a" /* isIterable */])(input)) {
            return Object(__WEBPACK_IMPORTED_MODULE_3__scheduleIterable__["a" /* scheduleIterable */])(input, scheduler);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_11__util_isReadableStreamLike__["a" /* isReadableStreamLike */])(input)) {
            return Object(__WEBPACK_IMPORTED_MODULE_12__scheduleReadableStreamLike__["a" /* scheduleReadableStreamLike */])(input, scheduler);
        }
    }
    throw Object(__WEBPACK_IMPORTED_MODULE_10__util_throwUnobservableError__["a" /* createInvalidObservableTypeError */])(input);
}
//# sourceMappingURL=scheduled.js.map

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scheduleIterable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_iterator__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_caughtSchedule__ = __webpack_require__(85);




function scheduleIterable(input, scheduler) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var iterator;
        subscriber.add(scheduler.schedule(function () {
            iterator = input[__WEBPACK_IMPORTED_MODULE_1__symbol_iterator__["a" /* iterator */]]();
            Object(__WEBPACK_IMPORTED_MODULE_3__util_caughtSchedule__["a" /* caughtSchedule */])(subscriber, scheduler, function () {
                var _a = iterator.next(), value = _a.value, done = _a.done;
                if (done) {
                    subscriber.complete();
                }
                else {
                    subscriber.next(value);
                    this.schedule();
                }
            });
        }));
        return function () { return Object(__WEBPACK_IMPORTED_MODULE_2__util_isFunction__["a" /* isFunction */])(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return(); };
    });
}
//# sourceMappingURL=scheduleIterable.js.map

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getSymbolIterator */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return iterator; });
function getSymbolIterator() {
    if (typeof Symbol !== 'function' || !Symbol.iterator) {
        return '@@iterator';
    }
    return Symbol.iterator;
}
var iterator = getSymbolIterator();
//# sourceMappingURL=iterator.js.map

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = caughtSchedule;
function caughtSchedule(subscriber, scheduler, execute, delay) {
    if (delay === void 0) { delay = 0; }
    var subscription = scheduler.schedule(function () {
        try {
            execute.call(this);
        }
        catch (err) {
            subscriber.error(err);
        }
    }, delay);
    subscriber.add(subscription);
    return subscription;
}
//# sourceMappingURL=caughtSchedule.js.map

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scheduleAsyncIterable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(13);


function scheduleAsyncIterable(input, scheduler) {
    if (!input) {
        throw new Error('Iterable cannot be null');
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["b" /* Subscription */]();
        sub.add(scheduler.schedule(function () {
            var iterator = input[Symbol.asyncIterator]();
            sub.add(scheduler.schedule(function () {
                var _this = this;
                iterator.next().then(function (result) {
                    if (result.done) {
                        subscriber.complete();
                    }
                    else {
                        subscriber.next(result.value);
                        _this.schedule();
                    }
                });
            }));
        }));
        return sub;
    });
}
//# sourceMappingURL=scheduleAsyncIterable.js.map

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isInteropObservable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_observable__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction__ = __webpack_require__(5);


function isInteropObservable(input) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__isFunction__["a" /* isFunction */])(input[__WEBPACK_IMPORTED_MODULE_0__symbol_observable__["a" /* observable */]]);
}
//# sourceMappingURL=isInteropObservable.js.map

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isIterable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbol_iterator__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction__ = __webpack_require__(5);


function isIterable(input) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__isFunction__["a" /* isFunction */])(input === null || input === void 0 ? void 0 : input[__WEBPACK_IMPORTED_MODULE_0__symbol_iterator__["a" /* iterator */]]);
}
//# sourceMappingURL=isIterable.js.map

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAsyncIterable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction__ = __webpack_require__(5);

function isAsyncIterable(obj) {
    return Symbol.asyncIterator && Object(__WEBPACK_IMPORTED_MODULE_0__isFunction__["a" /* isFunction */])(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}
//# sourceMappingURL=isAsyncIterable.js.map

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createInvalidObservableTypeError;
function createInvalidObservableTypeError(input) {
    return new TypeError("You provided " + (input !== null && typeof input === 'object' ? 'an invalid object' : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
//# sourceMappingURL=throwUnobservableError.js.map

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = throwError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isFunction__ = __webpack_require__(5);


function throwError(errorOrErrorFactory, scheduler) {
    var errorFactory = Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(errorOrErrorFactory) ? errorOrErrorFactory : function () { return errorOrErrorFactory; };
    var init = function (subscriber) { return subscriber.error(errorFactory()); };
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](scheduler ? function (subscriber) { return scheduler.schedule(init, 0, subscriber); } : init);
}
//# sourceMappingURL=throwError.js.map

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidDate;
function isValidDate(value) {
    return value instanceof Date && !isNaN(value);
}
//# sourceMappingURL=isDate.js.map

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindCallbackInternals;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isScheduler__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operators_subscribeOn__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_mapOneOrManyArgs__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__operators_observeOn__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AsyncSubject__ = __webpack_require__(78);







function bindCallbackInternals(isNodeStyle, callbackFunc, resultSelector, scheduler) {
    if (resultSelector) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__util_isScheduler__["a" /* isScheduler */])(resultSelector)) {
            scheduler = resultSelector;
        }
        else {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return bindCallbackInternals(isNodeStyle, callbackFunc, scheduler)
                    .apply(this, args)
                    .pipe(Object(__WEBPACK_IMPORTED_MODULE_4__util_mapOneOrManyArgs__["a" /* mapOneOrManyArgs */])(resultSelector));
            };
        }
    }
    if (scheduler) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return bindCallbackInternals(isNodeStyle, callbackFunc)
                .apply(this, args)
                .pipe(Object(__WEBPACK_IMPORTED_MODULE_3__operators_subscribeOn__["a" /* subscribeOn */])(scheduler), Object(__WEBPACK_IMPORTED_MODULE_5__operators_observeOn__["a" /* observeOn */])(scheduler));
        };
    }
    return function () {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var subject = new __WEBPACK_IMPORTED_MODULE_6__AsyncSubject__["a" /* AsyncSubject */]();
        var uninitialized = true;
        return new __WEBPACK_IMPORTED_MODULE_2__Observable__["a" /* Observable */](function (subscriber) {
            var subs = subject.subscribe(subscriber);
            if (uninitialized) {
                uninitialized = false;
                var isAsync_1 = false;
                var isComplete_1 = false;
                callbackFunc.apply(_this, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])([], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(args)), [
                    function () {
                        var results = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            results[_i] = arguments[_i];
                        }
                        if (isNodeStyle) {
                            var err = results.shift();
                            if (err != null) {
                                subject.error(err);
                                return;
                            }
                        }
                        subject.next(1 < results.length ? results : results[0]);
                        isComplete_1 = true;
                        if (isAsync_1) {
                            subject.complete();
                        }
                    },
                ]));
                if (isComplete_1) {
                    subject.complete();
                }
                isAsync_1 = true;
            }
            return subs;
        });
    };
}
//# sourceMappingURL=bindCallbackInternals.js.map

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = map;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_lift__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OperatorSubscriber__ = __webpack_require__(12);


function map(project, thisArg) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util_lift__["b" /* operate */])(function (source, subscriber) {
        var index = 0;
        source.subscribe(new __WEBPACK_IMPORTED_MODULE_1__OperatorSubscriber__["a" /* OperatorSubscriber */](subscriber, function (value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}
//# sourceMappingURL=map.js.map

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = argsArgArrayOrObject;
var isArray = Array.isArray;
var getPrototypeOf = Object.getPrototypeOf, objectProto = Object.prototype, getKeys = Object.keys;
function argsArgArrayOrObject(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if (isArray(first_1)) {
            return { args: first_1, keys: null };
        }
        if (isPOJO(first_1)) {
            var keys = getKeys(first_1);
            return {
                args: keys.map(function (key) { return first_1[key]; }),
                keys: keys,
            };
        }
    }
    return { args: args, keys: null };
}
function isPOJO(obj) {
    return obj && typeof obj === 'object' && getPrototypeOf(obj) === objectProto;
}
//# sourceMappingURL=argsArgArrayOrObject.js.map

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createObject;
function createObject(keys, values) {
    return keys.reduce(function (result, key, i) { return ((result[key] = values[i]), result); }, {});
}
//# sourceMappingURL=createObject.js.map

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeMap__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_identity__ = __webpack_require__(22);


function mergeAll(concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    return Object(__WEBPACK_IMPORTED_MODULE_0__mergeMap__["a" /* mergeMap */])(__WEBPACK_IMPORTED_MODULE_1__util_identity__["a" /* identity */], concurrent);
}
//# sourceMappingURL=mergeAll.js.map

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_from__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_lift__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mergeInternals__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isFunction__ = __webpack_require__(5);





function mergeMap(project, resultSelector, concurrent) {
    if (concurrent === void 0) { concurrent = Infinity; }
    if (Object(__WEBPACK_IMPORTED_MODULE_4__util_isFunction__["a" /* isFunction */])(resultSelector)) {
        return mergeMap(function (a, i) { return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* map */])(function (b, ii) { return resultSelector(a, b, i, ii); })(Object(__WEBPACK_IMPORTED_MODULE_1__observable_from__["c" /* innerFrom */])(project(a, i))); }, concurrent);
    }
    else if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__util_lift__["b" /* operate */])(function (source, subscriber) { return Object(__WEBPACK_IMPORTED_MODULE_3__mergeInternals__["a" /* mergeInternals */])(source, subscriber, project, concurrent); });
}
//# sourceMappingURL=mergeMap.js.map

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__scheduler_async__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isScheduler__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isDate__ = __webpack_require__(92);




function timer(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) { dueTime = 0; }
    if (scheduler === void 0) { scheduler = __WEBPACK_IMPORTED_MODULE_1__scheduler_async__["a" /* async */]; }
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__util_isScheduler__["a" /* isScheduler */])(intervalOrScheduler)) {
            scheduler = intervalOrScheduler;
        }
        else {
            intervalDuration = intervalOrScheduler;
        }
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var due = Object(__WEBPACK_IMPORTED_MODULE_3__util_isDate__["a" /* isValidDate */])(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) {
            due = 0;
        }
        var n = 0;
        return scheduler.schedule(function () {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) {
                    this.schedule(undefined, intervalDuration);
                }
                else {
                    subscriber.complete();
                }
            }
        }, due);
    });
}
//# sourceMappingURL=timer.js.map

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NEVER */
/* unused harmony export never */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_noop__ = __webpack_require__(35);


var NEVER = new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](__WEBPACK_IMPORTED_MODULE_1__util_noop__["a" /* noop */]);
function never() {
    return NEVER;
}
//# sourceMappingURL=never.js.map

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(221);


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Person; });
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Person=function(){function Person(nameOrPerson,id,organization,email,account){_classCallCheck(this,Person);this.name=nameOrPerson||"";this.competitionId=id||"";this.organization=organization||"";this.email=email||"";this.account=account||"";if((typeof nameOrPerson==="undefined"?"undefined":_typeof(nameOrPerson))==="object"){this.name=nameOrPerson.name;this.competitionId=nameOrPerson.competitionId||"";this.organization=nameOrPerson.organization||"";this.email=nameOrPerson.email||"";this.account=nameOrPerson.account||"";}this.email=this.email.trim();}_createClass(Person,[{key:"setDefaultOrganization",value:function setDefaultOrganization(organization){if([this.name,this.competitionId,this.organization,this.email,this.account].some(function(v){return v&&v!=="";})){if(!this.organization){this.organization=organization;}}}},{key:"toJson",value:function toJson(){return{name:this.name,email:this.email.trim(),organization:this.organization,account:this.account};}}],[{key:"fromJson",value:function fromJson(json){return new Person(json.name||"",json.competitionId||"",json.organization||"",json.email?json.email.trim():"",json.account||"");}}]);return Person;}();

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParticipantScore; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ParticipantScore=function(){function ParticipantScore(id,name,org,squad,division,cls,scores,eventId,eventName,position,note,redo,support){_classCallCheck(this,ParticipantScore);this.id=id;this.name=name;this.organization=org;this.squad=squad;this.scores=scores||[];this.class=cls==null?cls:division==="C"?cls.split('/')[0]:cls.slice(cls.indexOf('/')+1);this.division=division;this.eventId=eventId;this.eventName=eventName;this.position=position;this.note=note||"";this.redo=redo||0;this.support=support||0;}_createClass(ParticipantScore,[{key:'getScores',value:function getScores(stage){return this.scores.find(function(s){return s.stage===stage;});}},{key:'getScore',value:function getScore(stage,target){var score=this.getScores(stage);return score&&score.values[target];}},{key:'setScore',value:function setScore(stage,target,value){var score=this.getScores(stage);if(score==null){score={stage:stage,values:[]};this.scores.push(score);}score.values[target]=value;}},{key:'getStageTotal',value:function getStageTotal(stageDef){var score=this.getScores(stageDef.num);if(score==null)return"0/0";var values=score.values.slice(0,stageDef.targets);return values.filter(function(v){return v!==undefined;}).reduce(function(a,b){return a+b;},0)+'/'+values.filter(function(s){return s>0;}).length;}},{key:'getPrecisionTotal',value:function getPrecisionTotal(stage){var score=this.getScores(stage);if(score==null)return"0";return''+score.values.filter(function(v){return v!==undefined;}).map(function(x){return x==="X"?10:x;}).reduce(function(a,b){return a+b;},0);}},{key:'getTotal',value:function getTotal(){return"0";}},{key:'toStageJson',value:function toStageJson(stage){return Object.assign({},this,{score:this.scores.filter(function(n){return stage===undefined||n.stage===stage;})});}}],[{key:'fromJson',value:function fromJson(json){return new ParticipantScore(parseInt(json.id,10),json.name,json.organization,parseInt(json.squad,10),json.division,json.class,json.score.map(function(s){return{stage:parseInt(s.stage,10),values:s.values.map(function(n){return n==="X"?"X":parseInt(n,10);})};}),parseInt(json.event_id,10),json.event_name,parseInt(json.position,10),json.note,parseInt(json.redo,10)||0,parseInt(json.support,10)||0);}}]);return ParticipantScore;}();

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Team; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Team=function(){function Team(name,event,index,teamDefID){_classCallCheck(this,Team);this.name=name;this.event=event;this.index=index;this.members=[];this.alternates=[];this.team_definition_id=teamDefID;this.checkInitialized("name","event","index");}_createClass(Team,[{key:"checkInitialized",value:function checkInitialized(){var _this=this;for(var _len=arguments.length,props=Array(_len),_key=0;_key<_len;_key++){props[_key]=arguments[_key];}props.forEach(function(prop){if(_this[prop]===undefined){throw new Error("Property "+prop+" is undefined");}});}},{key:"toJson",value:function toJson(){return{name:this.name,event:this.event,index:this.index,members:this.members.filter(function(x){return x!==undefined;}),alternates:this.alternates.filter(function(x){return x!==undefined;}),team_definition_id:this.team_definition_id};}}],[{key:"fromJson",value:function fromJson(json){var nt=new Team(json.name,parseInt(json.event,10),parseInt(json.index,10));nt.members=json.members.map(function(m){return parseInt(m,10);});nt.alternates=json.alternates.map(function(a){return parseInt(a,10);});if(json.team_definition_id)nt.id=parseInt(json.team_definition_id,10);return nt;}}]);return Team;}();

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CenturyView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CenturyView_Decades__ = __webpack_require__(260);


function CenturyView(props) {
  function renderDecades() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__CenturyView_Decades__["a" /* default */], props);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "react-calendar__century-view"
  }, renderDecades());
}

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = between;
/* unused harmony export isValueWithinRange */
/* unused harmony export isRangeWithinRange */
/* unused harmony export doRangesOverlap */
/* harmony export (immutable) */ __webpack_exports__["b"] = getTileClasses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dates__ = __webpack_require__(14);
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


/**
 * Returns a value no smaller than min and no larger than max.
 *
 * @param {*} value Value to return.
 * @param {*} min Minimum return value.
 * @param {*} max Maximum return value.
 */

function between(value, min, max) {
  if (min && min > value) {
    return min;
  }

  if (max && max < value) {
    return max;
  }

  return value;
}
function isValueWithinRange(value, range) {
  return range[0] <= value && range[1] >= value;
}
function isRangeWithinRange(greaterRange, smallerRange) {
  return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
}
function doRangesOverlap(range1, range2) {
  return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
}

function getRangeClassNames(valueRange, dateRange, baseClassName) {
  var isRange = doRangesOverlap(dateRange, valueRange);
  var classes = [];

  if (isRange) {
    classes.push(baseClassName);
    var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
    var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);

    if (isRangeStart) {
      classes.push("".concat(baseClassName, "Start"));
    }

    if (isRangeEnd) {
      classes.push("".concat(baseClassName, "End"));
    }

    if (isRangeStart && isRangeEnd) {
      classes.push("".concat(baseClassName, "BothEnds"));
    }
  }

  return classes;
}

function getTileClasses() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      value = _ref.value,
      valueType = _ref.valueType,
      date = _ref.date,
      dateType = _ref.dateType,
      hover = _ref.hover;

  var className = 'react-calendar__tile';
  var classes = [className];

  if (!date) {
    return classes;
  }

  if (!Array.isArray(date) && !dateType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }

  var now = new Date();
  var dateRange = Array.isArray(date) ? date : Object(__WEBPACK_IMPORTED_MODULE_0__dates__["o" /* getRange */])(dateType, date);

  if (isValueWithinRange(now, dateRange)) {
    classes.push("".concat(className, "--now"));
  }

  if (!value) {
    return classes;
  }

  if (!Array.isArray(value) && !valueType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }

  var valueRange = Array.isArray(value) ? value : Object(__WEBPACK_IMPORTED_MODULE_0__dates__["o" /* getRange */])(valueType, value);

  if (isRangeWithinRange(valueRange, dateRange)) {
    classes.push("".concat(className, "--active"));
  } else if (doRangesOverlap(valueRange, dateRange)) {
    classes.push("".concat(className, "--hasActive"));
  }

  var valueRangeClassNames = getRangeClassNames(valueRange, dateRange, "".concat(className, "--range"));
  classes.push.apply(classes, _toConsumableArray(valueRangeClassNames));

  if (hover) {
    var hoverRange = hover > valueRange[1] ? [valueRange[1], hover] : [hover, valueRange[0]];
    var hoverRangeClassNames = getRangeClassNames(hoverRange, dateRange, "".concat(className, "--hover"));
    classes.push.apply(classes, _toConsumableArray(hoverRangeClassNames));
  }

  return classes;
}

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DecadeView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DecadeView_Years__ = __webpack_require__(262);


function DecadeView(props) {
  function renderYears() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__DecadeView_Years__["a" /* default */], props);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "react-calendar__decade-view"
  }, renderYears());
}

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = YearView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__YearView_Months__ = __webpack_require__(264);


function YearView(props) {
  function renderMonths() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__YearView_Months__["a" /* default */], props);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: "react-calendar__year-view"
  }, renderMonths());
}

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MonthView;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MonthView_Days__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MonthView_Weekdays__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MonthView_WeekNumbers__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_const__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__ = __webpack_require__(9);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }









function getCalendarTypeFromLocale(locale) {
  return Object.keys(__WEBPACK_IMPORTED_MODULE_5__shared_const__["b" /* CALENDAR_TYPE_LOCALES */]).find(function (calendarType) {
    return __WEBPACK_IMPORTED_MODULE_5__shared_const__["b" /* CALENDAR_TYPE_LOCALES */][calendarType].includes(locale);
  }) || __WEBPACK_IMPORTED_MODULE_5__shared_const__["a" /* CALENDAR_TYPES */].ISO_8601;
}

function MonthView(props) {
  var activeStartDate = props.activeStartDate,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;

  var _props$calendarType = props.calendarType,
      calendarType = _props$calendarType === void 0 ? getCalendarTypeFromLocale(locale) : _props$calendarType,
      formatShortWeekday = props.formatShortWeekday,
      onClickWeekNumber = props.onClickWeekNumber,
      showWeekNumbers = props.showWeekNumbers,
      childProps = _objectWithoutProperties(props, ["calendarType", "formatShortWeekday", "onClickWeekNumber", "showWeekNumbers"]);

  function renderWeekdays() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__MonthView_Weekdays__["a" /* default */], {
      calendarType: calendarType,
      formatShortWeekday: formatShortWeekday,
      locale: locale,
      onMouseLeave: onMouseLeave
    });
  }

  function renderWeekNumbers() {
    if (!showWeekNumbers) {
      return null;
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__MonthView_WeekNumbers__["a" /* default */], {
      activeStartDate: activeStartDate,
      calendarType: calendarType,
      onClickWeekNumber: onClickWeekNumber,
      onMouseLeave: onMouseLeave,
      showFixedNumberOfWeeks: showFixedNumberOfWeeks
    });
  }

  function renderDays() {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__MonthView_Days__["a" /* default */], _extends({
      calendarType: calendarType
    }, childProps));
  }

  var className = 'react-calendar__month-view';
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: [className, showWeekNumbers ? "".concat(className, "--weekNumbers") : ''].join(' ')
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, renderWeekNumbers(), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    style: {
      flexGrow: 1,
      width: '100%'
    }
  }, renderWeekdays(), renderDays())));
}
MonthView.propTypes = {
  activeStartDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,
  calendarType: __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__["a" /* isCalendarType */],
  formatShortWeekday: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onClickWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showFixedNumberOfWeeks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFormatter = getFormatter;
exports.formatShortMonth = exports.formatMonth = void 0;

var _getUserLocale = _interopRequireDefault(__webpack_require__(52));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getFormatter(options) {
  return function (locale, date) {
    return date.toLocaleString(locale || (0, _getUserLocale["default"])(), options);
  };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 */


function toSafeHour(date) {
  var safeDate = new Date(date);
  return new Date(safeDate.setHours(12));
}

function getSafeFormatter(options) {
  return function (locale, date) {
    return getFormatter(options)(locale, toSafeHour(date));
  };
}

var formatMonthOptions = {
  month: 'long'
};
var formatShortMonthOptions = {
  month: 'short'
};
var formatMonth = getSafeFormatter(formatMonthOptions);
exports.formatMonth = formatMonth;
var formatShortMonth = getSafeFormatter(formatShortMonthOptions);
exports.formatShortMonth = formatShortMonth;

/***/ }),
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegistrationRow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegistrationRow=function(_React$Component){_inherits(RegistrationRow,_React$Component);function RegistrationRow(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RegistrationRow);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegistrationRow.__proto__||Object.getPrototypeOf(RegistrationRow)).call.apply(_ref,[this].concat(args))),_this),_this.EventControls=function(_ref2){var row=_ref2.row,numRows=_ref2.numRows,participant=_ref2.participant,event=_ref2.event;var eventInfo=participant.event(event.id)||{event:event.id,rounds:[{}]};var controls=[];if(event.classes&&_this.Competition.classes(event.classes)){controls.push(row===0?_this.classDropdown(numRows,participant.id,event,eventInfo.class,_this.Competition.classes(event.classes)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:participant.uniqueId+'cls'+event.id}));}if(event.divisions&&_this.Competition.divisions(event.divisions)){controls.push(_this.divisionDropdown(row,participant.id,event.id,eventInfo.rounds,_this.Competition.divisions(event.divisions)));}if(event.schedule){controls.push(_this.addRoundButton(row,participant,event,eventInfo.rounds));controls.push(_this.scheduleButton(row,participant,event,eventInfo.rounds));controls.push(_this.deleteRoundButton(row,participant,event,eventInfo.rounds));}if(controls.length===0&&row===0){controls.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'participate',className:'center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',className:'checkbox',onChange:function onChange(c){return _this.Registration.setParticipantEvent(participant.id,event.id,c.target.checked);},checked:participant.participate(event.id)})));}return controls;},_this.RegistrationControls=function(_ref3){var row=_ref3.row,num_rows=_ref3.num_rows,participant=_ref3.participant;return _this.props.events.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.EventControls,{key:participant.uniqueId+'ev'+e.id+row,row:row,num_rows:num_rows,participant:participant,event:e});});},_this.NewRegistrationField=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'left',rowSpan:props.numRows},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'participant-header'},props.header_name),props.club_selector==="clubs"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.ClubSelector,props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({type:'text'},props))));},_this.RegistrationField=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'left',rowSpan:props.numRows},props.club_selector==="clubs"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.ClubSelector,props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({type:'text'},props)));},_this.NewParticipantFields=function(_ref4){var num_rows=_ref4.num_rows,participant=_ref4.participant;return _this.Competition.participantHeaders().map(function(h){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.RegistrationField,{key:h.field,value:participant[h.field],placeholder:h.placeholder||h.name,style:{width:h.width},num_rows:num_rows,size:h.size,onChange:function onChange(e){return _this.Registration.setParticipantField(participant.id,h.field,e.target.value);},club_selector:h.type,header_name:h.name});});},_this.ParticipantFields=function(_ref5){var num_rows=_ref5.num_rows,participant=_ref5.participant;return _this.Competition.participantHeaders().map(function(h){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.RegistrationField,{key:participant.uniqueId+h.field,value:participant[h.field],placeholder:h.placeholder||h.name,style:{width:h.width},num_rows:num_rows,size:h.size,onChange:function onChange(e){return _this.Registration.setParticipantField(participant.id,h.field,e.target.value);},club_selector:h.type});});},_this.ParticipantRow=function(_ref6){var row=_ref6.row,num_rows=_ref6.num_rows,participant=_ref6.participant;var p=participant;if(!p.uniqueId)p.uniqueId=RegistrationRow.pId++;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',{className:p.errors.length>0?"error registration":"registration"},row===0?_this.ParticipantFields({num_rows:num_rows,participant:p}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{colSpan:_this.Competition.participantHeaders().length}),_this.RegistrationControls({row:row,num_rows:num_rows,participant:p}),row===0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'vcenter tooltip',style:{position:"relative"},tooltip:'Ta bort deltagare','tooltip-position':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button-close small red',onClick:function onClick(e){return _this.fire(_this.Events.deleteParticipant,p.id);}})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RegistrationRow,[{key:'classDropdown',value:function classDropdown(numRows,participantId,event,value,values){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'c'+event.id,rowSpan:numRows},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["Dropdown"],{placeholder:'V\xE4lj klass...',value:value,list:values.map(function(v){return{id:v,description:v};}),onChange:function onChange(e){return _this3.Registration.setParticipantClass(participantId,event,e.target.value);}}));}},{key:'divisionDropdown',value:function divisionDropdown(row,participantId,eventId,rounds,values){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'d'+eventId+row,className:'division vcenter'},row<rounds.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["Dropdown"],{placeholder:'V\xE4lj vapengrupp...',value:rounds[row].division,list:values.filter(function(v){return!v.includes('+');}).map(function(v){return{id:v,description:v};}),onChange:function onChange(e){return _this4.Registration.setParticipantDivision(participantId,eventId,row,e.target.value);}}));}},{key:'scheduleButton',value:function scheduleButton(row,participant,event,rounds){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'s'+event.id+row,className:'vcenter'},row<rounds.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'scheduleButton',onClick:function onClick(e){return _this5.fire(_this5.Events.showSchedule,participant,event,row);}},participant.getStartTime(event.id,row)||"Välj starttid"));}},{key:'addRoundButton',value:function addRoundButton(row,participant,event,rounds){var _this6=this;if(event.maxRegistrations>1){if(row>0||rounds.length===event.maxRegistrations)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'r'+event.id+row});else return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'r'+event.id+row,className:'vcenter tooltip',style:{position:"relative"},tooltip:'L\xE4gg till ytterligare starttid','tooltip-position':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button-add small',onClick:function onClick(e){return _this6.Registration.addParticipantRound(participant.id,event.id);}}));}}},{key:'deleteRoundButton',value:function deleteRoundButton(row,participant,event,rounds){var _this7=this;if(event.maxRegistrations>1){if(rounds.length>1&&row<rounds.length)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'x'+event.id+row,className:'vcenter tooltip',style:{position:"relative"},tooltip:'Ta bort starttid','tooltip-position':'top'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button-close small red deleteButton',onClick:function onClick(e){return _this7.Registration.deleteParticipantRound(participant.id,event.id,row);}}));else return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:'x'+event.id+row});}}},{key:'numRounds',value:function numRounds(participant){var maxRound=1;participant.registrationInfo.forEach(function(e){if(e.rounds&&e.rounds.length>maxRound){maxRound=e.rounds.length;}});return maxRound;}},{key:'render',value:function render(){var rows=[];var p=this.props.participant;var numRows=this.numRounds(p);for(var i=0;i<numRows;i++){rows.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.ParticipantRow,{key:p.id+'+'+i,row:i,num_rows:numRows,participant:p,events:this.props.events}));}return rows;}}]);return RegistrationRow;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);RegistrationRow.register={name:"RegistrationRow"};RegistrationRow.wire=["fire","Competition","Registration","Events","ClubSelector"];RegistrationRow.pId=1;

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompetitionTests__ = __webpack_require__(362);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CompetitionTests", function() { return __WEBPACK_IMPORTED_MODULE_0__CompetitionTests__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ScheduleTests__ = __webpack_require__(363);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScheduleTests", function() { return __WEBPACK_IMPORTED_MODULE_1__ScheduleTests__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DivisionsTests__ = __webpack_require__(364);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DivisionsTests", function() { return __WEBPACK_IMPORTED_MODULE_2__DivisionsTests__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ClassesTests__ = __webpack_require__(365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClassesTests", function() { return __WEBPACK_IMPORTED_MODULE_3__ClassesTests__["a"]; });


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118);
module.exports = __webpack_require__(124);


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(119).enable();
  window.Promise = __webpack_require__(121);
}

// fetch() polyfill for making API calls.
__webpack_require__(122);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(123);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(58);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(59)))

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(58);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 122 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Buttons_css__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__general_Buttons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__general_Buttons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_Colors_css__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_Colors_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__general_Colors_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_Controls_css__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general_Controls_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__general_Controls_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__registerServiceWorker__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__logic_Injector_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__logic__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__test__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__App__ = __webpack_require__(373);
window._debug=true;var injector=new __WEBPACK_IMPORTED_MODULE_7__logic_Injector_js__["a" /* AutoInjector */]();injector.registerModule(__WEBPACK_IMPORTED_MODULE_8__components__);injector.registerModule(__WEBPACK_IMPORTED_MODULE_9__models__);injector.registerModule(__WEBPACK_IMPORTED_MODULE_10__logic__);injector.registerModule(__WEBPACK_IMPORTED_MODULE_11__views__);injector.registerModule(__WEBPACK_IMPORTED_MODULE_12__test__);injector.register(__WEBPACK_IMPORTED_MODULE_13__App__["a" /* App */]);// ToDo: Implement method registration
var eb=injector.EventBus;var fire=eb.fire.bind(eb);var subscribe=eb.subscribe.bind(eb);fire.register={name:"fire"};subscribe.register={name:"subscribe"};injector.register(fire);injector.register(subscribe);injector.inject();__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(injector.App,null),document.getElementById('root'));Object(__WEBPACK_IMPORTED_MODULE_6__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l=__webpack_require__(60),n=60103,p=60106;exports.Fragment=60107;exports.StrictMode=60108;exports.Profiler=60114;var q=60109,r=60110,t=60112;exports.Suspense=60113;var u=60115,v=60116;
if("function"===typeof Symbol&&Symbol.for){var w=Symbol.for;n=w("react.element");p=w("react.portal");exports.Fragment=w("react.fragment");exports.StrictMode=w("react.strict_mode");exports.Profiler=w("react.profiler");q=w("react.provider");r=w("react.context");t=w("react.forward_ref");exports.Suspense=w("react.suspense");u=w("react.memo");v=w("react.lazy")}var x="function"===typeof Symbol&&Symbol.iterator;
function y(a){if(null===a||"object"!==typeof a)return null;a=x&&a[x]||a["@@iterator"];return"function"===typeof a?a:null}function z(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var A={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},B={};function C(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}C.prototype.isReactComponent={};C.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(z(85));this.updater.enqueueSetState(this,a,b,"setState")};C.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function D(){}D.prototype=C.prototype;function E(a,b,c){this.props=a;this.context=b;this.refs=B;this.updater=c||A}var F=E.prototype=new D;F.constructor=E;l(F,C.prototype);F.isPureReactComponent=!0;var G={current:null},H=Object.prototype.hasOwnProperty,I={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,c){var e,d={},k=null,h=null;if(null!=b)for(e in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)H.call(b,e)&&!I.hasOwnProperty(e)&&(d[e]=b[e]);var g=arguments.length-2;if(1===g)d.children=c;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];d.children=f}if(a&&a.defaultProps)for(e in g=a.defaultProps,g)void 0===d[e]&&(d[e]=g[e]);return{$$typeof:n,type:a,key:k,ref:h,props:d,_owner:G.current}}
function K(a,b){return{$$typeof:n,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function L(a){return"object"===typeof a&&null!==a&&a.$$typeof===n}function escape(a){var b={"=":"=0",":":"=2"};return"$"+a.replace(/[=:]/g,function(a){return b[a]})}var M=/\/+/g;function N(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
function O(a,b,c,e,d){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case n:case p:h=!0}}if(h)return h=a,d=d(h),a=""===e?"."+N(h,0):e,Array.isArray(d)?(c="",null!=a&&(c=a.replace(M,"$&/")+"/"),O(d,b,c,"",function(a){return a})):null!=d&&(L(d)&&(d=K(d,c+(!d.key||h&&h.key===d.key?"":(""+d.key).replace(M,"$&/")+"/")+a)),b.push(d)),1;h=0;e=""===e?".":e+":";if(Array.isArray(a))for(var g=
0;g<a.length;g++){k=a[g];var f=e+N(k,g);h+=O(k,b,c,f,d)}else if(f=y(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=e+N(k,g++),h+=O(k,b,c,f,d);else if("object"===k)throw b=""+a,Error(z(31,"[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b));return h}function P(a,b,c){if(null==a)return a;var e=[],d=0;O(a,e,"","",function(a){return b.call(c,a,d++)});return e}
function Q(a){if(-1===a._status){var b=a._result;b=b();a._status=0;a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}if(1===a._status)return a._result;throw a._result;}var R={current:null};function S(){var a=R.current;if(null===a)throw Error(z(321));return a}var T={ReactCurrentDispatcher:R,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:G,IsSomeRendererActing:{current:!1},assign:l};
exports.Children={map:P,forEach:function(a,b,c){P(a,function(){b.apply(this,arguments)},c)},count:function(a){var b=0;P(a,function(){b++});return b},toArray:function(a){return P(a,function(a){return a})||[]},only:function(a){if(!L(a))throw Error(z(143));return a}};exports.Component=C;exports.PureComponent=E;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(z(267,a));var e=l({},a.props),d=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=G.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)H.call(b,f)&&!I.hasOwnProperty(f)&&(e[f]=void 0===b[f]&&void 0!==g?g[f]:b[f])}var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){g=Array(f);for(var m=0;m<f;m++)g[m]=arguments[m+2];e.children=g}return{$$typeof:n,type:a.type,
key:d,ref:k,props:e,_owner:h}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:r,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:q,_context:a};return a.Consumer=a};exports.createElement=J;exports.createFactory=function(a){var b=J.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:t,render:a}};exports.isValidElement=L;
exports.lazy=function(a){return{$$typeof:v,_payload:{_status:-1,_result:a},_init:Q}};exports.memo=function(a,b){return{$$typeof:u,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return S().useCallback(a,b)};exports.useContext=function(a,b){return S().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return S().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return S().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return S().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return S().useMemo(a,b)};exports.useReducer=function(a,b,c){return S().useReducer(a,b,c)};exports.useRef=function(a){return S().useRef(a)};exports.useState=function(a){return S().useState(a)};exports.version="17.0.2";


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),m=__webpack_require__(60),r=__webpack_require__(131);function y(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(y(227));var ba=new Set,ca={};function da(a,b){ea(a,b);ea(a+"Capture",b)}
function ea(a,b){ca[a]=b;for(a=0;a<b.length;a++)ba.add(b[a])}
var fa=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ia=Object.prototype.hasOwnProperty,
ja={},ka={};function la(a){if(ia.call(ka,a))return!0;if(ia.call(ja,a))return!1;if(ha.test(a))return ka[a]=!0;ja[a]=!0;return!1}function ma(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function na(a,b,c,d){if(null===b||"undefined"===typeof b||ma(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1,!1)});var oa=/[\-:]([a-z])/g;function pa(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(oa,
pa);D[b]=new B(b,1,!1,a,null,!1,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0,!0)});
function qa(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(na(b,c,e,d)&&(c=null),d||null===e?la(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var ra=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,sa=60103,ta=60106,ua=60107,wa=60108,xa=60114,ya=60109,za=60110,Aa=60112,Ba=60113,Ca=60120,Da=60115,Ea=60116,Fa=60121,Ga=60128,Ha=60129,Ia=60130,Ja=60131;
if("function"===typeof Symbol&&Symbol.for){var E=Symbol.for;sa=E("react.element");ta=E("react.portal");ua=E("react.fragment");wa=E("react.strict_mode");xa=E("react.profiler");ya=E("react.provider");za=E("react.context");Aa=E("react.forward_ref");Ba=E("react.suspense");Ca=E("react.suspense_list");Da=E("react.memo");Ea=E("react.lazy");Fa=E("react.block");E("react.scope");Ga=E("react.opaque.id");Ha=E("react.debug_trace_mode");Ia=E("react.offscreen");Ja=E("react.legacy_hidden")}
var Ka="function"===typeof Symbol&&Symbol.iterator;function La(a){if(null===a||"object"!==typeof a)return null;a=Ka&&a[Ka]||a["@@iterator"];return"function"===typeof a?a:null}var Ma;function Na(a){if(void 0===Ma)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);Ma=b&&b[1]||""}return"\n"+Ma+a}var Oa=!1;
function Pa(a,b){if(!a||Oa)return"";Oa=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[])}catch(k){var d=k}Reflect.construct(a,[],b)}else{try{b.call()}catch(k){d=k}a.call(b.prototype)}else{try{throw Error();}catch(k){d=k}a()}}catch(k){if(k&&d&&"string"===typeof k.stack){for(var e=k.stack.split("\n"),
f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h])return"\n"+e[g].replace(" at new "," at ");while(1<=g&&0<=h)}break}}}finally{Oa=!1,Error.prepareStackTrace=c}return(a=a?a.displayName||a.name:"")?Na(a):""}
function Qa(a){switch(a.tag){case 5:return Na(a.type);case 16:return Na("Lazy");case 13:return Na("Suspense");case 19:return Na("SuspenseList");case 0:case 2:case 15:return a=Pa(a.type,!1),a;case 11:return a=Pa(a.type.render,!1),a;case 22:return a=Pa(a.type._render,!1),a;case 1:return a=Pa(a.type,!0),a;default:return""}}
function Ra(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ua:return"Fragment";case ta:return"Portal";case xa:return"Profiler";case wa:return"StrictMode";case Ba:return"Suspense";case Ca:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case za:return(a.displayName||"Context")+".Consumer";case ya:return(a._context.displayName||"Context")+".Provider";case Aa:var b=a.render;b=b.displayName||b.name||"";
return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");case Da:return Ra(a.type);case Fa:return Ra(a._render);case Ea:b=a._payload;a=a._init;try{return Ra(a(b))}catch(c){}}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Ta(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a))}function Wa(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
function Ya(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function $a(a,b){b=b.checked;null!=b&&qa(a,"checked",b,!1)}
function ab(a,b){$a(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?bb(a,b.type,c):b.hasOwnProperty("defaultValue")&&bb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function cb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function bb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function db(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function eb(a,b){a=m({children:void 0},b);if(b=db(b.children))a.children=b;return a}
function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(y(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(y(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(y(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:Sa(c)}}
function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var kb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function lb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function mb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?lb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var nb,ob=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==kb.svg||"innerHTML"in a)a.innerHTML=b;else{nb=nb||document.createElement("div");nb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=nb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function pb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var qb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},rb=["Webkit","ms","Moz","O"];Object.keys(qb).forEach(function(a){rb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qb[b]=qb[a]})});function sb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qb.hasOwnProperty(a)&&qb[a]?(""+b).trim():b+"px"}
function tb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=sb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var ub=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function vb(a,b){if(b){if(ub[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(y(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(y(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(y(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(y(62));}}
function wb(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(y(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b))}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a])}}function Gb(a,b){return a(b)}function Hb(a,b,c,d,e){return a(b,c,d,e)}function Ib(){}var Jb=Gb,Kb=!1,Lb=!1;function Mb(){if(null!==zb||null!==Ab)Ib(),Fb()}
function Nb(a,b,c){if(Lb)return a(b,c);Lb=!0;try{return Jb(a,b,c)}finally{Lb=!1,Mb()}}
function Ob(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==
typeof c)throw Error(y(231,b,typeof c));return c}var Pb=!1;if(fa)try{var Qb={};Object.defineProperty(Qb,"passive",{get:function(){Pb=!0}});window.addEventListener("test",Qb,Qb);window.removeEventListener("test",Qb,Qb)}catch(a){Pb=!1}function Rb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var Sb=!1,Tb=null,Ub=!1,Vb=null,Wb={onError:function(a){Sb=!0;Tb=a}};function Xb(a,b,c,d,e,f,g,h,k){Sb=!1;Tb=null;Rb.apply(Wb,arguments)}
function Yb(a,b,c,d,e,f,g,h,k){Xb.apply(this,arguments);if(Sb){if(Sb){var l=Tb;Sb=!1;Tb=null}else throw Error(y(198));Ub||(Ub=!0,Vb=l)}}function Zb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.flags&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function $b(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function ac(a){if(Zb(a)!==a)throw Error(y(188));}
function bc(a){var b=a.alternate;if(!b){b=Zb(a);if(null===b)throw Error(y(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return ac(e),a;if(f===d)return ac(e),b;f=f.sibling}throw Error(y(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(y(189));}}if(c.alternate!==d)throw Error(y(190));}if(3!==c.tag)throw Error(y(188));return c.stateNode.current===c?a:b}function cc(a){a=bc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function dc(a,b){for(var c=a.alternate;null!==b;){if(b===a||b===c)return!0;b=b.return}return!1}var ec,fc,gc,hc,ic=!1,jc=[],kc=null,lc=null,mc=null,nc=new Map,oc=new Map,pc=[],qc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a,b,c,d,e){return{blockedOn:a,domEventName:b,eventSystemFlags:c|16,nativeEvent:e,targetContainers:[d]}}function sc(a,b){switch(a){case "focusin":case "focusout":kc=null;break;case "dragenter":case "dragleave":lc=null;break;case "mouseover":case "mouseout":mc=null;break;case "pointerover":case "pointerout":nc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":oc.delete(b.pointerId)}}
function tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=rc(b,c,d,e,f),null!==b&&(b=Cb(b),null!==b&&fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
function uc(a,b,c,d,e){switch(b){case "focusin":return kc=tc(kc,a,b,c,d,e),!0;case "dragenter":return lc=tc(lc,a,b,c,d,e),!0;case "mouseover":return mc=tc(mc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;nc.set(f,tc(nc.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,oc.set(f,tc(oc.get(f)||null,a,b,c,d,e)),!0}return!1}
function vc(a){var b=wc(a.target);if(null!==b){var c=Zb(b);if(null!==c)if(b=c.tag,13===b){if(b=$b(c),null!==b){a.blockedOn=b;hc(a.lanePriority,function(){r.unstable_runWithPriority(a.priority,function(){gc(c)})});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}
function xc(a){if(null!==a.blockedOn)return!1;for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c)return b=Cb(c),null!==b&&fc(b),a.blockedOn=c,!1;b.shift()}return!0}function zc(a,b,c){xc(a)&&c.delete(b)}
function Ac(){for(ic=!1;0<jc.length;){var a=jc[0];if(null!==a.blockedOn){a=Cb(a.blockedOn);null!==a&&ec(a);break}for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c){a.blockedOn=c;break}b.shift()}null===a.blockedOn&&jc.shift()}null!==kc&&xc(kc)&&(kc=null);null!==lc&&xc(lc)&&(lc=null);null!==mc&&xc(mc)&&(mc=null);nc.forEach(zc);oc.forEach(zc)}
function Bc(a,b){a.blockedOn===b&&(a.blockedOn=null,ic||(ic=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Ac)))}
function Cc(a){function b(b){return Bc(b,a)}if(0<jc.length){Bc(jc[0],a);for(var c=1;c<jc.length;c++){var d=jc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==kc&&Bc(kc,a);null!==lc&&Bc(lc,a);null!==mc&&Bc(mc,a);nc.forEach(b);oc.forEach(b);for(c=0;c<pc.length;c++)d=pc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<pc.length&&(c=pc[0],null===c.blockedOn);)vc(c),null===c.blockedOn&&pc.shift()}
function Dc(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ec={animationend:Dc("Animation","AnimationEnd"),animationiteration:Dc("Animation","AnimationIteration"),animationstart:Dc("Animation","AnimationStart"),transitionend:Dc("Transition","TransitionEnd")},Fc={},Gc={};
fa&&(Gc=document.createElement("div").style,"AnimationEvent"in window||(delete Ec.animationend.animation,delete Ec.animationiteration.animation,delete Ec.animationstart.animation),"TransitionEvent"in window||delete Ec.transitionend.transition);function Hc(a){if(Fc[a])return Fc[a];if(!Ec[a])return a;var b=Ec[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Gc)return Fc[a]=b[c];return a}
var Ic=Hc("animationend"),Jc=Hc("animationiteration"),Kc=Hc("animationstart"),Lc=Hc("transitionend"),Mc=new Map,Nc=new Map,Oc=["abort","abort",Ic,"animationEnd",Jc,"animationIteration",Kc,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart",
"lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking","seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",Lc,"transitionEnd","waiting","waiting"];function Pc(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1];e="on"+(e[0].toUpperCase()+e.slice(1));Nc.set(d,b);Mc.set(d,e);da(e,[d])}}var Qc=r.unstable_now;Qc();var F=8;
function Rc(a){if(0!==(1&a))return F=15,1;if(0!==(2&a))return F=14,2;if(0!==(4&a))return F=13,4;var b=24&a;if(0!==b)return F=12,b;if(0!==(a&32))return F=11,32;b=192&a;if(0!==b)return F=10,b;if(0!==(a&256))return F=9,256;b=3584&a;if(0!==b)return F=8,b;if(0!==(a&4096))return F=7,4096;b=4186112&a;if(0!==b)return F=6,b;b=62914560&a;if(0!==b)return F=5,b;if(a&67108864)return F=4,67108864;if(0!==(a&134217728))return F=3,134217728;b=805306368&a;if(0!==b)return F=2,b;if(0!==(1073741824&a))return F=1,1073741824;
F=8;return a}function Sc(a){switch(a){case 99:return 15;case 98:return 10;case 97:case 96:return 8;case 95:return 2;default:return 0}}function Tc(a){switch(a){case 15:case 14:return 99;case 13:case 12:case 11:case 10:return 98;case 9:case 8:case 7:case 6:case 4:case 5:return 97;case 3:case 2:case 1:return 95;case 0:return 90;default:throw Error(y(358,a));}}
function Uc(a,b){var c=a.pendingLanes;if(0===c)return F=0;var d=0,e=0,f=a.expiredLanes,g=a.suspendedLanes,h=a.pingedLanes;if(0!==f)d=f,e=F=15;else if(f=c&134217727,0!==f){var k=f&~g;0!==k?(d=Rc(k),e=F):(h&=f,0!==h&&(d=Rc(h),e=F))}else f=c&~g,0!==f?(d=Rc(f),e=F):0!==h&&(d=Rc(h),e=F);if(0===d)return 0;d=31-Vc(d);d=c&((0>d?0:1<<d)<<1)-1;if(0!==b&&b!==d&&0===(b&g)){Rc(b);if(e<=F)return b;F=e}b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-Vc(b),e=1<<c,d|=a[c],b&=~e;return d}
function Wc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function Xc(a,b){switch(a){case 15:return 1;case 14:return 2;case 12:return a=Yc(24&~b),0===a?Xc(10,b):a;case 10:return a=Yc(192&~b),0===a?Xc(8,b):a;case 8:return a=Yc(3584&~b),0===a&&(a=Yc(4186112&~b),0===a&&(a=512)),a;case 2:return b=Yc(805306368&~b),0===b&&(b=268435456),b}throw Error(y(358,a));}function Yc(a){return a&-a}function Zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
function $c(a,b,c){a.pendingLanes|=b;var d=b-1;a.suspendedLanes&=d;a.pingedLanes&=d;a=a.eventTimes;b=31-Vc(b);a[b]=c}var Vc=Math.clz32?Math.clz32:ad,bd=Math.log,cd=Math.LN2;function ad(a){return 0===a?32:31-(bd(a)/cd|0)|0}var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function gd(a,b,c,d){Kb||Ib();var e=hd,f=Kb;Kb=!0;try{Hb(e,a,b,c,d)}finally{(Kb=f)||Mb()}}function id(a,b,c,d){ed(dd,hd.bind(null,a,b,c,d))}
function hd(a,b,c,d){if(fd){var e;if((e=0===(b&4))&&0<jc.length&&-1<qc.indexOf(a))a=rc(null,a,b,c,d),jc.push(a);else{var f=yc(a,b,c,d);if(null===f)e&&sc(a,d);else{if(e){if(-1<qc.indexOf(a)){a=rc(f,a,b,c,d);jc.push(a);return}if(uc(f,a,b,c,d))return;sc(a,d)}jd(a,b,d,null,c)}}}}
function yc(a,b,c,d){var e=xb(d);e=wc(e);if(null!==e){var f=Zb(e);if(null===f)e=null;else{var g=f.tag;if(13===g){e=$b(f);if(null!==e)return e;e=null}else if(3===g){if(f.stateNode.hydrate)return 3===f.tag?f.stateNode.containerInfo:null;e=null}else f!==e&&(e=null)}}jd(a,b,d,e,c);return null}var kd=null,ld=null,md=null;
function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return!0}function qd(){return!1}
function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}m(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
(a.returnValue=!1),this.isDefaultPrevented=pd)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd)},persist:function(){},isPersistent:pd});return b}
var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=m({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=m({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return"movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=m({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=m({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=m({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=m({},sd,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=m({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
var Qd=m({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return"keypress"===a.type?od(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=m({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=m({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=m({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=m({},Ad,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=fa&&"CompositionEvent"in window,be=null;fa&&"documentMode"in document&&(be=document.documentMode);var ce=fa&&"TextEvent"in window&&!be,de=fa&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
function ge(a,b){switch(a){case "keyup":return-1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return!0;default:return!1}}function he(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
function ke(a,b){if(ie)return"compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}))}var pe=null,qe=null;function re(a){se(a,0)}function te(a){var b=ue(a);if(Wa(b))return a}
function ve(a,b){if("change"===a)return b}var we=!1;if(fa){var xe;if(fa){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput}xe=ye}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode)}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null)}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));a=re;if(Kb)a(b);else{Kb=!0;try{Gb(a,b)}finally{Kb=!1,Mb()}}}}
function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae()}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge,Ie=Object.prototype.hasOwnProperty;
function Je(a,b){if(He(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!Ie.call(b,c[d])||!He(a[c[d]],b[c[d]]))return!1;return!0}function Ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Le(a,b){var c=Ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Ke(c)}}function Me(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Me(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Ne(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xa(a.document)}return b}function Oe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Pe=fa&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Oe(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Je(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)))}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
0);Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);Pc(Oc,2);for(var Ve="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),We=0;We<Ve.length;We++)Nc.set(Ve[We],0);ea("onMouseEnter",["mouseout","mouseover"]);
ea("onMouseLeave",["mouseout","mouseover"]);ea("onPointerEnter",["pointerout","pointerover"]);ea("onPointerLeave",["pointerout","pointerover"]);da("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));da("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));da("onBeforeInput",["compositionend","keypress","textInput","paste"]);da("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));da("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var Xe="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Ye=new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Yb(d,b,void 0,a);a.currentTarget=null}
function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k}}}if(Ub)throw a=Vb,Ub=!1,Vb=null,a;}
function G(a,b){var c=$e(b),d=a+"__bubble";c.has(d)||(af(b,a,2,!1),c.add(d))}var bf="_reactListening"+Math.random().toString(36).slice(2);function cf(a){a[bf]||(a[bf]=!0,ba.forEach(function(b){Ye.has(b)||df(b,!1,a,null);df(b,!0,a,null)}))}
function df(a,b,c,d){var e=4<arguments.length&&void 0!==arguments[4]?arguments[4]:0,f=c;"selectionchange"===a&&9!==c.nodeType&&(f=c.ownerDocument);if(null!==d&&!b&&Ye.has(a)){if("scroll"!==a)return;e|=2;f=d}var g=$e(f),h=a+"__"+(b?"capture":"bubble");g.has(h)||(b&&(e|=4),af(f,a,e,b),g.add(h))}
function af(a,b,c,d){var e=Nc.get(b);switch(void 0===e?2:e){case 0:e=gd;break;case 1:e=id;break;default:e=hd}c=e.bind(null,b,c,a);e=void 0;!Pb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1)}
function jd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return}for(;null!==h;){g=wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode}}d=d.return}Nb(function(){var d=f,e=xb(c),g=[];
a:{var h=Mc.get(a);if(void 0!==h){var k=td,x=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":x="focus";k=Fd;break;case "focusout":x="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case Ic:case Jc:case Kc:k=Hd;break;case Lc:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td}var w=0!==(b&4),z=!w&&"scroll"===a,u=w?null!==h?h+"Capture":null:h;w=[];for(var t=d,q;null!==
t;){q=t;var v=q.stateNode;5===q.tag&&null!==v&&(q=v,null!==u&&(v=Ob(t,u),null!=v&&w.push(ef(t,v,q))));if(z)break;t=t.return}0<w.length&&(h=new k(h,x,null,c,e),g.push({event:h,listeners:w}))}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&0===(b&16)&&(x=c.relatedTarget||c.fromElement)&&(wc(x)||x[ff]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(x=c.relatedTarget||c.toElement,k=d,x=x?wc(x):null,null!==
x&&(z=Zb(x),x!==z||5!==x.tag&&6!==x.tag))x=null}else k=null,x=d;if(k!==x){w=Bd;v="onMouseLeave";u="onMouseEnter";t="mouse";if("pointerout"===a||"pointerover"===a)w=Td,v="onPointerLeave",u="onPointerEnter",t="pointer";z=null==k?h:ue(k);q=null==x?h:ue(x);h=new w(v,t+"leave",k,c,e);h.target=z;h.relatedTarget=q;v=null;wc(e)===d&&(w=new w(u,t+"enter",x,c,e),w.target=q,w.relatedTarget=z,v=w);z=v;if(k&&x)b:{w=k;u=x;t=0;for(q=w;q;q=gf(q))t++;q=0;for(v=u;v;v=gf(v))q++;for(;0<t-q;)w=gf(w),t--;for(;0<q-t;)u=
gf(u),q--;for(;t--;){if(w===u||null!==u&&w===u.alternate)break b;w=gf(w);u=gf(u)}w=null}else w=null;null!==k&&hf(g,h,k,w,!1);null!==x&&null!==z&&hf(g,z,x,w,!0)}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var J=ve;else if(me(h))if(we)J=Fe;else{J=De;var K=Ce}else(k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(J=Ee);if(J&&(J=J(a,d))){ne(g,J,c,e);break a}K&&K(a,h,d);"focusout"===a&&(K=h._wrapperState)&&
K.controlled&&"number"===h.type&&bb(h,"number",h.value)}K=d?ue(d):window;switch(a){case "focusin":if(me(K)||"true"===K.contentEditable)Qe=K,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e)}var Q;if(ae)b:{switch(a){case "compositionstart":var L="onCompositionStart";break b;case "compositionend":L="onCompositionEnd";break b;
case "compositionupdate":L="onCompositionUpdate";break b}L=void 0}else ie?ge(a,c)&&(L="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(L="onCompositionStart");L&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==L?"onCompositionEnd"===L&&ie&&(Q=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),K=oe(d,L),0<K.length&&(L=new Ld(L,a,null,c,e),g.push({event:L,listeners:K}),Q?L.data=Q:(Q=he(c),null!==Q&&(L.data=Q))));if(Q=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),0<d.length&&(e=new Ld("onBeforeInput",
"beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=Q)}se(g,b)})}function ef(a,b,c){return{instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Ob(a,c),null!=f&&d.unshift(ef(a,f,e)),f=Ob(a,b),null!=f&&d.push(ef(a,f,e)));a=a.return}return d}function gf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
function hf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Ob(c,f),null!=k&&g.unshift(ef(c,k,h))):e||(k=Ob(c,f),null!=k&&g.push(ef(c,k,h))));c=c.return}0!==g.length&&a.push({event:b,listeners:g})}function jf(){}var kf=null,lf=null;function mf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function nf(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var of="function"===typeof setTimeout?setTimeout:void 0,pf="function"===typeof clearTimeout?clearTimeout:void 0;function qf(a){1===a.nodeType?a.textContent="":9===a.nodeType&&(a=a.body,null!=a&&(a.textContent=""))}
function rf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}function sf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--}else"/$"===c&&b++}a=a.previousSibling}return null}var tf=0;function uf(a){return{$$typeof:Ga,toString:a,valueOf:a}}var vf=Math.random().toString(36).slice(2),wf="__reactFiber$"+vf,xf="__reactProps$"+vf,ff="__reactContainer$"+vf,yf="__reactEvents$"+vf;
function wc(a){var b=a[wf];if(b)return b;for(var c=a.parentNode;c;){if(b=c[ff]||c[wf]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=sf(a);null!==a;){if(c=a[wf])return c;a=sf(a)}return b}a=c;c=a.parentNode}return null}function Cb(a){a=a[wf]||a[ff];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(y(33));}function Db(a){return a[xf]||null}
function $e(a){var b=a[yf];void 0===b&&(b=a[yf]=new Set);return b}var zf=[],Af=-1;function Bf(a){return{current:a}}function H(a){0>Af||(a.current=zf[Af],zf[Af]=null,Af--)}function I(a,b){Af++;zf[Af]=a.current;a.current=b}var Cf={},M=Bf(Cf),N=Bf(!1),Df=Cf;
function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function Ff(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Gf(){H(N);H(M)}function Hf(a,b,c){if(M.current!==Cf)throw Error(y(168));I(M,b);I(N,c)}
function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(y(108,Ra(b)||"Unknown",e));return m({},c,d)}function Jf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Cf;Df=M.current;I(M,a);I(N,N.current);return!0}function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(y(169));c?(a=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=a,H(N),H(M),I(M,a)):H(N);I(N,c)}
var Lf=null,Mf=null,Nf=r.unstable_runWithPriority,Of=r.unstable_scheduleCallback,Pf=r.unstable_cancelCallback,Qf=r.unstable_shouldYield,Rf=r.unstable_requestPaint,Sf=r.unstable_now,Tf=r.unstable_getCurrentPriorityLevel,Uf=r.unstable_ImmediatePriority,Vf=r.unstable_UserBlockingPriority,Wf=r.unstable_NormalPriority,Xf=r.unstable_LowPriority,Yf=r.unstable_IdlePriority,Zf={},$f=void 0!==Rf?Rf:function(){},ag=null,bg=null,cg=!1,dg=Sf(),O=1E4>dg?Sf:function(){return Sf()-dg};
function eg(){switch(Tf()){case Uf:return 99;case Vf:return 98;case Wf:return 97;case Xf:return 96;case Yf:return 95;default:throw Error(y(332));}}function fg(a){switch(a){case 99:return Uf;case 98:return Vf;case 97:return Wf;case 96:return Xf;case 95:return Yf;default:throw Error(y(332));}}function gg(a,b){a=fg(a);return Nf(a,b)}function hg(a,b,c){a=fg(a);return Of(a,b,c)}function ig(){if(null!==bg){var a=bg;bg=null;Pf(a)}jg()}
function jg(){if(!cg&&null!==ag){cg=!0;var a=0;try{var b=ag;gg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});ag=null}catch(c){throw null!==ag&&(ag=ag.slice(a+1)),Of(Uf,ig),c;}finally{cg=!1}}}var kg=ra.ReactCurrentBatchConfig;function lg(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}var mg=Bf(null),ng=null,og=null,pg=null;function qg(){pg=og=ng=null}
function rg(a){var b=mg.current;H(mg);a.type._context._currentValue=b}function sg(a,b){for(;null!==a;){var c=a.alternate;if((a.childLanes&b)===b)if(null===c||(c.childLanes&b)===b)break;else c.childLanes|=b;else a.childLanes|=b,null!==c&&(c.childLanes|=b);a=a.return}}function tg(a,b){ng=a;pg=og=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(ug=!0),a.firstContext=null)}
function vg(a,b){if(pg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)pg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===og){if(null===ng)throw Error(y(308));og=b;ng.dependencies={lanes:0,firstContext:b,responders:null}}else og=og.next=b}return a._currentValue}var wg=!1;function xg(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null},effects:null}}
function yg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects})}function zg(a,b){return{eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}function Ag(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function Bg(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next}while(null!==c);null===f?e=f=b:f=f.next=b}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
b;c.lastBaseUpdate=b}
function Cg(a,b,c,d){var e=a.updateQueue;wg=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var n=a.alternate;if(null!==n){n=n.updateQueue;var A=n.lastBaseUpdate;A!==g&&(null===A?n.firstBaseUpdate=l:A.next=l,n.lastBaseUpdate=k)}}if(null!==f){A=e.baseState;g=0;n=l=k=null;do{h=f.lane;var p=f.eventTime;if((d&h)===h){null!==n&&(n=n.next={eventTime:p,lane:0,tag:f.tag,payload:f.payload,callback:f.callback,
next:null});a:{var C=a,x=f;h=b;p=c;switch(x.tag){case 1:C=x.payload;if("function"===typeof C){A=C.call(p,A,h);break a}A=C;break a;case 3:C.flags=C.flags&-4097|64;case 0:C=x.payload;h="function"===typeof C?C.call(p,A,h):C;if(null===h||void 0===h)break a;A=m({},A,h);break a;case 2:wg=!0}}null!==f.callback&&(a.flags|=32,h=e.effects,null===h?e.effects=[f]:h.push(f))}else p={eventTime:p,lane:h,tag:f.tag,payload:f.payload,callback:f.callback,next:null},null===n?(l=n=p,k=A):n=n.next=p,g|=h;f=f.next;if(null===
f)if(h=e.shared.pending,null===h)break;else f=h.next,h.next=null,e.lastBaseUpdate=h,e.shared.pending=null}while(1);null===n&&(k=A);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=n;Dg|=g;a.lanes=g;a.memoizedState=A}}function Eg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(y(191,e));e.call(d)}}}var Fg=(new aa.Component).refs;
function Gg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c)}
var Kg={isMounted:function(a){return(a=a._reactInternals)?Zb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d)},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=Hg(),d=Ig(a),e=zg(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=
b);Ag(a,e);Jg(a,d,c)}};function Lg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Je(c,d)||!Je(e,f):!0}
function Mg(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=vg(f):(e=Ff(b)?Df:M.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Kg;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Kg.enqueueReplaceState(b,b.state,null)}
function Og(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Fg;xg(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=vg(f):(f=Ff(b)?Df:M.current,e.context=Ef(a,f));Cg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Gg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Kg.enqueueReplaceState(e,e.state,null),Cg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4)}var Pg=Array.isArray;
function Qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(y(309));var d=c.stateNode}if(!d)throw Error(y(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Fg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(y(284));if(!c._owner)throw Error(y(290,a));}return a}
function Rg(a,b){if("textarea"!==a.type)throw Error(y(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b));}
function Sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.flags=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Tg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags=2,
c):d;b.flags=2;return c}function g(b){a&&null===b.alternate&&(b.flags=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Ug(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Qg(a,b,c),d.return=a,d;d=Vg(c.type,c.key,c.props,null,a.mode,d);d.ref=Qg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Wg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=Xg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function A(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ug(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case sa:return c=Vg(b.type,b.key,b.props,null,a.mode,c),c.ref=Qg(a,null,b),c.return=a,c;case ta:return b=Wg(b,a.mode,c),b.return=a,b}if(Pg(b)||La(b))return b=Xg(b,
a.mode,c,null),b.return=a,b;Rg(a,b)}return null}function p(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case sa:return c.key===e?c.type===ua?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case ta:return c.key===e?l(a,b,c,d):null}if(Pg(c)||La(c))return null!==e?null:n(a,b,c,d,null);Rg(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case sa:return a=a.get(null===d.key?c:d.key)||null,d.type===ua?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case ta:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Pg(d)||La(d))return a=a.get(c)||null,n(b,a,d,e,null);Rg(b,d)}return null}function x(e,g,h,k){for(var l=null,t=null,u=g,z=g=0,q=null;null!==u&&z<h.length;z++){u.index>z?(q=u,u=null):q=u.sibling;var n=p(e,u,h[z],k);if(null===n){null===u&&(u=q);break}a&&u&&null===
n.alternate&&b(e,u);g=f(n,g,z);null===t?l=n:t.sibling=n;t=n;u=q}if(z===h.length)return c(e,u),l;if(null===u){for(;z<h.length;z++)u=A(e,h[z],k),null!==u&&(g=f(u,g,z),null===t?l=u:t.sibling=u,t=u);return l}for(u=d(e,u);z<h.length;z++)q=C(u,e,z,h[z],k),null!==q&&(a&&null!==q.alternate&&u.delete(null===q.key?z:q.key),g=f(q,g,z),null===t?l=q:t.sibling=q,t=q);a&&u.forEach(function(a){return b(e,a)});return l}function w(e,g,h,k){var l=La(h);if("function"!==typeof l)throw Error(y(150));h=l.call(h);if(null==
h)throw Error(y(151));for(var t=l=null,u=g,z=g=0,q=null,n=h.next();null!==u&&!n.done;z++,n=h.next()){u.index>z?(q=u,u=null):q=u.sibling;var w=p(e,u,n.value,k);if(null===w){null===u&&(u=q);break}a&&u&&null===w.alternate&&b(e,u);g=f(w,g,z);null===t?l=w:t.sibling=w;t=w;u=q}if(n.done)return c(e,u),l;if(null===u){for(;!n.done;z++,n=h.next())n=A(e,n.value,k),null!==n&&(g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);return l}for(u=d(e,u);!n.done;z++,n=h.next())n=C(u,e,z,n.value,k),null!==n&&(a&&null!==n.alternate&&
u.delete(null===n.key?z:n.key),g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ua&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case sa:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ua){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,k.sibling);
d=e(k,f.props);d.ref=Qg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ua?(d=Xg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Vg(f.type,f.key,f.props,null,a.mode,h),h.ref=Qg(a,d,f),h.return=a,a=h)}return g(a);case ta:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=
Wg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Ug(f,a.mode,h),d.return=a,a=d),g(a);if(Pg(f))return x(a,d,f,h);if(La(f))return w(a,d,f,h);l&&Rg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 22:case 0:case 11:case 15:throw Error(y(152,Ra(a.type)||"Component"));}return c(a,d)}}var Yg=Sg(!0),Zg=Sg(!1),$g={},ah=Bf($g),bh=Bf($g),ch=Bf($g);
function dh(a){if(a===$g)throw Error(y(174));return a}function eh(a,b){I(ch,b);I(bh,a);I(ah,$g);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:mb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=mb(b,a)}H(ah);I(ah,b)}function fh(){H(ah);H(bh);H(ch)}function gh(a){dh(ch.current);var b=dh(ah.current);var c=mb(b,a.type);b!==c&&(I(bh,a),I(ah,c))}function hh(a){bh.current===a&&(H(ah),H(bh))}var P=Bf(0);
function ih(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}var jh=null,kh=null,lh=!1;
function mh(a,b){var c=nh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.flags=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function oh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ph(a){if(lh){var b=kh;if(b){var c=b;if(!oh(a,b)){b=rf(c.nextSibling);if(!b||!oh(a,b)){a.flags=a.flags&-1025|2;lh=!1;jh=a;return}mh(jh,c)}jh=a;kh=rf(b.firstChild)}else a.flags=a.flags&-1025|2,lh=!1,jh=a}}function qh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;jh=a}
function rh(a){if(a!==jh)return!1;if(!lh)return qh(a),lh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!nf(b,a.memoizedProps))for(b=kh;b;)mh(a,b),b=rf(b.nextSibling);qh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(y(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){kh=rf(a.nextSibling);break a}b--}else"$"!==c&&"$!"!==c&&"$?"!==c||b++}a=a.nextSibling}kh=null}}else kh=jh?rf(a.stateNode.nextSibling):null;return!0}
function sh(){kh=jh=null;lh=!1}var th=[];function uh(){for(var a=0;a<th.length;a++)th[a]._workInProgressVersionPrimary=null;th.length=0}var vh=ra.ReactCurrentDispatcher,wh=ra.ReactCurrentBatchConfig,xh=0,R=null,S=null,T=null,yh=!1,zh=!1;function Ah(){throw Error(y(321));}function Bh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return!1;return!0}
function Ch(a,b,c,d,e,f){xh=f;R=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;vh.current=null===a||null===a.memoizedState?Dh:Eh;a=c(d,e);if(zh){f=0;do{zh=!1;if(!(25>f))throw Error(y(301));f+=1;T=S=null;b.updateQueue=null;vh.current=Fh;a=c(d,e)}while(zh)}vh.current=Gh;b=null!==S&&null!==S.next;xh=0;T=S=R=null;yh=!1;if(b)throw Error(y(300));return a}function Hh(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===T?R.memoizedState=T=a:T=T.next=a;return T}
function Ih(){if(null===S){var a=R.alternate;a=null!==a?a.memoizedState:null}else a=S.next;var b=null===T?R.memoizedState:T.next;if(null!==b)T=b,S=a;else{if(null===a)throw Error(y(310));S=a;a={memoizedState:S.memoizedState,baseState:S.baseState,baseQueue:S.baseQueue,queue:S.queue,next:null};null===T?R.memoizedState=T=a:T=T.next=a}return T}function Jh(a,b){return"function"===typeof b?b(a):b}
function Kh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=S,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.lane;if((xh&l)===l)null!==h&&(h=h.next={lane:0,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),d=k.eagerReducer===a?k.eagerState:a(d,k.action);else{var n={lane:l,action:k.action,eagerReducer:k.eagerReducer,
eagerState:k.eagerState,next:null};null===h?(g=h=n,f=d):h=h.next=n;R.lanes|=l;Dg|=l}k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;He(d,b.memoizedState)||(ug=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function Lh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(ug=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function Mh(a,b,c){var d=b._getVersion;d=d(b._source);var e=b._workInProgressVersionPrimary;if(null!==e)a=e===d;else if(a=a.mutableReadLanes,a=(xh&a)===a)b._workInProgressVersionPrimary=d,th.push(b);if(a)return c(b._source);th.push(b);throw Error(y(350));}
function Nh(a,b,c,d){var e=U;if(null===e)throw Error(y(349));var f=b._getVersion,g=f(b._source),h=vh.current,k=h.useState(function(){return Mh(e,b,c)}),l=k[1],n=k[0];k=T;var A=a.memoizedState,p=A.refs,C=p.getSnapshot,x=A.source;A=A.subscribe;var w=R;a.memoizedState={refs:p,source:b,subscribe:d};h.useEffect(function(){p.getSnapshot=c;p.setSnapshot=l;var a=f(b._source);if(!He(g,a)){a=c(b._source);He(n,a)||(l(a),a=Ig(w),e.mutableReadLanes|=a&e.pendingLanes);a=e.mutableReadLanes;e.entangledLanes|=a;for(var d=
e.entanglements,h=a;0<h;){var k=31-Vc(h),v=1<<k;d[k]|=a;h&=~v}}},[c,b,d]);h.useEffect(function(){return d(b._source,function(){var a=p.getSnapshot,c=p.setSnapshot;try{c(a(b._source));var d=Ig(w);e.mutableReadLanes|=d&e.pendingLanes}catch(q){c(function(){throw q;})}})},[b,d]);He(C,c)&&He(x,b)&&He(A,d)||(a={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:n},a.dispatch=l=Oh.bind(null,R,a),k.queue=a,k.baseQueue=null,n=Mh(e,b,c),k.memoizedState=k.baseState=n);return n}
function Ph(a,b,c){var d=Ih();return Nh(d,a,b,c)}function Qh(a){var b=Hh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:a};a=a.dispatch=Oh.bind(null,R,a);return[b.memoizedState,a]}
function Rh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=R.updateQueue;null===b?(b={lastEffect:null},R.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function Sh(a){var b=Hh();a={current:a};return b.memoizedState=a}function Th(){return Ih().memoizedState}function Uh(a,b,c,d){var e=Hh();R.flags|=a;e.memoizedState=Rh(1|b,c,void 0,void 0===d?null:d)}
function Vh(a,b,c,d){var e=Ih();d=void 0===d?null:d;var f=void 0;if(null!==S){var g=S.memoizedState;f=g.destroy;if(null!==d&&Bh(d,g.deps)){Rh(b,c,f,d);return}}R.flags|=a;e.memoizedState=Rh(1|b,c,f,d)}function Wh(a,b){return Uh(516,4,a,b)}function Xh(a,b){return Vh(516,4,a,b)}function Yh(a,b){return Vh(4,2,a,b)}function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}
function $h(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,2,Zh.bind(null,b,a),c)}function ai(){}function bi(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}function ci(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}
function di(a,b){var c=eg();gg(98>c?98:c,function(){a(!0)});gg(97<c?97:c,function(){var c=wh.transition;wh.transition=1;try{a(!1),b()}finally{wh.transition=c}})}
function Oh(a,b,c){var d=Hg(),e=Ig(a),f={lane:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.pending;null===g?f.next=f:(f.next=g.next,g.next=f);b.pending=f;g=a.alternate;if(a===R||null!==g&&g===R)zh=yh=!0;else{if(0===a.lanes&&(null===g||0===g.lanes)&&(g=b.lastRenderedReducer,null!==g))try{var h=b.lastRenderedState,k=g(h,c);f.eagerReducer=g;f.eagerState=k;if(He(k,h))return}catch(l){}finally{}Jg(a,e,d)}}
var Gh={readContext:vg,useCallback:Ah,useContext:Ah,useEffect:Ah,useImperativeHandle:Ah,useLayoutEffect:Ah,useMemo:Ah,useReducer:Ah,useRef:Ah,useState:Ah,useDebugValue:Ah,useDeferredValue:Ah,useTransition:Ah,useMutableSource:Ah,useOpaqueIdentifier:Ah,unstable_isNewReconciler:!1},Dh={readContext:vg,useCallback:function(a,b){Hh().memoizedState=[a,void 0===b?null:b];return a},useContext:vg,useEffect:Wh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Uh(4,2,Zh.bind(null,
b,a),c)},useLayoutEffect:function(a,b){return Uh(4,2,a,b)},useMemo:function(a,b){var c=Hh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Hh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Oh.bind(null,R,a);return[d.memoizedState,a]},useRef:Sh,useState:Qh,useDebugValue:ai,useDeferredValue:function(a){var b=Qh(a),c=b[0],d=b[1];Wh(function(){var b=wh.transition;
wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Qh(!1),b=a[0];a=di.bind(null,a[1]);Sh(a);return[a,b]},useMutableSource:function(a,b,c){var d=Hh();d.memoizedState={refs:{getSnapshot:b,setSnapshot:null},source:a,subscribe:c};return Nh(d,a,b,c)},useOpaqueIdentifier:function(){if(lh){var a=!1,b=uf(function(){a||(a=!0,c("r:"+(tf++).toString(36)));throw Error(y(355));}),c=Qh(b)[1];0===(R.mode&2)&&(R.flags|=516,Rh(5,function(){c("r:"+(tf++).toString(36))},
void 0,null));return b}b="r:"+(tf++).toString(36);Qh(b);return b},unstable_isNewReconciler:!1},Eh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Kh,useRef:Th,useState:function(){return Kh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Kh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Kh(Jh)[0];return[Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Kh(Jh)[0]},unstable_isNewReconciler:!1},Fh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Lh,useRef:Th,useState:function(){return Lh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Lh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a)}finally{wh.transition=b}},[a]);return c},useTransition:function(){var a=Lh(Jh)[0];return[Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Lh(Jh)[0]},unstable_isNewReconciler:!1},ei=ra.ReactCurrentOwner,ug=!1;function fi(a,b,c,d){b.child=null===a?Zg(b,null,c,d):Yg(b,a.child,c,d)}function gi(a,b,c,d,e){c=c.render;var f=b.ref;tg(b,e);d=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,d,e);return b.child}
function ii(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!ji(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ki(a,b,g,d,e,f);a=Vg(c.type,null,d,b,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(0===(e&f)&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:Je,c(e,d)&&a.ref===b.ref))return hi(a,b,f);b.flags|=1;a=Tg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ki(a,b,c,d,e,f){if(null!==a&&Je(a.memoizedProps,d)&&a.ref===b.ref)if(ug=!1,0!==(f&e))0!==(a.flags&16384)&&(ug=!0);else return b.lanes=a.lanes,hi(a,b,f);return li(a,b,c,d,f)}
function mi(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode||"unstable-defer-without-hiding"===d.mode)if(0===(b.mode&4))b.memoizedState={baseLanes:0},ni(b,c);else if(0!==(c&1073741824))b.memoizedState={baseLanes:0},ni(b,null!==f?f.baseLanes:c);else return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a},ni(b,a),null;else null!==f?(d=f.baseLanes|c,b.memoizedState=null):d=c,ni(b,d);fi(a,b,e,c);return b.child}
function oi(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=128}function li(a,b,c,d,e){var f=Ff(c)?Df:M.current;f=Ef(b,f);tg(b,e);c=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,c,e);return b.child}
function pi(a,b,c,d,e){if(Ff(c)){var f=!0;Jf(b)}else f=!1;tg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),Mg(b,c,d),Og(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=vg(l):(l=Ff(c)?Df:M.current,l=Ef(b,l));var n=c.getDerivedStateFromProps,A="function"===typeof n||"function"===typeof g.getSnapshotBeforeUpdate;A||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Ng(b,g,d,l);wg=!1;var p=b.memoizedState;g.state=p;Cg(b,d,g,e);k=b.memoizedState;h!==d||p!==k||N.current||wg?("function"===typeof n&&(Gg(b,c,n,d),k=b.memoizedState),(h=wg||Lg(b,c,h,d,p,k,l))?(A||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.flags|=4)):("function"===typeof g.componentDidMount&&(b.flags|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4),d=!1)}else{g=b.stateNode;yg(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:lg(b.type,h);g.props=l;A=b.pendingProps;p=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=vg(k):(k=Ff(c)?Df:M.current,k=Ef(b,k));var C=c.getDerivedStateFromProps;(n="function"===typeof C||
"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==A||p!==k)&&Ng(b,g,d,k);wg=!1;p=b.memoizedState;g.state=p;Cg(b,d,g,e);var x=b.memoizedState;h!==A||p!==x||N.current||wg?("function"===typeof C&&(Gg(b,c,C,d),x=b.memoizedState),(l=wg||Lg(b,c,l,d,p,x,k))?(n||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),d=!1)}return qi(a,b,c,d,f,e)}
function qi(a,b,c,d,e,f){oi(a,b);var g=0!==(b.flags&64);if(!d&&!g)return e&&Kf(b,c,!1),hi(a,b,f);d=b.stateNode;ei.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Yg(b,a.child,null,f),b.child=Yg(b,null,h,f)):fi(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function ri(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);eh(a,b.containerInfo)}
var si={dehydrated:null,retryLane:0};
function ti(a,b,c){var d=b.pendingProps,e=P.current,f=!1,g;(g=0!==(b.flags&64))||(g=null!==a&&null===a.memoizedState?!1:0!==(e&2));g?(f=!0,b.flags&=-65):null!==a&&null===a.memoizedState||void 0===d.fallback||!0===d.unstable_avoidThisFallback||(e|=1);I(P,e&1);if(null===a){void 0!==d.fallback&&ph(b);a=d.children;e=d.fallback;if(f)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},b.memoizedState=si,a;if("number"===typeof d.unstable_expectedLoadTime)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},
b.memoizedState=si,b.lanes=33554432,a;c=vi({mode:"visible",children:a},b.mode,c,null);c.return=b;return b.child=c}if(null!==a.memoizedState){if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:
{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}function ui(a,b,c,d){var e=a.mode,f=a.child;b={mode:"hidden",children:b};0===(e&2)&&null!==f?(f.childLanes=0,f.pendingProps=b):f=vi(b,e,0,null);c=Xg(c,e,d,null);f.return=a;c.return=a;f.sibling=c;a.child=f;return c}
function xi(a,b,c,d){var e=a.child;a=e.sibling;c=Tg(e,{mode:"visible",children:c});0===(b.mode&2)&&(c.lanes=d);c.return=b;c.sibling=null;null!==a&&(a.nextEffect=null,a.flags=8,b.firstEffect=b.lastEffect=a);return b.child=c}
function wi(a,b,c,d,e){var f=b.mode,g=a.child;a=g.sibling;var h={mode:"hidden",children:c};0===(f&2)&&b.child!==g?(c=b.child,c.childLanes=0,c.pendingProps=h,g=c.lastEffect,null!==g?(b.firstEffect=c.firstEffect,b.lastEffect=g,g.nextEffect=null):b.firstEffect=b.lastEffect=null):c=Tg(g,h);null!==a?d=Tg(a,d):(d=Xg(d,f,e,null),d.flags|=2);d.return=b;c.return=b;c.sibling=d;b.child=c;return d}function yi(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);sg(a.return,b)}
function zi(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailMode=e,g.lastEffect=f)}
function Ai(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;fi(a,b,d.children,c);d=P.current;if(0!==(d&2))d=d&1|2,b.flags|=64;else{if(null!==a&&0!==(a.flags&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&yi(a,c);else if(19===a.tag)yi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(P,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===ih(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);zi(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===ih(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}zi(b,!0,c,null,f,b.lastEffect);break;case "together":zi(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function hi(a,b,c){null!==a&&(b.dependencies=a.dependencies);Dg|=b.lanes;if(0!==(c&b.childLanes)){if(null!==a&&b.child!==a.child)throw Error(y(153));if(null!==b.child){a=b.child;c=Tg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Tg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}return null}var Bi,Ci,Di,Ei;
Bi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ci=function(){};
Di=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;dh(ah.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "option":e=eb(a,e);d=eb(a,d);f=[];break;case "select":e=m({},e,{value:void 0});d=m({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=jf)}vb(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===
l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&(c||(c={}),c[g]="")}else"dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ca.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||
(c={}),c[g]=k[g])}else c||(f||(f=[]),f.push(l,c)),c=k;else"dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ca.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&G("scroll",a),f||h===k||(f=[])):"object"===typeof k&&null!==k&&k.$$typeof===Ga?k.toString():(f=f||[]).push(l,k))}c&&(f=f||[]).push("style",
c);var l=f;if(b.updateQueue=l)b.flags|=4}};Ei=function(a,b,c,d){c!==d&&(b.flags|=4)};function Fi(a,b){if(!lh)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Gi(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return Ff(b.type)&&Gf(),null;case 3:fh();H(N);H(M);uh();d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)rh(b)?b.flags|=4:d.hydrate||(b.flags|=256);Ci(b);return null;case 5:hh(b);var e=dh(ch.current);c=b.type;if(null!==a&&null!=b.stateNode)Di(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=128);else{if(!d){if(null===
b.stateNode)throw Error(y(166));return null}a=dh(ah.current);if(rh(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[wf]=b;d[xf]=f;switch(c){case "dialog":G("cancel",d);G("close",d);break;case "iframe":case "object":case "embed":G("load",d);break;case "video":case "audio":for(a=0;a<Xe.length;a++)G(Xe[a],d);break;case "source":G("error",d);break;case "img":case "image":case "link":G("error",d);G("load",d);break;case "details":G("toggle",d);break;case "input":Za(d,f);G("invalid",d);break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};G("invalid",d);break;case "textarea":hb(d,f),G("invalid",d)}vb(c,f);a=null;for(var g in f)f.hasOwnProperty(g)&&(e=f[g],"children"===g?"string"===typeof e?d.textContent!==e&&(a=["children",e]):"number"===typeof e&&d.textContent!==""+e&&(a=["children",""+e]):ca.hasOwnProperty(g)&&null!=e&&"onScroll"===g&&G("scroll",d));switch(c){case "input":Va(d);cb(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=
jf)}d=a;b.updateQueue=d;null!==d&&(b.flags|=4)}else{g=9===e.nodeType?e:e.ownerDocument;a===kb.html&&(a=lb(c));a===kb.html?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[wf]=b;a[xf]=d;Bi(a,b,!1,!1);b.stateNode=a;g=wb(c,d);switch(c){case "dialog":G("cancel",a);G("close",a);
e=d;break;case "iframe":case "object":case "embed":G("load",a);e=d;break;case "video":case "audio":for(e=0;e<Xe.length;e++)G(Xe[e],a);e=d;break;case "source":G("error",a);e=d;break;case "img":case "image":case "link":G("error",a);G("load",a);e=d;break;case "details":G("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);G("invalid",a);break;case "option":e=eb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=m({},d,{value:void 0});G("invalid",a);break;case "textarea":hb(a,d);e=
gb(a,d);G("invalid",a);break;default:e=d}vb(c,e);var h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?tb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&ob(a,k)):"children"===f?"string"===typeof k?("textarea"!==c||""!==k)&&pb(a,k):"number"===typeof k&&pb(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ca.hasOwnProperty(f)?null!=k&&"onScroll"===f&&G("scroll",a):null!=k&&qa(a,f,k,g))}switch(c){case "input":Va(a);cb(a,d,!1);
break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof e.onClick&&(a.onclick=jf)}mf(c,d)&&(b.flags|=4)}null!==b.ref&&(b.flags|=128)}return null;case 6:if(a&&null!=b.stateNode)Ei(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(y(166));
c=dh(ch.current);dh(ah.current);rh(b)?(d=b.stateNode,c=b.memoizedProps,d[wf]=b,d.nodeValue!==c&&(b.flags|=4)):(d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[wf]=b,b.stateNode=d)}return null;case 13:H(P);d=b.memoizedState;if(0!==(b.flags&64))return b.lanes=c,b;d=null!==d;c=!1;null===a?void 0!==b.memoizedProps.fallback&&rh(b):c=null!==a.memoizedState;if(d&&!c&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&1))0===V&&(V=3);else{if(0===V||3===V)V=
4;null===U||0===(Dg&134217727)&&0===(Hi&134217727)||Ii(U,W)}if(d||c)b.flags|=4;return null;case 4:return fh(),Ci(b),null===a&&cf(b.stateNode.containerInfo),null;case 10:return rg(b),null;case 17:return Ff(b.type)&&Gf(),null;case 19:H(P);d=b.memoizedState;if(null===d)return null;f=0!==(b.flags&64);g=d.rendering;if(null===g)if(f)Fi(d,!1);else{if(0!==V||null!==a&&0!==(a.flags&64))for(a=b.child;null!==a;){g=ih(a);if(null!==g){b.flags|=64;Fi(d,!1);f=g.updateQueue;null!==f&&(b.updateQueue=f,b.flags|=4);
null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=2,f.nextEffect=null,f.firstEffect=null,f.lastEffect=null,g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,
f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;I(P,P.current&1|2);return b.child}a=a.sibling}null!==d.tail&&O()>Ji&&(b.flags|=64,f=!0,Fi(d,!1),b.lanes=33554432)}else{if(!f)if(a=ih(g),null!==a){if(b.flags|=64,f=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Fi(d,!0),null===d.tail&&"hidden"===d.tailMode&&!g.alternate&&!lh)return b=b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*O()-d.renderingStartTime>Ji&&1073741824!==c&&(b.flags|=
64,f=!0,Fi(d,!1),b.lanes=33554432);d.isBackwards?(g.sibling=b.child,b.child=g):(c=d.last,null!==c?c.sibling=g:b.child=g,d.last=g)}return null!==d.tail?(c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=O(),c.sibling=null,b=P.current,I(P,f?b&1|2:b&1),c):null;case 23:case 24:return Ki(),null!==a&&null!==a.memoizedState!==(null!==b.memoizedState)&&"unstable-defer-without-hiding"!==d.mode&&(b.flags|=4),null}throw Error(y(156,b.tag));}
function Li(a){switch(a.tag){case 1:Ff(a.type)&&Gf();var b=a.flags;return b&4096?(a.flags=b&-4097|64,a):null;case 3:fh();H(N);H(M);uh();b=a.flags;if(0!==(b&64))throw Error(y(285));a.flags=b&-4097|64;return a;case 5:return hh(a),null;case 13:return H(P),b=a.flags,b&4096?(a.flags=b&-4097|64,a):null;case 19:return H(P),null;case 4:return fh(),null;case 10:return rg(a),null;case 23:case 24:return Ki(),null;default:return null}}
function Mi(a,b){try{var c="",d=b;do c+=Qa(d),d=d.return;while(d);var e=c}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack}return{value:a,source:b,stack:e}}function Ni(a,b){try{console.error(b.value)}catch(c){setTimeout(function(){throw c;})}}var Oi="function"===typeof WeakMap?WeakMap:Map;function Pi(a,b,c){c=zg(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Qi||(Qi=!0,Ri=d);Ni(a,b)};return c}
function Si(a,b,c){c=zg(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ni(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ti?Ti=new Set([this]):Ti.add(this),Ni(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}var Ui="function"===typeof WeakSet?WeakSet:Set;
function Vi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Wi(a,c)}else b.current=null}function Xi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.flags&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:lg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:b.flags&256&&qf(b.stateNode.containerInfo);return;case 5:case 6:case 4:case 17:return}throw Error(y(163));}
function Yi(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{if(3===(a.tag&3)){var d=a.create;a.destroy=d()}a=a.next}while(a!==b)}b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{var e=a;d=e.next;e=e.tag;0!==(e&4)&&0!==(e&1)&&(Zi(c,a),$i(c,a));a=d}while(a!==b)}return;case 1:a=c.stateNode;c.flags&4&&(null===b?a.componentDidMount():(d=c.elementType===c.type?b.memoizedProps:lg(c.type,b.memoizedProps),a.componentDidUpdate(d,
b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)));b=c.updateQueue;null!==b&&Eg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Eg(c,b,a)}return;case 5:a=c.stateNode;null===b&&c.flags&4&&mf(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Cc(c))));
return;case 19:case 17:case 20:case 21:case 23:case 24:return}throw Error(y(163));}
function aj(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d=d.style,"function"===typeof d.setProperty?d.setProperty("display","none","important"):d.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=sb("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if((23!==c.tag&&24!==c.tag||null===c.memoizedState||c===a)&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===
a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
function bj(a,b){if(Mf&&"function"===typeof Mf.onCommitFiberUnmount)try{Mf.onCommitFiberUnmount(Lf,b)}catch(f){}switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var c=a=a.next;do{var d=c,e=d.destroy;d=d.tag;if(void 0!==e)if(0!==(d&4))Zi(b,c);else{d=b;try{e()}catch(f){Wi(d,f)}}c=c.next}while(c!==a)}break;case 1:Vi(b);a=b.stateNode;if("function"===typeof a.componentWillUnmount)try{a.props=b.memoizedProps,a.state=b.memoizedState,a.componentWillUnmount()}catch(f){Wi(b,
f)}break;case 5:Vi(b);break;case 4:cj(a,b)}}function dj(a){a.alternate=null;a.child=null;a.dependencies=null;a.firstEffect=null;a.lastEffect=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.return=null;a.updateQueue=null}function ej(a){return 5===a.tag||3===a.tag||4===a.tag}
function fj(a){a:{for(var b=a.return;null!==b;){if(ej(b))break a;b=b.return}throw Error(y(160));}var c=b;b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(y(161));}c.flags&16&&(pb(b,""),c.flags&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ej(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.flags&2)continue b;if(null===
c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.flags&2)){c=c.stateNode;break a}}d?gj(a,c,b):hj(a,c,b)}
function gj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=jf));else if(4!==d&&(a=a.child,null!==a))for(gj(a,b,c),a=a.sibling;null!==a;)gj(a,b,c),a=a.sibling}
function hj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(hj(a,b,c),a=a.sibling;null!==a;)hj(a,b,c),a=a.sibling}
function cj(a,b){for(var c=b,d=!1,e,f;;){if(!d){d=c.return;a:for(;;){if(null===d)throw Error(y(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag){a:for(var g=a,h=c,k=h;;)if(bj(g,k),null!==k.child&&4!==k.tag)k.child.return=k,k=k.child;else{if(k===h)break a;for(;null===k.sibling;){if(null===k.return||k.return===h)break a;k=k.return}k.sibling.return=k.return;k=k.sibling}f?(g=e,h=c.stateNode,
8===g.nodeType?g.parentNode.removeChild(h):g.removeChild(h)):e.removeChild(c.stateNode)}else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(bj(a,c),null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
function ij(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:var c=b.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do 3===(d.tag&3)&&(a=d.destroy,d.destroy=void 0,void 0!==a&&a()),d=d.next;while(d!==c)}return;case 1:return;case 5:c=b.stateNode;if(null!=c){d=b.memoizedProps;var e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[xf]=d;"input"===a&&"radio"===d.type&&null!=d.name&&$a(c,d);wb(a,e);b=wb(a,d);for(e=0;e<f.length;e+=
2){var g=f[e],h=f[e+1];"style"===g?tb(c,h):"dangerouslySetInnerHTML"===g?ob(c,h):"children"===g?pb(c,h):qa(c,g,h,b)}switch(a){case "input":ab(c,d);break;case "textarea":ib(c,d);break;case "select":a=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?fb(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?fb(c,!!d.multiple,d.defaultValue,!0):fb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(y(162));b.stateNode.nodeValue=
b.memoizedProps;return;case 3:c=b.stateNode;c.hydrate&&(c.hydrate=!1,Cc(c.containerInfo));return;case 12:return;case 13:null!==b.memoizedState&&(jj=O(),aj(b.child,!0));kj(b);return;case 19:kj(b);return;case 17:return;case 23:case 24:aj(b,null!==b.memoizedState);return}throw Error(y(163));}function kj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Ui);b.forEach(function(b){var d=lj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
function mj(a,b){return null!==a&&(a=a.memoizedState,null===a||null!==a.dehydrated)?(b=b.memoizedState,null!==b&&null===b.dehydrated):!1}var nj=Math.ceil,oj=ra.ReactCurrentDispatcher,pj=ra.ReactCurrentOwner,X=0,U=null,Y=null,W=0,qj=0,rj=Bf(0),V=0,sj=null,tj=0,Dg=0,Hi=0,uj=0,vj=null,jj=0,Ji=Infinity;function wj(){Ji=O()+500}var Z=null,Qi=!1,Ri=null,Ti=null,xj=!1,yj=null,zj=90,Aj=[],Bj=[],Cj=null,Dj=0,Ej=null,Fj=-1,Gj=0,Hj=0,Ij=null,Jj=!1;function Hg(){return 0!==(X&48)?O():-1!==Fj?Fj:Fj=O()}
function Ig(a){a=a.mode;if(0===(a&2))return 1;if(0===(a&4))return 99===eg()?1:2;0===Gj&&(Gj=tj);if(0!==kg.transition){0!==Hj&&(Hj=null!==vj?vj.pendingLanes:0);a=Gj;var b=4186112&~Hj;b&=-b;0===b&&(a=4186112&~a,b=a&-a,0===b&&(b=8192));return b}a=eg();0!==(X&4)&&98===a?a=Xc(12,Gj):(a=Sc(a),a=Xc(a,Gj));return a}
function Jg(a,b,c){if(50<Dj)throw Dj=0,Ej=null,Error(y(185));a=Kj(a,b);if(null===a)return null;$c(a,b,c);a===U&&(Hi|=b,4===V&&Ii(a,W));var d=eg();1===b?0!==(X&8)&&0===(X&48)?Lj(a):(Mj(a,c),0===X&&(wj(),ig())):(0===(X&4)||98!==d&&99!==d||(null===Cj?Cj=new Set([a]):Cj.add(a)),Mj(a,c));vj=a}function Kj(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}
function Mj(a,b){for(var c=a.callbackNode,d=a.suspendedLanes,e=a.pingedLanes,f=a.expirationTimes,g=a.pendingLanes;0<g;){var h=31-Vc(g),k=1<<h,l=f[h];if(-1===l){if(0===(k&d)||0!==(k&e)){l=b;Rc(k);var n=F;f[h]=10<=n?l+250:6<=n?l+5E3:-1}}else l<=b&&(a.expiredLanes|=k);g&=~k}d=Uc(a,a===U?W:0);b=F;if(0===d)null!==c&&(c!==Zf&&Pf(c),a.callbackNode=null,a.callbackPriority=0);else{if(null!==c){if(a.callbackPriority===b)return;c!==Zf&&Pf(c)}15===b?(c=Lj.bind(null,a),null===ag?(ag=[c],bg=Of(Uf,jg)):ag.push(c),
c=Zf):14===b?c=hg(99,Lj.bind(null,a)):(c=Tc(b),c=hg(c,Nj.bind(null,a)));a.callbackPriority=b;a.callbackNode=c}}
function Nj(a){Fj=-1;Hj=Gj=0;if(0!==(X&48))throw Error(y(327));var b=a.callbackNode;if(Oj()&&a.callbackNode!==b)return null;var c=Uc(a,a===U?W:0);if(0===c)return null;var d=c;var e=X;X|=16;var f=Pj();if(U!==a||W!==d)wj(),Qj(a,d);do try{Rj();break}catch(h){Sj(a,h)}while(1);qg();oj.current=f;X=e;null!==Y?d=0:(U=null,W=0,d=V);if(0!==(tj&Hi))Qj(a,0);else if(0!==d){2===d&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),c=Wc(a),0!==c&&(d=Tj(a,c)));if(1===d)throw b=sj,Qj(a,0),Ii(a,c),Mj(a,O()),b;a.finishedWork=
a.current.alternate;a.finishedLanes=c;switch(d){case 0:case 1:throw Error(y(345));case 2:Uj(a);break;case 3:Ii(a,c);if((c&62914560)===c&&(d=jj+500-O(),10<d)){if(0!==Uc(a,0))break;e=a.suspendedLanes;if((e&c)!==c){Hg();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=of(Uj.bind(null,a),d);break}Uj(a);break;case 4:Ii(a,c);if((c&4186112)===c)break;d=a.eventTimes;for(e=-1;0<c;){var g=31-Vc(c);f=1<<g;g=d[g];g>e&&(e=g);c&=~f}c=e;c=O()-c;c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>
c?4320:1960*nj(c/1960))-c;if(10<c){a.timeoutHandle=of(Uj.bind(null,a),c);break}Uj(a);break;case 5:Uj(a);break;default:throw Error(y(329));}}Mj(a,O());return a.callbackNode===b?Nj.bind(null,a):null}function Ii(a,b){b&=~uj;b&=~Hi;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-Vc(b),d=1<<c;a[c]=-1;b&=~d}}
function Lj(a){if(0!==(X&48))throw Error(y(327));Oj();if(a===U&&0!==(a.expiredLanes&W)){var b=W;var c=Tj(a,b);0!==(tj&Hi)&&(b=Uc(a,b),c=Tj(a,b))}else b=Uc(a,0),c=Tj(a,b);0!==a.tag&&2===c&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),b=Wc(a),0!==b&&(c=Tj(a,b)));if(1===c)throw c=sj,Qj(a,0),Ii(a,b),Mj(a,O()),c;a.finishedWork=a.current.alternate;a.finishedLanes=b;Uj(a);Mj(a,O());return null}
function Vj(){if(null!==Cj){var a=Cj;Cj=null;a.forEach(function(a){a.expiredLanes|=24&a.pendingLanes;Mj(a,O())})}ig()}function Wj(a,b){var c=X;X|=1;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function Xj(a,b){var c=X;X&=-2;X|=8;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}}function ni(a,b){I(rj,qj);qj|=b;tj|=b}function Ki(){qj=rj.current;H(rj)}
function Qj(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,pf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Gf();break;case 3:fh();H(N);H(M);uh();break;case 5:hh(d);break;case 4:fh();break;case 13:H(P);break;case 19:H(P);break;case 10:rg(d);break;case 23:case 24:Ki()}c=c.return}U=a;Y=Tg(a.current,null);W=qj=tj=b;V=0;sj=null;uj=Hi=Dg=0}
function Sj(a,b){do{var c=Y;try{qg();vh.current=Gh;if(yh){for(var d=R.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next}yh=!1}xh=0;T=S=R=null;zh=!1;pj.current=null;if(null===c||null===c.return){V=1;sj=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=W;h.flags|=2048;h.firstEffect=h.lastEffect=null;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k;if(0===(h.mode&2)){var n=h.alternate;n?(h.updateQueue=n.updateQueue,h.memoizedState=n.memoizedState,h.lanes=n.lanes):
(h.updateQueue=null,h.memoizedState=null)}var A=0!==(P.current&1),p=g;do{var C;if(C=13===p.tag){var x=p.memoizedState;if(null!==x)C=null!==x.dehydrated?!0:!1;else{var w=p.memoizedProps;C=void 0===w.fallback?!1:!0!==w.unstable_avoidThisFallback?!0:A?!1:!0}}if(C){var z=p.updateQueue;if(null===z){var u=new Set;u.add(l);p.updateQueue=u}else z.add(l);if(0===(p.mode&2)){p.flags|=64;h.flags|=16384;h.flags&=-2981;if(1===h.tag)if(null===h.alternate)h.tag=17;else{var t=zg(-1,1);t.tag=2;Ag(h,t)}h.lanes|=1;break a}k=
void 0;h=b;var q=f.pingCache;null===q?(q=f.pingCache=new Oi,k=new Set,q.set(l,k)):(k=q.get(l),void 0===k&&(k=new Set,q.set(l,k)));if(!k.has(h)){k.add(h);var v=Yj.bind(null,f,l,h);l.then(v,v)}p.flags|=4096;p.lanes=b;break a}p=p.return}while(null!==p);k=Error((Ra(h.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.")}5!==V&&(V=2);k=Mi(k,h);p=
g;do{switch(p.tag){case 3:f=k;p.flags|=4096;b&=-b;p.lanes|=b;var J=Pi(p,f,b);Bg(p,J);break a;case 1:f=k;var K=p.type,Q=p.stateNode;if(0===(p.flags&64)&&("function"===typeof K.getDerivedStateFromError||null!==Q&&"function"===typeof Q.componentDidCatch&&(null===Ti||!Ti.has(Q)))){p.flags|=4096;b&=-b;p.lanes|=b;var L=Si(p,f,b);Bg(p,L);break a}}p=p.return}while(null!==p)}Zj(c)}catch(va){b=va;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}
function Pj(){var a=oj.current;oj.current=Gh;return null===a?Gh:a}function Tj(a,b){var c=X;X|=16;var d=Pj();U===a&&W===b||Qj(a,b);do try{ak();break}catch(e){Sj(a,e)}while(1);qg();X=c;oj.current=d;if(null!==Y)throw Error(y(261));U=null;W=0;return V}function ak(){for(;null!==Y;)bk(Y)}function Rj(){for(;null!==Y&&!Qf();)bk(Y)}function bk(a){var b=ck(a.alternate,a,qj);a.memoizedProps=a.pendingProps;null===b?Zj(a):Y=b;pj.current=null}
function Zj(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&2048)){c=Gi(c,b,qj);if(null!==c){Y=c;return}c=b;if(24!==c.tag&&23!==c.tag||null===c.memoizedState||0!==(qj&1073741824)||0===(c.mode&4)){for(var d=0,e=c.child;null!==e;)d|=e.lanes|e.childLanes,e=e.sibling;c.childLanes=d}null!==a&&0===(a.flags&2048)&&(null===a.firstEffect&&(a.firstEffect=b.firstEffect),null!==b.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=b.firstEffect),a.lastEffect=b.lastEffect),1<b.flags&&(null!==
a.lastEffect?a.lastEffect.nextEffect=b:a.firstEffect=b,a.lastEffect=b))}else{c=Li(b);if(null!==c){c.flags&=2047;Y=c;return}null!==a&&(a.firstEffect=a.lastEffect=null,a.flags|=2048)}b=b.sibling;if(null!==b){Y=b;return}Y=b=a}while(null!==b);0===V&&(V=5)}function Uj(a){var b=eg();gg(99,dk.bind(null,a,b));return null}
function dk(a,b){do Oj();while(null!==yj);if(0!==(X&48))throw Error(y(327));var c=a.finishedWork;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(y(177));a.callbackNode=null;var d=c.lanes|c.childLanes,e=d,f=a.pendingLanes&~e;a.pendingLanes=e;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=e;a.mutableReadLanes&=e;a.entangledLanes&=e;e=a.entanglements;for(var g=a.eventTimes,h=a.expirationTimes;0<f;){var k=31-Vc(f),l=1<<k;e[k]=0;g[k]=-1;h[k]=-1;f&=~l}null!==
Cj&&0===(d&24)&&Cj.has(a)&&Cj.delete(a);a===U&&(Y=U=null,W=0);1<c.flags?null!==c.lastEffect?(c.lastEffect.nextEffect=c,d=c.firstEffect):d=c:d=c.firstEffect;if(null!==d){e=X;X|=32;pj.current=null;kf=fd;g=Ne();if(Oe(g)){if("selectionStart"in g)h={start:g.selectionStart,end:g.selectionEnd};else a:if(h=(h=g.ownerDocument)&&h.defaultView||window,(l=h.getSelection&&h.getSelection())&&0!==l.rangeCount){h=l.anchorNode;f=l.anchorOffset;k=l.focusNode;l=l.focusOffset;try{h.nodeType,k.nodeType}catch(va){h=null;
break a}var n=0,A=-1,p=-1,C=0,x=0,w=g,z=null;b:for(;;){for(var u;;){w!==h||0!==f&&3!==w.nodeType||(A=n+f);w!==k||0!==l&&3!==w.nodeType||(p=n+l);3===w.nodeType&&(n+=w.nodeValue.length);if(null===(u=w.firstChild))break;z=w;w=u}for(;;){if(w===g)break b;z===h&&++C===f&&(A=n);z===k&&++x===l&&(p=n);if(null!==(u=w.nextSibling))break;w=z;z=w.parentNode}w=u}h=-1===A||-1===p?null:{start:A,end:p}}else h=null;h=h||{start:0,end:0}}else h=null;lf={focusedElem:g,selectionRange:h};fd=!1;Ij=null;Jj=!1;Z=d;do try{ek()}catch(va){if(null===
Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Ij=null;Z=d;do try{for(g=a;null!==Z;){var t=Z.flags;t&16&&pb(Z.stateNode,"");if(t&128){var q=Z.alternate;if(null!==q){var v=q.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(t&1038){case 2:fj(Z);Z.flags&=-3;break;case 6:fj(Z);Z.flags&=-3;ij(Z.alternate,Z);break;case 1024:Z.flags&=-1025;break;case 1028:Z.flags&=-1025;ij(Z.alternate,Z);break;case 4:ij(Z.alternate,Z);break;case 8:h=Z;cj(g,h);var J=h.alternate;dj(h);null!==
J&&dj(J)}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);v=lf;q=Ne();t=v.focusedElem;g=v.selectionRange;if(q!==t&&t&&t.ownerDocument&&Me(t.ownerDocument.documentElement,t)){null!==g&&Oe(t)&&(q=g.start,v=g.end,void 0===v&&(v=q),"selectionStart"in t?(t.selectionStart=q,t.selectionEnd=Math.min(v,t.value.length)):(v=(q=t.ownerDocument||document)&&q.defaultView||window,v.getSelection&&(v=v.getSelection(),h=t.textContent.length,J=Math.min(g.start,h),g=void 0===
g.end?J:Math.min(g.end,h),!v.extend&&J>g&&(h=g,g=J,J=h),h=Le(t,J),f=Le(t,g),h&&f&&(1!==v.rangeCount||v.anchorNode!==h.node||v.anchorOffset!==h.offset||v.focusNode!==f.node||v.focusOffset!==f.offset)&&(q=q.createRange(),q.setStart(h.node,h.offset),v.removeAllRanges(),J>g?(v.addRange(q),v.extend(f.node,f.offset)):(q.setEnd(f.node,f.offset),v.addRange(q))))));q=[];for(v=t;v=v.parentNode;)1===v.nodeType&&q.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===typeof t.focus&&t.focus();for(t=
0;t<q.length;t++)v=q[t],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}fd=!!kf;lf=kf=null;a.current=c;Z=d;do try{for(t=a;null!==Z;){var K=Z.flags;K&36&&Yi(t,Z.alternate,Z);if(K&128){q=void 0;var Q=Z.ref;if(null!==Q){var L=Z.stateNode;switch(Z.tag){case 5:q=L;break;default:q=L}"function"===typeof Q?Q(q):Q.current=q}}Z=Z.nextEffect}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect}while(null!==Z);Z=null;$f();X=e}else a.current=c;if(xj)xj=!1,yj=a,zj=b;else for(Z=d;null!==Z;)b=
Z.nextEffect,Z.nextEffect=null,Z.flags&8&&(K=Z,K.sibling=null,K.stateNode=null),Z=b;d=a.pendingLanes;0===d&&(Ti=null);1===d?a===Ej?Dj++:(Dj=0,Ej=a):Dj=0;c=c.stateNode;if(Mf&&"function"===typeof Mf.onCommitFiberRoot)try{Mf.onCommitFiberRoot(Lf,c,void 0,64===(c.current.flags&64))}catch(va){}Mj(a,O());if(Qi)throw Qi=!1,a=Ri,Ri=null,a;if(0!==(X&8))return null;ig();return null}
function ek(){for(;null!==Z;){var a=Z.alternate;Jj||null===Ij||(0!==(Z.flags&8)?dc(Z,Ij)&&(Jj=!0):13===Z.tag&&mj(a,Z)&&dc(Z,Ij)&&(Jj=!0));var b=Z.flags;0!==(b&256)&&Xi(a,Z);0===(b&512)||xj||(xj=!0,hg(97,function(){Oj();return null}));Z=Z.nextEffect}}function Oj(){if(90!==zj){var a=97<zj?97:zj;zj=90;return gg(a,fk)}return!1}function $i(a,b){Aj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}function Zi(a,b){Bj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}))}
function fk(){if(null===yj)return!1;var a=yj;yj=null;if(0!==(X&48))throw Error(y(331));var b=X;X|=32;var c=Bj;Bj=[];for(var d=0;d<c.length;d+=2){var e=c[d],f=c[d+1],g=e.destroy;e.destroy=void 0;if("function"===typeof g)try{g()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}c=Aj;Aj=[];for(d=0;d<c.length;d+=2){e=c[d];f=c[d+1];try{var h=e.create;e.destroy=h()}catch(k){if(null===f)throw Error(y(330));Wi(f,k)}}for(h=a.current.firstEffect;null!==h;)a=h.nextEffect,h.nextEffect=null,h.flags&8&&(h.sibling=
null,h.stateNode=null),h=a;X=b;ig();return!0}function gk(a,b,c){b=Mi(c,b);b=Pi(a,b,1);Ag(a,b);b=Hg();a=Kj(a,1);null!==a&&($c(a,1,b),Mj(a,b))}
function Wi(a,b){if(3===a.tag)gk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){gk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d))){a=Mi(b,a);var e=Si(c,a,1);Ag(c,e);e=Hg();c=Kj(c,1);if(null!==c)$c(c,1,e),Mj(c,e);else if("function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d)))try{d.componentDidCatch(b,a)}catch(f){}break}}c=c.return}}
function Yj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=Hg();a.pingedLanes|=a.suspendedLanes&c;U===a&&(W&c)===c&&(4===V||3===V&&(W&62914560)===W&&500>O()-jj?Qj(a,0):uj|=c);Mj(a,b)}function lj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=a.mode,0===(b&2)?b=1:0===(b&4)?b=99===eg()?1:2:(0===Gj&&(Gj=tj),b=Yc(62914560&~Gj),0===b&&(b=4194304)));c=Hg();a=Kj(a,b);null!==a&&($c(a,b,c),Mj(a,c))}var ck;
ck=function(a,b,c){var d=b.lanes;if(null!==a)if(a.memoizedProps!==b.pendingProps||N.current)ug=!0;else if(0!==(c&d))ug=0!==(a.flags&16384)?!0:!1;else{ug=!1;switch(b.tag){case 3:ri(b);sh();break;case 5:gh(b);break;case 1:Ff(b.type)&&Jf(b);break;case 4:eh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;var e=b.type._context;I(mg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){if(0!==(c&b.child.childLanes))return ti(a,b,c);I(P,P.current&1);b=hi(a,b,c);return null!==
b?b.sibling:null}I(P,P.current&1);break;case 19:d=0!==(c&b.childLanes);if(0!==(a.flags&64)){if(d)return Ai(a,b,c);b.flags|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);I(P,P.current);if(d)break;else return null;case 23:case 24:return b.lanes=0,mi(a,b,c)}return hi(a,b,c)}else ug=!1;b.lanes=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);a=b.pendingProps;e=Ef(b,M.current);tg(b,c);e=Ch(null,b,d,a,e,c);b.flags|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(Ff(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;xg(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Gg(b,d,g,a);e.updater=Kg;b.stateNode=e;e._reactInternals=b;Og(b,d,a,c);b=qi(null,b,d,!0,f,c)}else b.tag=0,fi(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;a:{null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);
a=b.pendingProps;f=e._init;e=f(e._payload);b.type=e;f=b.tag=hk(e);a=lg(e,a);switch(f){case 0:b=li(null,b,e,a,c);break a;case 1:b=pi(null,b,e,a,c);break a;case 11:b=gi(null,b,e,a,c);break a;case 14:b=ii(null,b,e,lg(e.type,a),d,c);break a}throw Error(y(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),li(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),pi(a,b,d,e,c);case 3:ri(b);d=b.updateQueue;if(null===a||null===d)throw Error(y(282));
d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;yg(a,b);Cg(b,d,null,c);d=b.memoizedState.element;if(d===e)sh(),b=hi(a,b,c);else{e=b.stateNode;if(f=e.hydrate)kh=rf(b.stateNode.containerInfo.firstChild),jh=b,f=lh=!0;if(f){a=e.mutableSourceEagerHydrationData;if(null!=a)for(e=0;e<a.length;e+=2)f=a[e],f._workInProgressVersionPrimary=a[e+1],th.push(f);c=Zg(b,null,d,c);for(b.child=c;c;)c.flags=c.flags&-3|1024,c=c.sibling}else fi(a,b,d,c),sh();b=b.child}return b;case 5:return gh(b),null===a&&
ph(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,nf(d,e)?g=null:null!==f&&nf(d,f)&&(b.flags|=16),oi(a,b),fi(a,b,g,c),b.child;case 6:return null===a&&ph(b),null;case 13:return ti(a,b,c);case 4:return eh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Yg(b,null,d,c):fi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),gi(a,b,d,e,c);case 7:return fi(a,b,b.pendingProps,c),b.child;case 8:return fi(a,b,b.pendingProps.children,
c),b.child;case 12:return fi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(mg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=He(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!N.current){b=hi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=
k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=zg(-1,c&-c),l.tag=2,Ag(h,l));h.lanes|=c;l=h.alternate;null!==l&&(l.lanes|=c);sg(h.return,c);k.lanes|=c;break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}fi(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,tg(b,c),e=vg(e,
f.unstable_observedBits),d=d(e),b.flags|=1,fi(a,b,d,c),b.child;case 14:return e=b.type,f=lg(e,b.pendingProps),f=lg(e.type,f),ii(a,b,e,f,d,c);case 15:return ki(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),b.tag=1,Ff(d)?(a=!0,Jf(b)):a=!1,tg(b,c),Mg(b,d,e),Og(b,d,e,c),qi(null,b,d,!0,a,c);case 19:return Ai(a,b,c);case 23:return mi(a,b,c);case 24:return mi(a,b,c)}throw Error(y(156,b.tag));
};function ik(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.flags=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childLanes=this.lanes=0;this.alternate=null}function nh(a,b,c,d){return new ik(a,b,c,d)}function ji(a){a=a.prototype;return!(!a||!a.isReactComponent)}
function hk(a){if("function"===typeof a)return ji(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Aa)return 11;if(a===Da)return 14}return 2}
function Tg(a,b){var c=a.alternate;null===c?(c=nh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Vg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)ji(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ua:return Xg(c.children,e,f,b);case Ha:g=8;e|=16;break;case wa:g=8;e|=1;break;case xa:return a=nh(12,c,b,e|8),a.elementType=xa,a.type=xa,a.lanes=f,a;case Ba:return a=nh(13,c,b,e),a.type=Ba,a.elementType=Ba,a.lanes=f,a;case Ca:return a=nh(19,c,b,e),a.elementType=Ca,a.lanes=f,a;case Ia:return vi(c,e,f,b);case Ja:return a=nh(24,c,b,e),a.elementType=Ja,a.lanes=f,a;default:if("object"===
typeof a&&null!==a)switch(a.$$typeof){case ya:g=10;break a;case za:g=9;break a;case Aa:g=11;break a;case Da:g=14;break a;case Ea:g=16;d=null;break a;case Fa:g=22;break a}throw Error(y(130,null==a?a:typeof a,""));}b=nh(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Xg(a,b,c,d){a=nh(7,a,d,b);a.lanes=c;return a}function vi(a,b,c,d){a=nh(23,a,d,b);a.elementType=Ia;a.lanes=c;return a}function Ug(a,b,c){a=nh(6,a,null,b);a.lanes=c;return a}
function Wg(a,b,c){b=nh(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function jk(a,b,c){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=0;this.eventTimes=Zc(0);this.expirationTimes=Zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=Zc(0);this.mutableSourceEagerHydrationData=null}
function kk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:ta,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
function lk(a,b,c,d){var e=b.current,f=Hg(),g=Ig(e);a:if(c){c=c._reactInternals;b:{if(Zb(c)!==c||1!==c.tag)throw Error(y(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(Ff(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(y(171));}if(1===c.tag){var k=c.type;if(Ff(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=zg(f,g);b.payload={element:a};d=void 0===d?null:d;null!==
d&&(b.callback=d);Ag(e,b);Jg(e,g,f);return g}function mk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function nk(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b}}function ok(a,b){nk(a,b);(a=a.alternate)&&nk(a,b)}function pk(){return null}
function qk(a,b,c){var d=null!=c&&null!=c.hydrationOptions&&c.hydrationOptions.mutableSources||null;c=new jk(a,b,null!=c&&!0===c.hydrate);b=nh(3,null,null,2===b?7:1===b?3:0);c.current=b;b.stateNode=c;xg(b);a[ff]=c.current;cf(8===a.nodeType?a.parentNode:a);if(d)for(a=0;a<d.length;a++){b=d[a];var e=b._getVersion;e=e(b._source);null==c.mutableSourceEagerHydrationData?c.mutableSourceEagerHydrationData=[b,e]:c.mutableSourceEagerHydrationData.push(b,e)}this._internalRoot=c}
qk.prototype.render=function(a){lk(a,this._internalRoot,null,null)};qk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;lk(null,a,null,function(){b[ff]=null})};function rk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function sk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qk(a,0,b?{hydrate:!0}:void 0)}
function tk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=mk(g);h.call(a)}}lk(b,g,a,e)}else{f=c._reactRootContainer=sk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=mk(g);k.call(a)}}Xj(function(){lk(b,g,a,e)})}return mk(g)}ec=function(a){if(13===a.tag){var b=Hg();Jg(a,4,b);ok(a,4)}};fc=function(a){if(13===a.tag){var b=Hg();Jg(a,67108864,b);ok(a,67108864)}};
gc=function(a){if(13===a.tag){var b=Hg(),c=Ig(a);Jg(a,c,b);ok(a,c)}};hc=function(a,b){return b()};
yb=function(a,b,c){switch(b){case "input":ab(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(y(90));Wa(d);ab(d,e)}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1)}};Gb=Wj;
Hb=function(a,b,c,d,e){var f=X;X|=4;try{return gg(98,a.bind(null,b,c,d,e))}finally{X=f,0===X&&(wj(),ig())}};Ib=function(){0===(X&49)&&(Vj(),Oj())};Jb=function(a,b){var c=X;X|=2;try{return a(b)}finally{X=c,0===X&&(wj(),ig())}};function uk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!rk(b))throw Error(y(200));return kk(a,b,null,c)}var vk={Events:[Cb,ue,Db,Eb,Fb,Oj,{current:!1}]},wk={findFiberByHostInstance:wc,bundleType:0,version:"17.0.2",rendererPackageName:"react-dom"};
var xk={bundleType:wk.bundleType,version:wk.version,rendererPackageName:wk.rendererPackageName,rendererConfig:wk.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ra.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=cc(a);return null===a?null:a.stateNode},findFiberByHostInstance:wk.findFiberByHostInstance||
pk,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var yk=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!yk.isDisabled&&yk.supportsFiber)try{Lf=yk.inject(xk),Mf=yk}catch(a){}}exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=vk;exports.createPortal=uk;
exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(y(188));throw Error(y(268,Object.keys(a)));}a=cc(b);a=null===a?null:a.stateNode;return a};exports.flushSync=function(a,b){var c=X;if(0!==(c&48))return a(b);X|=1;try{if(a)return gg(99,a.bind(null,b))}finally{X=c,ig()}};exports.hydrate=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!0,c)};
exports.render=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!1,c)};exports.unmountComponentAtNode=function(a){if(!rk(a))throw Error(y(40));return a._reactRootContainer?(Xj(function(){tk(null,null,a,!1,function(){a._reactRootContainer=null;a[ff]=null})}),!0):!1};exports.unstable_batchedUpdates=Wj;exports.unstable_createPortal=function(a,b){return uk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!rk(c))throw Error(y(200));if(null==a||void 0===a._reactInternals)throw Error(y(38));return tk(a,b,c,!1,d)};exports.version="17.0.2";


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(132);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f,g,h,k;if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()}}else{var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q}}
if("undefined"===typeof window||"function"!==typeof MessageChannel){var t=null,u=null,w=function(){if(null!==t)try{var a=exports.unstable_now();t(!0,a);t=null}catch(b){throw setTimeout(w,0),b;}};f=function(a){null!==t?setTimeout(f,0,a):(t=a,setTimeout(w,0))};g=function(a,b){u=setTimeout(a,b)};h=function(){clearTimeout(u)};exports.unstable_shouldYield=function(){return!1};k=exports.unstable_forceFrameRate=function(){}}else{var x=window.setTimeout,y=window.clearTimeout;if("undefined"!==typeof console){var z=
window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");"function"!==typeof z&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills")}var A=!1,B=null,C=-1,D=5,E=0;exports.unstable_shouldYield=function(){return exports.unstable_now()>=
E};k=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):D=0<a?Math.floor(1E3/a):5};var F=new MessageChannel,G=F.port2;F.port1.onmessage=function(){if(null!==B){var a=exports.unstable_now();E=a+D;try{B(!0,a)?G.postMessage(null):(A=!1,B=null)}catch(b){throw G.postMessage(null),b;}}else A=!1};f=function(a){B=a;A||(A=!0,G.postMessage(null))};g=function(a,b){C=
x(function(){a(exports.unstable_now())},b)};h=function(){y(C);C=-1}}function H(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<I(e,b))a[d]=b,a[c]=e,c=d;else break a}}function J(a){a=a[0];return void 0===a?null:a}
function K(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>I(n,c))void 0!==r&&0>I(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>I(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function I(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var L=[],M=[],N=1,O=null,P=3,Q=!1,R=!1,S=!1;
function T(a){for(var b=J(M);null!==b;){if(null===b.callback)K(M);else if(b.startTime<=a)K(M),b.sortIndex=b.expirationTime,H(L,b);else break;b=J(M)}}function U(a){S=!1;T(a);if(!R)if(null!==J(L))R=!0,f(V);else{var b=J(M);null!==b&&g(U,b.startTime-a)}}
function V(a,b){R=!1;S&&(S=!1,h());Q=!0;var c=P;try{T(b);for(O=J(L);null!==O&&(!(O.expirationTime>b)||a&&!exports.unstable_shouldYield());){var d=O.callback;if("function"===typeof d){O.callback=null;P=O.priorityLevel;var e=d(O.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?O.callback=e:O===J(L)&&K(L);T(b)}else K(L);O=J(L)}if(null!==O)var m=!0;else{var n=J(M);null!==n&&g(U,n.startTime-b);m=!1}return m}finally{O=null,P=c,Q=!1}}var W=k;exports.unstable_IdlePriority=5;
exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){R||Q||(R=!0,f(V))};exports.unstable_getCurrentPriorityLevel=function(){return P};exports.unstable_getFirstCallbackNode=function(){return J(L)};
exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=W;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3}e=c+e;a={id:N++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,H(M,a),null===J(L)&&a===J(M)&&(S?h():S=!0,g(U,c-d))):(a.sortIndex=e,H(L,a),R||Q||(R=!0,f(V)));return a};
exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AppHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppHeader_css__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppHeader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__AppHeader_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gpk_logo_wht_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gpk_logo_wht_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gpk_logo_wht_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(7);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AppHeader=function(_React$Component){_inherits(AppHeader,_React$Component);function AppHeader(props){_classCallCheck(this,AppHeader);var _this=_possibleConstructorReturn(this,(AppHeader.__proto__||Object.getPrototypeOf(AppHeader)).call(this,props));_this.updateTitle=function(t){_this.setState({title:t});document.title=t;};_this.setMode=function(mode){_this.setState({});};_this.AdminButton=function(props){return _this.Session.user!==""&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/admin',className:'globaltool'},'Administrera');};_this.Icon=function(props){var group=_this.CompetitionGroups.active;if(group.label===undefined){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_1__gpk_logo_wht_png___default.a,className:'Gpk-logo',alt:'logo'}));}if(group.url!==undefined){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('a',{href:''+group.url},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:group.iconPath,className:'Gpk-logo',alt:'logo'}));}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/group/'+group.label},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{src:group.iconPath,className:'Gpk-logo',alt:'logo'}));};_this.state={title:props.title};document.title=props.title;_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.changeTitle,_this.updateTitle);_this.subscribe(_this.Events.userChanged,function(){return _this.setState({});});_this.subscribe(_this.Events.configurationLoaded,function(){return _this.setState({});});_this.subscribe(_this.Events.modeChanged,_this.setMode);_this.subscribe(_this.Events.competitionGroupsUpdated,function(){return _this.setState({});});return _this;}_createClass(AppHeader,[{key:'mobileHeader',value:function mobileHeader(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('header',{className:'App-header mobile',style:{color:this.color(),backgroundColor:this.background()}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h1',{className:'App-title'},this.state.title),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:'App-header-tools'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:'global-tools'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/',className:'globaltool'},'Hem'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(this.LoginLogout,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/help',className:'globaltool'},'Hj\xE4lp?'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/about',className:'globaltool'},'Om...'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(this.ModeSelector,null))));}},{key:'background',value:function background(){if(this.CompetitionGroups.active){return this.CompetitionGroups.active.background;}return"#222";}},{key:'color',value:function color(){if(this.CompetitionGroups.active){return this.CompetitionGroups.active.color;}return"white";}},{key:'normalHeader',value:function normalHeader(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('header',{className:'App-header',style:{color:this.color(),backgroundColor:this.background()}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h1',{className:'App-title'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(this.Icon,null),this.state.title),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:'App-header-tools'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:'global-tools'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/',className:'globaltool'},'Hem'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(this.AdminButton,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(this.LoginLogout,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/help',className:'globaltool'},'Hj\xE4lp?'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/about',className:'globaltool'},'Om...'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(this.ModeSelector,null)),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('p',{className:'version'},'version ',"2.9.0",this.Configuration.loaded&&this.Configuration.site==="test"&&" (utveckling)")));}},{key:'render',value:function render(){return this.Configuration.mode==="mobile"?this.mobileHeader():this.normalHeader();}}]);return AppHeader;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);AppHeader.register={name:"AppHeader"};AppHeader.wire=["LoginLogout","LocalToggle","DeleteCookies","ModeSelector","Events","EventBus","Session","Configuration","CompetitionGroups"];

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(137);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(31);





var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : {};

function getUniqueId() {
  var key = '__global_unique_id__';
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
}

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + getUniqueId() + '__';

  var Provider = /*#__PURE__*/function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          if (false) {
            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired, _Provider$childContex);

  var Consumer = /*#__PURE__*/function (_Component2) {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext || createReactContext;

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(59)))

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(142)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 142 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(65);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Busy; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BusyIndicator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Busy=function(){function Busy(){_classCallCheck(this,Busy);this.busy=[];}_createClass(Busy,[{key:"setBusy",value:function setBusy(id,busy){if(busy){this.busy.push(id);}else{this.busy=this.busy.filter(function(e){return e!==id;});}this.fire(this.Events.busyChanged);}},{key:"wrap",value:function wrap(x){var _this=this;this.setBusy(x,true);for(var _len=arguments.length,args=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){args[_key-1]=arguments[_key];}x.apply(undefined,_toConsumableArray(args.map(function(p){return typeof p==="function"?function(){p.apply(undefined,arguments);_this.setBusy(x,false);}:p;})));}}]);return Busy;}();// ToDo: apply withEvents
Busy.register={name:"Busy",createInstance:true};Busy.wire=["fire","Events"];var BusyIndicator=function(_React$Component){_inherits(BusyIndicator,_React$Component);function BusyIndicator(props){_classCallCheck(this,BusyIndicator);var _this2=_possibleConstructorReturn(this,(BusyIndicator.__proto__||Object.getPrototypeOf(BusyIndicator)).call(this,props));_this2.EventBus.manageEvents(_this2);_this2.subscribe(_this2.Events.busyChanged,function(){return _this2.setState({});});return _this2;}_createClass(BusyIndicator,[{key:"render",value:function render(){return this.Busy.busy.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fullscreen shadow"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"centered"},"Working..."));}}]);return BusyIndicator;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);BusyIndicator.register={name:"BusyIndicator"};BusyIndicator.wire=["Busy","Events","EventBus"];

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClubSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClubSelector=function(_React$Component){_inherits(ClubSelector,_React$Component);function ClubSelector(props){_classCallCheck(this,ClubSelector);var _this=_possibleConstructorReturn(this,(ClubSelector.__proto__||Object.getPrototypeOf(ClubSelector)).call(this,props));_this.state={data:_this.Clubs.data};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.clubsLoaded,function(){return _this.setState({data:_this.Clubs.data});});return _this;}_createClass(ClubSelector,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",Object.assign({},this.props,{list:"clubs"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("datalist",{id:"clubs"},this.state.data.map(function(s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:s.id,value:s.name});})));}}]);return ClubSelector;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ClubSelector.register={name:"ClubSelector"};ClubSelector.wire=["Events","EventBus","Clubs"];

/***/ }),
/* 147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 148 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompetitionProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompetitionProperties_css__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompetitionProperties_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CompetitionProperties_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var default_class_group=[{id:-1,description:"Ingen klassindelning"}];var default_division_group=[{id:-1,description:"Inget val av vapengrupp"}];var CompetitionProperties=function(_React$Component){_inherits(CompetitionProperties,_React$Component);function CompetitionProperties(props){_classCallCheck(this,CompetitionProperties);var _this=_possibleConstructorReturn(this,(CompetitionProperties.__proto__||Object.getPrototypeOf(CompetitionProperties)).call(this,props));_this.toggle50pct=function(e){if(_this.Competition.rules.includes("50pct")){_this.Competition.removeRule("50pct");}else{_this.Competition.addRule("50pct");}};_this.toggleShowAcct=function(e){if(_this.Competition.rules.includes("show-acct")){_this.Competition.removeRule("show-acct");}else{_this.Competition.addRule("show-acct");}};_this.state={classGroups:default_class_group,divisionGroups:default_division_group};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.competitionUpdated,function(){return _this.setState({});});return _this;}_createClass(CompetitionProperties,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.ClassGroups.load(function(list){return _this2.setState({classGroups:default_class_group.concat(list)});});this.DivisionGroups.load(function(list){return _this2.setState({divisionGroups:default_division_group.concat(list)});});}},{key:'render',value:function render(){var _this3=this;var _state=this.state,classGroups=_state.classGroups,divisionGroups=_state.divisionGroups;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.StageProperties,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.ScheduleProperties,{divisionGroups:divisionGroups,onDelete:this.deleteSchedule}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.TeamProperties,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'competition-properties'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-group-label"},className:'property-label'},'Grupp'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-group-input"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{value:this.Competition.group,onChange:function onChange(e){return _this3.Competition.setProperty("group",e.target.value);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{value:''},'Ingen grupp'),this.CompetitionGroups.groups.map(function(g){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:g.id,value:g.label},g.name);}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-name-label"},className:'property-label'},'Namn'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-name-input"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.Competition.name,size:'50',placeholder:'Namn',onChange:function onChange(e){return _this3.Competition.setProperty("name",e.target.value);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-short-label"},className:'property-label'},'Underrubrik'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-short-input"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'text',value:this.Competition.shortDesc,size:'50',placeholder:'Underrubrik',onChange:function onChange(e){return _this3.Competition.setProperty("shortDesc",e.target.value);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-desc-label"},className:'property-label'},'Beskrivning'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-desc-input"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{rows:'8',cols:'50',placeholder:'Beskrivning',onChange:function onChange(e){return _this3.Competition.setProperty("description",e.target.value);},value:this.Competition.description})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-status-label"},className:'property-label'},'Status'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-status-input"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3____["Dropdown"],{className:'eventProperty',value:this.Competition.status,list:CompetitionProperties.status,onChange:function onChange(e){return _this3.Competition.setProperty("status",parseInt(e.target.value,10));}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-50pct-label"},className:'property-label'},'Max 50% skyttar fr\xE5n samma f\xF6rening'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-50pct-input"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',checked:this.Competition.rules.includes("50pct"),onChange:this.toggle50pct})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-show-acct-label"},className:'property-label'},'Visa f\xE4lt f\xF6r konto'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{gridArea:"competition-show-acct-input"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'checkbox',checked:this.Competition.rules.includes("show-acct"),onChange:this.toggleShowAcct}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'add-event'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:'addEventButton',className:'button-add green',onClick:function onClick(e){return _this3.Competition.addEvent();}}),'L\xE4gg till delt\xE4vling'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,this.Competition.events.map(function(e){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this3.EventProperties,{key:e.id,event:e,classGroups:classGroups,divisionGroups:divisionGroups});}))));}}]);return CompetitionProperties;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);CompetitionProperties.register={name:"CompetitionProperties"};CompetitionProperties.wire=["EventBus","Events","Server","CompetitionGroups","Competition","EventProperties","ScheduleProperties","StageProperties","DivisionGroups","ClassGroups","TeamProperties"];CompetitionProperties.status=[{id:__WEBPACK_IMPORTED_MODULE_2__models__["Status"].Hidden,description:"Gömd"},{id:__WEBPACK_IMPORTED_MODULE_2__models__["Status"].Open,description:"Öppen"},{id:__WEBPACK_IMPORTED_MODULE_2__models__["Status"].Closed,description:"Stängd"}];

/***/ }),
/* 150 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClassGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ClassGroups; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ValueList__ = __webpack_require__(67);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * A "class" is a ranking/rating tied to a participant. Example: in PPC, a participant can be a "High Master",
 * which is a higher rank than "Master". This is used to separate participants into groups where participants
 * compete against others of similar skill or with a similar handicap.
 * 
 * A "class group" is a set of classes that are valid for a given event. This can vary depending on the event 
 * and the discipline. Example: in a national competition you may be rated as class 1, 2 or 3 whereas in a PPC 
 * competition you are rated as "Master" or "High Master" (and a few others).
 */var ClassGroup=function(_ValueList){_inherits(ClassGroup,_ValueList);function ClassGroup(id,description){_classCallCheck(this,ClassGroup);return _possibleConstructorReturn(this,(ClassGroup.__proto__||Object.getPrototypeOf(ClassGroup)).call(this,"classes",id,description));}_createClass(ClassGroup,null,[{key:"fromJson",value:function fromJson(json){return __WEBPACK_IMPORTED_MODULE_0__ValueList__["a" /* ValueList */].fromJson(json,"classes");}}]);return ClassGroup;}(__WEBPACK_IMPORTED_MODULE_0__ValueList__["a" /* ValueList */]);var ClassGroups=function(){function ClassGroups(){_classCallCheck(this,ClassGroups);this.classGroups=[];}_createClass(ClassGroups,[{key:"forceLoad",value:function forceLoad(callback){var _this2=this;this.Server.loadClassGroups(function(data){_this2.classGroups=data.map(function(c){return ClassGroup.fromJson(c);});_this2.classGroups.sort(function(a,b){return a.index-b.index;});callback(_this2.classGroups);},this.Footers.errorHandler("Kan inte hämta klassindelning"));}},{key:"load",value:function load(callback){if(this.classGroups.length===0){this.forceLoad(callback);}else{callback(this.classGroups);}}},{key:"save",value:function save(newList){var _this3=this;var index=1;var deleteList=this.classGroups.filter(function(g){return!newList.some(function(n){return n.id===g.id;});});this.classGroups=newList;newList.forEach(function(g){return g.index=index++;});deleteList.forEach(function(g){return _this3.Server.deleteClassGroup(g.id,function(){});});newList.forEach(function(g){if(g.id<1000){_this3.Server.createClassGroup(g.toJson(),function(cg){return g.id=parseInt(cg.id,10);});}else{_this3.Server.updateClassGroup(g.toJson(),function(){});}});}},{key:"find",value:function find(x){return this.classGroups.find(x);}}]);return ClassGroups;}();ClassGroups.register={name:"ClassGroups",createInstance:true};ClassGroups.wire=["Server","Footers"];

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Clubs; });
function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Clubs=function Clubs(){var _this=this;_classCallCheck(this,Clubs);this.data=[];this.initialize=function(){fetch("/clubs.json").then(function(res){if(res.ok)res.json().then(function(json){_this.data=json;_this.fire(_this.Events.clubsLoaded);});});};};Clubs.register={name:"Clubs",createInstance:true};Clubs.wire=["fire","Events","Server"];

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventGroup; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var EventGroup=function(){function EventGroup(id,name,events,classes){_classCallCheck(this,EventGroup);this.id=id||0;this.name=name;this.events=events||[];this.classes=classes;}_createClass(EventGroup,null,[{key:"toNumber",value:function toNumber(x){if(x===undefined){return undefined;}x=parseInt(x.toString(),10);return isNaN(x)?undefined:x;}},{key:"fromJson",value:function fromJson(obj){return new EventGroup(EventGroup.toNumber(obj.id),obj.name,obj.events?obj.events.map(function(e){return EventGroup.toNumber(e);}):[],obj.classes?EventGroup.toNumber(obj.classes):obj.classes);}}]);return EventGroup;}();

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompetitionGroup; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var CompetitionGroup=function(){function CompetitionGroup(id,label,name,description,icon,url,background,color,status){_classCallCheck(this,CompetitionGroup);this.id=id;this.label=label;this.name=name;this.description=description;this.icon=icon;this.url=url;this.background=background;this.color=color;this.status=status;}_createClass(CompetitionGroup,null,[{key:"fromJson",value:function fromJson(_ref){var id=_ref.id,label=_ref.label,name=_ref.name,description=_ref.description,icon=_ref.icon,url=_ref.url,background=_ref.background,color=_ref.color,status=_ref.status;function parse(i){return typeof i==="number"?i:parseInt(i,10);}return new CompetitionGroup(parse(id),label,name,description,icon,url,background,color,parse(status));}},{key:"toJson",value:function toJson(g){return g;}}]);return CompetitionGroup;}();

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DivisionGroup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DivisionGroups; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ValueList__ = __webpack_require__(67);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/** List of Divisions a participant can compete in. A Division is a way to separate participants
 * based on factors not related to the participants themselves. E.g. which equipment they are using.
 * Example: PPC SR2,75" is a Division separate from PPC SR4" */var DivisionGroup=function(_ValueList){_inherits(DivisionGroup,_ValueList);function DivisionGroup(id,description){_classCallCheck(this,DivisionGroup);return _possibleConstructorReturn(this,(DivisionGroup.__proto__||Object.getPrototypeOf(DivisionGroup)).call(this,"divisions",id,description));}_createClass(DivisionGroup,null,[{key:"fromJson",value:function fromJson(json){return __WEBPACK_IMPORTED_MODULE_0__ValueList__["a" /* ValueList */].fromJson(json,"divisions");}}]);return DivisionGroup;}(__WEBPACK_IMPORTED_MODULE_0__ValueList__["a" /* ValueList */]);/** A list of ways a competition can be stratified into different Divisions.
 * Example: One entry might contain the different divisions for PPC, while another might contain the
 * ones for Precision shooting.
 */var DivisionGroups=function(){function DivisionGroups(){_classCallCheck(this,DivisionGroups);this.divisionGroups=[];}_createClass(DivisionGroups,[{key:"forceLoad",value:function forceLoad(callback){var _this2=this;this.Server.loadDivisionGroups(function(data){_this2.divisionGroups=data.map(function(c){return DivisionGroup.fromJson(c);});_this2.divisionGroups.sort(function(a,b){return a.index-b.index;});callback(_this2.divisionGroups);},this.Footers.errorHandler("Kan inte hämta vapengruppsindelning"));}},{key:"load",value:function load(callback){if(this.divisionGroups.length===0){this.forceLoad(callback);}else{callback(this.divisionGroups);}}},{key:"save",value:function save(newList){var _this3=this;var index=1;var deleteList=this.divisionGroups.filter(function(g){return!newList.some(function(n){return n.id===g.id;});});this.divisionGroups=newList;newList.forEach(function(g){return g.index=index++;});deleteList.forEach(function(g){return _this3.Server.deleteDivisionGroup(g.id,function(){});});newList.forEach(function(g){if(g.id<1000){_this3.Server.createDivisionGroup(g.toJson(),function(cg){return g.id=parseInt(cg.id,10);});}else{_this3.Server.updateDivisionGroup(g.toJson(),function(){});}});// this.forceLoad(() => { });
}},{key:"find",value:function find(x){return this.divisionGroups.find(x);}}]);return DivisionGroups;}();DivisionGroups.register={name:"DivisionGroups",createInstance:true};DivisionGroups.wire=["Server","Footers"];

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Event; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(1);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Event=function(){function Event(id,name,date){_classCallCheck(this,Event);this.id=id;this.name=name;this.date=date;this.discipline=__WEBPACK_IMPORTED_MODULE_0____["Discipline"].none;this.maxRegistrations=1;this.scores=8;this.stages=[];this.teams=[];this.cost=100;}_createClass(Event,[{key:"adjustStages",value:function adjustStages(){if(__WEBPACK_IMPORTED_MODULE_0____["Discipline"].hasStages.includes(this.discipline)){while(this.stages.length<this.scores){this.stages.push(new __WEBPACK_IMPORTED_MODULE_0____["StageDef"](this.stages.length+1));}while(this.stages.length>this.scores){this.stages.pop();}}}},{key:"getStage",value:function getStage(num){return this.stages.find(function(s){return s.num===num;});}},{key:"toJson",// Necessary to avoid storing objects
value:function toJson(){function pad(num){var s=num.toString();while(s.length<2){s="0"+s;}return s;}return{name:this.name,// date: this.date,
date:this.date.getFullYear()+"-"+pad(this.date.getMonth()+1)+"-"+pad(this.date.getDate()),id:this.id,classes:this.classes,divisions:this.divisions,schedule:this.schedule&&this.schedule.id?this.schedule.id:this.schedule,maxRegistrations:this.maxRegistrations,scores:this.scores,cost:this.cost,discipline:__WEBPACK_IMPORTED_MODULE_0____["Discipline"].toJson(this.discipline),stages:__WEBPACK_IMPORTED_MODULE_0____["Discipline"].hasStages.includes(this.discipline)?this.stages.map(function(s){return s.toJson();}):[],teamDef:this.teams.map(function(t){return t.toJson();})};}}],[{key:"fromJson",value:function fromJson(e){function toNumber(x){if(x===undefined){return undefined;}x=parseInt(x.toString(),10);return isNaN(x)?undefined:x;}var nE=new Event(toNumber(e.id),e.name,new Date(e.date||Date.now()));nE.classes=toNumber(e.classes);nE.divisions=toNumber(e.divisions);nE.schedule=_typeof(e.schedule)==="object"?e.schedule.id:toNumber(e.schedule);nE.schedule=nE.schedule===0?undefined:nE.schedule;nE.maxRegistrations=parseInt(e.maxRegistrations.toString(),10);nE.scores=e.scores!==undefined?parseInt(e.scores.toString(),10):8;nE.cost=e.cost!==undefined?parseInt(e.cost.toString(),10):100;nE.discipline=__WEBPACK_IMPORTED_MODULE_0____["Discipline"].fromJson(e.discipline);nE.stages=e.stages!==undefined?e.stages.map(function(s){return __WEBPACK_IMPORTED_MODULE_0____["StageDef"].fromJson(s);}):[];nE.teams=e.teamDef!==undefined?e.teamDef.map(function(t){return __WEBPACK_IMPORTED_MODULE_0____["TeamDef"].fromJson(t);}):[];return nE;}}]);return Event;}();

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Time; });
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Time=function(){function Time(){_classCallCheck(this,Time);}_createClass(Time,null,[{key:"pad",value:function pad(number,length){return number.toString().length<length?"0"+number:number;}},{key:"canSetTime",value:function canSetTime(text){return text.toString().match(/^[0-2]?\d?:?[0-5]?\d?$/);}},{key:"format",value:function format(t){return Math.trunc(t/60)+":"+Time.pad(t%60,2);}},{key:"timeFromText",value:function timeFromText(text){var _text$split=text.split(":"),_text$split2=_slicedToArray(_text$split,2),hrs=_text$split2[0],mins=_text$split2[1];hrs=parseInt(hrs,10);if(!mins&&hrs>24)return hrs;return hrs*60+parseInt(mins||"0",10);}},{key:"durationFromText",value:function durationFromText(text){var _text$split3=text.split(":"),_text$split4=_slicedToArray(_text$split3,2),hrs=_text$split4[0],mins=_text$split4[1];if(!mins)return parseInt(hrs,10);return parseInt(hrs,10)*60+parseInt(mins,10);}}]);return Time;}();

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Events; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rxjs__ = __webpack_require__(70);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Events=function Events(){_classCallCheck(this,Events);};Events.register={name:"Events"};Events.eventId=1;Events.addFooter=Events.eventId++;Events.footersChanged=Events.eventId++;Events.changeTitle=Events.eventId++;Events.busyChanged=Events.eventId++;Events.competitionGroupsUpdated=Events.eventId++;Events.competitionUpdated=Events.eventId++;Events.updateCompetition=Events.eventId++;Events.deleteParticipant=Events.eventId++;Events.showParticipantPicker=Events.eventId++;Events.showSchedule=Events.eventId++;Events.editSchedule=Events.eventId++;Events.editStages=Events.eventId++;Events.registryUpdated=Events.eventId++;Events.setRegistrationInfo=Events.eventId++;Events.registrationUpdated=Events.eventId++;Events.resultsUpdated=Events.eventId++;Events.registerForCompetition=Events.eventId++;Events.userChanged=Events.eventId++;Events.serverChanged=Events.eventId++;Events.selectSquad=Events.eventId++;Events.configurationLoaded=Events.eventId++;Events.clubsLoaded=Events.eventId++;Events.modeChanged=Events.eventId++;Events.editTeams=Events.eventId++;var EventBus=function(){function EventBus(){_classCallCheck(this,EventBus);this.bus=new __WEBPACK_IMPORTED_MODULE_0_rxjs__["a" /* Subject */]();}/**
	 * Manages event subscriptions for a React.Component by setting up a list of handlers and masking componentDidMount
	 * and componentWillUnmount to make sure the component subscribes to events at the correct times. This simplified
	 * avoiding problems with messages being sent to unmounted components and triggering a setState().
	 * 
	 * @param {React.Component} target 
	 */_createClass(EventBus,[{key:"manageEvents",value:function manageEvents(target){// Handlers
target._handlers=[];// Subscribe
var targetSubscribe=function targetSubscribe(e,h){this._handlers.push({event:e,handler:h,subscription:null});};target.subscribe=targetSubscribe.bind(target);// Fire
target.fire=this.fire.bind(this);// ComponentDidMount
var mySubscribe=this.subscribe.bind(this);var inheritedMount=target.componentDidMount;var targetMount=function targetMount(){this._handlers.forEach(function(h){return h.subscription=mySubscribe(h.event,h.handler);});if(inheritedMount){inheritedMount.apply(target);}};target.componentDidMount=targetMount.bind(target);// ComponentWillUnmount
var inheritedUnmount=target.componentWillUnmount;var targetUnmount=function targetUnmount(){this._handlers.forEach(function(h){if(h.subscription){h.subscription.unsubscribe();h.subscription=null;}});if(inheritedUnmount){inheritedUnmount.apply(target);}};target.componentWillUnmount=targetUnmount.bind(target);}},{key:"subscribe",value:function subscribe(event,action){if(event===undefined){throw new Error("Cannot subscribe to undefined event!");}// ToDo: add error handling?
return this.bus.subscribe(function(_ref){var ev=_ref.ev,params=_ref.params;if(ev===event){action.apply(null,params);}});}},{key:"fire",value:function fire(event){for(var _len=arguments.length,params=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){params[_key-1]=arguments[_key];}this.bus.next({ev:event,params:params});}}]);return EventBus;}();EventBus.register={name:"EventBus",createInstance:true};

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPLETE_NOTIFICATION; });
/* harmony export (immutable) */ __webpack_exports__["b"] = errorNotification;
/* harmony export (immutable) */ __webpack_exports__["c"] = nextNotification;
/* unused harmony export createNotification */
var COMPLETE_NOTIFICATION = (function () { return createNotification('C', undefined, undefined); })();
function errorNotification(error) {
    return createNotification('E', undefined, error);
}
function nextNotification(value) {
    return createNotification('N', value, undefined);
}
function createNotification(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error,
    };
}
//# sourceMappingURL=NotificationFactories.js.map

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ConnectableObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operators_refCount__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operators_OperatorSubscriber__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_lift__ = __webpack_require__(15);






var ConnectableObservable = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(ConnectableObservable, _super);
    function ConnectableObservable(source, subjectFactory) {
        var _this = _super.call(this) || this;
        _this.source = source;
        _this.subjectFactory = subjectFactory;
        _this._subject = null;
        _this._refCount = 0;
        _this._connection = null;
        if (Object(__WEBPACK_IMPORTED_MODULE_5__util_lift__["a" /* hasLift */])(source)) {
            _this.lift = source.lift;
        }
        return _this;
    }
    ConnectableObservable.prototype._subscribe = function (subscriber) {
        return this.getSubject().subscribe(subscriber);
    };
    ConnectableObservable.prototype.getSubject = function () {
        var subject = this._subject;
        if (!subject || subject.isStopped) {
            this._subject = this.subjectFactory();
        }
        return this._subject;
    };
    ConnectableObservable.prototype._teardown = function () {
        this._refCount = 0;
        var _connection = this._connection;
        this._subject = this._connection = null;
        _connection === null || _connection === void 0 ? void 0 : _connection.unsubscribe();
    };
    ConnectableObservable.prototype.connect = function () {
        var _this = this;
        var connection = this._connection;
        if (!connection) {
            connection = this._connection = new __WEBPACK_IMPORTED_MODULE_2__Subscription__["b" /* Subscription */]();
            var subject_1 = this.getSubject();
            connection.add(this.source.subscribe(new __WEBPACK_IMPORTED_MODULE_4__operators_OperatorSubscriber__["a" /* OperatorSubscriber */](subject_1, undefined, function () {
                _this._teardown();
                subject_1.complete();
            }, function (err) {
                _this._teardown();
                subject_1.error(err);
            }, function () { return _this._teardown(); })));
            if (connection.closed) {
                this._connection = null;
                connection = __WEBPACK_IMPORTED_MODULE_2__Subscription__["b" /* Subscription */].EMPTY;
            }
        }
        return connection;
    };
    ConnectableObservable.prototype.refCount = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_3__operators_refCount__["a" /* refCount */])()(this);
    };
    return ConnectableObservable;
}(__WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */]));

//# sourceMappingURL=ConnectableObservable.js.map

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = refCount;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_lift__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OperatorSubscriber__ = __webpack_require__(12);


function refCount() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util_lift__["b" /* operate */])(function (source, subscriber) {
        var connection = null;
        source._refCount++;
        var refCounter = new __WEBPACK_IMPORTED_MODULE_1__OperatorSubscriber__["a" /* OperatorSubscriber */](subscriber, undefined, undefined, undefined, function () {
            if (!source || source._refCount <= 0 || 0 < --source._refCount) {
                connection = null;
                return;
            }
            var sharedConnection = source._connection;
            var conn = connection;
            connection = null;
            if (sharedConnection && (!conn || sharedConnection === conn)) {
                sharedConnection.unsubscribe();
            }
            subscriber.unsubscribe();
        });
        source.subscribe(refCounter);
        if (!refCounter.closed) {
            connection = source.connect();
        }
    });
}
//# sourceMappingURL=refCount.js.map

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export animationFrames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_performanceTimestampProvider__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scheduler_animationFrameProvider__ = __webpack_require__(75);




function animationFrames(timestampProvider) {
    return timestampProvider ? animationFramesFactory(timestampProvider) : DEFAULT_ANIMATION_FRAMES;
}
function animationFramesFactory(timestampProvider) {
    var schedule = __WEBPACK_IMPORTED_MODULE_3__scheduler_animationFrameProvider__["a" /* animationFrameProvider */].schedule;
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var subscription = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["b" /* Subscription */]();
        var provider = timestampProvider || __WEBPACK_IMPORTED_MODULE_2__scheduler_performanceTimestampProvider__["a" /* performanceTimestampProvider */];
        var start = provider.now();
        var run = function (timestamp) {
            var now = provider.now();
            subscriber.next({
                timestamp: timestampProvider ? now : timestamp,
                elapsed: now - start
            });
            if (!subscriber.closed) {
                subscription.add(schedule(run));
            }
        };
        subscription.add(schedule(run));
        return subscription;
    });
}
var DEFAULT_ANIMATION_FRAMES = animationFramesFactory();
//# sourceMappingURL=animationFrames.js.map

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return performanceTimestampProvider; });
var performanceTimestampProvider = {
    now: function () {
        return (performanceTimestampProvider.delegate || performance).now();
    },
    delegate: undefined,
};
//# sourceMappingURL=performanceTimestampProvider.js.map

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BehaviorSubject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(23);


var BehaviorSubject = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function () {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function (subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function () {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) {
            throw thrownError;
        }
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function (value) {
        _super.prototype.next.call(this, (this._value = value));
    };
    return BehaviorSubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]));

//# sourceMappingURL=BehaviorSubject.js.map

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ReplaySubject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subject__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scheduler_dateTimestampProvider__ = __webpack_require__(77);



var ReplaySubject = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) { _bufferSize = Infinity; }
        if (_windowTime === void 0) { _windowTime = Infinity; }
        if (_timestampProvider === void 0) { _timestampProvider = __WEBPACK_IMPORTED_MODULE_2__scheduler_dateTimestampProvider__["a" /* dateTimestampProvider */]; }
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function (value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function (subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for (var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2) {
            subscriber.next(copy[i]);
        }
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function () {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for (var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2) {
                last = i;
            }
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}(__WEBPACK_IMPORTED_MODULE_1__Subject__["a" /* Subject */]));

//# sourceMappingURL=ReplaySubject.js.map

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export asapScheduler */
/* unused harmony export asap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsapAction__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsapScheduler__ = __webpack_require__(172);


var asapScheduler = new __WEBPACK_IMPORTED_MODULE_1__AsapScheduler__["a" /* AsapScheduler */](__WEBPACK_IMPORTED_MODULE_0__AsapAction__["a" /* AsapAction */]);
var asap = asapScheduler;
//# sourceMappingURL=asap.js.map

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsapAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncAction__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__immediateProvider__ = __webpack_require__(170);



var AsapAction = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(AsapAction, _super);
    function AsapAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AsapAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = __WEBPACK_IMPORTED_MODULE_2__immediateProvider__["a" /* immediateProvider */].setImmediate(scheduler.flush.bind(scheduler, undefined)));
    };
    AsapAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if ((delay != null && delay > 0) || (delay == null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            __WEBPACK_IMPORTED_MODULE_2__immediateProvider__["a" /* immediateProvider */].clearImmediate(id);
            scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AsapAction;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncAction__["a" /* AsyncAction */]));

//# sourceMappingURL=AsapAction.js.map

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Action; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(13);


var Action = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        return this;
    };
    return Action;
}(__WEBPACK_IMPORTED_MODULE_1__Subscription__["b" /* Subscription */]));

//# sourceMappingURL=Action.js.map

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return intervalProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);

var intervalProvider = {
    setInterval: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var delegate = intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) || setInterval).apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])([], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(args)));
    },
    clearInterval: function (handle) {
        var delegate = intervalProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined,
};
//# sourceMappingURL=intervalProvider.js.map

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return immediateProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Immediate__ = __webpack_require__(171);


var setImmediate = __WEBPACK_IMPORTED_MODULE_1__util_Immediate__["a" /* Immediate */].setImmediate, clearImmediate = __WEBPACK_IMPORTED_MODULE_1__util_Immediate__["a" /* Immediate */].clearImmediate;
var immediateProvider = {
    setImmediate: function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var delegate = immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.setImmediate) || setImmediate).apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])([], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(args)));
    },
    clearImmediate: function (handle) {
        var delegate = immediateProvider.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearImmediate) || clearImmediate)(handle);
    },
    delegate: undefined,
};
//# sourceMappingURL=immediateProvider.js.map

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Immediate; });
/* unused harmony export TestTools */
var nextHandle = 1;
var resolved;
var activeHandles = {};
function findAndClearHandle(handle) {
    if (handle in activeHandles) {
        delete activeHandles[handle];
        return true;
    }
    return false;
}
var Immediate = {
    setImmediate: function (cb) {
        var handle = nextHandle++;
        activeHandles[handle] = true;
        if (!resolved) {
            resolved = Promise.resolve();
        }
        resolved.then(function () { return findAndClearHandle(handle) && cb(); });
        return handle;
    },
    clearImmediate: function (handle) {
        findAndClearHandle(handle);
    },
};
var TestTools = {
    pending: function () {
        return Object.keys(activeHandles).length;
    }
};
//# sourceMappingURL=Immediate.js.map

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AsapScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = __webpack_require__(25);


var AsapScheduler = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(AsapScheduler, _super);
    function AsapScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsapScheduler.prototype.flush = function (action) {
        this._active = true;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        action = action || actions.shift();
        var count = actions.length;
        do {
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this._active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AsapScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */]));

//# sourceMappingURL=AsapScheduler.js.map

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export queueScheduler */
/* unused harmony export queue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__QueueAction__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__QueueScheduler__ = __webpack_require__(175);


var queueScheduler = new __WEBPACK_IMPORTED_MODULE_1__QueueScheduler__["a" /* QueueScheduler */](__WEBPACK_IMPORTED_MODULE_0__QueueAction__["a" /* QueueAction */]);
var queue = queueScheduler;
//# sourceMappingURL=queue.js.map

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueueAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncAction__ = __webpack_require__(24);


var QueueAction = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(QueueAction, _super);
    function QueueAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    QueueAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay > 0) {
            return _super.prototype.schedule.call(this, state, delay);
        }
        this.delay = delay;
        this.state = state;
        this.scheduler.flush(this);
        return this;
    };
    QueueAction.prototype.execute = function (state, delay) {
        return (delay > 0 || this.closed) ?
            _super.prototype.execute.call(this, state, delay) :
            this._execute(state, delay);
    };
    QueueAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if ((delay != null && delay > 0) || (delay == null && this.delay > 0)) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        return scheduler.flush(this);
    };
    return QueueAction;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncAction__["a" /* AsyncAction */]));

//# sourceMappingURL=QueueAction.js.map

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return QueueScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = __webpack_require__(25);


var QueueScheduler = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(QueueScheduler, _super);
    function QueueScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return QueueScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */]));

//# sourceMappingURL=QueueScheduler.js.map

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export animationFrameScheduler */
/* unused harmony export animationFrame */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AnimationFrameAction__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimationFrameScheduler__ = __webpack_require__(178);


var animationFrameScheduler = new __WEBPACK_IMPORTED_MODULE_1__AnimationFrameScheduler__["a" /* AnimationFrameScheduler */](__WEBPACK_IMPORTED_MODULE_0__AnimationFrameAction__["a" /* AnimationFrameAction */]);
var animationFrame = animationFrameScheduler;
//# sourceMappingURL=animationFrame.js.map

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationFrameAction; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncAction__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__animationFrameProvider__ = __webpack_require__(75);



var AnimationFrameAction = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if (delay !== null && delay > 0) {
            return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        }
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = __WEBPACK_IMPORTED_MODULE_2__animationFrameProvider__["a" /* animationFrameProvider */].requestAnimationFrame(function () { return scheduler.flush(undefined); }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        if ((delay != null && delay > 0) || (delay == null && this.delay > 0)) {
            return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        }
        if (scheduler.actions.length === 0) {
            __WEBPACK_IMPORTED_MODULE_2__animationFrameProvider__["a" /* animationFrameProvider */].cancelAnimationFrame(id);
            scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncAction__["a" /* AsyncAction */]));

//# sourceMappingURL=AnimationFrameAction.js.map

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimationFrameScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__ = __webpack_require__(25);


var AnimationFrameScheduler = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function (action) {
        this._active = true;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        var index = -1;
        action = action || actions.shift();
        var count = actions.length;
        do {
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        } while (++index < count && (action = actions.shift()));
        this._active = false;
        if (error) {
            while (++index < count && (action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    return AnimationFrameScheduler;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncScheduler__["a" /* AsyncScheduler */]));

//# sourceMappingURL=AnimationFrameScheduler.js.map

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VirtualTimeScheduler */
/* unused harmony export VirtualAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AsyncAction__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Subscription__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AsyncScheduler__ = __webpack_require__(25);




var VirtualTimeScheduler = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(VirtualTimeScheduler, _super);
    function VirtualTimeScheduler(schedulerActionCtor, maxFrames) {
        if (schedulerActionCtor === void 0) { schedulerActionCtor = VirtualAction; }
        if (maxFrames === void 0) { maxFrames = Infinity; }
        var _this = _super.call(this, schedulerActionCtor, function () { return _this.frame; }) || this;
        _this.maxFrames = maxFrames;
        _this.frame = 0;
        _this.index = -1;
        return _this;
    }
    VirtualTimeScheduler.prototype.flush = function () {
        var _a = this, actions = _a.actions, maxFrames = _a.maxFrames;
        var error;
        var action;
        while ((action = actions[0]) && action.delay <= maxFrames) {
            actions.shift();
            this.frame = action.delay;
            if ((error = action.execute(action.state, action.delay))) {
                break;
            }
        }
        if (error) {
            while ((action = actions.shift())) {
                action.unsubscribe();
            }
            throw error;
        }
    };
    VirtualTimeScheduler.frameTimeFactor = 10;
    return VirtualTimeScheduler;
}(__WEBPACK_IMPORTED_MODULE_3__AsyncScheduler__["a" /* AsyncScheduler */]));

var VirtualAction = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __extends */])(VirtualAction, _super);
    function VirtualAction(scheduler, work, index) {
        if (index === void 0) { index = (scheduler.index += 1); }
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.index = index;
        _this.active = true;
        _this.index = scheduler.index = index;
        return _this;
    }
    VirtualAction.prototype.schedule = function (state, delay) {
        if (delay === void 0) { delay = 0; }
        if (Number.isFinite(delay)) {
            if (!this.id) {
                return _super.prototype.schedule.call(this, state, delay);
            }
            this.active = false;
            var action = new VirtualAction(this.scheduler, this.work);
            this.add(action);
            return action.schedule(state, delay);
        }
        else {
            return __WEBPACK_IMPORTED_MODULE_2__Subscription__["b" /* Subscription */].EMPTY;
        }
    };
    VirtualAction.prototype.requestAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        this.delay = scheduler.frame + delay;
        var actions = scheduler.actions;
        actions.push(this);
        actions.sort(VirtualAction.sortActions);
        return true;
    };
    VirtualAction.prototype.recycleAsyncId = function (scheduler, id, delay) {
        if (delay === void 0) { delay = 0; }
        return undefined;
    };
    VirtualAction.prototype._execute = function (state, delay) {
        if (this.active === true) {
            return _super.prototype._execute.call(this, state, delay);
        }
    };
    VirtualAction.sortActions = function (a, b) {
        if (a.delay === b.delay) {
            if (a.index === b.index) {
                return 0;
            }
            else if (a.index > b.index) {
                return 1;
            }
            else {
                return -1;
            }
        }
        else if (a.delay > b.delay) {
            return 1;
        }
        else {
            return -1;
        }
    };
    return VirtualAction;
}(__WEBPACK_IMPORTED_MODULE_1__AsyncAction__["a" /* AsyncAction */]));

//# sourceMappingURL=VirtualTimeScheduler.js.map

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NotificationKind */
/* unused harmony export Notification */
/* unused harmony export observeNotification */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_empty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__observable_of__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_throwError__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isFunction__ = __webpack_require__(5);




var NotificationKind;
(function (NotificationKind) {
    NotificationKind["NEXT"] = "N";
    NotificationKind["ERROR"] = "E";
    NotificationKind["COMPLETE"] = "C";
})(NotificationKind || (NotificationKind = {}));
var Notification = (function () {
    function Notification(kind, value, error) {
        this.kind = kind;
        this.value = value;
        this.error = error;
        this.hasValue = kind === 'N';
    }
    Notification.prototype.observe = function (observer) {
        return observeNotification(this, observer);
    };
    Notification.prototype.do = function (nextHandler, errorHandler, completeHandler) {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        return kind === 'N' ? nextHandler === null || nextHandler === void 0 ? void 0 : nextHandler(value) : kind === 'E' ? errorHandler === null || errorHandler === void 0 ? void 0 : errorHandler(error) : completeHandler === null || completeHandler === void 0 ? void 0 : completeHandler();
    };
    Notification.prototype.accept = function (nextOrObserver, error, complete) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_3__util_isFunction__["a" /* isFunction */])((_a = nextOrObserver) === null || _a === void 0 ? void 0 : _a.next)
            ? this.observe(nextOrObserver)
            : this.do(nextOrObserver, error, complete);
    };
    Notification.prototype.toObservable = function () {
        var _a = this, kind = _a.kind, value = _a.value, error = _a.error;
        var result = kind === 'N'
            ?
                Object(__WEBPACK_IMPORTED_MODULE_1__observable_of__["a" /* of */])(value)
            :
                kind === 'E'
                    ?
                        Object(__WEBPACK_IMPORTED_MODULE_2__observable_throwError__["a" /* throwError */])(function () { return error; })
                    :
                        kind === 'C'
                            ?
                                __WEBPACK_IMPORTED_MODULE_0__observable_empty__["a" /* EMPTY */]
                            :
                                0;
        if (!result) {
            throw new TypeError("Unexpected notification kind " + kind);
        }
        return result;
    };
    Notification.createNext = function (value) {
        return new Notification('N', value);
    };
    Notification.createError = function (err) {
        return new Notification('E', undefined, err);
    };
    Notification.createComplete = function () {
        return Notification.completeNotification;
    };
    Notification.completeNotification = new Notification('C');
    return Notification;
}());

function observeNotification(notification, observer) {
    var _a, _b, _c;
    var _d = notification, kind = _d.kind, value = _d.value, error = _d.error;
    if (typeof kind !== 'string') {
        throw new TypeError('Invalid notification, missing "kind"');
    }
    kind === 'N' ? (_a = observer.next) === null || _a === void 0 ? void 0 : _a.call(observer, value) : kind === 'E' ? (_b = observer.error) === null || _b === void 0 ? void 0 : _b.call(observer, error) : (_c = observer.complete) === null || _c === void 0 ? void 0 : _c.call(observer);
}
//# sourceMappingURL=Notification.js.map

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scheduleObservable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscription__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_observable__ = __webpack_require__(21);



function scheduleObservable(input, scheduler) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var sub = new __WEBPACK_IMPORTED_MODULE_1__Subscription__["b" /* Subscription */]();
        sub.add(scheduler.schedule(function () {
            var observable = input[__WEBPACK_IMPORTED_MODULE_2__symbol_observable__["a" /* observable */]]();
            sub.add(observable.subscribe({
                next: function (value) { sub.add(scheduler.schedule(function () { return subscriber.next(value); })); },
                error: function (err) { sub.add(scheduler.schedule(function () { return subscriber.error(err); })); },
                complete: function () { sub.add(scheduler.schedule(function () { return subscriber.complete(); })); },
            }));
        }));
        return sub;
    });
}
//# sourceMappingURL=scheduleObservable.js.map

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = schedulePromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);

function schedulePromise(input, scheduler) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        return scheduler.schedule(function () {
            return input.then(function (value) {
                subscriber.add(scheduler.schedule(function () {
                    subscriber.next(value);
                    subscriber.add(scheduler.schedule(function () { return subscriber.complete(); }));
                }));
            }, function (err) {
                subscriber.add(scheduler.schedule(function () { return subscriber.error(err); }));
            });
        });
    });
}
//# sourceMappingURL=schedulePromise.js.map

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = scheduleReadableStreamLike;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduleAsyncIterable__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isReadableStreamLike__ = __webpack_require__(50);


function scheduleReadableStreamLike(input, scheduler) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__scheduleAsyncIterable__["a" /* scheduleAsyncIterable */])(Object(__WEBPACK_IMPORTED_MODULE_1__util_isReadableStreamLike__["b" /* readableStreamLikeToAsyncGenerator */])(input), scheduler);
}
//# sourceMappingURL=scheduleReadableStreamLike.js.map

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isObservable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFunction__ = __webpack_require__(5);


function isObservable(obj) {
    return !!obj && (obj instanceof __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */] || (Object(__WEBPACK_IMPORTED_MODULE_1__isFunction__["a" /* isFunction */])(obj.lift) && Object(__WEBPACK_IMPORTED_MODULE_1__isFunction__["a" /* isFunction */])(obj.subscribe)));
}
//# sourceMappingURL=isObservable.js.map

/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export lastValueFrom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_EmptyError__ = __webpack_require__(51);

function lastValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function (resolve, reject) {
        var _hasValue = false;
        var _value;
        source.subscribe({
            next: function (value) {
                _value = value;
                _hasValue = true;
            },
            error: reject,
            complete: function () {
                if (_hasValue) {
                    resolve(_value);
                }
                else if (hasConfig) {
                    resolve(config.defaultValue);
                }
                else {
                    reject(new __WEBPACK_IMPORTED_MODULE_0__util_EmptyError__["a" /* EmptyError */]());
                }
            },
        });
    });
}
//# sourceMappingURL=lastValueFrom.js.map

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export firstValueFrom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_EmptyError__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subscriber__ = __webpack_require__(33);


function firstValueFrom(source, config) {
    var hasConfig = typeof config === 'object';
    return new Promise(function (resolve, reject) {
        var subscriber = new __WEBPACK_IMPORTED_MODULE_1__Subscriber__["a" /* SafeSubscriber */]({
            next: function (value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function () {
                if (hasConfig) {
                    resolve(config.defaultValue);
                }
                else {
                    reject(new __WEBPACK_IMPORTED_MODULE_0__util_EmptyError__["a" /* EmptyError */]());
                }
            },
        });
        source.subscribe(subscriber);
    });
}
//# sourceMappingURL=firstValueFrom.js.map

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ArgumentOutOfRangeError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createErrorClass__ = __webpack_require__(17);

var ArgumentOutOfRangeError = Object(__WEBPACK_IMPORTED_MODULE_0__createErrorClass__["a" /* createErrorClass */])(function (_super) {
    return function ArgumentOutOfRangeErrorImpl() {
        _super(this);
        this.name = 'ArgumentOutOfRangeError';
        this.message = 'argument out of range';
    };
});
//# sourceMappingURL=ArgumentOutOfRangeError.js.map

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NotFoundError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createErrorClass__ = __webpack_require__(17);

var NotFoundError = Object(__WEBPACK_IMPORTED_MODULE_0__createErrorClass__["a" /* createErrorClass */])(function (_super) {
    return function NotFoundErrorImpl(message) {
        _super(this);
        this.name = 'NotFoundError';
        this.message = message;
    };
});
//# sourceMappingURL=NotFoundError.js.map

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SequenceError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createErrorClass__ = __webpack_require__(17);

var SequenceError = Object(__WEBPACK_IMPORTED_MODULE_0__createErrorClass__["a" /* createErrorClass */])(function (_super) {
    return function SequenceErrorImpl(message) {
        _super(this);
        this.name = 'SequenceError';
        this.message = message;
    };
});
//# sourceMappingURL=SequenceError.js.map

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TimeoutError */
/* unused harmony export timeout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_async__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isDate__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_lift__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__observable_from__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_createErrorClass__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_caughtSchedule__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__OperatorSubscriber__ = __webpack_require__(12);







var TimeoutError = Object(__WEBPACK_IMPORTED_MODULE_4__util_createErrorClass__["a" /* createErrorClass */])(function (_super) {
    return function TimeoutErrorImpl(info) {
        if (info === void 0) { info = null; }
        _super(this);
        this.message = 'Timeout has occurred';
        this.name = 'TimeoutError';
        this.info = info;
    };
});
function timeout(config, schedulerArg) {
    var _a = (Object(__WEBPACK_IMPORTED_MODULE_1__util_isDate__["a" /* isValidDate */])(config)
        ? { first: config }
        : typeof config === 'number'
            ? { each: config }
            : config), first = _a.first, each = _a.each, _b = _a.with, _with = _b === void 0 ? timeoutErrorFactory : _b, _c = _a.scheduler, scheduler = _c === void 0 ? schedulerArg !== null && schedulerArg !== void 0 ? schedulerArg : __WEBPACK_IMPORTED_MODULE_0__scheduler_async__["b" /* asyncScheduler */] : _c, _d = _a.meta, meta = _d === void 0 ? null : _d;
    if (first == null && each == null) {
        throw new TypeError('No timeout provided.');
    }
    return Object(__WEBPACK_IMPORTED_MODULE_2__util_lift__["b" /* operate */])(function (source, subscriber) {
        var originalSourceSubscription;
        var timerSubscription;
        var lastValue = null;
        var seen = 0;
        var startTimer = function (delay) {
            timerSubscription = Object(__WEBPACK_IMPORTED_MODULE_5__util_caughtSchedule__["a" /* caughtSchedule */])(subscriber, scheduler, function () {
                originalSourceSubscription.unsubscribe();
                Object(__WEBPACK_IMPORTED_MODULE_3__observable_from__["c" /* innerFrom */])(_with({
                    meta: meta,
                    lastValue: lastValue,
                    seen: seen,
                })).subscribe(subscriber);
            }, delay);
        };
        originalSourceSubscription = source.subscribe(new __WEBPACK_IMPORTED_MODULE_6__OperatorSubscriber__["a" /* OperatorSubscriber */](subscriber, function (value) {
            timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
            seen++;
            subscriber.next((lastValue = value));
            each > 0 && startTimer(each);
        }, undefined, undefined, function () {
            if (!(timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.closed)) {
                timerSubscription === null || timerSubscription === void 0 ? void 0 : timerSubscription.unsubscribe();
            }
            lastValue = null;
        }));
        startTimer(first != null ? (typeof first === 'number' ? first : +first - scheduler.now()) : each);
    });
}
function timeoutErrorFactory(info) {
    throw new TimeoutError(info);
}
//# sourceMappingURL=timeout.js.map

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bindCallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bindCallbackInternals__ = __webpack_require__(93);

function bindCallback(callbackFunc, resultSelector, scheduler) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__bindCallbackInternals__["a" /* bindCallbackInternals */])(false, callbackFunc, resultSelector, scheduler);
}
//# sourceMappingURL=bindCallback.js.map

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subscribeOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_lift__ = __webpack_require__(15);

function subscribeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return Object(__WEBPACK_IMPORTED_MODULE_0__util_lift__["b" /* operate */])(function (source, subscriber) {
        subscriber.add(scheduler.schedule(function () { return source.subscribe(subscriber); }, delay));
    });
}
//# sourceMappingURL=subscribeOn.js.map

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = observeOn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_lift__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OperatorSubscriber__ = __webpack_require__(12);


function observeOn(scheduler, delay) {
    if (delay === void 0) { delay = 0; }
    return Object(__WEBPACK_IMPORTED_MODULE_0__util_lift__["b" /* operate */])(function (source, subscriber) {
        source.subscribe(new __WEBPACK_IMPORTED_MODULE_1__OperatorSubscriber__["a" /* OperatorSubscriber */](subscriber, function (value) { return subscriber.add(scheduler.schedule(function () { return subscriber.next(value); }, delay)); }, function () { return subscriber.add(scheduler.schedule(function () { return subscriber.complete(); }, delay)); }, function (err) { return subscriber.add(scheduler.schedule(function () { return subscriber.error(err); }, delay)); }));
    });
}
//# sourceMappingURL=observeOn.js.map

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bindNodeCallback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bindCallbackInternals__ = __webpack_require__(93);

function bindNodeCallback(callbackFunc, resultSelector, scheduler) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__bindCallbackInternals__["a" /* bindCallbackInternals */])(true, callbackFunc, resultSelector, scheduler);
}
//# sourceMappingURL=bindNodeCallback.js.map

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export combineLatest */
/* unused harmony export combineLatestInit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_argsArgArrayOrObject__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__from__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_identity__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_mapOneOrManyArgs__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_args__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_createObject__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__operators_OperatorSubscriber__ = __webpack_require__(12);








function combineLatest() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = Object(__WEBPACK_IMPORTED_MODULE_5__util_args__["c" /* popScheduler */])(args);
    var resultSelector = Object(__WEBPACK_IMPORTED_MODULE_5__util_args__["b" /* popResultSelector */])(args);
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1__util_argsArgArrayOrObject__["a" /* argsArgArrayOrObject */])(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__from__["a" /* from */])([], scheduler);
    }
    var result = new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](combineLatestInit(observables, scheduler, keys
        ?
            function (values) { return Object(__WEBPACK_IMPORTED_MODULE_6__util_createObject__["a" /* createObject */])(keys, values); }
        :
            __WEBPACK_IMPORTED_MODULE_3__util_identity__["a" /* identity */]));
    return resultSelector ? result.pipe(Object(__WEBPACK_IMPORTED_MODULE_4__util_mapOneOrManyArgs__["a" /* mapOneOrManyArgs */])(resultSelector)) : result;
}
function combineLatestInit(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) { valueTransform = __WEBPACK_IMPORTED_MODULE_3__util_identity__["a" /* identity */]; }
    return function (subscriber) {
        maybeSchedule(scheduler, function () {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function (i) {
                maybeSchedule(scheduler, function () {
                    var source = Object(__WEBPACK_IMPORTED_MODULE_2__from__["a" /* from */])(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe(new __WEBPACK_IMPORTED_MODULE_7__operators_OperatorSubscriber__["a" /* OperatorSubscriber */](subscriber, function (value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) {
                            subscriber.next(valueTransform(values.slice()));
                        }
                    }, function () {
                        if (!--active) {
                            subscriber.complete();
                        }
                    }));
                }, subscriber);
            };
            for (var i = 0; i < length; i++) {
                _loop_1(i);
            }
        }, subscriber);
    };
}
function maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) {
        subscription.add(scheduler.schedule(execute));
    }
    else {
        execute();
    }
}
//# sourceMappingURL=combineLatest.js.map

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export concat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__operators_concatAll__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_args__ = __webpack_require__(20);



function concat() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0__operators_concatAll__["a" /* concatAll */])()(Object(__WEBPACK_IMPORTED_MODULE_1__fromArray__["a" /* internalFromArray */])(args, Object(__WEBPACK_IMPORTED_MODULE_2__util_args__["c" /* popScheduler */])(args)));
}
//# sourceMappingURL=concat.js.map

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = concatAll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeAll__ = __webpack_require__(97);

function concatAll() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__mergeAll__["a" /* mergeAll */])(1);
}
//# sourceMappingURL=concatAll.js.map

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeInternals;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__observable_from__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OperatorSubscriber__ = __webpack_require__(12);


function mergeInternals(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalTeardown) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function () {
        if (isComplete && !buffer.length && !active) {
            subscriber.complete();
        }
    };
    var outerNext = function (value) { return (active < concurrent ? doInnerSub(value) : buffer.push(value)); };
    var doInnerSub = function (value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        Object(__WEBPACK_IMPORTED_MODULE_0__observable_from__["c" /* innerFrom */])(project(value, index++)).subscribe(new __WEBPACK_IMPORTED_MODULE_1__OperatorSubscriber__["a" /* OperatorSubscriber */](subscriber, function (innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
            if (expand) {
                outerNext(innerValue);
            }
            else {
                subscriber.next(innerValue);
            }
        }, function () {
            innerComplete = true;
        }, undefined, function () {
            if (innerComplete) {
                try {
                    active--;
                    var _loop_1 = function () {
                        var bufferedValue = buffer.shift();
                        innerSubScheduler ? subscriber.add(innerSubScheduler.schedule(function () { return doInnerSub(bufferedValue); })) : doInnerSub(bufferedValue);
                    };
                    while (buffer.length && active < concurrent) {
                        _loop_1();
                    }
                    checkComplete();
                }
                catch (err) {
                    subscriber.error(err);
                }
            }
        }));
    };
    source.subscribe(new __WEBPACK_IMPORTED_MODULE_1__OperatorSubscriber__["a" /* OperatorSubscriber */](subscriber, outerNext, function () {
        isComplete = true;
        checkComplete();
    }));
    return function () {
        additionalTeardown === null || additionalTeardown === void 0 ? void 0 : additionalTeardown();
    };
}
//# sourceMappingURL=mergeInternals.js.map

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export connectable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Subject__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defer__ = __webpack_require__(39);



var DEFAULT_CONFIG = {
    connector: function () { return new __WEBPACK_IMPORTED_MODULE_0__Subject__["a" /* Subject */](); },
    resetOnDisconnect: true,
};
function connectable(source, config) {
    if (config === void 0) { config = DEFAULT_CONFIG; }
    var connection = null;
    var connector = config.connector, _a = config.resetOnDisconnect, resetOnDisconnect = _a === void 0 ? true : _a;
    var subject = connector();
    var result = new __WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */](function (subscriber) {
        return subject.subscribe(subscriber);
    });
    result.connect = function () {
        if (!connection || connection.closed) {
            connection = Object(__WEBPACK_IMPORTED_MODULE_2__defer__["a" /* defer */])(function () { return source; }).subscribe(subject);
            if (resetOnDisconnect) {
                connection.add(function () { return (subject = connector()); });
            }
        }
        return connection;
    };
    return result;
}
//# sourceMappingURL=connectable.js.map

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export forkJoin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_argsArgArrayOrObject__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__from__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_args__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__operators_OperatorSubscriber__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_mapOneOrManyArgs__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_createObject__ = __webpack_require__(96);







function forkJoin() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resultSelector = Object(__WEBPACK_IMPORTED_MODULE_3__util_args__["b" /* popResultSelector */])(args);
    var _a = Object(__WEBPACK_IMPORTED_MODULE_1__util_argsArgArrayOrObject__["a" /* argsArgArrayOrObject */])(args), sources = _a.args, keys = _a.keys;
    var result = new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var length = sources.length;
        if (!length) {
            subscriber.complete();
            return;
        }
        var values = new Array(length);
        var remainingCompletions = length;
        var remainingEmissions = length;
        var _loop_1 = function (sourceIndex) {
            var hasValue = false;
            Object(__WEBPACK_IMPORTED_MODULE_2__from__["c" /* innerFrom */])(sources[sourceIndex]).subscribe(new __WEBPACK_IMPORTED_MODULE_4__operators_OperatorSubscriber__["a" /* OperatorSubscriber */](subscriber, function (value) {
                if (!hasValue) {
                    hasValue = true;
                    remainingEmissions--;
                }
                values[sourceIndex] = value;
            }, function () {
                if (!--remainingCompletions || !hasValue) {
                    if (!remainingEmissions) {
                        subscriber.next(keys ? Object(__WEBPACK_IMPORTED_MODULE_6__util_createObject__["a" /* createObject */])(keys, values) : values);
                    }
                    subscriber.complete();
                }
            }));
        };
        for (var sourceIndex = 0; sourceIndex < length; sourceIndex++) {
            _loop_1(sourceIndex);
        }
    });
    return resultSelector ? result.pipe(Object(__WEBPACK_IMPORTED_MODULE_5__util_mapOneOrManyArgs__["a" /* mapOneOrManyArgs */])(resultSelector)) : result;
}
//# sourceMappingURL=forkJoin.js.map

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fromEvent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__operators_mergeMap__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_isArrayLike__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_mapOneOrManyArgs__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fromArray__ = __webpack_require__(37);







var nodeEventEmitterMethods = ['addListener', 'removeListener'];
var eventTargetMethods = ['addEventListener', 'removeEventListener'];
var jqueryMethods = ['on', 'off'];
function fromEvent(target, eventName, options, resultSelector) {
    if (Object(__WEBPACK_IMPORTED_MODULE_4__util_isFunction__["a" /* isFunction */])(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(Object(__WEBPACK_IMPORTED_MODULE_5__util_mapOneOrManyArgs__["a" /* mapOneOrManyArgs */])(resultSelector));
    }
    var _a = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(isEventTarget(target)
        ? eventTargetMethods.map(function (methodName) { return function (handler) { return target[methodName](eventName, handler, options); }; })
        :
            isNodeStyleEventEmitter(target)
                ? nodeEventEmitterMethods.map(toCommonHandlerRegistry(target, eventName))
                : isJQueryStyleEventEmitter(target)
                    ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName))
                    : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if (Object(__WEBPACK_IMPORTED_MODULE_3__util_isArrayLike__["a" /* isArrayLike */])(target)) {
            return Object(__WEBPACK_IMPORTED_MODULE_2__operators_mergeMap__["a" /* mergeMap */])(function (subTarget) { return fromEvent(subTarget, eventName, options); })(Object(__WEBPACK_IMPORTED_MODULE_6__fromArray__["a" /* internalFromArray */])(target));
        }
    }
    if (!add) {
        throw new TypeError('Invalid event target');
    }
    return new __WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */](function (subscriber) {
        var handler = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function () { return remove(handler); };
    });
}
function toCommonHandlerRegistry(target, eventName) {
    return function (methodName) { return function (handler) { return target[methodName](eventName, handler); }; };
}
function isNodeStyleEventEmitter(target) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__util_isFunction__["a" /* isFunction */])(target.addListener) && Object(__WEBPACK_IMPORTED_MODULE_4__util_isFunction__["a" /* isFunction */])(target.removeListener);
}
function isJQueryStyleEventEmitter(target) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__util_isFunction__["a" /* isFunction */])(target.on) && Object(__WEBPACK_IMPORTED_MODULE_4__util_isFunction__["a" /* isFunction */])(target.off);
}
function isEventTarget(target) {
    return Object(__WEBPACK_IMPORTED_MODULE_4__util_isFunction__["a" /* isFunction */])(target.addEventListener) && Object(__WEBPACK_IMPORTED_MODULE_4__util_isFunction__["a" /* isFunction */])(target.removeEventListener);
}
//# sourceMappingURL=fromEvent.js.map

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fromEventPattern */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_isFunction__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_mapOneOrManyArgs__ = __webpack_require__(26);



function fromEventPattern(addHandler, removeHandler, resultSelector) {
    if (resultSelector) {
        return fromEventPattern(addHandler, removeHandler).pipe(Object(__WEBPACK_IMPORTED_MODULE_2__util_mapOneOrManyArgs__["a" /* mapOneOrManyArgs */])(resultSelector));
    }
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var handler = function () {
            var e = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                e[_i] = arguments[_i];
            }
            return subscriber.next(e.length === 1 ? e[0] : e);
        };
        var retValue = addHandler(handler);
        return Object(__WEBPACK_IMPORTED_MODULE_1__util_isFunction__["a" /* isFunction */])(removeHandler) ? function () { return removeHandler(handler, retValue); } : undefined;
    });
}
//# sourceMappingURL=fromEventPattern.js.map

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export generate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_identity__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_isScheduler__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defer__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scheduled_scheduleIterable__ = __webpack_require__(83);





function generate(initialStateOrOptions, condition, iterate, resultSelectorOrScheduler, scheduler) {
    var _a, _b;
    var resultSelector;
    var initialState;
    if (arguments.length === 1) {
        (_a = initialStateOrOptions, initialState = _a.initialState, condition = _a.condition, iterate = _a.iterate, _b = _a.resultSelector, resultSelector = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_1__util_identity__["a" /* identity */] : _b, scheduler = _a.scheduler);
    }
    else {
        initialState = initialStateOrOptions;
        if (!resultSelectorOrScheduler || Object(__WEBPACK_IMPORTED_MODULE_2__util_isScheduler__["a" /* isScheduler */])(resultSelectorOrScheduler)) {
            resultSelector = __WEBPACK_IMPORTED_MODULE_1__util_identity__["a" /* identity */];
            scheduler = resultSelectorOrScheduler;
        }
        else {
            resultSelector = resultSelectorOrScheduler;
        }
    }
    function gen() {
        var state;
        return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    state = initialState;
                    _a.label = 1;
                case 1:
                    if (!(!condition || condition(state))) return [3, 4];
                    return [4, resultSelector(state)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    state = iterate(state);
                    return [3, 1];
                case 4: return [2];
            }
        });
    }
    return Object(__WEBPACK_IMPORTED_MODULE_3__defer__["a" /* defer */])((scheduler
        ?
            function () { return Object(__WEBPACK_IMPORTED_MODULE_4__scheduled_scheduleIterable__["a" /* scheduleIterable */])(gen(), scheduler); }
        :
            gen));
}
//# sourceMappingURL=generate.js.map

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export iif */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defer__ = __webpack_require__(39);

function iif(condition, trueResult, falseResult) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__defer__["a" /* defer */])(function () { return (condition() ? trueResult : falseResult); });
}
//# sourceMappingURL=iif.js.map

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export interval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scheduler_async__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timer__ = __webpack_require__(99);


function interval(period, scheduler) {
    if (period === void 0) { period = 0; }
    if (scheduler === void 0) { scheduler = __WEBPACK_IMPORTED_MODULE_0__scheduler_async__["b" /* asyncScheduler */]; }
    if (period < 0) {
        period = 0;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__timer__["a" /* timer */])(period, period, scheduler);
}
//# sourceMappingURL=interval.js.map

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__operators_mergeAll__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromArray__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__from__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__empty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_args__ = __webpack_require__(20);





function merge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var scheduler = Object(__WEBPACK_IMPORTED_MODULE_4__util_args__["c" /* popScheduler */])(args);
    var concurrent = Object(__WEBPACK_IMPORTED_MODULE_4__util_args__["a" /* popNumber */])(args, Infinity);
    var sources = args;
    return !sources.length
        ?
            __WEBPACK_IMPORTED_MODULE_3__empty__["a" /* EMPTY */]
        : sources.length === 1
            ?
                Object(__WEBPACK_IMPORTED_MODULE_2__from__["c" /* innerFrom */])(sources[0])
            :
                Object(__WEBPACK_IMPORTED_MODULE_0__operators_mergeAll__["a" /* mergeAll */])(concurrent)(Object(__WEBPACK_IMPORTED_MODULE_1__fromArray__["a" /* internalFromArray */])(sources, scheduler));
}
//# sourceMappingURL=merge.js.map

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export onErrorResumeNext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__empty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__operators_onErrorResumeNext__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_argsOrArgArray__ = __webpack_require__(40);



function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    return Object(__WEBPACK_IMPORTED_MODULE_1__operators_onErrorResumeNext__["a" /* onErrorResumeNext */])(Object(__WEBPACK_IMPORTED_MODULE_2__util_argsOrArgArray__["a" /* argsOrArgArray */])(sources))(__WEBPACK_IMPORTED_MODULE_0__empty__["a" /* EMPTY */]);
}
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = onErrorResumeNext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_lift__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__observable_from__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_argsOrArgArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OperatorSubscriber__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_noop__ = __webpack_require__(35);






function onErrorResumeNext() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    var nextSources = Object(__WEBPACK_IMPORTED_MODULE_3__util_argsOrArgArray__["a" /* argsOrArgArray */])(sources);
    return Object(__WEBPACK_IMPORTED_MODULE_1__util_lift__["b" /* operate */])(function (source, subscriber) {
        var remaining = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])([source], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(nextSources));
        var subscribeNext = function () {
            if (!subscriber.closed) {
                if (remaining.length > 0) {
                    var nextSource = void 0;
                    try {
                        nextSource = Object(__WEBPACK_IMPORTED_MODULE_2__observable_from__["c" /* innerFrom */])(remaining.shift());
                    }
                    catch (err) {
                        subscribeNext();
                        return;
                    }
                    var innerSub = new __WEBPACK_IMPORTED_MODULE_4__OperatorSubscriber__["a" /* OperatorSubscriber */](subscriber, undefined, __WEBPACK_IMPORTED_MODULE_5__util_noop__["a" /* noop */], __WEBPACK_IMPORTED_MODULE_5__util_noop__["a" /* noop */]);
                    subscriber.add(nextSource.subscribe(innerSub));
                    innerSub.add(subscribeNext);
                }
                else {
                    subscriber.complete();
                }
            }
        };
        subscribeNext();
    });
}
//# sourceMappingURL=onErrorResumeNext.js.map

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__from__ = __webpack_require__(8);

function pairs(obj, scheduler) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__from__["a" /* from */])(Object.entries(obj), scheduler);
}
//# sourceMappingURL=pairs.js.map

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export partition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_not__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__operators_filter__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__from__ = __webpack_require__(8);



function partition(source, predicate, thisArg) {
    return [Object(__WEBPACK_IMPORTED_MODULE_1__operators_filter__["a" /* filter */])(predicate, thisArg)(Object(__WEBPACK_IMPORTED_MODULE_2__from__["c" /* innerFrom */])(source)), Object(__WEBPACK_IMPORTED_MODULE_1__operators_filter__["a" /* filter */])(Object(__WEBPACK_IMPORTED_MODULE_0__util_not__["a" /* not */])(predicate, thisArg))(Object(__WEBPACK_IMPORTED_MODULE_2__from__["c" /* innerFrom */])(source))];
}
//# sourceMappingURL=partition.js.map

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = not;
function not(pred, thisArg) {
    return function (value, index) { return !pred.call(thisArg, value, index); };
}
//# sourceMappingURL=not.js.map

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_lift__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__OperatorSubscriber__ = __webpack_require__(12);


function filter(predicate, thisArg) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__util_lift__["b" /* operate */])(function (source, subscriber) {
        var index = 0;
        source.subscribe(new __WEBPACK_IMPORTED_MODULE_1__OperatorSubscriber__["a" /* OperatorSubscriber */](subscriber, function (value) { return predicate.call(thisArg, value, index++) && subscriber.next(value); }));
    });
}
//# sourceMappingURL=filter.js.map

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export race */
/* unused harmony export raceInit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_argsOrArgArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__operators_OperatorSubscriber__ = __webpack_require__(12);




function race() {
    var sources = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        sources[_i] = arguments[_i];
    }
    sources = Object(__WEBPACK_IMPORTED_MODULE_2__util_argsOrArgArray__["a" /* argsOrArgArray */])(sources);
    return sources.length === 1 ? Object(__WEBPACK_IMPORTED_MODULE_1__from__["c" /* innerFrom */])(sources[0]) : new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](raceInit(sources));
}
function raceInit(sources) {
    return function (subscriber) {
        var subscriptions = [];
        var _loop_1 = function (i) {
            subscriptions.push(Object(__WEBPACK_IMPORTED_MODULE_1__from__["c" /* innerFrom */])(sources[i]).subscribe(new __WEBPACK_IMPORTED_MODULE_3__operators_OperatorSubscriber__["a" /* OperatorSubscriber */](subscriber, function (value) {
                if (subscriptions) {
                    for (var s = 0; s < subscriptions.length; s++) {
                        s !== i && subscriptions[s].unsubscribe();
                    }
                    subscriptions = null;
                }
                subscriber.next(value);
            })));
        };
        for (var i = 0; subscriptions && !subscriber.closed && i < sources.length; i++) {
            _loop_1(i);
        }
    };
}
//# sourceMappingURL=race.js.map

/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export range */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__empty__ = __webpack_require__(16);


function range(start, count, scheduler) {
    if (count == null) {
        count = start;
        start = 0;
    }
    if (count <= 0) {
        return __WEBPACK_IMPORTED_MODULE_1__empty__["a" /* EMPTY */];
    }
    var end = count + start;
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](scheduler
        ?
            function (subscriber) {
                var n = start;
                return scheduler.schedule(function () {
                    if (n < end) {
                        subscriber.next(n++);
                        this.schedule();
                    }
                    else {
                        subscriber.complete();
                    }
                });
            }
        :
            function (subscriber) {
                var n = start;
                while (n < end && !subscriber.closed) {
                    subscriber.next(n++);
                }
                subscriber.complete();
            });
}
//# sourceMappingURL=range.js.map

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export using */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__from__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__empty__ = __webpack_require__(16);



function using(resourceFactory, observableFactory) {
    return new __WEBPACK_IMPORTED_MODULE_0__Observable__["a" /* Observable */](function (subscriber) {
        var resource = resourceFactory();
        var result = observableFactory(resource);
        var source = result ? Object(__WEBPACK_IMPORTED_MODULE_1__from__["c" /* innerFrom */])(result) : __WEBPACK_IMPORTED_MODULE_2__empty__["a" /* EMPTY */];
        source.subscribe(subscriber);
        return function () {
            if (resource) {
                resource.unsubscribe();
            }
        };
    });
}
//# sourceMappingURL=using.js.map

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export zip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Observable__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__from__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_argsOrArgArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__empty__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__operators_OperatorSubscriber__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_args__ = __webpack_require__(20);







function zip() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resultSelector = Object(__WEBPACK_IMPORTED_MODULE_6__util_args__["b" /* popResultSelector */])(args);
    var sources = Object(__WEBPACK_IMPORTED_MODULE_3__util_argsOrArgArray__["a" /* argsOrArgArray */])(args);
    return sources.length
        ? new __WEBPACK_IMPORTED_MODULE_1__Observable__["a" /* Observable */](function (subscriber) {
            var buffers = sources.map(function () { return []; });
            var completed = sources.map(function () { return false; });
            subscriber.add(function () {
                buffers = completed = null;
            });
            var _loop_1 = function (sourceIndex) {
                Object(__WEBPACK_IMPORTED_MODULE_2__from__["c" /* innerFrom */])(sources[sourceIndex]).subscribe(new __WEBPACK_IMPORTED_MODULE_5__operators_OperatorSubscriber__["a" /* OperatorSubscriber */](subscriber, function (value) {
                    buffers[sourceIndex].push(value);
                    if (buffers.every(function (buffer) { return buffer.length; })) {
                        var result = buffers.map(function (buffer) { return buffer.shift(); });
                        subscriber.next(resultSelector ? resultSelector.apply(void 0, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __spreadArray */])([], Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __read */])(result))) : result);
                        if (buffers.some(function (buffer, i) { return !buffer.length && completed[i]; })) {
                            subscriber.complete();
                        }
                    }
                }, function () {
                    completed[sourceIndex] = true;
                    !buffers[sourceIndex].length && subscriber.complete();
                }));
            };
            for (var sourceIndex = 0; !subscriber.closed && sourceIndex < sources.length; sourceIndex++) {
                _loop_1(sourceIndex);
            }
            return function () {
                buffers = completed = null;
            };
        })
        : __WEBPACK_IMPORTED_MODULE_4__empty__["a" /* EMPTY */];
}
//# sourceMappingURL=zip.js.map

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=types.js.map

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Validation; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Validation=function(){function Validation(competitionInfo){_classCallCheck(this,Validation);this.competitionInfo=competitionInfo;}_createClass(Validation,[{key:"error",value:function error(desc,p){return{error:desc,participant:p};}},{key:"validateParticipantInfo",value:function validateParticipantInfo(p){p.errors=[];if(p.name===undefined||p.name===""){p.errors.push(this.error("Namn saknas!",p));}if(p.competitionId===undefined||p.competitionId===""){p.errors.push(this.error(p.name!==undefined&&p.name!==""?p.name+" saknar ID!":"ID saknas!",p));}if(p.organization===undefined||p.organization===""){p.errors.push(this.error(p.name!==undefined&&p.name!==""?p.name+" har ingen f\xF6rening!":"Förening saknas!",p));}}},{key:"validateRegistration",value:function validateRegistration(p){var _this=this;if(p.registrationInfo.length===0){p.errors.push(this.error("Ingen start vald!",p));}p.registrationInfo.forEach(function(r){var event=_this.competitionInfo.event(r.event);if(event.classes&&!r.class)p.errors.push(_this.error("Ingen klass vald!",p));if(r.rounds){r.rounds.forEach(function(rd){if(event.divisions&&!rd.division)p.errors.push(_this.error("Ingen vapengrupp vald!",p));if(event.schedule&&!rd.squad)p.errors.push(_this.error("Ingen starttid vald!",p));});}});}},{key:"validateParticipant",value:function validateParticipant(p){this.validateParticipantInfo(p);this.validateRegistration(p);}},{key:"validate",value:function validate(participants){var _this2=this;var errors=[];if(participants.length===0)errors.push(this.error("Inga skyttar i anmälan!",null));participants.forEach(function(p){_this2.validateParticipant(p);errors=errors.concat(p.errors);});return errors;}}]);return Validation;}();Validation.register={name:"Validation"};

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamValidation; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var TeamValidation=function(){function TeamValidation(competition){_classCallCheck(this,TeamValidation);this.competition=competition;}_createClass(TeamValidation,[{key:"error",value:function error(desc,team){return{error:desc,team:team};}},{key:"validateTeam",value:function validateTeam(team,errors){if(team.event===undefined){errors.push(this.error("No event set",team));return;}var event=this.competition.events.find(function(e){return e.id===team.event;});if(event===null){errors.push(this.error("Deltävlingen finns inte!",team));return;}if(event.teams.length<=team.index){errors.push(this.error("Ingen lagdefinition!",team));return;}var teamDef=event.teams[team.index];if(team.members.filter(function(m){return m!==undefined&&m!==null&&m>0;}).length<teamDef.members){errors.push(this.error("Alla ordinarie platser i laget måste ha deltagare!",team));}}},{key:"validate",value:function validate(teams){var _this=this;var errors=[];teams.forEach(function(t){return _this.validateTeam(t,errors);});return errors;}}]);return TeamValidation;}();

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Server; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Log__ = __webpack_require__(223);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Server=function(){function Server(){var _this=this;_classCallCheck(this,Server);this.load=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(url,callback,error){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:url=_this.Configuration.baseUrl+"/"+url;fetch(url,{crossDomain:true,credentials:'include'}).then(function(res){if(!res.ok){_this.handleSafely(res,error);}else res.json().then(callback).catch(error);});// finally() not supported in several browsers :(
// .finally(() => this.Busy.setBusy(Server.id, false));
case 2:case"end":return _context.stop();}}},_callee,_this);}));return function(_x,_x2,_x3){return _ref.apply(this,arguments);};}();this.send=function(url,data,callback,error){url=_this.Configuration.baseUrl+"/"+url;Object(__WEBPACK_IMPORTED_MODULE_1__Log__["g" /* logUrl */])(url);return fetch(url,{crossDomain:true,credentials:'include',method:'POST',body:JSON.stringify(data),headers:new Headers({'Content-Type':'application/json'})}).then(function(res){if(!res.ok){_this.handleSafely(res,error);}else res.json().then(callback).catch(function(){return callback(true);});// res.ok but no JSON returned
});};this.update=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(url,data,callback,error){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:url=_this.Configuration.baseUrl+"/"+url;Object(__WEBPACK_IMPORTED_MODULE_1__Log__["g" /* logUrl */])(url);console.log("Update",url,data);return _context2.abrupt("return",fetch(url,{crossDomain:true,credentials:'include',method:'PUT',body:JSON.stringify(data),headers:new Headers({'Content-Type':'application/json'})}).then(function(res){if(!res.ok){_this.handleSafely(res,error);}else callback(true);}));case 4:case"end":return _context2.stop();}}},_callee2,_this);}));return function(_x4,_x5,_x6,_x7){return _ref2.apply(this,arguments);};}();this.delete=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(url,callback,error){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:url=_this.Configuration.baseUrl+"/"+url;Object(__WEBPACK_IMPORTED_MODULE_1__Log__["g" /* logUrl */])(url);return _context3.abrupt("return",fetch(url,{crossDomain:true,credentials:'include',method:'DELETE'}).then(function(res){if(!res.ok){_this.handleSafely(res,error);}else callback(true);}));case 3:case"end":return _context3.stop();}}},_callee3,_this);}));return function(_x8,_x9,_x10){return _ref3.apply(this,arguments);};}();}_createClass(Server,[{key:"initialize",value:function initialize(){this.setLocal(this.Storage.get(this.Storage.keys.toggleServerMode)&&this.Storage.get(this.Storage.keys.serverMode));}//#region Main fetch/send methods and helpers
},{key:"send2",value:function send2(url,data,callback,error){this.Busy.wrap(this.send,url,data,callback,error);}},{key:"update2",value:function update2(url,data,callback,error){this.Busy.wrap(this.update,url,data,callback,error);}},{key:"delete2",value:function delete2(url,callback,error){this.Busy.wrap(this.delete,url,callback,error);}},{key:"jsonFile",value:function jsonFile(name){return ""+"/"+name+".json";}},{key:"handleSafely",value:function handleSafely(res,error){res.text().then(function(txt){try{var json=JSON.parse(txt);error(json);}catch(e){error(txt);}}).catch(error);}//#endregion
//#region Remote Services
},{key:"remoteCompetitionService",value:function remoteCompetitionService(){var _this2=this;return{loadCompetitionList:function loadCompetitionList(callback,error){_this2.Busy.wrap(_this2.load,"competition",callback,error);},loadCompetition:function loadCompetition(id,callback,error){_this2.Busy.wrap(_this2.load,isNaN(parseInt(id,10))?_this2.jsonFile(id):"competition/"+id,callback,error);},createCompetition:function createCompetition(competition,callback,error){_this2.Busy.wrap(_this2.send,"competition",competition,callback,error);},updateCompetition:function updateCompetition(competition,callback,error){_this2.Busy.wrap(_this2.update,"competition/"+competition.id,competition,callback,error);},deleteCompetition:function deleteCompetition(id,callback,error){_this2.Busy.wrap(_this2.delete,"competition/"+id,callback,error);},getParticipants:function getParticipants(id,callback,error){_this2.load("competition/"+id+"/list",callback,error);}};}},{key:"remoteResultService",value:function remoteResultService(){var _this3=this;return{loadResults:function loadResults(competitionId,eventId,callback,error){_this3.Busy.wrap(_this3.load,"competition/"+competitionId+"/scores/"+eventId,callback,error);}};}},{key:"remoteScheduleService",value:function remoteScheduleService(){var _this4=this;return{createSchedule:function createSchedule(schedule,callback,error){_this4.send2("schedules",schedule,callback,error);},getSchedule:function getSchedule(scheduleId,callback,error){_this4.load("schedules/"+scheduleId,callback,error);},getParticipants:function getParticipants(scheduleId,callback,error){_this4.Busy.wrap(_this4.load,"schedules/"+scheduleId+"/squad",callback,error);},updateParticipants:function updateParticipants(scheduleId,data,callback,error){_this4.update("schedules/"+scheduleId+"/move",data,callback,error);},updateSchedule:function updateSchedule(schedule,callback,error){_this4.update2("schedules/"+schedule.id,schedule,callback,error);},deleteSchedule:function deleteSchedule(scheduleId,callback,error){_this4.delete2("schedules/"+scheduleId,callback,error);}};}},{key:"remoteRegistrationService",value:function remoteRegistrationService(){var _this5=this;return{loadRegistration:function loadRegistration(id,token,callback,error){_this5.Busy.wrap(_this5.load,isNaN(parseInt(id,10))?_this5.jsonFile(id+"_token"):"competition/"+id+"/"+token,callback,error);},sendRegistration:function sendRegistration(data,callback,error){_this5.send2("register",data,callback,error);},updateRegistration:function updateRegistration(token,data,callback,error){_this5.send2("register/"+token,data,callback,error);},deleteRegistration:function deleteRegistration(id,token,callback,error){_this5.delete2("competition/"+id+"/"+token,callback,error);}};}},{key:"remoteCategoryService",value:function remoteCategoryService(){var _this6=this;return{loadClassGroups:function loadClassGroups(callback,error){_this6.Busy.wrap(_this6.load,"classes",callback,error);},loadDivisionGroups:function loadDivisionGroups(callback,error){_this6.Busy.wrap(_this6.load,"divisions",callback,error);}};}},{key:"remoteStagesService",value:function remoteStagesService(){var _this7=this;return{loadStageDefs:function loadStageDefs(competitionId,eventId,callback,error){_this7.Busy.wrap(_this7.load,"competition/"+competitionId+"/stages/"+eventId,callback,error);}};}},{key:"remoteTeamsService",value:function remoteTeamsService(){var _this8=this;return{loadTeams:function loadTeams(competitionId,eventId,callback,error){_this8.load("competition/"+competitionId+"/event/"+eventId+"/team",callback,error);}};}//#endregion
//#region Local Services
},{key:"localCategoryServive",value:function localCategoryServive(){var _this9=this;return{loadClassGroups:function loadClassGroups(callback,error){_this9.Busy.wrap(_this9.load,_this9.jsonFile("classes"),callback);},loadDivisionGroups:function loadDivisionGroups(callback,error){_this9.Busy.wrap(_this9.load,_this9.jsonFile("divisions"),callback);}};}//#endregion
//#region Property manipulation
},{key:"setLocal",value:function setLocal(on){this.local=on;if(this.local){this.competitionService=this.CompetitionService;this.scheduleService=this.ScheduleService;this.resultService=this.ResultService;this.registrationService=this.RegistrationService;this.categoryService=this.localCategoryService();}else{this.competitionService=this.remoteCompetitionService();this.scheduleService=this.remoteScheduleService();this.resultService=this.remoteResultService();this.registrationService=this.remoteRegistrationService();this.categoryService=this.remoteCategoryService();}this.stagesService=this.remoteStagesService();this.teamsService=this.remoteTeamsService();this.Storage.set(this.Storage.keys.serverMode,this.local);this.fire(this.Events.serverChanged);}//#endregion
//#region Clubs
},{key:"loadClubs",value:function loadClubs(callback,error){var _this10=this;error=Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error);this.Busy.setBusy(this,true);fetch("/clubs.json").then(function(res){_this10.Busy.setBusy(_this10,false);if(!res.ok){_this10.handleSafely(res,error);}else res.json().then(callback).catch(error);});}//#endregion
//#region Groups
},{key:"loadCompetitionGroups",value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(callback,error){var _this11=this;var id;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:id="lcg";this.Busy.setBusy(id,true);fetch("/groups.json").then(function(res){_this11.Busy.setBusy(id,false);if(!res.ok){_this11.handleSafely(res,error);}else res.json().then(callback).catch(error);}).catch(function(){_this11.Busy.setBusy(id,false);error();});case 3:case"end":return _context4.stop();}}},_callee4,this);}));function loadCompetitionGroups(_x11,_x12){return _ref4.apply(this,arguments);}return loadCompetitionGroups;}()},{key:"loadRemoteCompetitionGroups",value:function loadRemoteCompetitionGroups(callback,error){this.Busy.wrap(this.load,"group",callback,error);}},{key:"createCompetitionGroup",value:function createCompetitionGroup(callback,error){}//#endregion
//#region Competition
},{key:"loadCompetitionList",value:function loadCompetitionList(callback,error){this.competitionService.loadCompetitionList(Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Loading competition list"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"loadCompetition",value:function loadCompetition(competitionId,callback,error){this.competitionService.loadCompetition(competitionId,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Loading competition data for competition "+competitionId),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"createCompetition",value:function createCompetition(competition,callback,error){this.competitionService.createCompetition(competition,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["d" /* logSendCallback */])(callback,competition,"Creating new competition"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"updateCompetition",value:function updateCompetition(competition,callback,error){this.competitionService.updateCompetition(competition,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["d" /* logSendCallback */])(callback,competition,"Updating competition"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"deleteCompetition",value:function deleteCompetition(competitionId,callback,error){this.competitionService.deleteCompetition(competitionId,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Deleting competition "+competitionId),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"getCompetitionParticipants",value:function getCompetitionParticipants(competitionId,callback,error){this.competitionService.getParticipants(competitionId,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Getting participants for competition "+competitionId),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}//#endregion
//#region Results
},{key:"loadResults",value:function loadResults(competitionId,eventId,callback,error){this.resultService.loadResults(competitionId,eventId,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Loading competition results for "+competitionId+"/"+eventId),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}//#endregion
//#region Teams
},{key:"loadTeams",value:function loadTeams(competitionId,eventId,callback,error){this.teamsService.loadTeams(competitionId,eventId,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Loading teams for "+competitionId+"/"+eventId),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}//#endregion
//#region Registration
},{key:"loadRegistration",value:function loadRegistration(competitionId,token,callback,error){this.registrationService.loadRegistration(competitionId,token,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Loading registration data for "+competitionId+"/"+token),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"sendRegistration",value:function sendRegistration(data,callback,error){this.registrationService.sendRegistration(data,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["d" /* logSendCallback */])(callback,data,"Sending registration"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"updateRegistration",value:function updateRegistration(token,data,callback,error){this.registrationService.updateRegistration(token,data,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["d" /* logSendCallback */])(callback,data,"Updating registration"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"sendNewToken",value:function sendNewToken(registration,callback,error){this.send2("competition/send_token",registration,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["d" /* logSendCallback */])(callback,registration,"Beg\xE4r nytt mail"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"deleteRegistration",value:function deleteRegistration(competitionId,token,callback,error){this.registrationService.deleteRegistration(competitionId,token,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["a" /* logDeleteCallback */])(callback,"Raderar anm\xE4lan "+token+" i t\xE4vling "+competitionId),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"loadRoster",value:function loadRoster(competitionId,callback,error){this.Busy.wrap(this.load,"competition/"+competitionId+"/list",Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"H\xE4mtar deltagare f\xF6r t\xE4vling "+competitionId),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}//#endregion
//#region Schedule
},{key:"createSchedule",value:function createSchedule(schedule,callback,error){this.scheduleService.createSchedule(schedule,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["e" /* logSendCallback2 */])(callback,schedule,"Creating schedule"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"loadSchedule",value:function loadSchedule(scheduleId,callback,error){this.scheduleService.getSchedule(scheduleId,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Loading schedule"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"loadParticipants",value:function loadParticipants(scheduleId,callback,error){this.scheduleService.getParticipants(scheduleId,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Loading participants"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"updateParticipants",value:function updateParticipants(scheduleId,data,callback,error){this.scheduleService.updateParticipants(scheduleId,data,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["f" /* logUpdateCallback */])(callback,data,"Updating participants"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"updateSchedule",value:function updateSchedule(schedule,callback,error){this.scheduleService.updateSchedule(schedule,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["f" /* logUpdateCallback */])(callback,schedule,"Updating schedule"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"deleteSchedule",value:function deleteSchedule(scheduleId,callback,error){this.scheduleService.deleteSchedule(scheduleId,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Deleting schedule "+scheduleId),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}//#endregion
//#region Stages
},{key:"loadStageDefs",value:function loadStageDefs(competitionId,eventId,callback,error){this.stagesService.loadStageDefs(competitionId,eventId,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Loading stage definitions for "+competitionId+"/"+eventId),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}//#endregion
//#region Value lists
},{key:"loadClassGroups",value:function loadClassGroups(callback,error){this.categoryService.loadClassGroups(Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Loading class groups"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"loadDivisionGroups",value:function loadDivisionGroups(callback,error){this.categoryService.loadDivisionGroups(Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Loading division groups"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"createClassGroup",value:function createClassGroup(classGroup,callback,error){this.send2("classes",classGroup,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["f" /* logUpdateCallback */])(callback,classGroup,"Creating ClassGroup"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"createDivisionGroup",value:function createDivisionGroup(divisionGroup,callback,error){this.send2("divisions",divisionGroup,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["f" /* logUpdateCallback */])(callback,divisionGroup,"Creating DivisionGroup"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"updateClassGroup",value:function updateClassGroup(classGroup,callback,error){this.update2("classes/"+classGroup.id,classGroup,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["f" /* logUpdateCallback */])(callback,classGroup,"Updating ClassGroup"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"updateDivisionGroup",value:function updateDivisionGroup(divisionGroup,callback,error){this.update2("divisions/"+divisionGroup.id,divisionGroup,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["f" /* logUpdateCallback */])(callback,divisionGroup,"Updating DivisionGroup"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"deleteClassGroup",value:function deleteClassGroup(classGroupId,callback,error){this.delete2("classes/"+classGroupId,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Deleting ClassGroup "+classGroupId),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"deleteDivisionGroup",value:function deleteDivisionGroup(divisionGroupId,callback,error){this.delete2("divisions/"+divisionGroupId,Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Deleting DivisionGroup "+divisionGroupId),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}//#endregion
//#region Login
},{key:"login",value:function login(user,password,callback,error){if(this.local){callback({});}else{this.send2("login",{user:user,password:password},Object(__WEBPACK_IMPORTED_MODULE_1__Log__["d" /* logSendCallback */])(callback,user,"Login"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}}},{key:"logout",value:function logout(callback,error){if(this.local){callback({});}else{this.Busy.wrap(this.load,"logout",Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Logout"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}}//#endregion
//#region Admin
},{key:"getRegistrations",value:function getRegistrations(competitionId,callback,error){this.Busy.wrap(this.load,"admin/competition/"+competitionId+"/list_token",Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Getting registrations"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}},{key:"getTeamRegistrations",value:function getTeamRegistrations(competitionId,callback,error){this.Busy.wrap(this.load,"admin/competition/"+competitionId+"/list_token_team",Object(__WEBPACK_IMPORTED_MODULE_1__Log__["c" /* logFetchCallback */])(callback,"Getting team registrations"),Object(__WEBPACK_IMPORTED_MODULE_1__Log__["b" /* logErrorHandler */])(error));}//#endregion
}]);return Server;}();Server.register={name:"Server",createInstance:true};Server.wire=["fire","Events","Busy","Storage","ScheduleService","CompetitionService","ResultService","RegistrationService","Configuration"];

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(222);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 222 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = logFetchCallback;
/* harmony export (immutable) */ __webpack_exports__["a"] = logDeleteCallback;
/* harmony export (immutable) */ __webpack_exports__["d"] = logSendCallback;
/* harmony export (immutable) */ __webpack_exports__["e"] = logSendCallback2;
/* harmony export (immutable) */ __webpack_exports__["f"] = logUpdateCallback;
/* harmony export (immutable) */ __webpack_exports__["b"] = logErrorHandler;
/* harmony export (immutable) */ __webpack_exports__["g"] = logUrl;
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function logFetchCallback(c,msg){if(!window._debug){return c;}console.log(msg);return function(json){console.log('Fetch data:',json);c(json);};}function logDeleteCallback(c,msg){if(!window._debug){return c;}console.log(msg);return function(json){console.log('Delete result:',json);c(json);};}function logSendCallback(c,data,msg){if(c===undefined)c=function c(){};if(!window._debug){return c;}console.log(msg);console.log('Sent data:',data);return function(json){console.log('Reply:',json);c(json);};}function logSendCallback2(c,data,msg){if(c===undefined)c=function c(){};if(!window._debug){return c;}console.log(msg);console.log('Sent data:',data);return function(json){console.log('Reply ('+msg+'):');console.log(json);c(json);};}function logUpdateCallback(c,data,msg){if(c===undefined)c=function c(){};if(!window._debug){return c;}console.log(msg);console.log('Update data:',data);return c;}function logErrorHandler(e){if(e===undefined)e=function e(){};if(!window._debug){return e;}return function(txt){if((typeof txt==='undefined'?'undefined':_typeof(txt))==='object')console.log('Error: '+JSON.stringify(txt));else console.log('Error: '+txt);e(txt);};}function logUrl(url){if(window._debug){console.log('URL: '+url);}}

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Storage; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Storage=function(){function Storage(){_classCallCheck(this,Storage);this.keys={allowStorage:"allowStorage",lastContact:"lastContact",registry:"registry",newCompetition:"newCompetition",tokens:"tokens",localTokens:"localTokens",results:"results",serverMode:"serverMode",toggleServerMode:"toggleServer",scheduleService:"scheduleService",competitionService:"competitionService",resultService:"resultService",registrationService:"registrationService",registrationContact:"registrationContact",resultsQueue:"resultsQueue",programMode:"programMode"};}_createClass(Storage,[{key:"set",value:function set(key,value){// if (!this.keys[key]) { throw new Error("The key has not been registered! (" + key + ")"); }
if(key===this.keys.allowStorage&&value)this.allowStorage=true;if(this.allowStorage)window.localStorage[key]=JSON.stringify(value);}},{key:"get",value:function get(key){// if (!this.keys[key]) { throw new Error("The key has not been registered! (" + key + ")"); }
try{if(key===this.keys.allowStorage){this.allowStorage=JSON.parse(window.localStorage[key]);}// Patch old bug
if(key===this.keys.registrationContact&&window.localStorage["Contact"]){window.localStorage[this.keys.registrationContact]=window.localStorage["Contact"];this.deleteKey("Contact");}return JSON.parse(window.localStorage[key]);}catch(error){return undefined;}}},{key:"deleteKey",value:function deleteKey(key){window.localStorage.removeItem(key);}},{key:"delete",value:function _delete(){if(window._debug){console.log("Deleting storage",this.keys);}for(var k in this.keys){window.localStorage.removeItem(k);}}}]);return Storage;}();Storage.register={name:"Storage",createInstance:true};

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = setCookie;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCookie;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteCookie;
function setCookie(name,value,expiration){document.cookie=name+"="+value+"; "+(expiration?expiration+"; ":"")+"path=/;SameSite=Lax";}function getCookie(name){var defaultValue=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var d=decodeURIComponent(document.cookie).split(";").filter(function(c){return c.trim().startsWith(name+"=");}).map(function(c){return c.split("=")[1];});if(d.length===0)return defaultValue;return d[0];}function deleteCookie(name){document.cookie=name+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";}

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalScheduleService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LocalScheduleService=function(){function LocalScheduleService(){_classCallCheck(this,LocalScheduleService);}_createClass(LocalScheduleService,[{key:"initialize",value:function initialize(){var _this=this;this.schedules=this.Storage.get(this.Storage.keys.scheduleService)||[];// ToDo: remove backwards compatibility hack?
this.schedules=this.schedules.filter(function(l){return l!==undefined&&l.id!==undefined;}).map(function(s){return __WEBPACK_IMPORTED_MODULE_0__models__["Schedule"].fromJson(s);});this.id=1;this.schedules.forEach(function(s){if(s.id>=_this.id){_this.id=s.id+1;}});}},{key:"createSchedule",value:function createSchedule(schedule,callback){var newSchedule=new __WEBPACK_IMPORTED_MODULE_0__models__["Schedule"]();newSchedule=Object.assign({},schedule);newSchedule.id=this.id++;this.schedules.push(newSchedule);this.Storage.set(this.Storage.keys.scheduleService,this.schedules);callback(newSchedule);}},{key:"getSchedule",value:function getSchedule(scheduleId,callback){callback(this.schedules.find(function(s){return s.id===scheduleId;})||__WEBPACK_IMPORTED_MODULE_0__models__["Schedule"].fromJson({id:scheduleId,squads:[],squadId:1}));}},{key:"updateSchedule",value:function updateSchedule(schedule,callback){this.schedules=this.schedules.map(function(s){return s.id===schedule.id?schedule:s;});this.Storage.set(this.Storage.keys.scheduleService,this.schedules);callback({});}},{key:"deleteSchedule",value:function deleteSchedule(scheduleId,callback){this.schedules=this.schedules.filter(function(s){return s.id!==scheduleId;});callback({});}}]);return LocalScheduleService;}();LocalScheduleService.register={name:"ScheduleService",createInstance:true};LocalScheduleService.wire=["Storage"];

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalCompetitionService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LocalCompetitionService=function(){function LocalCompetitionService(){_classCallCheck(this,LocalCompetitionService);this.competitionId=1;this.competitions=[];}_createClass(LocalCompetitionService,[{key:"initialize",value:function initialize(){var competitionData=this.Storage.get(this.Storage.keys.competitionService)||{};this.competitions=competitionData.competitions||[];this.competitionId=competitionData.id||1;}},{key:"store",value:function store(){this.Storage.set(this.Storage.keys.competitionService,{competitions:this.competitions,id:this.competitionId});}},{key:"permissions",value:function permissions(c){return c.creator===this.Session.user?__WEBPACK_IMPORTED_MODULE_0__models__["Permissions"].Own:__WEBPACK_IMPORTED_MODULE_0__models__["Permissions"].Any;}},{key:"loadCompetitionList",value:function loadCompetitionList(callback){var _this=this;callback(this.competitions.map(function(c){return{id:c.id,name:c.name,description:c.description,status:c.status,permissions:_this.permissions(c)};}));}},{key:"loadCompetition",value:function loadCompetition(id,callback){var competition=this.competitions.find(function(c){return c.id.toString()===id;});if(competition){competition=Object.assign({},competition,{permissions:this.permissions(competition),id:competition.id.toString()});}callback(competition);}},{key:"createCompetition",value:function createCompetition(competition,callback){competition.id=(this.competitionId++).toString();competition.creator=this.Session.user;this.competitions.push(competition);this.store();callback(competition.id);}},{key:"updateCompetition",value:function updateCompetition(id,competition,callback){competition.creator=this.Session.user;this.competitions=this.competitions.map(function(c){return c.id===competition.id?competition:c;});this.store();callback(true);}},{key:"deleteCompetition",value:function deleteCompetition(id,callback){var c=this.competitions.find(function(x){return x.id===id;});if(c.creator!==this.Session.user){callback(false);return;}this.competitions=this.competitions.filter(function(c){return c.id!==id;});this.store();callback(true);}}]);return LocalCompetitionService;}();LocalCompetitionService.register={name:"CompetitionService",createInstance:true};LocalCompetitionService.wire=["Storage","Session"];

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalResultService; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LocalResultService=function(){function LocalResultService(){_classCallCheck(this,LocalResultService);}_createClass(LocalResultService,[{key:"initialize",value:function initialize(){this.results=this.Storage.get(this.Storage.keys.resultService)||[];}},{key:"loadResults",value:function loadResults(competitionId,eventId,callback){var results=this.results.find(function(r){return r.id===competitionId&&r.event===eventId;});callback(results?results.data:[]);}}]);return LocalResultService;}();LocalResultService.register={name:"ResultService",createInstance:true};LocalResultService.wire=["Storage"];

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LocalRegistrationService; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LocalRegistrationService=function(){function LocalRegistrationService(){_classCallCheck(this,LocalRegistrationService);}_createClass(LocalRegistrationService,[{key:"initialize",value:function initialize(){this.registrationData=this.Storage.get(this.Storage.keys.registrationService)||{};}},{key:"findRegistrationData",value:function findRegistrationData(competitionId,token){var competitionData=this.registrationData[competitionId];if(competitionData===undefined||competitionData[token]===undefined){return{};}return competitionData[token];}},{key:"loadRegistration",value:function loadRegistration(competitionId,token,callback){callback(this.findRegistrationData(competitionId,token));}},{key:"generateToken",value:function generateToken(competitionData){var token=void 0;while(token===undefined||competitionData[token]!==undefined){token=Math.random().toString(36).substr(2)+Math.random().toString(36).substr(2);}return token;}},{key:"sendRegistration",value:function sendRegistration(data,callback,error){if(window._debug){console.log("Receiving registration data",data);}var competitionId=data.competition;if(competitionId===undefined){error({message:"TävlingsId måste anges!"});return;}var competitionData=this.registrationData[competitionId]||{};var token=data.token||this.generateToken(competitionData);competitionData[token]=data;this.registrationData[competitionId]=competitionData;this.Storage.set(this.Storage.keys.registrationService,this.registrationData);callback({token:token});}}]);return LocalRegistrationService;}();LocalRegistrationService.register={name:"RegistrationService",createInstance:true};LocalRegistrationService.wire=["Storage"];

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Configuration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gpk_logo_wht_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gpk_logo_wht_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gpk_logo_wht_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Configuration=function(){function Configuration(){_classCallCheck(this,Configuration);this.loaded=false;this.baseUrl='';this.site='';this.mode="computer";this.color="white";this.background="#222";this.icon=__WEBPACK_IMPORTED_MODULE_0__gpk_logo_wht_png___default.a;}_createClass(Configuration,[{key:'setMode',value:function setMode(mode){this.mode=mode;this.Storage.set(this.Storage.keys.programMode,mode);this.fire(this.Events.modeChanged,mode);}},{key:'initialize',value:function initialize(){var _this=this;this.mode=this.Storage.get(this.Storage.keys.programMode)||__WEBPACK_IMPORTED_MODULE_1__models__["Mode"].computer;fetch("/config.json").then(function(res){return res.json();}).then(function(json){if(json.useSite){_this.site=json.useSite||'real';_this.baseUrl=(_this.site==='test'?json.baseUrlTest:json.baseUrlReal)||json.baseUrl;}else{console.log("Setting baseUrl",json.baseUrl);_this.baseUrl=json.baseUrl;}_this.loaded=true;window._debug=_this.site!=='real';_this.fire(_this.Events.configurationLoaded);});}}]);return Configuration;}();Configuration.register={name:"Configuration",createInstance:true};Configuration.wire=["fire","Events","Storage"];

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompetitionGroups; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gpk_logo_wht_png__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__gpk_logo_wht_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__gpk_logo_wht_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gavleborg_png__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__gavleborg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__gavleborg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sm_2022_png__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sm_2022_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__sm_2022_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hille_png__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hille_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__hille_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var CompetitionGroups=function(){function CompetitionGroups(){_classCallCheck(this,CompetitionGroups);this.defaultGroup={name:"Tävlingsanmälan",description:"Anmälningssystem Gävle PK",icon:__WEBPACK_IMPORTED_MODULE_0__gpk_logo_wht_png___default.a,background:"#000000",color:"#FFFFFF"};this.defaults=[{id:1,label:"traning_gpk",name:"Gävle PK",description:"Träningar och interna tävlingar Gävle PK",icon:"GPK",background:"#000000",color:"#FFFFFF",status:1},{id:4,label:"hille",name:"Hille Skyttegille",description:"Träningar och interna tävlingar Hille HSG",icon:"HILLE",url:"/group/hille",background:"#CFCFCF",color:"#000000",status:1},{id:2,label:"xkretsen",name:"X-kretsen",description:"Kretstävlingar Gävleborg",icon:"XKRETSEN",background:"#CFCFFF",color:"#000000",status:1},{id:3,label:"sm_2022",name:"SM Fält 2022",description:"Anmälan SM Fält 2022",icon:"SM2022",background:"#206196",color:"#000000",status:0}];this.groups=[];this.icons={GPK:__WEBPACK_IMPORTED_MODULE_0__gpk_logo_wht_png___default.a,XKRETSEN:__WEBPACK_IMPORTED_MODULE_1__gavleborg_png___default.a,SM2022:__WEBPACK_IMPORTED_MODULE_2__sm_2022_png___default.a,HILLE:__WEBPACK_IMPORTED_MODULE_3__hille_png___default.a};this.active=null;this.loadGroups=function(){console.log("Load groups");};}_createClass(CompetitionGroups,[{key:'initialize',value:function initialize(){var _this=this;this.subscribe(this.Events.configurationLoaded,this.loadGroups);this.active=this.defaultGroup;this.Server.loadCompetitionGroups(function(json){_this.groups=json.map(function(g){return __WEBPACK_IMPORTED_MODULE_4__models__["CompetitionGroup"].fromJson(g);});_this.defaults.forEach(function(d){if(!_this.groups.some(function(g){return g.id===d.id;})){_this.groups.push(d);}});_this.groups.forEach(function(g){return g.iconPath=_this.icons[g.icon]||__WEBPACK_IMPORTED_MODULE_0__gpk_logo_wht_png___default.a;});_this.fire(_this.Events.competitionGroupsUpdated);/*
			this.Server.loadRemoteCompetitionGroups(json => {
				// TODO: Implement remote groups!!!
				console.log("Remote groups", json);
			}, this.Footers.errorHandler(CompetitionGroups.E_CANNOT_FETCH));
			*/},this.Footers.errorHandler(CompetitionGroups.E_CANNOT_FETCH));}},{key:'setGroup',value:function setGroup(group){if(group!==this.active){this.active=group;this.fire(this.Events.competitionGroupsUpdated);}}},{key:'findGroup',value:function findGroup(label){return this.groups.find(function(g){return g.label===label;})||this.defaultGroup;}},{key:'updateGroup',value:function updateGroup(group,prop,value){console.log("Group update",group,prop,value);group[prop]=value;}},{key:'save',value:function save(){}}]);return CompetitionGroups;}();CompetitionGroups.register={name:"CompetitionGroups",createInstance:true};CompetitionGroups.wire=["fire","subscribe","Events","Server","Footers"];CompetitionGroups.E_CANNOT_FETCH="Kan inte hämta grupper";

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gavleborg.8b78eca6.png";

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/sm_2022.c7d51dae.png";

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hille.27365240.png";

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Session; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Session=function(){function Session(){var _this=this;_classCallCheck(this,Session);this.checkLogin=function(){_this.user=Object(__WEBPACK_IMPORTED_MODULE_0____["getCookie"])("user","");if(_this.user&&_this.user!==""){_this.login_token=Object(__WEBPACK_IMPORTED_MODULE_0____["getCookie"])("login_token");_this.keepAliveTimer=setInterval(_this.keepAlive,Session.KEEPALIVE_INTERVAL);_this.keepAlive();}};this.keepAlive=function(){var errorHandler=function errorHandler(error){console.log("Error contacting server",error);// Do not log out user on error from keepalive!!!
// this.user = "";
// deleteCookie("user");
// this.login_token = "";
// deleteCookie("login_token");
// if (this.keepAliveTimer !== undefined) {
// 	clearInterval(this.keepAliveTimer);
// 	this.keepAliveTimer = undefined;
// }
// this.fire(Events.userChanged);
};fetch(_this.Configuration.baseUrl+"/keepalive",{crossDomain:true,credentials:'include',method:"POST",body:JSON.stringify({login_token:_this.login_token})}).then(function(res){if(!res.ok){errorHandler(res);}else res.json().then(function(json){_this.login_token=json.login_token;Object(__WEBPACK_IMPORTED_MODULE_0____["setCookie"])("login_token",json.login_token);}).catch(errorHandler);}).catch(errorHandler);};}_createClass(Session,[{key:"initialize",value:function initialize(){this.subscribe(__WEBPACK_IMPORTED_MODULE_0____["Events"].configurationLoaded,this.checkLogin);}},{key:"login",value:function login(user,password){var _this2=this;this.Server.login(user,password,function(status){_this2.user=user;Object(__WEBPACK_IMPORTED_MODULE_0____["setCookie"])("user",_this2.user);if(user==="patrik")_this2.Storage.set(_this2.Storage.keys.toggleServerMode,true);_this2.keepAliveTimer=setInterval(_this2.keepAlive,Session.KEEPALIVE_INTERVAL);_this2.fire(__WEBPACK_IMPORTED_MODULE_0____["Events"].userChanged);_this2.keepAlive();},this.Footers.errorHandler(Session.E_LOGIN_ERROR));}},{key:"logout",value:function logout(){var _this3=this;if(this.user!==""){this.Server.logout(function(res){_this3.user="";Object(__WEBPACK_IMPORTED_MODULE_0____["deleteCookie"])("user");Object(__WEBPACK_IMPORTED_MODULE_0____["deleteCookie"])("login_token");if(_this3.keepAliveTimer){clearInterval(_this3.keepAliveTimer);_this3.keepAliveTimer=undefined;}_this3.fire(__WEBPACK_IMPORTED_MODULE_0____["Events"].userChanged);},this.Footers.errorHandler(Session.E_LOGOUT_ERROR));}}},{key:"isAdmin",value:function isAdmin(){return this.user==="patrik";}}]);return Session;}();Session.register={name:"Session",createInstance:true};Session.wire=["fire","subscribe","Server","Configuration","Storage","Footers"];Session.E_LOGIN_ERROR="Kan inte logga in";Session.E_LOGOUT_ERROR="Kan inte logga ut";Session.KEEPALIVE_INTERVAL=1000*60*15;

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StdFieldScore; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var sum=function sum(a,b){return a+b;};var tgt=function tgt(x){return x>0;};var StdFieldScore=function(){function StdFieldScore(){_classCallCheck(this,StdFieldScore);}_createClass(StdFieldScore,null,[{key:"calculateScores",value:function calculateScores(results,event){var stages=[];event.stages.forEach(function(s){return stages[s.num]=s;});return results.map(function(p){var scores=[],targets=[],value=0;for(var i=0;i<event.scores;i++){scores[i]=0;targets[i]=0;}p.scores.forEach(function(s){if(s.stage<=event.scores){var score=[].concat(_toConsumableArray(s.values));if(stages[s.stage].value){value+=score.pop();}scores[s.stage-1]=score.reduce(sum);targets[s.stage-1]=score.filter(tgt).length;}});return{id:p.id,name:p.name,organization:p.organization,scores:scores,targets:targets,class:p.class,total:[scores.reduce(sum),targets.reduce(sum),value]};});}},{key:"finalScore",value:function finalScore(total){return total[0]+"/"+total[1];}}]);return StdFieldScore;}();

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PointFieldScore; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var sum=function sum(a,b){return a+b;};var tgt=function tgt(x){return x>0;};var PointFieldScore=function(){function PointFieldScore(){_classCallCheck(this,PointFieldScore);}_createClass(PointFieldScore,null,[{key:"calculateScores",value:function calculateScores(results,event){var stages=[];event.stages.forEach(function(s){return stages[s.num]=s;});return results.map(function(p){var scores=[],targets=[],value=0;for(var i=0;i<event.scores;i++){scores[i]=0;targets[i]=0;}p.scores.forEach(function(s){if(s.stage<=event.scores){var score=[].concat(_toConsumableArray(s.values));if(stages[s.stage].value){value+=score.pop();}scores[s.stage-1]=score.reduce(sum);targets[s.stage-1]=score.filter(tgt).length;}});return{id:p.id,name:p.name,organization:p.organization,scores:scores,targets:targets,class:p.class,total:[scores.reduce(sum)+targets.reduce(sum),0,value]};});}},{key:"finalScore",value:function finalScore(total){return""+total[0];}}]);return PointFieldScore;}();

/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Participant; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Person__ = __webpack_require__(102);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Participant=function(_Person){_inherits(Participant,_Person);function Participant(p,registrationInfo){_classCallCheck(this,Participant);var _this=_possibleConstructorReturn(this,(Participant.__proto__||Object.getPrototypeOf(Participant)).call(this,p));_this.errors=[];_this.id=Participant.nextId++;_this.registrationInfo=registrationInfo||[];return _this;}_createClass(Participant,[{key:'toJson',value:function toJson(){return{participant:{name:this.name,id:this.competitionId,organization:this.organization,support:this.registrationInfo.some(function(r){return /VetÄ/.test(r.class);})?1:0},entries:this.registrationInfo.map(function(r){return{class:r.class,event:r.event,rounds:r.rounds};})};}},{key:'event',value:function event(id){return this.registrationInfo.find(function(e){return e.event===id;});}},{key:'addEvent',value:function addEvent(id){var info=this.event(id);if(info!==undefined){return info;}this.registrationInfo.push({event:id,rounds:[{}]});return this.event(id);}},{key:'addSquad',value:function addSquad(eventId,round,squad){var info=this.addEvent(eventId);if(null===squad){info.rounds[round].squad=undefined;info.rounds[round].time=undefined;}else{info.rounds[round].squad=squad.id;info.rounds[round].time=squad.startTime;}}},{key:'getStartTime',value:function getStartTime(eventId,round){var info=this.event(eventId);return info===undefined?undefined:info.rounds[round]===undefined?undefined:info.rounds[round].time;}},{key:'getSquadsExcept',value:function getSquadsExcept(eventId,round){var squads=[];this.registrationInfo.forEach(function(e){return e.rounds.forEach(function(r,i){if(e.event!==eventId&&round!==i&&r.squad!==undefined)squads.push(r.squad);});});return squads;}},{key:'getDivision',value:function getDivision(eventId,round){var info=this.event(eventId);return info===undefined?undefined:info.rounds[round]===undefined?undefined:info.rounds[round].division;}},{key:'removeEvent',value:function removeEvent(id){this.registrationInfo=this.registrationInfo.filter(function(e){return e.event!==id;});}},{key:'participate',value:function participate(id){return this.event(id)!==undefined;}},{key:'setParticipate',value:function setParticipate(id,value){if(value){this.addEvent(id);}else{this.removeEvent(id);}}}],[{key:'fromServer',value:function fromServer(_ref){var participant=_ref.participant,entries=_ref.entries;return new Participant({name:participant.name,competitionId:participant.id,organization:participant.organization},entries.map(function(e){return{class:e.class,event:parseInt(e.event,10),rounds:e.rounds===undefined?undefined:e.rounds.map(function(r){return{division:r.division,squad:r.squad===undefined?undefined:parseInt(r.squad,10),time:r.time};})};}));}}]);return Participant;}(__WEBPACK_IMPORTED_MODULE_0__Person__["a" /* Person */]);Participant.nextId=0;

/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Registration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logic__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Team__ = __webpack_require__(104);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Registration=function(){function Registration(){var _this=this;_classCallCheck(this,Registration);this.token=undefined;this.contact=new __WEBPACK_IMPORTED_MODULE_1____["Person"]();this.participants=[];this.teams=[];this.newRegistration=function(){_this.token=undefined;_this.participants=[];_this.teams=[];_this.loadContact();_this.Tokens.setToken(_this.Competition.id,undefined);_this.fire(_this.Events.registrationUpdated,_this);};}_createClass(Registration,[{key:'initialize',// ToDo: Rewrite to not use event handlers
value:function initialize(){var _this2=this;this.subscribe(this.Events.setRegistrationInfo,this.setContactField.bind(this));this.subscribe(this.Events.selectSquad,this.selectSquad.bind(this));this.subscribe(this.Events.registerForCompetition,function(){return _this2.register();});this.loadContact();}},{key:'load',value:function load(id,token){var _this3=this;if(token===undefined||token===null){token=this.Tokens.getToken(id);}if(token!==undefined&&token!==null){this.Server.loadRegistration(id,token,function(json){_this3.token=token;// Hack to compensate for server not storing organization
// this.contact = Person.fromJson(json.contact);
if(json.contact){var nC=__WEBPACK_IMPORTED_MODULE_1____["Person"].fromJson(json.contact);nC.setDefaultOrganization(_this3.contact.organization);_this3.contact=nC;}// Loading participants from json
if(json.registration){_this3.participants=json.registration.map(function(p){return __WEBPACK_IMPORTED_MODULE_1____["Participant"].fromServer(p);});_this3.setParticipantDefaults();}else{_this3.participants=[];}if(json.teams){_this3.teams=json.teams.map(function(t){return __WEBPACK_IMPORTED_MODULE_2__Team__["a" /* Team */].fromJson(t);});}else{_this3.teams=[];}_this3.fire(_this3.Events.registrationUpdated,_this3);},this.Footers.errorHandler("Kan inte hämta anmälan"));}else{this.token=undefined;this.loadContact();// ToDo: ???
this.participants=[];}}},{key:'loadContact',value:function loadContact(){var storedPerson=this.Storage.get(this.Storage.keys.registrationContact);this.contact=storedPerson?__WEBPACK_IMPORTED_MODULE_1____["Person"].fromJson(storedPerson):new __WEBPACK_IMPORTED_MODULE_1____["Person"]();this.contact.account=this.contact.account||"";// Patch to handle stored information without account
this.fire(this.Events.registrationUpdated,this);}},{key:'setParticipantDefaults',value:function setParticipantDefaults(){var _this4=this;this.participants.forEach(function(p){p.registrationInfo=p.registrationInfo.filter(function(r){return _this4.Competition.event(r.event)!==undefined;});p.registrationInfo.forEach(function(r){var event=_this4.Competition.event(r.event);if(event.classes){var classes=_this4.Competition.classes(event.classes);if(!classes.includes(r.class)){r.class=classes.find(function(c){return c.startsWith("!");})||classes[0];}}if(event.divisions){var divisions=_this4.Competition.divisions(event.divisions);r.rounds.forEach(function(rd){if(!divisions.includes(rd.division)){rd.division=divisions.find(function(d){return d.startsWith("!");})||divisions[0];}});}});});}},{key:'addMe',value:function addMe(){var _this5=this;if(this.participants.some(function(p){return p.name===_this5.contact.name;})){this.fire(this.Events.addFooter,"Deltagaren finns redan!");return;}var newParticipant=new __WEBPACK_IMPORTED_MODULE_1____["Participant"]();newParticipant.name=this.contact.name;newParticipant.organization=this.contact.organization;var me=this.Registry.competitors.find(function(c){return c.name===_this5.contact.name;});if(me){newParticipant.competitionId=me.competitionId;}this.Competition.events.forEach(function(e){return newParticipant.addEvent(e.id);});this.participants.push(newParticipant);this.setParticipantDefaults();this.fire(this.Events.registrationUpdated,this);}},{key:'addParticipant',value:function addParticipant(p){if(p!==undefined&&this.participants.find(function(f){return f.competitionId===p.competitionId;})!==undefined){this.fire(this.Events.addFooter,"Deltagaren finns redan!");return;}var newParticipant=new __WEBPACK_IMPORTED_MODULE_1____["Participant"](p);if(p===undefined){newParticipant.organization=this.contact.organization;}this.Competition.events.forEach(function(e){return newParticipant.addEvent(e.id);});this.participants.push(newParticipant);this.setParticipantDefaults();this.fire(this.Events.registrationUpdated,this);}},{key:'getParticipant',value:function getParticipant(pId){return this.participants.find(function(p){return pId===p.id;});}},{key:'deleteParticipant',value:function deleteParticipant(id){this.participants=this.participants.filter(function(p){return p.id!==id;});this.fire(this.Events.registrationUpdated,this);}},{key:'setParticipantField',value:function setParticipantField(id,field,value){if(field==="competitionId"&&(value.length>5||!/^\d*$/.test(value))){return;}// Add more validation rules later?
this.participants.forEach(function(p){if(p.id===id){p[field]=value;}});this.fire(this.Events.registrationUpdated,this);}},{key:'setParticipantEvent',value:function setParticipantEvent(pId,eventId,value){this.getParticipant(pId).setParticipate(eventId,value);this.fire(this.Events.registrationUpdated,this);}},{key:'setParticipantClass',value:function setParticipantClass(pId,event,value){this.getParticipant(pId).addEvent(event.id).class=value.startsWith("!")?undefined:value;this.fire(this.Events.registrationUpdated,this);}},{key:'addParticipantRound',value:function addParticipantRound(pId,id){this.getParticipant(pId).addEvent(id).rounds.push({});this.setParticipantDefaults();this.fire(this.Events.registrationUpdated,this);}},{key:'deleteParticipantRound',value:function deleteParticipantRound(pId,eventId,round){this.getParticipant(pId).event(eventId).rounds.splice(round,1);this.fire(this.Events.registrationUpdated,this);}},{key:'setParticipantDivision',value:function setParticipantDivision(pId,eventId,round,value){this.getParticipant(pId).addEvent(eventId).rounds[round].division=value.startsWith("!")?undefined:value;this.getParticipant(pId).addSquad(eventId,round,{});// Why do this?
this.fire(this.Events.registrationUpdated,this);}},{key:'setParticipantSlot',value:function setParticipantSlot(pId,event,round,value){this.getParticipant(pId).addEvent(event.id).rounds[round].slot=value;this.fire(this.Events.registrationUpdated,this);}},{key:'setContactField',value:function setContactField(field,value){if(field==="account"&&(value.length>10||!/^\d*[-]?\d*$/.test(value))){return;}// Add more validation rules later?
if(field==="email"){value=value.trim();}this.contact[field]=value;this.fire(this.Events.registrationUpdated,this);}},{key:'selectSquad',value:function selectSquad(pId,eventId,round,squad){this.getParticipant(pId).addSquad(eventId,round,squad);this.fire(this.Events.registrationUpdated);}},{key:'removeUnselected',value:function removeUnselected(){var _this6=this;this.participants.forEach(function(p){p.registrationInfo.forEach(function(e){var divisions=_this6.Competition.event(e.event).divisions;var schedule=_this6.Competition.event(e.event).schedule;e.rounds=e.rounds.filter(function(r){return r.division||!divisions||_this6.Competition.divisions(divisions).some(function(d){return d.startsWith("!");});}).filter(function(r){return r.squad||!schedule;});});p.registrationInfo=p.registrationInfo.filter(function(e){var event=_this6.Competition.event(e.event);return(e.class||!event.classes||_this6.Competition.classes(event.classes).some(function(c){return c.startsWith("!");}))&&(e.rounds.length>0||!event.schedule&&!event.divisions);});});}},{key:'countEvents',value:function countEvents(){var events=0;this.participants.forEach(function(p){p.registrationInfo.forEach(function(r){events+=r.rounds.length;});});return events;}},{key:'toJson',value:function toJson(){var registration={competition:this.Competition.id,token:this.token,contact:this.contact.toJson()};if(this.participants.length>0){registration.registration=this.participants.map(function(p){return p.toJson();});}if(this.teams.length>0){registration.teams=this.teams.map(function(t){return t.toJson();});}return registration;}},{key:'register',value:function register(){var _this7=this;this.Storage.set(this.Storage.keys.registrationContact,this.contact);this.Registry.storeCompetitors(this.participants);this.removeUnselected();this.setParticipantDefaults();// ToDo: missing values should result in errors instead?
var errors=new __WEBPACK_IMPORTED_MODULE_0__logic__["Validation"](this.Competition).validate(this.participants);if(errors.length===0){this.Server.sendRegistration(this.toJson(),function(res){_this7.Footers.addFooter(_this7.countEvents()+" starter registrerade","info");if(_this7.token!==res.token){_this7.token=res.token;_this7.Tokens.setToken(_this7.Competition.id,res.token);_this7.fire(_this7.Events.registrationUpdated,_this7);}},function(error){_this7.Footers.addFooter('Registreringen misslyckades! ('+(error.message||error)+')');});}else{this.Footers.addFooter(errors.length===1?errors[0].error:errors.length+" fel hindrar registrering!");this.fire(this.Events.registrationUpdated,this);}}},{key:'registerTeams',value:function registerTeams(){var _this8=this;this.Storage.set(this.Storage.keys.registrationContact,this.contact);var errors=new __WEBPACK_IMPORTED_MODULE_0__logic__["TeamValidation"](this.Competition).validate(this.teams);if(errors.length===0){this.Server.sendRegistration(this.toJson(),function(res){_this8.Footers.addFooter(_this8.teams.length+' lag registrerade',"info");if(_this8.token!==res.token){_this8.token=res.token;_this8.Tokens.setToken(_this8.Competition.id,res.token);_this8.fire(_this8.Events.registrationUpdated,_this8);}},function(error){_this8.Footers.addFooter('Registreringen misslyckades! ('+(error.message||error)+')');});}else{this.Footers.addFooter(errors.length===1?errors[0].error:errors.length+" fel hindrar registrering!");// this.fire(this.Events.registrationUpdated, this);
}}},{key:'deleteRegistration',value:function deleteRegistration(){var _this9=this;this.Server.deleteRegistration(this.Competition.id,this.token,function(){_this9.token=undefined;_this9.participants=[];_this9.Tokens.setToken(_this9.Competition.id,undefined);_this9.Footers.addFooter("Anmälan raderad","info");_this9.fire(_this9.Events.registrationUpdated,_this9);},this.Footers.errorHandler("Kan inte ta bort anmälan"));}}]);return Registration;}();Registration.register={name:"Registration",createInstance:true};Registration.wire=["subscribe","fire","Competition","Storage","Server","EventBus","Events","Registry","Footers","Tokens"];

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Registry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Registry=function(){function Registry(){_classCallCheck(this,Registry);this.competitors=[];}_createClass(Registry,[{key:"initialize",value:function initialize(){// Patch old bug
var old=this.Storage.get(this.Storage.registry);if(old){this.Storage.deleteKey(this.Storage.registry);this.Storage.set(this.Storage.keys.registry,old);}this.competitors=this.Storage.get(this.Storage.keys.registry)||this.competitors;}},{key:"storeCompetitors",value:function storeCompetitors(participants){var competitors=participants.filter(function(p){return p.name!=="";}).map(function(p){return new __WEBPACK_IMPORTED_MODULE_0____["Person"](p);});this.competitors.forEach(function(p){if(!competitors.some(function(e){return e.competitionId===p.competitionId;}))competitors.push(p);});this.competitors=competitors;this.Storage.set(this.Storage.keys.registry,this.competitors);this.fire(this.Events.registryUpdated);}},{key:"deleteCompetitor",value:function deleteCompetitor(id){this.competitors=this.competitors.filter(function(c){return c.competitionId!==id;});this.Storage.set(this.Storage.registry,this.competitors);this.fire(this.Events.registryUpdated);}}]);return Registry;}();Registry.register={name:"Registry",createInstance:true};Registry.wire=["fire","Storage","Events"];

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Results; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ParticipantScore__ = __webpack_require__(103);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Results=function(){function Results(){var _this=this;_classCallCheck(this,Results);this.competition=null;this.event=null;this.scores=[];this.trySendResults=function(){if(_this.queue.length>0){var res=_this.queue[0];_this.Server.send("competition/"+res.competition+"/event/"+res.event+"/participant",res.scores,function(json){_this.queue=_this.queue.filter(function(r){return r!==res;});if(window._debug){console.log("Successfully sent results");}_this.Storage.set(_this.Storage.keys.resultsQueue,_this.queue);_this.fire(_this.Events.resultsUpdated);if(_this.queue.length>0){_this.trySendResults();}else{if(_this.lastEvent){_this.load(_this.Competition.id,_this.lastEvent,true);}}},function(error){console.log("Error sending results",error,error.message,JSON.stringify(error));});}// Do not periodically load results - that will screw up result entry
};}_createClass(Results,[{key:"initialize",value:function initialize(){this.queue=this.Storage.get(this.Storage.keys.resultsQueue)||[];setInterval(this.trySendResults,1000*60);}},{key:"load",value:function load(competitionId,eventId,force){var _this2=this;if(force||eventId!==this.lastEvent||this.lastTime===undefined||Date.now()-this.last>10*1000){this.lastEvent=eventId;this.lastTime=Date.now();this.Server.load("competition/"+competitionId+"/event/"+eventId+"/participant",function(json){if(window._debug){console.log("Loaded results",json);}_this2.competition=parseInt(competitionId,10);_this2.event=parseInt(eventId,10);_this2.scores=json.map(function(p){return __WEBPACK_IMPORTED_MODULE_0__ParticipantScore__["a" /* ParticipantScore */].fromJson(p);});_this2.fire(_this2.Events.resultsUpdated);},this.Footers.errorHandler("Kan inte hämta deltagare för tävlingen"));}}},{key:"getScores",value:function getScores(squad){return squad?this.scores.filter(function(s){return s.squad===squad;}):this.scores;}},{key:"updateScore",value:function updateScore(event,scorecard){var score=this.scores.find(function(p){return p.id===scorecard;});score=Object.assign({},score,{score:score.scores});this.queue.push({competition:this.competition,event:event,squad:score.squad,scores:[score]});if(window._debug){console.log("Queueing score update",this.queue);}this.Storage.set(this.Storage.keys.resultsQueue,this.queue);this.fire(this.Events.resultsUpdated);this.trySendResults();}},{key:"report",value:function report(event,squad,stage){var scores=this.scores.filter(function(p){return p.squad===squad.id;}).map(function(p){return p.toStageJson(stage);});if(scores.length>0){this.queue.push({competition:this.competition,event:event.id,squad:squad.id,scores:scores});if(window._debug){console.log("Adding score to queue",this.queue);}this.Storage.set(this.Storage.keys.resultsQueue,this.queue);this.fire(this.Events.resultsUpdated);}this.trySendResults();}},{key:"clearQueue",value:function clearQueue(){this.queue=[];this.Storage.set(this.Storage.keys.resultsQueue,this.queue);this.fire(this.Events.resultsUpdated);}}]);return Results;}();Results.register={name:"Results",createInstance:true};Results.wire=["fire","Competition","Storage","Server","Events","Footers","Busy"];

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Schedule; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Schedule=function(){function Schedule(duration,divisionGroup){_classCallCheck(this,Schedule);this.nextSquadId=1;this.squads=[];this.duration=duration||"2:00";this.divisionGroup=divisionGroup||0;}_createClass(Schedule,[{key:'toJson',value:function toJson(){return{id:this.id,squads:this.squads.map(function(s){return s.toJson();}),duration:__WEBPACK_IMPORTED_MODULE_1__logic__["Time"].durationFromText(this.duration),divisionGroup:this.divisionGroup};}},{key:'addSquad',value:function addSquad(startTime,slots,divisions,mixed){this.squads.push(new __WEBPACK_IMPORTED_MODULE_0____["Squad"](startTime,slots,divisions,mixed,this.nextSquadId++));}},{key:'deleteSquad',value:function deleteSquad(squad){this.squads=this.squads.filter(function(s){return s.id!==squad.id;});}},{key:'updateSquadProperty',value:function updateSquadProperty(squadId,property,value){this.squads.forEach(function(s){if(s.id===squadId){s[property]=value;}});}}],[{key:'fromJson',value:function fromJson(s,p){var schedule=new Schedule();schedule.id=parseInt(s.id.toString(),10);schedule.nextSquadId=s.squads&&s.squads.length>0?Math.max.apply(Math,_toConsumableArray(s.squads.map(function(sq){return parseInt(sq.id.toString(),10);}))):1;// ToDo: why is null present?
if(p&&s.squads){s.squads.forEach(function(sq){sq.participants=p.find(function(ps){return ps.id===sq.id;}).entries;});}schedule.squads=s.squads?s.squads.filter(function(x){return x!==null;}).map(function(s){return __WEBPACK_IMPORTED_MODULE_0____["Squad"].fromJson(s);}):[];schedule.duration=s.duration?__WEBPACK_IMPORTED_MODULE_1__logic__["Time"].format(parseInt(s.duration.toString(),10)):"2:00";schedule.divisionGroup=s.divisionGroup;return schedule;}}]);return Schedule;}();

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScoringModels; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Discipline__ = __webpack_require__(69);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var E_MISSING_VALUE="Värde saknas";var E_INCORRECT_SPREAD="Träffarna inte fördelade korrekt";var E_TOO_MANY_HITS="För många träffar";var PrecisionScoring=function(){function PrecisionScoring(){_classCallCheck(this,PrecisionScoring);}_createClass(PrecisionScoring,null,[{key:"validateScore",value:function validateScore(participant,event,stage){participant.error=null;var score=participant.getScores(stage);if(score==null||score.values.length<5||score.values.some(function(s){return s===null||s===undefined;})){participant.error=E_MISSING_VALUE;return false;}return true;}},{key:"total",value:function total(participant,event){return 0;}}]);return PrecisionScoring;}();var FieldScoring=function(){function FieldScoring(){_classCallCheck(this,FieldScoring);}_createClass(FieldScoring,null,[{key:"validateScore",value:function validateScore(participant,event,stage){var stageDef=event.stages.find(function(s){return s.num===stage;});participant.error=null;var score=participant.getScores(stage);if(score==null){participant.error=E_MISSING_VALUE;return false;}var length=stageDef.targets+(stageDef.value?1:0);var values=score.values;if(values.length<length){participant.error=E_MISSING_VALUE;return false;}else for(var t=0;t<length;t++){if(values[t]==null){participant.error=E_MISSING_VALUE;return false;}}if(stageDef.min>0){var max=stageDef.shots+values.filter(function(t){return t<stageDef.min;}).map(function(t){return t-stageDef.min;}).reduce(function(a,b){return a+b;},0);if(values.reduce(function(a,b){return a+b;},0)>max){participant.error=E_INCORRECT_SPREAD;return false;}}values=values.slice(0,stageDef.targets);if(values.some(function(t){return t>stageDef.max;})||values.reduce(function(a,b){return a+b;},0)>stageDef.shots){participant.error=E_TOO_MANY_HITS;return false;}return true;}},{key:"total",value:function total(participant,event){}}]);return FieldScoring;}();var PointFieldScoring=function(_FieldScoring){_inherits(PointFieldScoring,_FieldScoring);function PointFieldScoring(){_classCallCheck(this,PointFieldScoring);return _possibleConstructorReturn(this,(PointFieldScoring.__proto__||Object.getPrototypeOf(PointFieldScoring)).apply(this,arguments));}_createClass(PointFieldScoring,null,[{key:"total",value:function total(participant,event){}}]);return PointFieldScoring;}(FieldScoring);var ScoringModels=function(){function ScoringModels(){_classCallCheck(this,ScoringModels);}_createClass(ScoringModels,null,[{key:"getModel",value:function getModel(discipline){switch(discipline){case __WEBPACK_IMPORTED_MODULE_0__Discipline__["a" /* Discipline */].target:return PrecisionScoring;case __WEBPACK_IMPORTED_MODULE_0__Discipline__["a" /* Discipline */].fieldP:case __WEBPACK_IMPORTED_MODULE_0__Discipline__["a" /* Discipline */].fieldK:return FieldScoring;case __WEBPACK_IMPORTED_MODULE_0__Discipline__["a" /* Discipline */].scoredP:case __WEBPACK_IMPORTED_MODULE_0__Discipline__["a" /* Discipline */].scoredK:return PointFieldScoring;default:return null;}}}]);return ScoringModels;}();

/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Squad; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Squad=function(){function Squad(startTime,slots,divisions,mixed,id){_classCallCheck(this,Squad);this.id=id;this.startTime=startTime;this.slots=slots;this.divisions=divisions;this.mixed=mixed;this.participants=[];}_createClass(Squad,[{key:"toJson",value:function toJson(){// eslint-disable-next-line
var id=this.id,stored=this.stored,data=_objectWithoutProperties(this,["id","stored"]);if(this.stored)data.id=id;return data;}}],[{key:"fromJson",value:function fromJson(s){var n=new Squad();n.stored=true;if(s){n.startTime=s.startTime.split(":").slice(0,2).join(":");while(n.startTime[0]==='0'){n.startTime=n.startTime.slice(1);}n.slots=parseInt(s.slots.toString(),10);n.divisions=[].concat(_toConsumableArray(new Set(s.divisions)));// Fix to mitigate server bug
n.mixed=s.mixed==="true";n.id=parseInt(s.id.toString(),10);n.participants=s.participants||[];}return n;}}]);return Squad;}();

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StageDef; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var StageDef=function(){function StageDef(num,targets,value,max,min,shots){_classCallCheck(this,StageDef);this.num=num;this.targets=targets||1;this.value=value||false;this.max=max||6;this.min=min||0;this.shots=shots||6;}_createClass(StageDef,[{key:"toJson",value:function toJson(){return{num:this.num,targets:this.targets,value:this.value?1:0,max:this.max,min:this.min,shots:this.shots};}}],[{key:"fromJson",value:function fromJson(json){return new StageDef(parseInt(json.num,10),parseInt(json.targets,10),json.value==="1",parseInt(json.max,10),parseInt(json.min,10),parseInt(json.shots,10));}}]);return StageDef;}();

/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TabInfo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Competition__ = __webpack_require__(68);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var TabInfo=function(){function TabInfo(name,path,order,permissions,status){_classCallCheck(this,TabInfo);this.name=name;this.path=path;this.order=order;this.permissions=permissions;this.status=status;}_createClass(TabInfo,[{key:"show",value:function show(competition){return competition.permissions>=__WEBPACK_IMPORTED_MODULE_0__Competition__["c" /* Permissions */].Admin||this.permissions<=competition.permissions&&(this.status===undefined||this.status===competition.status);}}]);return TabInfo;}();

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamRegistration; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var TeamRegistration=function(){function TeamRegistration(){_classCallCheck(this,TeamRegistration);}_createClass(TeamRegistration,[{key:"initialize",value:function initialize(){this.EventBus.manageEvents(this);}}]);return TeamRegistration;}();TeamRegistration.register={name:"TeamRegistration",createInstance:true};TeamRegistration.wire=["EventBus","Events","Server","Storage"];

/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamDef; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var TeamDef=function(){function TeamDef(id,division,cls,members,alternates,cost){_classCallCheck(this,TeamDef);this.division=division;this.class=cls;this.members=members||2;this.alternates=alternates||1;this.cost=cost||0;}_createClass(TeamDef,[{key:"toJson",value:function toJson(){var json={members:this.members,alternates:this.alternates};if(this.division){json.division=this.division;}if(this.class){json.class=this.class;}json.cost=this.cost;return json;}}],[{key:"fromJson",value:function fromJson(json){return new TeamDef(parseInt(json.team_definition_id,10),json.division!==""?json.division:undefined,json.class!==""?json.class:undefined,parseInt(json.members.toString(),10),parseInt(json.alternates.toString(),10),parseInt(json.cost,10));}}]);return TeamDef;}();

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tokens; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Tokens=function(){function Tokens(){_classCallCheck(this,Tokens);}_createClass(Tokens,[{key:"findTokens",value:function findTokens(){if(this.Server.local){return this.Storage.get(this.Storage.keys.localTokens)||[];}return this.Storage.get(this.Storage.keys.tokens)||this.Storage.get("Tokens")||[];}},{key:"getToken",value:function getToken(competitionId){return this.findTokens()[competitionId];}},{key:"setToken",value:function setToken(competitionId,token){var tokens=this.findTokens();tokens[competitionId]=token;this.Storage.set(this.Server.local?this.Storage.keys.localTokens:this.Storage.keys.tokens,tokens);}}]);return Tokens;}();Tokens.register={name:"Tokens",createInstance:true};Tokens.wire=["Storage","Server"];

/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Description;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function link(a){if(a){if(a.includes("|")){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:a.split("|")[1]},a.split("|")[0]);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:a},a);}}return a;}function linkify(t,c){var p=1;if(t.includes("[")&&t.includes("]")){return t.split("]").map(function(s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{key:p++},s.split("[")[0],link(s.split("[")[1]));}).concat([__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",{key:p++})]);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{key:c},t,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null));}function Description(_ref){var value=_ref.value;if(value==null||value===""){return null;}var c=1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},value.split("\n").map(function(t){return linkify(t,c++);}));}

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventProperties_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventProperties_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EventProperties_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_date_picker__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_date_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_date_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EventProperties=function(_React$Component){_inherits(EventProperties,_React$Component);function EventProperties(props){_classCallCheck(this,EventProperties);var _this=_possibleConstructorReturn(this,(EventProperties.__proto__||Object.getPrototypeOf(EventProperties)).call(this,props));_this.setDiscipline=function(event,discipline){_this.Competition.updateEvent(event,"discipline",parseInt(discipline,10));};_this.setCost=function(event,cost){cost=parseInt(cost,10);if(!isNaN(cost))_this.Competition.updateEvent(event,"cost",cost);};_this.setGroup=function(event,property,group){group=parseInt(group,10);_this.Competition.updateEvent(event,property,group===-1?undefined:group);};_this.showSchedule=function(){_this.fire(_this.Events.editSchedule,_this.props.event);};_this.showStages=function(e){_this.fire(_this.Events.editStages,_this.props.event);};_this.editTeams=function(e){_this.fire(_this.Events.editTeams,_this.props.event);};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.competitionUpdated,function(){return _this.setState({});});return _this;}_createClass(EventProperties,[{key:'render',value:function render(){var _this2=this;var event=this.props.event;var onDelete=this.Competition.events.length>1?function(e){return _this2.Competition.removeEvent(e);}:undefined;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'event'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'eventTitle'},onDelete&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{value:event.name,size:'20',onChange:function onChange(e){return _this2.Competition.updateEvent(event,"name",e.target.value);}}),onDelete&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button-close small red',onClick:function onClick(){return onDelete(event);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'eventProperties'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Label"],{text:'Datum'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_date_picker___default.a,{value:event.date,onChange:function onChange(d){return _this2.Competition.updateEvent(event,"date",d);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Label"],{text:'Gren'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Dropdown"],{className:'eventProperty',value:event.discipline||__WEBPACK_IMPORTED_MODULE_3__models__["Discipline"].none,list:__WEBPACK_IMPORTED_MODULE_3__models__["Discipline"].list,onChange:function onChange(e){return _this2.setDiscipline(event,e.target.value);}}),' '),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Label"],{text:'Antal serier/stationer',align:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Spinner"],{className:'eventProperty',value:event.scores||8,onChange:function onChange(value){return _this2.Competition.updateEvent(event,"scores",Math.max(1,value));}})),__WEBPACK_IMPORTED_MODULE_3__models__["Discipline"].hasStages.includes(event.discipline)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Label"],{text:'F\xF6ruts\xE4ttningar',align:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'eventProperty button',onClick:this.showStages},'Redigera')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Label"],{text:'Startavgift'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{className:'eventProperty fee',maxLength:'5',value:event.cost||100,onChange:function onChange(e){return _this2.setCost(event,e.target.value);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Label"],{text:'Vapengrupper'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Dropdown"],{className:'eventProperty',value:event.divisions||-1,list:this.props.divisionGroups,onChange:function onChange(e){return _this2.setGroup(event,"divisions",e.target.value);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Label"],{text:'Klasser'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Dropdown"],{className:'eventProperty',value:event.classes||-1,list:this.props.classGroups,onChange:function onChange(e){return _this2.setGroup(event,"classes",e.target.value);}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Label"],{text:'Max starter',align:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Spinner"],{className:'eventProperty',value:event.maxRegistrations||1,onChange:function onChange(value){return _this2.Competition.updateEvent(event,"maxRegistrations",Math.max(1,value));}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Label"],{text:'Skjutlag/patruller',align:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'eventProperty button',onClick:this.showSchedule},event.schedule?"Redigera":"Skapa")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4____["Label"],{text:'Lag',align:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'eventProperty button',onClick:this.editTeams},'Redigera'))));}}]);return EventProperties;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);EventProperties.register={name:"EventProperties"};EventProperties.wire=["EventBus","Events","Competition","Server"];

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

__webpack_require__(253);

var _DatePicker = _interopRequireDefault(__webpack_require__(254));

__webpack_require__(283);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// File is created during build phase and placed in dist directory
// eslint-disable-next-line import/no-unresolved
var _default = _DatePicker["default"];
exports["default"] = _default;

/***/ }),
/* 253 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _makeEventProps = _interopRequireDefault(__webpack_require__(255));

var _mergeClassNames = _interopRequireDefault(__webpack_require__(27));

var _reactCalendar = _interopRequireDefault(__webpack_require__(256));

var _reactFit = _interopRequireDefault(__webpack_require__(271));

var _DateInput = _interopRequireDefault(__webpack_require__(274));

var _propTypes2 = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var baseClassName = 'react-date-picker';
var outsideActionEvents = ['mousedown', 'focusin', 'touchstart'];
var allViews = ['century', 'decade', 'year', 'month'];

var DatePicker = /*#__PURE__*/function (_PureComponent) {
  _inherits(DatePicker, _PureComponent);

  var _super = _createSuper(DatePicker);

  function DatePicker() {
    var _this;

    _classCallCheck(this, DatePicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "onOutsideAction", function (event) {
      if (_this.wrapper && !_this.wrapper.contains(event.target)) {
        _this.closeCalendar();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      var closeCalendar = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.closeCalendar;
      var onChange = _this.props.onChange;

      if (closeCalendar) {
        _this.closeCalendar();
      }

      if (onChange) {
        onChange(value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onFocus", function (event) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onFocus = _this$props.onFocus;

      if (onFocus) {
        onFocus(event);
      } // Internet Explorer still fires onFocus on disabled elements


      if (disabled) {
        return;
      }

      _this.openCalendar();
    });

    _defineProperty(_assertThisInitialized(_this), "openCalendar", function () {
      _this.setState({
        isOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeCalendar", function () {
      _this.setState(function (prevState) {
        if (!prevState.isOpen) {
          return null;
        }

        return {
          isOpen: false
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "toggleCalendar", function () {
      _this.setState(function (prevState) {
        return {
          isOpen: !prevState.isOpen
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "stopPropagation", function (event) {
      return event.stopPropagation();
    });

    _defineProperty(_assertThisInitialized(_this), "clear", function () {
      return _this.onChange(null);
    });

    return _this;
  }

  _createClass(DatePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleOutsideActionListeners();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var isOpen = this.state.isOpen;
      var _this$props2 = this.props,
          onCalendarClose = _this$props2.onCalendarClose,
          onCalendarOpen = _this$props2.onCalendarOpen;

      if (isOpen !== prevState.isOpen) {
        this.handleOutsideActionListeners();
        var callback = isOpen ? onCalendarOpen : onCalendarClose;
        if (callback) callback();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleOutsideActionListeners(false);
    }
  }, {
    key: "handleOutsideActionListeners",
    value: function handleOutsideActionListeners(shouldListen) {
      var _this2 = this;

      var isOpen = this.state.isOpen;
      var shouldListenWithFallback = typeof shouldListen !== 'undefined' ? shouldListen : isOpen;
      var fnName = shouldListenWithFallback ? 'addEventListener' : 'removeEventListener';
      outsideActionEvents.forEach(function (eventName) {
        return document[fnName](eventName, _this2.onOutsideAction);
      });
    }
  }, {
    key: "renderInputs",
    value: function renderInputs() {
      var _this$props3 = this.props,
          autoFocus = _this$props3.autoFocus,
          calendarAriaLabel = _this$props3.calendarAriaLabel,
          calendarIcon = _this$props3.calendarIcon,
          clearAriaLabel = _this$props3.clearAriaLabel,
          clearIcon = _this$props3.clearIcon,
          dayAriaLabel = _this$props3.dayAriaLabel,
          dayPlaceholder = _this$props3.dayPlaceholder,
          disableCalendar = _this$props3.disableCalendar,
          disabled = _this$props3.disabled,
          format = _this$props3.format,
          locale = _this$props3.locale,
          maxDate = _this$props3.maxDate,
          maxDetail = _this$props3.maxDetail,
          minDate = _this$props3.minDate,
          monthAriaLabel = _this$props3.monthAriaLabel,
          monthPlaceholder = _this$props3.monthPlaceholder,
          name = _this$props3.name,
          nativeInputAriaLabel = _this$props3.nativeInputAriaLabel,
          required = _this$props3.required,
          returnValue = _this$props3.returnValue,
          showLeadingZeros = _this$props3.showLeadingZeros,
          value = _this$props3.value,
          yearAriaLabel = _this$props3.yearAriaLabel,
          yearPlaceholder = _this$props3.yearPlaceholder;
      var isOpen = this.state.isOpen;

      var _concat = [].concat(value),
          _concat2 = _slicedToArray(_concat, 1),
          valueFrom = _concat2[0];

      var ariaLabelProps = {
        dayAriaLabel: dayAriaLabel,
        monthAriaLabel: monthAriaLabel,
        nativeInputAriaLabel: nativeInputAriaLabel,
        yearAriaLabel: yearAriaLabel
      };
      var placeholderProps = {
        dayPlaceholder: dayPlaceholder,
        monthPlaceholder: monthPlaceholder,
        yearPlaceholder: yearPlaceholder
      };
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(baseClassName, "__wrapper")
      }, /*#__PURE__*/_react["default"].createElement(_DateInput["default"], _extends({}, ariaLabelProps, placeholderProps, {
        autoFocus: autoFocus,
        className: "".concat(baseClassName, "__inputGroup"),
        disabled: disabled,
        format: format,
        isCalendarOpen: isOpen,
        locale: locale,
        maxDate: maxDate,
        maxDetail: maxDetail,
        minDate: minDate,
        name: name,
        onChange: this.onChange,
        required: required,
        returnValue: returnValue,
        showLeadingZeros: showLeadingZeros,
        value: valueFrom
      })), clearIcon !== null && /*#__PURE__*/_react["default"].createElement("button", {
        "aria-label": clearAriaLabel,
        className: "".concat(baseClassName, "__clear-button ").concat(baseClassName, "__button"),
        disabled: disabled,
        onClick: this.clear,
        onFocus: this.stopPropagation,
        type: "button"
      }, clearIcon), calendarIcon !== null && !disableCalendar && /*#__PURE__*/_react["default"].createElement("button", {
        "aria-label": calendarAriaLabel,
        className: "".concat(baseClassName, "__calendar-button ").concat(baseClassName, "__button"),
        disabled: disabled,
        onBlur: this.resetValue,
        onClick: this.toggleCalendar,
        onFocus: this.stopPropagation,
        type: "button"
      }, calendarIcon));
    }
  }, {
    key: "renderCalendar",
    value: function renderCalendar() {
      var disableCalendar = this.props.disableCalendar;
      var isOpen = this.state.isOpen;

      if (isOpen === null || disableCalendar) {
        return null;
      }

      var _this$props4 = this.props,
          calendarClassName = _this$props4.calendarClassName,
          datePickerClassName = _this$props4.className,
          onChange = _this$props4.onChange,
          value = _this$props4.value,
          calendarProps = _objectWithoutProperties(_this$props4, ["calendarClassName", "className", "onChange", "value"]);

      var className = "".concat(baseClassName, "__calendar");
      return /*#__PURE__*/_react["default"].createElement(_reactFit["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _mergeClassNames["default"])(className, "".concat(className, "--").concat(isOpen ? 'open' : 'closed'))
      }, /*#__PURE__*/_react["default"].createElement(_reactCalendar["default"], _extends({
        className: calendarClassName,
        onChange: this.onChange,
        value: value || null
      }, calendarProps))));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props5 = this.props,
          className = _this$props5.className,
          disabled = _this$props5.disabled;
      var isOpen = this.state.isOpen;
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        className: (0, _mergeClassNames["default"])(baseClassName, "".concat(baseClassName, "--").concat(isOpen ? 'open' : 'closed'), "".concat(baseClassName, "--").concat(disabled ? 'disabled' : 'enabled'), className)
      }, this.eventProps, {
        onFocus: this.onFocus,
        ref: function ref(_ref) {
          if (!_ref) {
            return;
          }

          _this3.wrapper = _ref;
        }
      }), this.renderInputs(), this.renderCalendar());
    }
  }, {
    key: "eventProps",
    get: function get() {
      return (0, _makeEventProps["default"])(this.props);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isOpen !== prevState.isOpenProps) {
        return {
          isOpen: nextProps.isOpen,
          isOpenProps: nextProps.isOpen
        };
      }

      return null;
    }
  }]);

  return DatePicker;
}(_react.PureComponent);

exports["default"] = DatePicker;
var iconProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: 19,
  height: 19,
  viewBox: '0 0 19 19',
  stroke: 'black',
  strokeWidth: 2
};

var CalendarIcon = /*#__PURE__*/_react["default"].createElement("svg", _extends({}, iconProps, {
  className: "".concat(baseClassName, "__calendar-button__icon ").concat(baseClassName, "__button__icon")
}), /*#__PURE__*/_react["default"].createElement("rect", {
  fill: "none",
  height: "15",
  width: "15",
  x: "2",
  y: "2"
}), /*#__PURE__*/_react["default"].createElement("line", {
  x1: "6",
  x2: "6",
  y1: "0",
  y2: "4"
}), /*#__PURE__*/_react["default"].createElement("line", {
  x1: "13",
  x2: "13",
  y1: "0",
  y2: "4"
}));

var ClearIcon = /*#__PURE__*/_react["default"].createElement("svg", _extends({}, iconProps, {
  className: "".concat(baseClassName, "__clear-button__icon ").concat(baseClassName, "__button__icon")
}), /*#__PURE__*/_react["default"].createElement("line", {
  x1: "4",
  x2: "15",
  y1: "4",
  y2: "15"
}), /*#__PURE__*/_react["default"].createElement("line", {
  x1: "15",
  x2: "4",
  y1: "4",
  y2: "15"
}));

DatePicker.defaultProps = {
  calendarIcon: CalendarIcon,
  clearIcon: ClearIcon,
  closeCalendar: true,
  isOpen: null,
  returnValue: 'start'
};

var isValue = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]);

DatePicker.propTypes = {
  autoFocus: _propTypes["default"].bool,
  calendarAriaLabel: _propTypes["default"].string,
  calendarClassName: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  calendarIcon: _propTypes["default"].node,
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  clearAriaLabel: _propTypes["default"].string,
  clearIcon: _propTypes["default"].node,
  closeCalendar: _propTypes["default"].bool,
  dayAriaLabel: _propTypes["default"].string,
  dayPlaceholder: _propTypes["default"].string,
  disableCalendar: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  format: _propTypes["default"].string,
  isOpen: _propTypes["default"].bool,
  locale: _propTypes["default"].string,
  maxDate: _propTypes2.isMaxDate,
  maxDetail: _propTypes["default"].oneOf(allViews),
  minDate: _propTypes2.isMinDate,
  monthAriaLabel: _propTypes["default"].string,
  monthPlaceholder: _propTypes["default"].string,
  name: _propTypes["default"].string,
  nativeInputAriaLabel: _propTypes["default"].string,
  onCalendarClose: _propTypes["default"].func,
  onCalendarOpen: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  required: _propTypes["default"].bool,
  returnValue: _propTypes["default"].oneOf(['start', 'end', 'range']),
  showLeadingZeros: _propTypes["default"].bool,
  value: _propTypes["default"].oneOfType([isValue, _propTypes["default"].arrayOf(isValue)]),
  yearAriaLabel: _propTypes["default"].string,
  yearPlaceholder: _propTypes["default"].string
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.focusEvents = exports.keyboardEvents = exports.touchEvents = exports.mouseEvents = void 0;
// As defined on the list of supported mouse events: https://reactjs.org/docs/events.html#mouse-events
var mouseEvents = ['onClick', 'onContextMenu', 'onDoubleClick', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp']; // As defined on the list of supported touch events: https://reactjs.org/docs/events.html#touch-events

exports.mouseEvents = mouseEvents;
var touchEvents = ['onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart']; // As defined on the list of supported keyboard events: https://reactjs.org/docs/events.html#keyboard-events

exports.touchEvents = touchEvents;
var keyboardEvents = ['onKeyDown', 'onKeyPress', 'onKeyUp']; // As defined on the list of supported keyboard events: https://reactjs.org/docs/events.html#focus-events

exports.keyboardEvents = keyboardEvents;
var focusEvents = ['onFocus', 'onBlur'];
/**
 * Returns an object with on-event callback props curried with provided args.
 * @param {Object} props Props passed to a component.
 * @param {Function=} getArgs A function that returns argument(s) on-event callbacks
 *   shall be curried with.
 */

exports.focusEvents = focusEvents;

var makeEventProps = function makeEventProps(props, getArgs) {
  var eventProps = {};
  [].concat(mouseEvents, touchEvents, keyboardEvents, focusEvents).forEach(function (eventName) {
    if (props[eventName]) {
      eventProps[eventName] = function (event) {
        return getArgs ? props[eventName](event, getArgs(eventName)) : props[eventName](event);
      };
    }
  });
  return eventProps;
};

var _default = makeEventProps;
exports.default = _default;

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Calendar__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CenturyView__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DecadeView__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__YearView__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MonthView__ = __webpack_require__(110);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Calendar", function() { return __WEBPACK_IMPORTED_MODULE_0__Calendar__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CenturyView", function() { return __WEBPACK_IMPORTED_MODULE_1__CenturyView__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DecadeView", function() { return __WEBPACK_IMPORTED_MODULE_2__DecadeView__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "YearView", function() { return __WEBPACK_IMPORTED_MODULE_3__YearView__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MonthView", function() { return __WEBPACK_IMPORTED_MODULE_4__MonthView__["a"]; });





/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Calendar__["a" /* default */]);


/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Calendar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_merge_class_names__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Calendar_Navigation__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CenturyView__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DecadeView__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__YearView__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MonthView__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_dates__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_propTypes__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_utils__ = __webpack_require__(107);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }












var defaultMinDate = new Date();
defaultMinDate.setFullYear(1, 0, 1);
defaultMinDate.setHours(0, 0, 0, 0);
var defaultMaxDate = new Date(8.64e15);
var baseClassName = 'react-calendar';
var allViews = ['century', 'decade', 'year', 'month'];
var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);

function toDate(value) {
  if (value instanceof Date) {
    return value;
  }

  return new Date(value);
}
/**
 * Returns views array with disallowed values cut off.
 */


function getLimitedViews(minDetail, maxDetail) {
  return allViews.slice(allViews.indexOf(minDetail), allViews.indexOf(maxDetail) + 1);
}
/**
 * Determines whether a given view is allowed with currently applied settings.
 */


function isViewAllowed(view, minDetail, maxDetail) {
  var views = getLimitedViews(minDetail, maxDetail);
  return views.indexOf(view) !== -1;
}
/**
 * Gets either provided view if allowed by minDetail and maxDetail, or gets
 * the default view if not allowed.
 */


function getView(view, minDetail, maxDetail) {
  if (isViewAllowed(view, minDetail, maxDetail)) {
    return view;
  }

  return maxDetail;
}
/**
 * Returns value type that can be returned with currently applied settings.
 */


function getValueType(maxDetail) {
  return allValueTypes[allViews.indexOf(maxDetail)];
}

function getValue(value, index) {
  if (!value) {
    return null;
  }

  var rawValue = Array.isArray(value) && value.length === 2 ? value[index] : value;

  if (!rawValue) {
    return null;
  }

  var valueDate = toDate(rawValue);

  if (isNaN(valueDate.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  return valueDate;
}

function getDetailValue(_ref, index) {
  var value = _ref.value,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      maxDetail = _ref.maxDetail;
  var valuePiece = getValue(value, index);

  if (!valuePiece) {
    return null;
  }

  var valueType = getValueType(maxDetail);
  var detailValueFrom = [__WEBPACK_IMPORTED_MODULE_8__shared_dates__["a" /* getBegin */], __WEBPACK_IMPORTED_MODULE_8__shared_dates__["l" /* getEnd */]][index](valueType, valuePiece);
  return Object(__WEBPACK_IMPORTED_MODULE_10__shared_utils__["a" /* between */])(detailValueFrom, minDate, maxDate);
}

var getDetailValueFrom = function getDetailValueFrom(args) {
  return getDetailValue(args, 0);
};

var getDetailValueTo = function getDetailValueTo(args) {
  return getDetailValue(args, 1);
};

var getDetailValueArray = function getDetailValueArray(args) {
  var value = args.value;

  if (Array.isArray(value)) {
    return value;
  }

  return [getDetailValueFrom, getDetailValueTo].map(function (fn) {
    return fn(args);
  });
};

function getActiveStartDate(props) {
  var maxDate = props.maxDate,
      maxDetail = props.maxDetail,
      minDate = props.minDate,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view;
  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = getDetailValueFrom({
    value: value,
    minDate: minDate,
    maxDate: maxDate,
    maxDetail: maxDetail
  }) || new Date();
  return Object(__WEBPACK_IMPORTED_MODULE_8__shared_dates__["a" /* getBegin */])(rangeType, valueFrom);
}

function getInitialActiveStartDate(props) {
  var activeStartDate = props.activeStartDate,
      defaultActiveStartDate = props.defaultActiveStartDate,
      defaultValue = props.defaultValue,
      defaultView = props.defaultView,
      maxDetail = props.maxDetail,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view,
      otherProps = _objectWithoutProperties(props, ["activeStartDate", "defaultActiveStartDate", "defaultValue", "defaultView", "maxDetail", "minDetail", "value", "view"]);

  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = activeStartDate || defaultActiveStartDate;

  if (valueFrom) {
    return Object(__WEBPACK_IMPORTED_MODULE_8__shared_dates__["a" /* getBegin */])(rangeType, valueFrom);
  }

  return getActiveStartDate(_objectSpread({
    maxDetail: maxDetail,
    minDetail: minDetail,
    value: value || defaultValue,
    view: view || defaultView
  }, otherProps));
}

var getIsSingleValue = function getIsSingleValue(value) {
  return value && [].concat(value).length === 1;
};

var Calendar = /*#__PURE__*/function (_Component) {
  _inherits(Calendar, _Component);

  var _super = _createSuper(Calendar);

  function Calendar() {
    var _this;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(_args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      /* eslint-disable react/destructuring-assignment */
      activeStartDate: _this.props.defaultActiveStartDate,
      value: _this.props.defaultValue,
      view: _this.props.defaultView
      /* eslint-enable react/destructuring-assignment */

    });

    _defineProperty(_assertThisInitialized(_this), "setStateAndCallCallbacks", function (nextState, event, callback) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          previousActiveStartDate = _assertThisInitialize.activeStartDate,
          previousView = _assertThisInitialize.view;

      var _this$props = _this.props,
          allowPartialRange = _this$props.allowPartialRange,
          onActiveStartDateChange = _this$props.onActiveStartDateChange,
          onChange = _this$props.onChange,
          onViewChange = _this$props.onViewChange,
          selectRange = _this$props.selectRange;
      var prevArgs = {
        activeStartDate: previousActiveStartDate,
        view: previousView
      };

      _this.setState(nextState, function () {
        var args = {
          activeStartDate: nextState.activeStartDate || _this.activeStartDate,
          value: nextState.value || _this.value,
          view: nextState.view || _this.view
        };

        function shouldUpdate(key) {
          return (// Key must exist, and…
            key in nextState && ( // …key changed from undefined to defined or the other way around, or…
            _typeof(nextState[key]) !== _typeof(prevArgs[key]) // …value changed.
            || (nextState[key] instanceof Date ? nextState[key].getTime() !== prevArgs[key].getTime() : nextState[key] !== prevArgs[key]))
          );
        }

        if (shouldUpdate('activeStartDate')) {
          if (onActiveStartDateChange) onActiveStartDateChange(args);
        }

        if (shouldUpdate('view')) {
          if (onViewChange) onViewChange(args);
        }

        if (shouldUpdate('value')) {
          if (onChange) {
            if (selectRange) {
              var isSingleValue = getIsSingleValue(nextState.value);

              if (!isSingleValue) {
                onChange(nextState.value, event);
              } else if (allowPartialRange) {
                onChange([nextState.value], event);
              }
            } else {
              onChange(nextState.value, event);
            }
          }
        }

        if (callback) callback(args);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setActiveStartDate", function (activeStartDate) {
      _this.setStateAndCallCallbacks({
        activeStartDate: activeStartDate
      });
    });

    _defineProperty(_assertThisInitialized(_this), "drillDown", function (nextActiveStartDate, event) {
      if (!_this.drillDownAvailable) {
        return;
      }

      _this.onClickTile(nextActiveStartDate, event);

      var _assertThisInitialize2 = _assertThisInitialized(_this),
          view = _assertThisInitialize2.view,
          views = _assertThisInitialize2.views;

      var onDrillDown = _this.props.onDrillDown;
      var nextView = views[views.indexOf(view) + 1];

      _this.setStateAndCallCallbacks({
        activeStartDate: nextActiveStartDate,
        view: nextView
      }, undefined, onDrillDown);
    });

    _defineProperty(_assertThisInitialized(_this), "drillUp", function () {
      if (!_this.drillUpAvailable) {
        return;
      }

      var _assertThisInitialize3 = _assertThisInitialized(_this),
          activeStartDate = _assertThisInitialize3.activeStartDate,
          view = _assertThisInitialize3.view,
          views = _assertThisInitialize3.views;

      var onDrillUp = _this.props.onDrillUp;
      var nextView = views[views.indexOf(view) - 1];
      var nextActiveStartDate = Object(__WEBPACK_IMPORTED_MODULE_8__shared_dates__["a" /* getBegin */])(nextView, activeStartDate);

      _this.setStateAndCallCallbacks({
        activeStartDate: nextActiveStartDate,
        view: nextView
      }, undefined, onDrillUp);
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value, event) {
      var selectRange = _this.props.selectRange;

      _this.onClickTile(value, event);

      var nextValue;

      if (selectRange) {
        // Range selection turned on
        var _assertThisInitialize4 = _assertThisInitialized(_this),
            previousValue = _assertThisInitialize4.value,
            valueType = _assertThisInitialize4.valueType;

        if (!getIsSingleValue(previousValue)) {
          // Value has 0 or 2 elements - either way we're starting a new array
          // First value
          nextValue = Object(__WEBPACK_IMPORTED_MODULE_8__shared_dates__["a" /* getBegin */])(valueType, value);
        } else {
          // Second value
          nextValue = Object(__WEBPACK_IMPORTED_MODULE_8__shared_dates__["p" /* getValueRange */])(valueType, previousValue, value);
        }
      } else {
        // Range selection turned off
        nextValue = _this.getProcessedValue(value);
      }

      var nextActiveStartDate = getActiveStartDate(_objectSpread(_objectSpread({}, _this.props), {}, {
        value: nextValue
      }));
      event.persist();

      _this.setStateAndCallCallbacks({
        activeStartDate: nextActiveStartDate,
        value: nextValue
      }, event);
    });

    _defineProperty(_assertThisInitialized(_this), "onClickTile", function (value, event) {
      var _assertThisInitialize5 = _assertThisInitialized(_this),
          view = _assertThisInitialize5.view;

      var _this$props2 = _this.props,
          onClickDay = _this$props2.onClickDay,
          onClickDecade = _this$props2.onClickDecade,
          onClickMonth = _this$props2.onClickMonth,
          onClickYear = _this$props2.onClickYear;

      var callback = function () {
        switch (view) {
          case 'century':
            return onClickDecade;

          case 'decade':
            return onClickYear;

          case 'year':
            return onClickMonth;

          case 'month':
            return onClickDay;

          default:
            throw new Error("Invalid view: ".concat(view, "."));
        }
      }();

      if (callback) callback(value, event);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function (value) {
      _this.setState(function (prevState) {
        if (prevState.hover && prevState.hover.getTime() === value.getTime()) {
          return null;
        }

        return {
          hover: value
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.setState({
        hover: null
      });
    });

    return _this;
  }

  _createClass(Calendar, [{
    key: "getProcessedValue",

    /**
     * Gets current value in a desired format.
     */
    value: function getProcessedValue(value) {
      var _this$props3 = this.props,
          minDate = _this$props3.minDate,
          maxDate = _this$props3.maxDate,
          maxDetail = _this$props3.maxDetail,
          returnValue = _this$props3.returnValue;

      var processFunction = function () {
        switch (returnValue) {
          case 'start':
            return getDetailValueFrom;

          case 'end':
            return getDetailValueTo;

          case 'range':
            return getDetailValueArray;

          default:
            throw new Error('Invalid returnValue.');
        }
      }();

      return processFunction({
        value: value,
        minDate: minDate,
        maxDate: maxDate,
        maxDetail: maxDetail
      });
    }
  }, {
    key: "renderContent",
    value: function renderContent(next) {
      var currentActiveStartDate = this.activeStartDate,
          onMouseOver = this.onMouseOver,
          valueType = this.valueType,
          value = this.value,
          view = this.view;
      var _this$props4 = this.props,
          calendarType = _this$props4.calendarType,
          locale = _this$props4.locale,
          maxDate = _this$props4.maxDate,
          minDate = _this$props4.minDate,
          selectRange = _this$props4.selectRange,
          tileClassName = _this$props4.tileClassName,
          tileContent = _this$props4.tileContent,
          tileDisabled = _this$props4.tileDisabled;
      var hover = this.hover;
      var activeStartDate = next ? Object(__WEBPACK_IMPORTED_MODULE_8__shared_dates__["b" /* getBeginNext */])(view, currentActiveStartDate) : Object(__WEBPACK_IMPORTED_MODULE_8__shared_dates__["a" /* getBegin */])(view, currentActiveStartDate);
      var onClick = this.drillDownAvailable ? this.drillDown : this.onChange;
      var commonProps = {
        activeStartDate: activeStartDate,
        hover: hover,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        onClick: onClick,
        onMouseOver: selectRange ? onMouseOver : null,
        tileClassName: tileClassName,
        tileContent: tileContent,
        tileDisabled: tileDisabled,
        value: value,
        valueType: valueType
      };

      switch (view) {
        case 'century':
          {
            var formatYear = this.props.formatYear;
            return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__CenturyView__["a" /* default */], _extends({
              formatYear: formatYear
            }, commonProps));
          }

        case 'decade':
          {
            var _formatYear = this.props.formatYear;
            return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__DecadeView__["a" /* default */], _extends({
              formatYear: _formatYear
            }, commonProps));
          }

        case 'year':
          {
            var _this$props5 = this.props,
                formatMonth = _this$props5.formatMonth,
                formatMonthYear = _this$props5.formatMonthYear;
            return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__YearView__["a" /* default */], _extends({
              formatMonth: formatMonth,
              formatMonthYear: formatMonthYear
            }, commonProps));
          }

        case 'month':
          {
            var _this$props6 = this.props,
                formatLongDate = _this$props6.formatLongDate,
                formatShortWeekday = _this$props6.formatShortWeekday,
                onClickWeekNumber = _this$props6.onClickWeekNumber,
                showDoubleView = _this$props6.showDoubleView,
                showFixedNumberOfWeeks = _this$props6.showFixedNumberOfWeeks,
                showNeighboringMonth = _this$props6.showNeighboringMonth,
                showWeekNumbers = _this$props6.showWeekNumbers;
            var onMouseLeave = this.onMouseLeave;
            return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__MonthView__["a" /* default */], _extends({
              calendarType: calendarType,
              formatLongDate: formatLongDate,
              formatShortWeekday: formatShortWeekday,
              onClickWeekNumber: onClickWeekNumber,
              onMouseLeave: selectRange ? onMouseLeave : null,
              showFixedNumberOfWeeks: showFixedNumberOfWeeks || showDoubleView,
              showNeighboringMonth: showNeighboringMonth,
              showWeekNumbers: showWeekNumbers
            }, commonProps));
          }

        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      var showNavigation = this.props.showNavigation;

      if (!showNavigation) {
        return null;
      }

      var activeStartDate = this.activeStartDate,
          view = this.view,
          views = this.views;
      var _this$props7 = this.props,
          formatMonthYear = _this$props7.formatMonthYear,
          formatYear = _this$props7.formatYear,
          locale = _this$props7.locale,
          maxDate = _this$props7.maxDate,
          minDate = _this$props7.minDate,
          navigationAriaLabel = _this$props7.navigationAriaLabel,
          navigationLabel = _this$props7.navigationLabel,
          next2AriaLabel = _this$props7.next2AriaLabel,
          next2Label = _this$props7.next2Label,
          nextAriaLabel = _this$props7.nextAriaLabel,
          nextLabel = _this$props7.nextLabel,
          prev2AriaLabel = _this$props7.prev2AriaLabel,
          prev2Label = _this$props7.prev2Label,
          prevAriaLabel = _this$props7.prevAriaLabel,
          prevLabel = _this$props7.prevLabel,
          showDoubleView = _this$props7.showDoubleView;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Calendar_Navigation__["a" /* default */], {
        activeStartDate: activeStartDate,
        drillUp: this.drillUp,
        formatMonthYear: formatMonthYear,
        formatYear: formatYear,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        navigationAriaLabel: navigationAriaLabel,
        navigationLabel: navigationLabel,
        next2AriaLabel: next2AriaLabel,
        next2Label: next2Label,
        nextAriaLabel: nextAriaLabel,
        nextLabel: nextLabel,
        prev2AriaLabel: prev2AriaLabel,
        prev2Label: prev2Label,
        prevAriaLabel: prevAriaLabel,
        prevLabel: prevLabel,
        setActiveStartDate: this.setActiveStartDate,
        showDoubleView: showDoubleView,
        view: view,
        views: views
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props8 = this.props,
          className = _this$props8.className,
          inputRef = _this$props8.inputRef,
          selectRange = _this$props8.selectRange,
          showDoubleView = _this$props8.showDoubleView;
      var onMouseLeave = this.onMouseLeave,
          value = this.value;
      var valueArray = [].concat(value);
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_2_merge_class_names__["default"])(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), showDoubleView && "".concat(baseClassName, "--doubleView"), className),
        ref: inputRef
      }, this.renderNavigation(), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "".concat(baseClassName, "__viewContainer"),
        onBlur: selectRange ? onMouseLeave : null,
        onMouseLeave: selectRange ? onMouseLeave : null
      }, this.renderContent(), showDoubleView && this.renderContent(true)));
    }
  }, {
    key: "activeStartDate",
    get: function get() {
      var activeStartDateProps = this.props.activeStartDate;
      var activeStartDateState = this.state.activeStartDate;
      return activeStartDateProps || activeStartDateState || getInitialActiveStartDate(this.props);
    }
  }, {
    key: "value",
    get: function get() {
      var _this$props9 = this.props,
          selectRange = _this$props9.selectRange,
          valueProps = _this$props9.value;
      var valueState = this.state.value; // In the middle of range selection, use value from state

      if (selectRange && getIsSingleValue(valueState)) {
        return valueState;
      }

      return valueProps !== undefined ? valueProps : valueState;
    }
  }, {
    key: "valueType",
    get: function get() {
      var maxDetail = this.props.maxDetail;
      return getValueType(maxDetail);
    }
  }, {
    key: "view",
    get: function get() {
      var _this$props10 = this.props,
          minDetail = _this$props10.minDetail,
          maxDetail = _this$props10.maxDetail,
          viewProps = _this$props10.view;
      var viewState = this.state.view;
      return getView(viewProps || viewState, minDetail, maxDetail);
    }
  }, {
    key: "views",
    get: function get() {
      var _this$props11 = this.props,
          minDetail = _this$props11.minDetail,
          maxDetail = _this$props11.maxDetail;
      return getLimitedViews(minDetail, maxDetail);
    }
  }, {
    key: "hover",
    get: function get() {
      var selectRange = this.props.selectRange;
      var hover = this.state.hover;
      return selectRange ? hover : null;
    }
  }, {
    key: "drillDownAvailable",
    get: function get() {
      var view = this.view,
          views = this.views;
      return views.indexOf(view) < views.length - 1;
    }
  }, {
    key: "drillUpAvailable",
    get: function get() {
      var view = this.view,
          views = this.views;
      return views.indexOf(view) > 0;
    }
  }]);

  return Calendar;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


Calendar.defaultProps = {
  maxDate: defaultMaxDate,
  maxDetail: 'month',
  minDate: defaultMinDate,
  minDetail: 'century',
  returnValue: 'start',
  showNavigation: true,
  showNeighboringMonth: true
};
var isActiveStartDate = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date);
var isLooseValue = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9__shared_propTypes__["f" /* isValue */]]);
Calendar.propTypes = {
  activeStartDate: isActiveStartDate,
  allowPartialRange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  calendarType: __WEBPACK_IMPORTED_MODULE_9__shared_propTypes__["a" /* isCalendarType */],
  className: __WEBPACK_IMPORTED_MODULE_9__shared_propTypes__["b" /* isClassName */],
  defaultActiveStartDate: isActiveStartDate,
  defaultValue: isLooseValue,
  defaultView: __WEBPACK_IMPORTED_MODULE_9__shared_propTypes__["g" /* isView */],
  formatLongDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  formatMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  formatMonthYear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  formatShortWeekday: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  formatYear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  inputRef: __WEBPACK_IMPORTED_MODULE_9__shared_propTypes__["e" /* isRef */],
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_9__shared_propTypes__["c" /* isMaxDate */],
  maxDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(allViews),
  minDate: __WEBPACK_IMPORTED_MODULE_9__shared_propTypes__["d" /* isMinDate */],
  minDetail: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(allViews),
  navigationAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  navigationLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  next2AriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  next2Label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  nextAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  onActiveStartDateChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickDay: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickDecade: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClickYear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDrillDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onDrillUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onViewChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  prev2AriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prev2Label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  prevAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prevLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  returnValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['start', 'end', 'range']),
  selectRange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showDoubleView: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showFixedNumberOfWeeks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showNavigation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showNeighboringMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showWeekNumbers: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  tileClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_9__shared_propTypes__["b" /* isClassName */]]),
  tileContent: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]),
  tileDisabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  value: isLooseValue,
  view: __WEBPACK_IMPORTED_MODULE_9__shared_propTypes__["g" /* isView */]
};

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Navigation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_get_user_locale__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_dates__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_dateFormatter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_propTypes__ = __webpack_require__(9);






var className = 'react-calendar__navigation';
function Navigation(_ref) {
  var activeStartDate = _ref.activeStartDate,
      drillUp = _ref.drillUp,
      _ref$formatMonthYear = _ref.formatMonthYear,
      formatMonthYear = _ref$formatMonthYear === void 0 ? __WEBPACK_IMPORTED_MODULE_4__shared_dateFormatter__["c" /* formatMonthYear */] : _ref$formatMonthYear,
      _ref$formatYear = _ref.formatYear,
      formatYear = _ref$formatYear === void 0 ? __WEBPACK_IMPORTED_MODULE_4__shared_dateFormatter__["f" /* formatYear */] : _ref$formatYear,
      locale = _ref.locale,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      _ref$navigationAriaLa = _ref.navigationAriaLabel,
      navigationAriaLabel = _ref$navigationAriaLa === void 0 ? '' : _ref$navigationAriaLa,
      navigationLabel = _ref.navigationLabel,
      _ref$next2AriaLabel = _ref.next2AriaLabel,
      next2AriaLabel = _ref$next2AriaLabel === void 0 ? '' : _ref$next2AriaLabel,
      _ref$next2Label = _ref.next2Label,
      next2Label = _ref$next2Label === void 0 ? '»' : _ref$next2Label,
      _ref$nextAriaLabel = _ref.nextAriaLabel,
      nextAriaLabel = _ref$nextAriaLabel === void 0 ? '' : _ref$nextAriaLabel,
      _ref$nextLabel = _ref.nextLabel,
      nextLabel = _ref$nextLabel === void 0 ? '›' : _ref$nextLabel,
      _ref$prev2AriaLabel = _ref.prev2AriaLabel,
      prev2AriaLabel = _ref$prev2AriaLabel === void 0 ? '' : _ref$prev2AriaLabel,
      _ref$prev2Label = _ref.prev2Label,
      prev2Label = _ref$prev2Label === void 0 ? '«' : _ref$prev2Label,
      _ref$prevAriaLabel = _ref.prevAriaLabel,
      prevAriaLabel = _ref$prevAriaLabel === void 0 ? '' : _ref$prevAriaLabel,
      _ref$prevLabel = _ref.prevLabel,
      prevLabel = _ref$prevLabel === void 0 ? '‹' : _ref$prevLabel,
      setActiveStartDate = _ref.setActiveStartDate,
      showDoubleView = _ref.showDoubleView,
      view = _ref.view,
      views = _ref.views;
  var drillUpAvailable = views.indexOf(view) > 0;
  var shouldShowPrevNext2Buttons = view !== 'century';
  var previousActiveStartDate = Object(__WEBPACK_IMPORTED_MODULE_3__shared_dates__["g" /* getBeginPrevious */])(view, activeStartDate);
  var previousActiveStartDate2 = shouldShowPrevNext2Buttons && Object(__WEBPACK_IMPORTED_MODULE_3__shared_dates__["h" /* getBeginPrevious2 */])(view, activeStartDate);
  var nextActiveStartDate = Object(__WEBPACK_IMPORTED_MODULE_3__shared_dates__["b" /* getBeginNext */])(view, activeStartDate);
  var nextActiveStartDate2 = shouldShowPrevNext2Buttons && Object(__WEBPACK_IMPORTED_MODULE_3__shared_dates__["c" /* getBeginNext2 */])(view, activeStartDate);

  var prevButtonDisabled = function () {
    if (previousActiveStartDate.getFullYear() < 0) {
      return true;
    }

    var previousActiveEndDate = Object(__WEBPACK_IMPORTED_MODULE_3__shared_dates__["m" /* getEndPrevious */])(view, activeStartDate);
    return minDate && minDate >= previousActiveEndDate;
  }();

  var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function () {
    if (previousActiveStartDate2.getFullYear() < 0) {
      return true;
    }

    var previousActiveEndDate = Object(__WEBPACK_IMPORTED_MODULE_3__shared_dates__["n" /* getEndPrevious2 */])(view, activeStartDate);
    return minDate && minDate >= previousActiveEndDate;
  }();

  var nextButtonDisabled = maxDate && maxDate <= nextActiveStartDate;
  var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate <= nextActiveStartDate2;

  function onClickPrevious() {
    setActiveStartDate(previousActiveStartDate);
  }

  function onClickPrevious2() {
    setActiveStartDate(previousActiveStartDate2);
  }

  function onClickNext() {
    setActiveStartDate(nextActiveStartDate);
  }

  function onClickNext2() {
    setActiveStartDate(nextActiveStartDate2);
  }

  function renderLabel(date) {
    var label = function () {
      switch (view) {
        case 'century':
          return Object(__WEBPACK_IMPORTED_MODULE_3__shared_dates__["i" /* getCenturyLabel */])(locale, formatYear, date);

        case 'decade':
          return Object(__WEBPACK_IMPORTED_MODULE_3__shared_dates__["k" /* getDecadeLabel */])(locale, formatYear, date);

        case 'year':
          return formatYear(locale, date);

        case 'month':
          return formatMonthYear(locale, date);

        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }();

    return navigationLabel ? navigationLabel({
      date: date,
      label: label,
      locale: locale || Object(__WEBPACK_IMPORTED_MODULE_2_get_user_locale__["getUserLocale"])(),
      view: view
    }) : label;
  }

  function renderButton() {
    var labelClassName = "".concat(className, "__label");
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
      "aria-label": navigationAriaLabel,
      className: labelClassName,
      disabled: !drillUpAvailable,
      onClick: drillUp,
      style: {
        flexGrow: 1
      },
      type: "button"
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--from")
    }, renderLabel(activeStartDate)), showDoubleView && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "".concat(labelClassName, "__divider")
    }, ' ', "\u2013", ' '), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
      className: "".concat(labelClassName, "__labelText ").concat(labelClassName, "__labelText--to")
    }, renderLabel(nextActiveStartDate))));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: className,
    style: {
      display: 'flex'
    }
  }, prev2Label !== null && shouldShowPrevNext2Buttons && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    "aria-label": prev2AriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__prev2-button"),
    disabled: prev2ButtonDisabled,
    onClick: onClickPrevious2,
    type: "button"
  }, prev2Label), prevLabel !== null && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    "aria-label": prevAriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__prev-button"),
    disabled: prevButtonDisabled,
    onClick: onClickPrevious,
    type: "button"
  }, prevLabel), renderButton(), nextLabel !== null && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    "aria-label": nextAriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__next-button"),
    disabled: nextButtonDisabled,
    onClick: onClickNext,
    type: "button"
  }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", {
    "aria-label": next2AriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__next2-button"),
    disabled: next2ButtonDisabled,
    onClick: onClickNext2,
    type: "button"
  }, next2Label));
}
Navigation.propTypes = {
  activeStartDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,
  drillUp: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  formatMonthYear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  formatYear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  maxDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date),
  minDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date),
  navigationAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  navigationLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  next2AriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  next2Label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  nextAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  nextLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  prev2AriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prev2Label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  prevAriaLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prevLabel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  setActiveStartDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  showDoubleView: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  view: __WEBPACK_IMPORTED_MODULE_5__shared_propTypes__["g" /* isView */].isRequired,
  views: __WEBPACK_IMPORTED_MODULE_5__shared_propTypes__["h" /* isViews */].isRequired
};

/***/ }),
/* 259 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = once;


/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Decades;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wojtekmaj_date_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TileGroup__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Decade__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_dates__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_propTypes__ = __webpack_require__(9);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }







function Decades(props) {
  var activeStartDate = props.activeStartDate;
  var start = Object(__WEBPACK_IMPORTED_MODULE_4__shared_dates__["d" /* getBeginOfCenturyYear */])(activeStartDate);
  var end = start + 99;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TileGroup__["a" /* default */], _extends({}, props, {
    className: "react-calendar__century-view__decades",
    dateTransform: __WEBPACK_IMPORTED_MODULE_1__wojtekmaj_date_utils__["getDecadeStart"],
    dateType: "decade",
    end: end,
    start: start,
    step: 10,
    tile: __WEBPACK_IMPORTED_MODULE_3__Decade__["a" /* default */]
  }));
}
Decades.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_5__shared_propTypes__["i" /* tileGroupProps */]);

/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Decade;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tile__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_dates__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_dateFormatter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__ = __webpack_require__(9);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








var className = 'react-calendar__century-view__decades__decade';
function Decade(_ref) {
  var classes = _ref.classes,
      _ref$formatYear = _ref.formatYear,
      formatYear = _ref$formatYear === void 0 ? __WEBPACK_IMPORTED_MODULE_5__shared_dateFormatter__["f" /* formatYear */] : _ref$formatYear,
      otherProps = _objectWithoutProperties(_ref, ["classes", "formatYear"]);

  var date = otherProps.date,
      locale = otherProps.locale;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Tile__["a" /* default */], _extends({}, otherProps, {
    classes: [].concat(classes, className),
    maxDateTransform: __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getDecadeEnd"],
    minDateTransform: __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getDecadeStart"],
    view: "century"
  }), Object(__WEBPACK_IMPORTED_MODULE_4__shared_dates__["k" /* getDecadeLabel */])(locale, formatYear, date));
}
Decade.propTypes = _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__["j" /* tileProps */]), {}, {
  formatYear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Years;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TileGroup__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Year__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_dates__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_propTypes__ = __webpack_require__(9);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






function Years(props) {
  var activeStartDate = props.activeStartDate;
  var start = Object(__WEBPACK_IMPORTED_MODULE_3__shared_dates__["e" /* getBeginOfDecadeYear */])(activeStartDate);
  var end = start + 9;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__TileGroup__["a" /* default */], _extends({}, props, {
    className: "react-calendar__decade-view__years",
    dateTransform: function dateTransform(year) {
      var date = new Date();
      date.setFullYear(year, 0, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "year",
    end: end,
    start: start,
    tile: __WEBPACK_IMPORTED_MODULE_2__Year__["a" /* default */]
  }));
}
Years.propTypes = _objectSpread({}, __WEBPACK_IMPORTED_MODULE_4__shared_propTypes__["i" /* tileGroupProps */]);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Year;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tile__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_dateFormatter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_propTypes__ = __webpack_require__(9);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var className = 'react-calendar__decade-view__years__year';
function Year(_ref) {
  var classes = _ref.classes,
      _ref$formatYear = _ref.formatYear,
      formatYear = _ref$formatYear === void 0 ? __WEBPACK_IMPORTED_MODULE_4__shared_dateFormatter__["f" /* formatYear */] : _ref$formatYear,
      otherProps = _objectWithoutProperties(_ref, ["classes", "formatYear"]);

  var date = otherProps.date,
      locale = otherProps.locale;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Tile__["a" /* default */], _extends({}, otherProps, {
    classes: [].concat(classes, className),
    maxDateTransform: __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getYearEnd"],
    minDateTransform: __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getYearStart"],
    view: "decade"
  }), formatYear(locale, date));
}
Year.propTypes = _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_5__shared_propTypes__["j" /* tileProps */]), {}, {
  formatYear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});

/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Months;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TileGroup__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Month__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_propTypes__ = __webpack_require__(9);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }







function Months(props) {
  var activeStartDate = props.activeStartDate;
  var start = 0;
  var end = 11;
  var year = Object(__WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getYear"])(activeStartDate);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TileGroup__["a" /* default */], _extends({}, props, {
    className: "react-calendar__year-view__months",
    dateTransform: function dateTransform(monthIndex) {
      var date = new Date();
      date.setFullYear(year, monthIndex, 1);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "month",
    end: end,
    start: start,
    tile: __WEBPACK_IMPORTED_MODULE_4__Month__["a" /* default */]
  }));
}
Months.propTypes = _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_5__shared_propTypes__["i" /* tileGroupProps */]), {}, {
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string
});

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Month;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tile__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_dateFormatter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_propTypes__ = __webpack_require__(9);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }







var className = 'react-calendar__year-view__months__month';
function Month(_ref) {
  var classes = _ref.classes,
      _ref$formatMonth = _ref.formatMonth,
      formatMonth = _ref$formatMonth === void 0 ? __WEBPACK_IMPORTED_MODULE_4__shared_dateFormatter__["b" /* formatMonth */] : _ref$formatMonth,
      _ref$formatMonthYear = _ref.formatMonthYear,
      formatMonthYear = _ref$formatMonthYear === void 0 ? __WEBPACK_IMPORTED_MODULE_4__shared_dateFormatter__["c" /* formatMonthYear */] : _ref$formatMonthYear,
      otherProps = _objectWithoutProperties(_ref, ["classes", "formatMonth", "formatMonthYear"]);

  var date = otherProps.date,
      locale = otherProps.locale;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Tile__["a" /* default */], _extends({}, otherProps, {
    classes: [].concat(classes, className),
    formatAbbr: formatMonthYear,
    maxDateTransform: __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getMonthEnd"],
    minDateTransform: __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getMonthStart"],
    view: "year"
  }), formatMonth(locale, date));
}
Month.propTypes = _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_5__shared_propTypes__["j" /* tileProps */]), {}, {
  formatMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  formatMonthYear: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});

/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Days;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TileGroup__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Day__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_dates__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__ = __webpack_require__(9);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








function Days(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType;

  var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks,
      showNeighboringMonth = props.showNeighboringMonth,
      otherProps = _objectWithoutProperties(props, ["showFixedNumberOfWeeks", "showNeighboringMonth"]);

  var year = Object(__WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getYear"])(activeStartDate);
  var monthIndex = Object(__WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getMonth"])(activeStartDate);
  var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
  var dayOfWeek = Object(__WEBPACK_IMPORTED_MODULE_5__shared_dates__["j" /* getDayOfWeek */])(activeStartDate, calendarType);
  var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
  /**
   * Defines on which day of the month the grid shall start. If we simply show current
   * month, we obviously start on day one, but if showNeighboringMonth is set to
   * true, we need to find the beginning of the week the first day of the month is in.
   */

  var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
  /**
   * Defines on which day of the month the grid shall end. If we simply show current
   * month, we need to stop on the last day of the month, but if showNeighboringMonth
   * is set to true, we need to find the end of the week the last day of the month is in.
   */

  var end = function () {
    if (showFixedNumberOfWeeks) {
      // Always show 6 weeks
      return start + 6 * 7 - 1;
    }

    var daysInMonth = Object(__WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getDaysInMonth"])(activeStartDate);

    if (showNeighboringMonth) {
      var activeEndDate = new Date();
      activeEndDate.setFullYear(year, monthIndex, daysInMonth);
      activeEndDate.setHours(0, 0, 0, 0);
      var daysUntilEndOfTheWeek = 7 - Object(__WEBPACK_IMPORTED_MODULE_5__shared_dates__["j" /* getDayOfWeek */])(activeEndDate, calendarType) - 1;
      return daysInMonth + daysUntilEndOfTheWeek;
    }

    return daysInMonth;
  }();

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__TileGroup__["a" /* default */], _extends({}, otherProps, {
    className: "react-calendar__month-view__days",
    count: 7,
    currentMonthIndex: monthIndex,
    dateTransform: function dateTransform(day) {
      var date = new Date();
      date.setFullYear(year, monthIndex, day);
      date.setHours(0, 0, 0, 0);
      return date;
    },
    dateType: "day",
    end: end,
    offset: offset,
    start: start,
    tile: __WEBPACK_IMPORTED_MODULE_4__Day__["a" /* default */]
  }));
}
Days.propTypes = _objectSpread({
  calendarType: __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__["a" /* isCalendarType */].isRequired,
  showFixedNumberOfWeeks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showNeighboringMonth: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
}, __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__["i" /* tileGroupProps */]);

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Day;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tile__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_dates__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_dateFormatter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__ = __webpack_require__(9);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








var className = 'react-calendar__month-view__days__day';
function Day(_ref) {
  var _ref$formatLongDate = _ref.formatLongDate,
      formatLongDate = _ref$formatLongDate === void 0 ? __WEBPACK_IMPORTED_MODULE_5__shared_dateFormatter__["a" /* formatLongDate */] : _ref$formatLongDate,
      calendarType = _ref.calendarType,
      classes = _ref.classes,
      currentMonthIndex = _ref.currentMonthIndex,
      otherProps = _objectWithoutProperties(_ref, ["formatLongDate", "calendarType", "classes", "currentMonthIndex"]);

  var date = otherProps.date;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Tile__["a" /* default */], _extends({}, otherProps, {
    classes: [].concat(classes, className, Object(__WEBPACK_IMPORTED_MODULE_4__shared_dates__["r" /* isWeekend */])(date, calendarType) ? "".concat(className, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat(className, "--neighboringMonth") : null),
    formatAbbr: formatLongDate,
    maxDateTransform: __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getDayEnd"],
    minDateTransform: __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getDayStart"],
    view: "month"
  }), Object(__WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getDate"])(date));
}
Day.propTypes = _objectSpread(_objectSpread({}, __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__["j" /* tileProps */]), {}, {
  currentMonthIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired,
  formatLongDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Weekdays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Flex__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_dates__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_dateFormatter__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__ = __webpack_require__(9);







var className = 'react-calendar__month-view__weekdays';
function Weekdays(props) {
  var calendarType = props.calendarType,
      _props$formatShortWee = props.formatShortWeekday,
      formatShortWeekday = _props$formatShortWee === void 0 ? __WEBPACK_IMPORTED_MODULE_5__shared_dateFormatter__["d" /* formatShortWeekday */] : _props$formatShortWee,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave;
  var anyDate = new Date();
  var beginOfMonth = Object(__WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getMonthStart"])(anyDate);
  var year = Object(__WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getYear"])(beginOfMonth);
  var monthIndex = Object(__WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getMonth"])(beginOfMonth);
  var weekdays = [];

  for (var weekday = 1; weekday <= 7; weekday += 1) {
    var weekdayDate = new Date(year, monthIndex, weekday - Object(__WEBPACK_IMPORTED_MODULE_4__shared_dates__["j" /* getDayOfWeek */])(beginOfMonth, calendarType));
    var abbr = Object(__WEBPACK_IMPORTED_MODULE_5__shared_dateFormatter__["e" /* formatWeekday */])(locale, weekdayDate);
    weekdays.push( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
      key: weekday,
      className: "".concat(className, "__weekday")
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("abbr", {
      "aria-label": abbr,
      title: abbr
    }, formatShortWeekday(locale, weekdayDate).replace('.', ''))));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Flex__["a" /* default */], {
    className: className,
    count: 7,
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave
  }, weekdays);
}
Weekdays.propTypes = {
  calendarType: __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__["a" /* isCalendarType */].isRequired,
  formatShortWeekday: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  locale: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WeekNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__WeekNumber__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Flex__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_dates__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__ = __webpack_require__(9);







function WeekNumbers(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType,
      onClickWeekNumber = props.onClickWeekNumber,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;

  var numberOfWeeks = function () {
    if (showFixedNumberOfWeeks) {
      return 6;
    }

    var numberOfDays = Object(__WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getDaysInMonth"])(activeStartDate);
    var startWeekday = Object(__WEBPACK_IMPORTED_MODULE_5__shared_dates__["j" /* getDayOfWeek */])(activeStartDate, calendarType);
    var days = numberOfDays - (7 - startWeekday);
    return 1 + Math.ceil(days / 7);
  }();

  var dates = function () {
    var year = Object(__WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getYear"])(activeStartDate);
    var monthIndex = Object(__WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getMonth"])(activeStartDate);
    var day = Object(__WEBPACK_IMPORTED_MODULE_2__wojtekmaj_date_utils__["getDate"])(activeStartDate);
    var result = [];

    for (var index = 0; index < numberOfWeeks; index += 1) {
      result.push(Object(__WEBPACK_IMPORTED_MODULE_5__shared_dates__["f" /* getBeginOfWeek */])(new Date(year, monthIndex, day + index * 7), calendarType));
    }

    return result;
  }();

  var weekNumbers = dates.map(function (date) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__shared_dates__["q" /* getWeekNumber */])(date, calendarType);
  });
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Flex__["a" /* default */], {
    className: "react-calendar__month-view__weekNumbers",
    count: numberOfWeeks,
    direction: "column",
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave,
    style: {
      flexBasis: 'calc(100% * (1 / 8)',
      flexShrink: 0
    }
  }, weekNumbers.map(function (weekNumber, weekIndex) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__WeekNumber__["a" /* default */], {
      key: weekNumber,
      date: dates[weekIndex],
      onClickWeekNumber: onClickWeekNumber,
      weekNumber: weekNumber
    });
  }));
}
WeekNumbers.propTypes = {
  activeStartDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,
  calendarType: __WEBPACK_IMPORTED_MODULE_6__shared_propTypes__["a" /* isCalendarType */].isRequired,
  onClickWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showFixedNumberOfWeeks: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
};

/***/ }),
/* 270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WeekNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function WeekNumber(_ref) {
  var date = _ref.date,
      onClickWeekNumber = _ref.onClickWeekNumber,
      weekNumber = _ref.weekNumber;
  var props = {
    className: 'react-calendar__tile',
    style: {
      flexGrow: 1
    }
  };
  var children = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", null, weekNumber);
  return onClickWeekNumber ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button", _extends({}, props, {
    onClick: function onClick(event) {
      return onClickWeekNumber(weekNumber, date, event);
    },
    type: "button"
  }), children) : /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", props, children);
}
WeekNumber.propTypes = {
  date: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.instanceOf(Date).isRequired,
  onClickWeekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  weekNumber: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node.isRequired
};

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Fit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_detect_element_overflow__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_utils__ = __webpack_require__(273);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }






var isBrowser = typeof window !== 'undefined';
var isDisplayContentsSupported = isBrowser && 'CSS' in window && 'supports' in window.CSS && CSS.supports('display', 'contents');
var isMutationObserverSupported = isBrowser && 'MutationObserver' in window;

function capitalize(a) {
  return a[0].toUpperCase() + a.slice(1);
}

function findScrollContainer(element) {
  if (!element) {
    return undefined;
  }

  var parent = element.parentElement;

  while (parent) {
    var _window$getComputedSt = window.getComputedStyle(parent),
        overflow = _window$getComputedSt.overflow;

    if (overflow.split(' ').every(function (o) {
      return o === 'auto' || o === 'scroll';
    })) {
      return parent;
    }

    parent = parent.parentElement;
  }

  return document.documentElement;
}

function alignAxis(_ref) {
  var axis = _ref.axis,
      container = _ref.container,
      element = _ref.element,
      invertAxis = _ref.invertAxis,
      secondary = _ref.secondary,
      scrollContainer = _ref.scrollContainer,
      spacing = _ref.spacing;
  var style = window.getComputedStyle(element);
  var parent = container.parentElement;
  var scrollContainerCollisions = Object(__WEBPACK_IMPORTED_MODULE_3_detect_element_overflow__["a" /* default */])(parent, scrollContainer);
  var documentCollisions = Object(__WEBPACK_IMPORTED_MODULE_3_detect_element_overflow__["a" /* default */])(parent, document.documentElement);
  var isX = axis === 'x';
  var startProperty = isX ? 'left' : 'top';
  var endProperty = isX ? 'right' : 'bottom';
  var sizeProperty = isX ? 'width' : 'height';
  var overflowStartProperty = "overflow".concat(capitalize(startProperty));
  var overflowEndProperty = "overflow".concat(capitalize(endProperty));
  var scrollProperty = "scroll".concat(capitalize(startProperty));
  var uppercasedSizeProperty = capitalize(sizeProperty);
  var offsetSizeProperty = "offset".concat(uppercasedSizeProperty);
  var clientSizeProperty = "client".concat(uppercasedSizeProperty);
  var minSizeProperty = "min-".concat(sizeProperty);
  var scrollbarWidth = scrollContainer[offsetSizeProperty] - scrollContainer[clientSizeProperty];
  var startSpacing = _typeof(spacing) === 'object' ? spacing[startProperty] : spacing;
  var availableStartSpace = -Math.max(scrollContainerCollisions[overflowStartProperty], documentCollisions[overflowStartProperty] + document.documentElement[scrollProperty]) - startSpacing;
  var endSpacing = _typeof(spacing) === 'object' ? spacing[endProperty] : spacing;
  var availableEndSpace = -Math.max(scrollContainerCollisions[overflowEndProperty], documentCollisions[overflowEndProperty] - document.documentElement[scrollProperty]) - endSpacing - scrollbarWidth;

  if (secondary) {
    availableStartSpace += parent[clientSizeProperty];
    availableEndSpace += parent[clientSizeProperty];
  }

  var offsetSize = element[offsetSizeProperty];

  function displayStart() {
    element.style[startProperty] = 'unset';
    element.style[endProperty] = secondary ? '0' : '100%';
  }

  function displayEnd() {
    element.style[startProperty] = secondary ? '0' : '100%';
    element.style[endProperty] = 'unset';
  }

  function displayIfFits(availableSpace, display) {
    var fits = offsetSize <= availableSpace;

    if (fits) {
      display();
    }

    return fits;
  }

  function displayStartIfFits() {
    return displayIfFits(availableStartSpace, displayStart);
  }

  function displayEndIfFits() {
    return displayIfFits(availableEndSpace, displayEnd);
  }

  function displayWhereverShrinkedFits() {
    var moreSpaceStart = availableStartSpace > availableEndSpace;
    var minSize = style[minSizeProperty] && parseInt(style[minSizeProperty], 10);

    function shrinkToSize(size) {
      if (minSize && size < minSize) {
        Object(__WEBPACK_IMPORTED_MODULE_4__shared_utils__["a" /* warnOnDev */])("<Fit />'s child will not fit anywhere with its current ".concat(minSizeProperty, " of ").concat(minSize, "px."));
      }

      var newSize = Math.max(size, minSize || 0);
      Object(__WEBPACK_IMPORTED_MODULE_4__shared_utils__["a" /* warnOnDev */])("<Fit />'s child needed to have its ".concat(sizeProperty, " decreased to ").concat(newSize, "px."));
      element.style[sizeProperty] = "".concat(newSize, "px");
    }

    if (moreSpaceStart) {
      shrinkToSize(availableStartSpace);
      displayStart();
    } else {
      shrinkToSize(availableEndSpace);
      displayEnd();
    }
  }

  var fits;

  if (invertAxis) {
    fits = displayStartIfFits() || displayEndIfFits();
  } else {
    fits = displayEndIfFits() || displayStartIfFits();
  }

  if (!fits) {
    displayWhereverShrinkedFits();
  }
}

function alignMainAxis(args) {
  alignAxis(args);
}

function alignSecondaryAxis(args) {
  alignAxis(_objectSpread(_objectSpread({}, args), {}, {
    axis: args.axis === 'x' ? 'y' : 'x',
    secondary: true
  }));
}

function alignBothAxis(args) {
  var invertAxis = args.invertAxis,
      invertSecondaryAxis = args.invertSecondaryAxis,
      commonArgs = _objectWithoutProperties(args, ["invertAxis", "invertSecondaryAxis"]);

  alignMainAxis(_objectSpread(_objectSpread({}, commonArgs), {}, {
    invertAxis: invertAxis
  }));
  alignSecondaryAxis(_objectSpread(_objectSpread({}, commonArgs), {}, {
    invertAxis: invertSecondaryAxis
  }));
}

var Fit = /*#__PURE__*/function (_Component) {
  _inherits(Fit, _Component);

  var _super = _createSuper(Fit);

  function Fit() {
    var _this;

    _classCallCheck(this, Fit);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onMutation", function () {
      _this.fit();
    });

    _defineProperty(_assertThisInitialized(_this), "mutationObserver", isMutationObserverSupported && new MutationObserver(_this.onMutation));

    _defineProperty(_assertThisInitialized(_this), "fit", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          scrollContainer = _assertThisInitialize.scrollContainer,
          container = _assertThisInitialize.container,
          element = _assertThisInitialize.element;

      if (!element) {
        return;
      }

      var elementWidth = element.clientWidth;
      var elementHeight = element.clientHeight; // No need to recalculate - already did that for current dimensions

      if (_this.elementWidth === elementWidth && _this.elementHeight === elementHeight) {
        return;
      } // Save the dimensions so that we know we don't need to repeat the function if unchanged


      _this.elementWidth = elementWidth;
      _this.elementHeight = elementHeight;
      var parent = container.parentElement; // Container was unmounted

      if (!parent) {
        return;
      }
      /**
       * We need to ensure that <Fit />'s child has a absolute position. Otherwise,
       * we wouldn't be able to place the child in the correct position.
       */


      var style = window.getComputedStyle(element);
      var position = style.position;

      if (position !== 'absolute') {
        Object(__WEBPACK_IMPORTED_MODULE_4__shared_utils__["a" /* warnOnDev */])('<Fit />\'s child does not have absolute position. You should apply `position: absolute` to it.');
        element.style.position = 'absolute';
      }
      /**
       * We need to ensure that <Fit />'s parent has a relative position. Otherwise,
       * we wouldn't be able to place the child in the correct position.
       */


      var parentStyle = window.getComputedStyle(parent);
      var parentPosition = parentStyle.position;

      if (parentPosition !== 'relative' && parentPosition !== 'absolute') {
        Object(__WEBPACK_IMPORTED_MODULE_4__shared_utils__["a" /* warnOnDev */])('<Fit />\'s parent does not have relative position. You should apply `position: relative` to it.');
        parent.style.position = 'relative';
      }

      var _this$props = _this.props,
          invertAxis = _this$props.invertAxis,
          invertSecondaryAxis = _this$props.invertSecondaryAxis,
          mainAxis = _this$props.mainAxis,
          spacing = _this$props.spacing;
      alignBothAxis({
        container: container,
        element: element,
        invertAxis: invertAxis,
        invertSecondaryAxis: invertSecondaryAxis,
        axis: mainAxis,
        scrollContainer: scrollContainer,
        spacing: spacing
      });
    });

    return _this;
  }

  _createClass(Fit, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!isDisplayContentsSupported) {
        // eslint-disable-next-line react/no-find-dom-node
        var element = Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(this);
        this.container = element;
        this.element = element;
        this.scrollContainer = findScrollContainer(element);
      }

      this.fit();

      if (isMutationObserverSupported) {
        this.mutationObserver.observe(this.element, {
          attributes: true,
          attributeFilter: ['class', 'style']
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var child = __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children);

      if (isDisplayContentsSupported) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
          ref: function ref(container) {
            _this2.container = container;
            var element = container && container.firstChild;
            _this2.element = element;
            _this2.scrollContainer = findScrollContainer(element);
          },
          style: {
            display: 'contents'
          }
        }, child);
      }

      return child;
    }
  }]);

  return Fit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);


Fit.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  invertAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  invertSecondaryAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  mainAxis: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(['x', 'y']),
  spacing: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    bottom: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    left: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    right: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired,
    top: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number.isRequired
  })])
};
Fit.defaultProps = {
  mainAxis: 'y',
  spacing: 8
};

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var getRect = function getRect(element) {
  return element.getBoundingClientRect();
};

var detectElementOverflow = function detectElementOverflow(element, container) {
  return {
    get collidedTop() {
      return getRect(element).top < getRect(container).top;
    },

    get collidedBottom() {
      return getRect(element).bottom > getRect(container).bottom;
    },

    get collidedLeft() {
      return getRect(element).left < getRect(container).left;
    },

    get collidedRight() {
      return getRect(element).right > getRect(container).right;
    },

    get overflowTop() {
      return getRect(container).top - getRect(element).top;
    },

    get overflowBottom() {
      return getRect(element).bottom - getRect(container).bottom;
    },

    get overflowLeft() {
      return getRect(container).left - getRect(element).left;
    },

    get overflowRight() {
      return getRect(element).right - getRect(container).right;
    }

  };
};

/* harmony default export */ __webpack_exports__["a"] = (detectElementOverflow);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isProduction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return warnOnDev; });
/**
 * Checks whether we're running on a production build or not.
 */
var isProduction = "production" === 'production';

var consoleOnDev = function consoleOnDev(method) {
  if (!isProduction) {
    var _console;

    for (var _len = arguments.length, message = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      message[_key - 1] = arguments[_key];
    }

    // eslint-disable-next-line no-console
    (_console = console)[method].apply(_console, message);
  }
};

var warnOnDev = function warnOnDev() {
  for (var _len2 = arguments.length, message = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    message[_key2] = arguments[_key2];
  }

  return consoleOnDev.apply(void 0, ['warn'].concat(message));
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _dateUtils = __webpack_require__(6);

var _Divider = _interopRequireDefault(__webpack_require__(275));

var _DayInput = _interopRequireDefault(__webpack_require__(276));

var _MonthInput = _interopRequireDefault(__webpack_require__(278));

var _MonthSelect = _interopRequireDefault(__webpack_require__(279));

var _YearInput = _interopRequireDefault(__webpack_require__(280));

var _NativeInput = _interopRequireDefault(__webpack_require__(281));

var _dateFormatter = __webpack_require__(111);

var _dates = __webpack_require__(282);

var _propTypes2 = __webpack_require__(19);

var _utils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var defaultMinDate = new Date();
defaultMinDate.setFullYear(1, 0, 1);
defaultMinDate.setHours(0, 0, 0, 0);
var defaultMaxDate = new Date(8.64e15);
var allViews = ['century', 'decade', 'year', 'month'];
var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);

function toDate(value) {
  if (value instanceof Date) {
    return value;
  }

  return new Date(value);
}

function datesAreDifferent(date1, date2) {
  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
}
/**
 * Returns value type that can be returned with currently applied settings.
 */


function getValueType(maxDetail) {
  return allValueTypes[allViews.indexOf(maxDetail)];
}

function getValue(value, index) {
  if (!value) {
    return null;
  }

  var rawValue = Array.isArray(value) && value.length === 2 ? value[index] : value;

  if (!rawValue) {
    return null;
  }

  var valueDate = toDate(rawValue);

  if (isNaN(valueDate.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  return valueDate;
}

function getDetailValue(_ref, index) {
  var value = _ref.value,
      minDate = _ref.minDate,
      maxDate = _ref.maxDate,
      maxDetail = _ref.maxDetail;
  var valuePiece = getValue(value, index);

  if (!valuePiece) {
    return null;
  }

  var valueType = getValueType(maxDetail);
  var detailValueFrom = [_dates.getBegin, _dates.getEnd][index](valueType, valuePiece);
  return (0, _utils.between)(detailValueFrom, minDate, maxDate);
}

var getDetailValueFrom = function getDetailValueFrom(args) {
  return getDetailValue(args, 0);
};

var getDetailValueTo = function getDetailValueTo(args) {
  return getDetailValue(args, 1);
};

var getDetailValueArray = function getDetailValueArray(args) {
  var value = args.value;

  if (Array.isArray(value)) {
    return value;
  }

  return [getDetailValueFrom, getDetailValueTo].map(function (fn) {
    return fn(args);
  });
};

function isInternalInput(element) {
  return element.getAttribute('data-input') === 'true';
}

function findInput(element, property) {
  var nextElement = element;

  do {
    nextElement = nextElement[property];
  } while (nextElement && !isInternalInput(nextElement));

  return nextElement;
}

function focus(element) {
  if (element) {
    element.focus();
  }
}

function _renderCustomInputs(placeholder, elementFunctions, allowMultipleInstances) {
  var usedFunctions = [];
  var pattern = new RegExp(Object.keys(elementFunctions).map(function (el) {
    return "".concat(el, "+");
  }).join('|'), 'g');
  var matches = placeholder.match(pattern);
  return placeholder.split(pattern).reduce(function (arr, element, index) {
    var divider = element &&
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    _react["default"].createElement(_Divider["default"], {
      key: "separator_".concat(index)
    }, element);

    var res = [].concat(_toConsumableArray(arr), [divider]);
    var currentMatch = matches && matches[index];

    if (currentMatch) {
      var renderFunction = elementFunctions[currentMatch] || elementFunctions[Object.keys(elementFunctions).find(function (elementFunction) {
        return currentMatch.match(elementFunction);
      })];

      if (!allowMultipleInstances && usedFunctions.includes(renderFunction)) {
        res.push(currentMatch);
      } else {
        res.push(renderFunction(currentMatch, index));
        usedFunctions.push(renderFunction);
      }
    }

    return res;
  }, []);
}

var DateInput = /*#__PURE__*/function (_PureComponent) {
  _inherits(DateInput, _PureComponent);

  var _super = _createSuper(DateInput);

  function DateInput() {
    var _this;

    _classCallCheck(this, DateInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      year: null,
      month: null,
      day: null
    });

    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      if (event.target === event.currentTarget) {
        // Wrapper was directly clicked
        var firstInput = event.target.children[1];
        focus(firstInput);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      switch (event.key) {
        case 'ArrowLeft':
        case 'ArrowRight':
        case _this.divider:
          {
            event.preventDefault();
            var input = event.target;
            var property = event.key === 'ArrowLeft' ? 'previousElementSibling' : 'nextElementSibling';
            var nextInput = findInput(input, property);
            focus(nextInput);
            break;
          }

        default:
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyUp", function (event) {
      var key = event.key,
          input = event.target;
      var isNumberKey = !isNaN(parseInt(key, 10));

      if (!isNumberKey) {
        return;
      }

      var value = input.value;
      var max = input.getAttribute('max');
      /**
       * Given 1, the smallest possible number the user could type by adding another digit is 10.
       * 10 would be a valid value given max = 12, so we won't jump to the next input.
       * However, given 2, smallers possible number would be 20, and thus keeping the focus in
       * this field doesn't make sense.
       */

      if (value * 10 > max || value.length >= max.length) {
        var property = 'nextElementSibling';
        var nextInput = findInput(input, property);
        focus(nextInput);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event) {
      var _event$target = event.target,
          name = _event$target.name,
          value = _event$target.value;

      _this.setState(_defineProperty({}, name, value ? parseInt(value, 10) : null), _this.onChangeExternal);
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeNative", function (event) {
      var onChange = _this.props.onChange;
      var value = event.target.value;

      if (!onChange) {
        return;
      }

      var processedValue = function () {
        if (!value) {
          return null;
        }

        var _value$split = value.split('-'),
            _value$split2 = _slicedToArray(_value$split, 3),
            yearString = _value$split2[0],
            monthString = _value$split2[1],
            dayString = _value$split2[2];

        var year = parseInt(yearString, 10);
        var monthIndex = parseInt(monthString, 10) - 1 || 0;
        var day = parseInt(dayString, 10) || 1;
        var proposedValue = new Date();
        proposedValue.setFullYear(year, monthIndex, day);
        proposedValue.setHours(0, 0, 0, 0);
        return proposedValue;
      }();

      onChange(processedValue, false);
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeExternal", function () {
      var onChange = _this.props.onChange;

      if (!onChange) {
        return;
      }

      var formElements = [_this.dayInput, _this.monthInput, _this.yearInput].filter(Boolean);
      var values = {};
      formElements.forEach(function (formElement) {
        values[formElement.name] = formElement.value;
      });

      if (formElements.every(function (formElement) {
        return !formElement.value;
      })) {
        onChange(null, false);
      } else if (formElements.every(function (formElement) {
        return formElement.value && formElement.validity.valid;
      })) {
        var year = parseInt(values.year, 10);
        var monthIndex = parseInt(values.month, 10) - 1 || 0;
        var day = parseInt(values.day || 1, 10);
        var proposedValue = new Date();
        proposedValue.setFullYear(year, monthIndex, day);
        proposedValue.setHours(0, 0, 0, 0);

        var processedValue = _this.getProcessedValue(proposedValue);

        onChange(processedValue, false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderDay", function (currentMatch, index) {
      var _this$props = _this.props,
          autoFocus = _this$props.autoFocus,
          dayAriaLabel = _this$props.dayAriaLabel,
          dayPlaceholder = _this$props.dayPlaceholder,
          showLeadingZeros = _this$props.showLeadingZeros;
      var _this$state = _this.state,
          day = _this$state.day,
          month = _this$state.month,
          year = _this$state.year;

      if (currentMatch && currentMatch.length > 2) {
        throw new Error("Unsupported token: ".concat(currentMatch));
      }

      var showLeadingZerosFromFormat = currentMatch && currentMatch.length === 2;
      return /*#__PURE__*/_react["default"].createElement(_DayInput["default"], _extends({
        key: "day"
      }, _this.commonInputProps, {
        ariaLabel: dayAriaLabel,
        autoFocus: index === 0 && autoFocus,
        month: month,
        placeholder: dayPlaceholder,
        showLeadingZeros: showLeadingZerosFromFormat || showLeadingZeros,
        value: day,
        year: year
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderMonth", function (currentMatch, index) {
      var _this$props2 = _this.props,
          autoFocus = _this$props2.autoFocus,
          locale = _this$props2.locale,
          monthAriaLabel = _this$props2.monthAriaLabel,
          monthPlaceholder = _this$props2.monthPlaceholder,
          showLeadingZeros = _this$props2.showLeadingZeros;
      var _this$state2 = _this.state,
          month = _this$state2.month,
          year = _this$state2.year;

      if (currentMatch && currentMatch.length > 4) {
        throw new Error("Unsupported token: ".concat(currentMatch));
      }

      if (currentMatch.length > 2) {
        return /*#__PURE__*/_react["default"].createElement(_MonthSelect["default"], _extends({
          key: "month"
        }, _this.commonInputProps, {
          ariaLabel: monthAriaLabel,
          autoFocus: index === 0 && autoFocus,
          locale: locale,
          placeholder: monthPlaceholder,
          "short": currentMatch.length === 3,
          value: month,
          year: year
        }));
      }

      var showLeadingZerosFromFormat = currentMatch && currentMatch.length === 2;
      return /*#__PURE__*/_react["default"].createElement(_MonthInput["default"], _extends({
        key: "month"
      }, _this.commonInputProps, {
        ariaLabel: monthAriaLabel,
        autoFocus: index === 0 && autoFocus,
        placeholder: monthPlaceholder,
        showLeadingZeros: showLeadingZerosFromFormat || showLeadingZeros,
        value: month,
        year: year
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderYear", function (currentMatch, index) {
      var _this$props3 = _this.props,
          autoFocus = _this$props3.autoFocus,
          yearAriaLabel = _this$props3.yearAriaLabel,
          yearPlaceholder = _this$props3.yearPlaceholder;
      var year = _this.state.year;
      return /*#__PURE__*/_react["default"].createElement(_YearInput["default"], _extends({
        key: "year"
      }, _this.commonInputProps, {
        ariaLabel: yearAriaLabel,
        autoFocus: index === 0 && autoFocus,
        placeholder: yearPlaceholder,
        value: year,
        valueType: _this.valueType
      }));
    });

    return _this;
  }

  _createClass(DateInput, [{
    key: "getProcessedValue",

    /**
     * Gets current value in a desired format.
     */
    value: function getProcessedValue(value) {
      var _this$props4 = this.props,
          minDate = _this$props4.minDate,
          maxDate = _this$props4.maxDate,
          maxDetail = _this$props4.maxDetail,
          returnValue = _this$props4.returnValue;

      var processFunction = function () {
        switch (returnValue) {
          case 'start':
            return getDetailValueFrom;

          case 'end':
            return getDetailValueTo;

          case 'range':
            return getDetailValueArray;

          default:
            throw new Error('Invalid returnValue.');
        }
      }();

      return processFunction({
        value: value,
        minDate: minDate,
        maxDate: maxDate,
        maxDetail: maxDetail
      });
    }
  }, {
    key: "renderCustomInputs",
    value: function renderCustomInputs() {
      var placeholder = this.placeholder;
      var format = this.props.format;
      var elementFunctions = {
        d: this.renderDay,
        M: this.renderMonth,
        y: this.renderYear
      };
      var allowMultipleInstances = typeof format !== 'undefined';
      return _renderCustomInputs(placeholder, elementFunctions, allowMultipleInstances);
    }
  }, {
    key: "renderNativeInput",
    value: function renderNativeInput() {
      var _this$props5 = this.props,
          disabled = _this$props5.disabled,
          maxDate = _this$props5.maxDate,
          minDate = _this$props5.minDate,
          name = _this$props5.name,
          nativeInputAriaLabel = _this$props5.nativeInputAriaLabel,
          required = _this$props5.required;
      var value = this.state.value;
      return /*#__PURE__*/_react["default"].createElement(_NativeInput["default"], {
        key: "date",
        ariaLabel: nativeInputAriaLabel,
        disabled: disabled,
        maxDate: maxDate || defaultMaxDate,
        minDate: minDate || defaultMinDate,
        name: name,
        onChange: this.onChangeNative,
        required: required,
        value: value,
        valueType: this.valueType
      });
    }
  }, {
    key: "render",
    value: function render() {
      var className = this.props.className;
      /* eslint-disable jsx-a11y/click-events-have-key-events */

      /* eslint-disable jsx-a11y/no-static-element-interactions */

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: className,
        onClick: this.onClick
      }, this.renderNativeInput(), this.renderCustomInputs());
    }
  }, {
    key: "formatDate",
    get: function get() {
      var maxDetail = this.props.maxDetail;
      var options = {
        year: 'numeric'
      };
      var level = allViews.indexOf(maxDetail);

      if (level >= 2) {
        options.month = 'numeric';
      }

      if (level >= 3) {
        options.day = 'numeric';
      }

      return (0, _dateFormatter.getFormatter)(options);
    }
  }, {
    key: "divider",
    get: function get() {
      var dividers = this.placeholder.match(/[^0-9a-z]/i);
      return dividers ? dividers[0] : null;
    }
  }, {
    key: "placeholder",
    get: function get() {
      var _this$props6 = this.props,
          format = _this$props6.format,
          locale = _this$props6.locale;

      if (format) {
        return format;
      }

      var year = 2017;
      var monthIndex = 11;
      var day = 11;
      var date = new Date(year, monthIndex, day);
      var formattedDate = this.formatDate(locale, date);
      var datePieces = ['year', 'month', 'day'];
      var datePieceReplacements = ['y', 'M', 'd'];

      function formatDatePiece(name, dateToFormat) {
        return (0, _dateFormatter.getFormatter)(_defineProperty({
          useGrouping: false
        }, name, 'numeric'))(locale, dateToFormat).match(/\d{1,}/);
      }

      var placeholder = formattedDate;
      datePieces.forEach(function (datePiece, index) {
        var formattedDatePiece = formatDatePiece(datePiece, date);
        var datePieceReplacement = datePieceReplacements[index];
        placeholder = placeholder.replace(formattedDatePiece, datePieceReplacement);
      });
      return placeholder;
    }
  }, {
    key: "commonInputProps",
    get: function get() {
      var _this2 = this;

      var _this$props7 = this.props,
          className = _this$props7.className,
          disabled = _this$props7.disabled,
          isCalendarOpen = _this$props7.isCalendarOpen,
          maxDate = _this$props7.maxDate,
          minDate = _this$props7.minDate,
          required = _this$props7.required;
      return {
        className: className,
        disabled: disabled,
        maxDate: maxDate || defaultMaxDate,
        minDate: minDate || defaultMinDate,
        onChange: this.onChange,
        onKeyDown: this.onKeyDown,
        onKeyUp: this.onKeyUp,
        // This is only for showing validity when editing
        required: required || isCalendarOpen,
        itemRef: function itemRef(ref, name) {
          // Save a reference to each input field
          _this2["".concat(name, "Input")] = ref;
        }
      };
    }
  }, {
    key: "valueType",
    get: function get() {
      var maxDetail = this.props.maxDetail;
      return getValueType(maxDetail);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var minDate = nextProps.minDate,
          maxDate = nextProps.maxDate,
          maxDetail = nextProps.maxDetail;
      var nextState = {};
      /**
       * If isCalendarOpen flag has changed, we have to update it.
       * It's saved in state purely for use in getDerivedStateFromProps.
       */

      if (nextProps.isCalendarOpen !== prevState.isCalendarOpen) {
        nextState.isCalendarOpen = nextProps.isCalendarOpen;
      }
      /**
       * If the next value is different from the current one  (with an exception of situation in
       * which values provided are limited by minDate and maxDate so that the dates are the same),
       * get a new one.
       */


      var nextValue = getDetailValueFrom({
        value: nextProps.value,
        minDate: minDate,
        maxDate: maxDate,
        maxDetail: maxDetail
      });
      var values = [nextValue, prevState.value];

      if ( // Toggling calendar visibility resets values
      nextState.isCalendarOpen // Flag was toggled
      || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
        return getDetailValueFrom({
          value: value,
          minDate: minDate,
          maxDate: maxDate,
          maxDetail: maxDetail
        });
      }))) || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
        return getDetailValueTo({
          value: value,
          minDate: minDate,
          maxDate: maxDate,
          maxDetail: maxDetail
        });
      })))) {
        if (nextValue) {
          nextState.year = (0, _dateUtils.getYear)(nextValue);
          nextState.month = (0, _dateUtils.getMonthHuman)(nextValue);
          nextState.day = (0, _dateUtils.getDate)(nextValue);
        } else {
          nextState.year = null;
          nextState.month = null;
          nextState.day = null;
        }

        nextState.value = nextValue;
      }

      return nextState;
    }
  }]);

  return DateInput;
}(_react.PureComponent);

exports["default"] = DateInput;
DateInput.defaultProps = {
  maxDetail: 'month',
  name: 'date',
  returnValue: 'start'
};

var isValue = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]);

DateInput.propTypes = {
  autoFocus: _propTypes["default"].bool,
  className: _propTypes["default"].string.isRequired,
  dayAriaLabel: _propTypes["default"].string,
  dayPlaceholder: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  format: _propTypes["default"].string,
  isCalendarOpen: _propTypes["default"].bool,
  locale: _propTypes["default"].string,
  maxDate: _propTypes2.isMaxDate,
  maxDetail: _propTypes["default"].oneOf(allViews),
  minDate: _propTypes2.isMinDate,
  monthAriaLabel: _propTypes["default"].string,
  monthPlaceholder: _propTypes["default"].string,
  name: _propTypes["default"].string,
  nativeInputAriaLabel: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  required: _propTypes["default"].bool,
  returnValue: _propTypes["default"].oneOf(['start', 'end', 'range']),
  showLeadingZeros: _propTypes["default"].bool,
  value: _propTypes["default"].oneOfType([isValue, _propTypes["default"].arrayOf(isValue)]),
  yearAriaLabel: _propTypes["default"].string,
  yearPlaceholder: _propTypes["default"].string
};

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Divider;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Divider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "react-date-picker__inputGroup__divider"
  }, children);
}

Divider.propTypes = {
  children: _propTypes["default"].node
};

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DayInput;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _dateUtils = __webpack_require__(6);

var _Input = _interopRequireDefault(__webpack_require__(55));

var _propTypes2 = __webpack_require__(19);

var _utils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function DayInput(_ref) {
  var maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      month = _ref.month,
      year = _ref.year,
      otherProps = _objectWithoutProperties(_ref, ["maxDate", "minDate", "month", "year"]);

  var currentMonthMaxDays = function () {
    if (!month) {
      return 31;
    }

    return (0, _dateUtils.getDaysInMonth)(new Date(year, month - 1, 1));
  }();

  function isSameMonth(date) {
    return date && year === (0, _dateUtils.getYear)(date) && month === (0, _dateUtils.getMonthHuman)(date);
  }

  var maxDay = (0, _utils.safeMin)(currentMonthMaxDays, isSameMonth(maxDate) && (0, _dateUtils.getDate)(maxDate));
  var minDay = (0, _utils.safeMax)(1, isSameMonth(minDate) && (0, _dateUtils.getDate)(minDate));
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
    max: maxDay,
    min: minDay,
    name: "day"
  }, otherProps));
}

DayInput.propTypes = {
  ariaLabel: _propTypes["default"].string,
  className: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  itemRef: _propTypes["default"].func,
  maxDate: _propTypes2.isMaxDate,
  minDate: _propTypes2.isMinDate,
  month: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  showLeadingZeros: _propTypes["default"].bool,
  value: _propTypes["default"].number,
  year: _propTypes["default"].number
};

/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["getFontShorthand"] = getFontShorthand;
/* harmony export (immutable) */ __webpack_exports__["measureText"] = measureText;
/* harmony export (immutable) */ __webpack_exports__["updateInputWidth"] = updateInputWidth;
var allowedVariants = ['normal', 'small-caps'];
/**
 * Gets font CSS shorthand property given element.
 *
 * @param {HTMLElement} element Element to get font CSS shorthand property from
 */

function getFontShorthand(element) {
  var style = window.getComputedStyle(element);

  if (style.font) {
    return style.font;
  }

  var isFontDefined = style['font-family'] !== '';

  if (!isFontDefined) {
    return '';
  }

  var fontVariant = allowedVariants.includes(style['font-variant']) ? style['font-variant'] : 'normal';
  return "".concat(style['font-style'], " ").concat(fontVariant, " ").concat(style['font-weight'], " ").concat(style['font-size'], " / ").concat(style['line-height'], " ").concat(style['font-family']);
}
/**
 * Measures text width given text and font CSS shorthand.
 *
 * @param {String} text Text to measure
 * @param {String} font Font to use when measuring the text
 */

function measureText(text, font) {
  var canvas = measureText.canvas || (measureText.canvas = document.createElement('canvas'));
  var context = canvas.getContext('2d'); // Context type not supported

  if (!context) {
    return null;
  }

  context.font = font;

  var _context$measureText = context.measureText(text),
      width = _context$measureText.width;

  return Math.ceil(width);
}
/**
 * Updates input element width to fit its content given input element
 * @param {HTMLInputElement} element
 */

function updateInputWidth(element) {
  if (typeof window === 'undefined') {
    return null;
  }

  var font = getFontShorthand(element);
  var text = element.value || element.placeholder;
  var width = measureText(text, font);

  if (width === null) {
    return null;
  }

  element.style.width = "".concat(width, "px");
  return width;
}
/* harmony default export */ __webpack_exports__["default"] = (updateInputWidth);

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MonthInput;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _dateUtils = __webpack_require__(6);

var _Input = _interopRequireDefault(__webpack_require__(55));

var _propTypes2 = __webpack_require__(19);

var _utils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function MonthInput(_ref) {
  var maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      year = _ref.year,
      otherProps = _objectWithoutProperties(_ref, ["maxDate", "minDate", "year"]);

  function isSameYear(date) {
    return date && year === (0, _dateUtils.getYear)(date);
  }

  var maxMonth = (0, _utils.safeMin)(12, isSameYear(maxDate) && (0, _dateUtils.getMonthHuman)(maxDate));
  var minMonth = (0, _utils.safeMax)(1, isSameYear(minDate) && (0, _dateUtils.getMonthHuman)(minDate));
  return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
    max: maxMonth,
    min: minMonth,
    name: "month"
  }, otherProps));
}

MonthInput.propTypes = {
  ariaLabel: _propTypes["default"].string,
  className: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  itemRef: _propTypes["default"].func,
  maxDate: _propTypes2.isMaxDate,
  minDate: _propTypes2.isMinDate,
  onChange: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  showLeadingZeros: _propTypes["default"].bool,
  value: _propTypes["default"].number,
  year: _propTypes["default"].number
};

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MonthSelect;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _mergeClassNames = _interopRequireDefault(__webpack_require__(27));

var _dateUtils = __webpack_require__(6);

var _dateFormatter = __webpack_require__(111);

var _propTypes2 = __webpack_require__(19);

var _utils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function MonthSelect(_ref) {
  var ariaLabel = _ref.ariaLabel,
      className = _ref.className,
      itemRef = _ref.itemRef,
      locale = _ref.locale,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '--' : _ref$placeholder,
      _short = _ref["short"],
      value = _ref.value,
      year = _ref.year,
      otherProps = _objectWithoutProperties(_ref, ["ariaLabel", "className", "itemRef", "locale", "maxDate", "minDate", "placeholder", "short", "value", "year"]);

  function isSameYear(date) {
    return date && year === (0, _dateUtils.getYear)(date);
  }

  var maxMonth = (0, _utils.safeMin)(12, isSameYear(maxDate) && (0, _dateUtils.getMonthHuman)(maxDate));
  var minMonth = (0, _utils.safeMax)(1, isSameYear(minDate) && (0, _dateUtils.getMonthHuman)(minDate));

  var dates = _toConsumableArray(Array(12)).map(function (el, index) {
    return new Date(2019, index, 1);
  });

  var name = 'month';
  var formatter = _short ? _dateFormatter.formatShortMonth : _dateFormatter.formatMonth;
  return /*#__PURE__*/_react["default"].createElement("select", _extends({
    "aria-label": ariaLabel,
    className: (0, _mergeClassNames["default"])("".concat(className, "__input"), "".concat(className, "__").concat(name)),
    "data-input": "true",
    name: name,
    ref: function ref(_ref2) {
      if (itemRef) {
        itemRef(_ref2, name);
      }
    },
    value: value !== null ? value : ''
  }, otherProps), !value && /*#__PURE__*/_react["default"].createElement("option", {
    value: ""
  }, placeholder), dates.map(function (date) {
    var month = (0, _dateUtils.getMonthHuman)(date);
    var disabled = month < minMonth || month > maxMonth;
    return /*#__PURE__*/_react["default"].createElement("option", {
      key: month,
      disabled: disabled,
      value: month
    }, formatter(locale, date));
  }));
}

MonthSelect.propTypes = {
  ariaLabel: _propTypes["default"].string,
  className: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  itemRef: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  maxDate: _propTypes2.isMaxDate,
  minDate: _propTypes2.isMinDate,
  onChange: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  "short": _propTypes["default"].bool,
  value: _propTypes["default"].number,
  year: _propTypes["default"].number
};

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = YearInput;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _dateUtils = __webpack_require__(6);

var _Input = _interopRequireDefault(__webpack_require__(55));

var _propTypes2 = __webpack_require__(19);

var _utils = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function YearInput(_ref) {
  var maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? '----' : _ref$placeholder,
      valueType = _ref.valueType,
      otherProps = _objectWithoutProperties(_ref, ["maxDate", "minDate", "placeholder", "valueType"]);

  var maxYear = (0, _utils.safeMin)(275760, maxDate && (0, _dateUtils.getYear)(maxDate));
  var minYear = (0, _utils.safeMax)(1, minDate && (0, _dateUtils.getYear)(minDate));

  var yearStep = function () {
    if (valueType === 'century') {
      return 10;
    }

    return 1;
  }();

  return /*#__PURE__*/_react["default"].createElement(_Input["default"], _extends({
    max: maxYear,
    min: minYear,
    name: "year",
    placeholder: placeholder,
    step: yearStep
  }, otherProps));
}

YearInput.propTypes = {
  ariaLabel: _propTypes["default"].string,
  className: _propTypes["default"].string.isRequired,
  disabled: _propTypes["default"].bool,
  itemRef: _propTypes["default"].func,
  maxDate: _propTypes2.isMaxDate,
  minDate: _propTypes2.isMinDate,
  onChange: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  placeholder: _propTypes["default"].string,
  required: _propTypes["default"].bool,
  value: _propTypes["default"].number,
  valueType: _propTypes2.isValueType
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = NativeInput;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(2));

var _dateUtils = __webpack_require__(6);

var _propTypes2 = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function NativeInput(_ref) {
  var ariaLabel = _ref.ariaLabel,
      disabled = _ref.disabled,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      name = _ref.name,
      onChange = _ref.onChange,
      required = _ref.required,
      value = _ref.value,
      valueType = _ref.valueType;

  var nativeInputType = function () {
    switch (valueType) {
      case 'decade':
      case 'year':
        return 'number';

      case 'month':
        return 'month';

      case 'day':
        return 'date';

      default:
        throw new Error('Invalid valueType.');
    }
  }();

  var nativeValueParser = function () {
    switch (valueType) {
      case 'century':
      case 'decade':
      case 'year':
        return _dateUtils.getYear;

      case 'month':
        return _dateUtils.getISOLocalMonth;

      case 'day':
        return _dateUtils.getISOLocalDate;

      default:
        throw new Error('Invalid valueType.');
    }
  }();

  function stopPropagation(event) {
    event.stopPropagation();
  }

  return /*#__PURE__*/_react["default"].createElement("input", {
    "aria-label": ariaLabel,
    disabled: disabled,
    max: maxDate ? nativeValueParser(maxDate) : null,
    min: minDate ? nativeValueParser(minDate) : null,
    name: name,
    onChange: onChange,
    onFocus: stopPropagation,
    required: required,
    style: {
      visibility: 'hidden',
      position: 'absolute',
      zIndex: '-999'
    },
    type: nativeInputType,
    value: value ? nativeValueParser(value) : ''
  });
}

NativeInput.propTypes = {
  ariaLabel: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  maxDate: _propTypes2.isMaxDate,
  minDate: _propTypes2.isMinDate,
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  required: _propTypes["default"].bool,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].instanceOf(Date)]),
  valueType: _propTypes2.isValueType
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBegin = getBegin;
exports.getEnd = getEnd;

var _dateUtils = __webpack_require__(6);

/**
 * Returns the beginning of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */
function getBegin(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return (0, _dateUtils.getCenturyStart)(date);

    case 'decade':
      return (0, _dateUtils.getDecadeStart)(date);

    case 'year':
      return (0, _dateUtils.getYearStart)(date);

    case 'month':
      return (0, _dateUtils.getMonthStart)(date);

    case 'day':
      return (0, _dateUtils.getDayStart)(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
/**
 * Returns the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */


function getEnd(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return (0, _dateUtils.getCenturyEnd)(date);

    case 'decade':
      return (0, _dateUtils.getDecadeEnd)(date);

    case 'year':
      return (0, _dateUtils.getYearEnd)(date);

    case 'month':
      return (0, _dateUtils.getMonthEnd)(date);

    case 'day':
      return (0, _dateUtils.getDayEnd)(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ParticipantResult;
/* harmony export (immutable) */ __webpack_exports__["b"] = TeamResult;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Results_css__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Results_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Results_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resultlists__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__teamresults__ = __webpack_require__(289);
function ParticipantResult(props){for(var rl in __WEBPACK_IMPORTED_MODULE_2__resultlists__){var List=__WEBPACK_IMPORTED_MODULE_2__resultlists__[rl];if(List.disciplines&&List.disciplines.includes(props.event.discipline)){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(List,props);}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Resultat \xE4r inte implementerat f\xF6r t\xE4vlingsformen');}function TeamResult(props){if(props.teams===undefined){return null;}for(var tl in __WEBPACK_IMPORTED_MODULE_3__teamresults__){var List=__WEBPACK_IMPORTED_MODULE_3__teamresults__[tl];if(List.disciplines&&List.disciplines.includes(props.event.discipline)){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(List,props);}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Resultat \xE4r inte implementerat f\xF6r t\xE4vlingsformen');}

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FieldResult__ = __webpack_require__(287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldResult", function() { return __WEBPACK_IMPORTED_MODULE_0__FieldResult__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PrecisionResult__ = __webpack_require__(288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PrecisionResult", function() { return __WEBPACK_IMPORTED_MODULE_1__PrecisionResult__["a"]; });


/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logic__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var sort=function sort(a,b){var pos=0;while(pos<a.total.length&&pos<b.total.length){if(a.total[pos]===b.total[pos]){pos++;}else{return b.total[pos]-a.total[pos];}}pos=a.scores.length;while(pos-->0){if(a.scores[pos]!==b.scores[pos]){return b.scores[pos]-a.scores[pos];}if(a.targets[pos]!==b.targets[pos]){return b.targets[pos]-a.targets[pos];}}return 0;};var FieldResult=function(_React$Component){_inherits(FieldResult,_React$Component);function FieldResult(props){_classCallCheck(this,FieldResult);var _this=_possibleConstructorReturn(this,(FieldResult.__proto__||Object.getPrototypeOf(FieldResult)).call(this,props));_initialiseProps.call(_this);_this.scorer=props.event.discipline===__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].fieldP||props.event.discipline===__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].fieldK?__WEBPACK_IMPORTED_MODULE_3__logic__["StdFieldScore"]:__WEBPACK_IMPORTED_MODULE_3__logic__["PointFieldScore"];return _this;}_createClass(FieldResult,[{key:"assignStd",value:function assignStd(scores){var sBreak=Math.floor(scores.length/9);var bBreak=Math.floor(scores.length/3);var sLim=48,bLim=48;scores.forEach(function(s,i){if(i<sBreak||s.total[0]===sLim){s.std="S";sLim=s.total[0];bLim=s.total[0];}else if(i<bBreak||s.total[0]===bLim){s.std="B";bLim=s.total[0];}});return scores;}},{key:"scores",value:function scores(results,filter){var _this2=this;var _props=this.props,competition=_props.competition,event=_props.event,division=_props.division;var showValues=event.stages.some(function(s){return s.value;});var linkBase="/competition/"+competition.id+"/results/"+event.id+"/"+(division&&isNaN(division)?division+"/":"");filter=filter.toUpperCase();return results.sort(function(a,b){return sort(a,b);}).map(function(p,i){return Object.assign({},p,{pos:i+1});}).filter(function(p){return p.name.toUpperCase().includes(filter)||p.organization.toUpperCase().includes(filter);}).map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.Participant,{key:p.id,pos:p.pos,event:event,data:p,showValues:showValues,linkBase:linkBase});});// .concat([<tr key={results[0].class}><td>&nbsp;</td></tr>]);
}},{key:"render",value:function render(){var _this3=this;var _props2=this.props,event=_props2.event,filter=_props2.filter;var showValues=event.stages.some(function(s){return s.value;});var results=this.props.results.map(function(r){return _this3.scorer.calculateScores(r,event);});this.assignStd(results.flat().sort(function(a,b){return sort(a,b);}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"score-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.Header,{event:event,showValues:showValues}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,results.flatMap(function(r){return _this3.scores(r,filter);})));}}]);return FieldResult;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);FieldResult.disciplines=[__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].fieldP,__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].fieldK,__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].scoredP,__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].scoredK];var _initialiseProps=function _initialiseProps(){var _this4=this;this.Header=function(props){var scores=[],s=0;while(s++<props.event.scores){scores.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{key:s},s));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Plac"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"left"},"Namn"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"left"},"F\xF6rening"),props.event.classes>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"left"},"Klass"),scores,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Summa"),props.showValues&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Po\xE4ng"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Std")));};this.Participant=function(props){var data=props.data,pos=props.pos,event=props.event;var id=data.id,name=data.name,organization=data.organization,scores=data.scores,targets=data.targets,total=data.total,std=data.std;var txts=[];for(var i=0;i<scores.length;i++){txts[i]=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{key:i},scores[i]+"/"+targets[i]);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:pos===1?"first":pos%2===0?"even":undefined},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,pos),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.linkBase+id},name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"left"},organization),event.classes>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.class),txts,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,_this4.scorer.finalScore(total)),props.showValues&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,total[2],"p"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,std));};};

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrecisionResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var sort=function sort(a,b){var pos=0;while(pos<a.total.length&&pos<b.total.length){if(a.total[pos]===b.total[pos]){pos++;}else{return b.total[pos]-a.total[pos];}}pos=a.scores.length;while(pos-->0){if(a.scores[pos]!==b.scores[pos]){return b.scores[pos]-a.scores[pos];}}return 0;};var PrecisionResult=function(_React$Component){_inherits(PrecisionResult,_React$Component);function PrecisionResult(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrecisionResult);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrecisionResult.__proto__||Object.getPrototypeOf(PrecisionResult)).call.apply(_ref,[this].concat(args))),_this),_this.Header=function(props){var scores=[],s=0;while(s++<props.event.scores){scores.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{key:s},s));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Plac"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"left"},"Namn"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"left"},"F\xF6rening"),props.event.classes>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"left"},"Klass"),scores,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Summa"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"X"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Std")));},_this.Participant=function(props){var data=props.data,pos=props.pos,event=props.event;var id=data.id,name=data.name,organization=data.organization,scores=data.scores,total=data.total,std=data.std;var txts=[];for(var i=0;i<event.scores;i++){txts[i]=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{key:i},scores[i]);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:pos===1?"first":pos%2===0?"even":undefined},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,pos),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"left"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.linkBase+id},name)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"left"},organization),event.classes>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.class),txts,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,total[0]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,total[1]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,std));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrecisionResult,[{key:"getBreaks",value:function getBreaks(event,division){if(__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].target===event.discipline)if(["M1","M2","M3","M4"].includes(division))return{s:282,b:274};if("M5"===division)return{s:294,b:288};if(["M6","M7"].includes(division))return{s:270,b:253};if("A"===division){if(6===event.scores)return{s:277,b:267};if(7===event.scores)return{s:323,b:312};if(10===event.scores)return{s:461,b:445};}if("B"===division){if(6===event.scores)return{s:282,b:273};if(7===event.scores)return{s:329,b:319};if(10===event.scores)return{s:470,b:455};}if("C"===division){if(6===event.scores)return{s:283,b:276};if(7===event.scores)return{s:330,b:322};if(10===event.scores)return{s:471,b:460};}return{s:1000,b:1000};}},{key:"assignStd",value:function assignStd(scores){var fixedBreaks=this.getBreaks(this.props.event,this.props.division);var sBreak=Math.floor(scores.length/9);var bBreak=Math.floor(scores.length/3);var sLim=fixedBreaks.s,bLim=fixedBreaks.b;scores.forEach(function(s,i){if(i<sBreak||s.total[0]>=sLim){s.std="S";if(s.total[0]<sLim){sLim=s.total[0];}if(s.total[0]<bLim){bLim=s.total[0];}}else if(i<bBreak||s.total[0]>=bLim){s.std="B";if(s.total[0]<bLim){bLim=s.total[0];}}});return scores;}},{key:"scores",value:function scores(results,filter){var _this2=this;var _props=this.props,competition=_props.competition,event=_props.event,division=_props.division;var linkBase="/competition/"+competition.id+"/results/"+event.id+"/"+(division&&isNaN(division)?division+"/":"");filter=filter.toUpperCase();return results.sort(function(a,b){return sort(a,b);}).map(function(p,i){return Object.assign({},p,{pos:i+1});}).filter(function(p){return p.name.toUpperCase().includes(filter)||p.organization.toUpperCase().includes(filter);}).map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.Participant,{key:p.id,pos:p.pos,event:event,data:p,linkBase:linkBase});});// .concat([<tr key={results[0].class}><td>&nbsp;</td></tr>]);
}},{key:"calculateScores",value:function calculateScores(results){var sum=function sum(a,b){return a+b;};return results.map(function(p){var scores=[];var Xs=0;p.scores.forEach(function(s){scores[s.stage-1]=s.values.filter(function(v){return v!==undefined;}).map(function(v){return v==="X"?10:v;}).reduce(sum,0);Xs+=s.values.filter(function(s){return s==="X";}).length;});return{id:p.id,name:p.name,organization:p.organization,scores:scores,class:p.class,total:[scores.reduce(sum,0),Xs]};});}},{key:"render",value:function render(){var _this3=this;var _props2=this.props,event=_props2.event,filter=_props2.filter;var results=this.props.results.map(function(r){return _this3.calculateScores(r);});this.assignStd(results.flat().sort(function(a,b){return sort(a,b);}),event);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"score-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.Header,{event:event}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,results.flatMap(function(r){return _this3.scores(r,filter);})));}}]);return PrecisionResult;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PrecisionResult.disciplines=[__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].target];

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FieldResult__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldResult", function() { return __WEBPACK_IMPORTED_MODULE_0__FieldResult__["a"]; });


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logic__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { Link } from 'react-router-dom';
var sort=function sort(a,b){var pos=0;while(pos<a.total.length&&pos<b.total.length){if(a.total[pos]===b.total[pos]){pos++;}else{return b.total[pos]-a.total[pos];}}/* TODO: How to implement for teams???
	pos = a.scores.length;
	while (pos-- > 0) {
		if (a.scores[pos] !== b.scores[pos]) { return b.scores[pos] - a.scores[pos]; }
		if (a.targets[pos] !== b.targets[pos]) { return b.targets[pos] - a.targets[pos]; }
	}
	*/return 0;};function Header(_ref){var event=_ref.event,showValues=_ref.showValues;var scores=[],s=0;while(s++<event.scores){scores.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{key:s},s));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Plac"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"left"},"Namn"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"left"},"F\xF6rening"),event.classes>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"left"},"Klass"),scores,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Summa"),showValues&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Po\xE4ng")));}function Summary(_ref2){var pos=_ref2.pos,team=_ref2.team,finalScore=_ref2.finalScore,event=_ref2.event,showValues=_ref2.showValues;var scores=[],s=0;while(s++<event.scores){scores.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{key:s}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,pos),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"left"},team.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"left"},team.organization),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null),scores,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,finalScore),showValues&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,team.total[2]));}function Participant(_ref3){var data=_ref3.data,finalScore=_ref3.finalScore,pos=_ref3.pos,event=_ref3.event,showValues=_ref3.showValues;if(data===undefined)return null;var name=data.name,scores=data.scores,targets=data.targets,total=data.total;var txts=[];for(var i=0;i<scores.length;i++){txts[i]=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{key:i},scores[i]+"/"+targets[i]);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:pos%2===0?"even":undefined},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"left"},name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"left"}),event.classes>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,data.class),txts,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,finalScore),showValues&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,total[2],"p"));}var FieldResult=function(_React$Component){_inherits(FieldResult,_React$Component);function FieldResult(props){_classCallCheck(this,FieldResult);var _this=_possibleConstructorReturn(this,(FieldResult.__proto__||Object.getPrototypeOf(FieldResult)).call(this,props));_this.scorer=props.event.discipline===__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].fieldP||props.event.discipline===__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].fieldK?__WEBPACK_IMPORTED_MODULE_2__logic__["StdFieldScore"]:__WEBPACK_IMPORTED_MODULE_2__logic__["PointFieldScore"];return _this;}_createClass(FieldResult,[{key:"calcScores",value:function calcScores(team,event,results){team.scores=team.members.concat(team.alternates).map(function(id){return parseInt(id,10);}).map(function(id){return results.flat().find(function(r){return r.id===id;});}).filter(function(s){return s!==undefined;});if(team.scores.length===0){return;}// Determine team members
// TODO: Remove members that belong to other teams?!
var teamDef=event.teams[parseInt(team.team_definition_id,10)];var i=team.scores.length-1;while(team.scores.length>teamDef.members){if(i>-1){if(team.scores[i].total[0]===0){team.scores.splice(i,1);}i--;}else{team.scores.pop();}}// Add upp scores for team
team.total=[].concat(_toConsumableArray(team.scores[0].total));for(i=1;i<team.scores.length;i++){for(var j=0;j<team.total.length;j++){team.total[j]+=team.scores[i].total[j];}}}},{key:"team",value:function team(index,_team,event,showValues){var _this2=this;var scores=_team.scores.filter(function(s){return s!==undefined;}).map(function(s,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Participant,{key:"p"+index+i,data:s,finalScore:_this2.scorer.finalScore(s.total),pos:i,event:event,showValues:showValues});});if(scores.length===0){return null;}return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Summary,{key:"sum"+index,pos:index+1,team:_team,finalScore:this.scorer.finalScore(_team.total),event:event,showValues:showValues})].concat(_toConsumableArray(scores));}},{key:"scores",value:function scores(event,teams,filter,showValues){var _this3=this;// let linkBase = `/competition/${competition.id}/results/${event.id}/${division && isNaN(division) ? `${division}/` : ""}`;
filter=filter.toUpperCase();var f=function f(txt){return txt.toUpperCase().includes(filter);};teams=teams.flat();return teams.filter(function(t){return f(t.name)||f(t.organization)||t.scores.some(function(p){return f(p.name);});}).map(function(t,i){return _this3.team(i,t,event,showValues);});}},{key:"render",value:function render(){var _this4=this;var _props=this.props,event=_props.event,teams=_props.teams,filter=_props.filter;var showValues=event.stages.some(function(s){return s.value;});var results=this.props.results.map(function(r){return _this4.scorer.calculateScores(r,event);});teams=teams.flat().filter(function(t){return parseInt(t.event,10)===event.id;});teams.forEach(function(t){return _this4.calcScores(t,event,results);});teams=teams.filter(function(t){return t.scores.length>0;}).sort(sort);if(teams.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"score-table"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,{event:event,showValues:showValues}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,this.scores(event,teams,filter,showValues)));}}]);return FieldResult;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);FieldResult.disciplines=[__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].fieldP,__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].fieldK,__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].scoredP,__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].scoredK];

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Footers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Footer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Footers=function(){function Footers(){_classCallCheck(this,Footers);this.messageId=1;this.footers=[];}_createClass(Footers,[{key:'initialize',value:function initialize(){var _this=this;this.subscribe(__WEBPACK_IMPORTED_MODULE_1__logic__["Events"].addFooter,function(msg,type,timeout){return _this.addFooter(msg,type,timeout);});}},{key:'addCustomFooter',value:function addCustomFooter(content){var myId=this.messageId++;this.footers=this.footers.concat([{id:myId,content:content}]);this.fire(__WEBPACK_IMPORTED_MODULE_1__logic__["Events"].footersChanged,myId);}},{key:'addFooter',value:function addFooter(msg){var _this2=this;var type=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"error";var timeout=arguments.length>2&&arguments[2]!==undefined?arguments[2]:3000;if(this.footers.filter(function(f){return f.msg===msg;}).length>0){return;}var myId=this.messageId++;var newFooter={id:myId,msg:msg,content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:myId,className:type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:'centered'},msg))};this.footers=[newFooter].concat(this.footers);var timer=setTimeout(function(){_this2.deleteFooter(myId);clearTimeout(timer);},timeout);this.fire(__WEBPACK_IMPORTED_MODULE_1__logic__["Events"].footersChanged,myId);}},{key:'deleteFooter',value:function deleteFooter(id){this.footers=this.footers.filter(function(f){return f.id!==id;});this.fire(__WEBPACK_IMPORTED_MODULE_1__logic__["Events"].footersChanged,id);}},{key:'errorHandler',value:function errorHandler(msg){var _this3=this;return function(e){if(e===undefined){_this3.addFooter("Oväntat fel!");console.log(msg);}else if(e.msg!==undefined)_this3.addFooter(msg+' - '+e.msg);else if(e.message!==undefined)_this3.addFooter(msg+' - '+e.message);else _this3.addFooter(msg+' - '+e.toString());};}}]);return Footers;}();Footers.register={name:"Footers",createInstance:true};Footers.wire=["fire","subscribe"];var Footer=function(_React$Component){_inherits(Footer,_React$Component);function Footer(props){_classCallCheck(this,Footer);var _this4=_possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).call(this,props));_this4.EventBus.manageEvents(_this4);_this4.subscribe(__WEBPACK_IMPORTED_MODULE_1__logic__["Events"].footersChanged,function(){return _this4.setState({});});return _this4;}_createClass(Footer,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'footer',className:'footer'},this.Footers.footers.map(function(f){return f.content;}));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);Footer.register={name:"Footer"};Footer.wire=["Footers","subscribe","EventBus"];

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupProperties=function(_React$Component){_inherits(GroupProperties,_React$Component);function GroupProperties(){_classCallCheck(this,GroupProperties);return _possibleConstructorReturn(this,(GroupProperties.__proto__||Object.getPrototypeOf(GroupProperties)).apply(this,arguments));}_createClass(GroupProperties,[{key:'render',value:function render(){var _props=this.props,groups=_props.groups,selected=_props.selected,_onChange=_props.onChange;var icons=["Ingen"].concat(Object.keys(groups.icons));var status=[{id:0,description:"Gömd"},{id:1,description:"Synlig"}];if(selected===undefined){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'group-props'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'group-header'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["TextInput"],{name:'Gruppnamn',id:'group-name',placeholder:'Namn',value:selected.name,onChange:function onChange(e){return _onChange(selected,"name",e.target.value);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["TextInput"],{name:'ID',id:'group-id',placeholder:'ID',value:selected.label,onChange:function onChange(e){return _onChange(selected,"label",e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["TextInput"],{name:'Beskrivning',id:'group-desc',placeholder:'Beskrivning',value:selected.description,onChange:function onChange(e){return _onChange(selected,"description",e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["Dropdown"],{name:'Ikon',id:'group-icon',placeholder:'Ingen',value:selected.icon,list:icons,onChange:function onChange(e){return _onChange(selected,"icon",e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["TextInput"],{name:'Textf\xE4rg',id:'group-color',placeholder:'#000000',value:selected.color,onChange:function onChange(e){return _onChange(selected,"color",e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["TextInput"],{name:'Bakgrundsf\xE4rg',id:'group-background',placeholder:'#FFFFFF',value:selected.background,onChange:function onChange(e){return _onChange(selected,"background",e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["Dropdown"],{name:'Status',id:'group-status',placeholder:'Synlig',value:selected.status,list:status,onChange:function onChange(e){return _onChange(selected,"status",parseInt(e.target.value,10));}}));}}]);return GroupProperties;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginControl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginControl=function(_React$Component){_inherits(LoginControl,_React$Component);function LoginControl(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LoginControl);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LoginControl.__proto__||Object.getPrototypeOf(LoginControl)).call.apply(_ref,[this].concat(args))),_this),_this.login=function(e){e.preventDefault();_this.Session.login(_this.user.value,_this.password.value);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LoginControl,[{key:"componentDidMount",value:function componentDidMount(){this.EventBus.fire(this.Events.changeTitle,"Logga in");this.user.focus();}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"login"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{className:"login",onSubmit:this.login},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Inloggning"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Anv\xE4ndarnamn:\xA0"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:"userName",ref:function ref(user){return _this2.user=user;},type:"text",size:"30"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"L\xF6senord:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{id:"password",type:"password",size:"30",ref:function ref(input){return _this2.password=input;}}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button",type:"submit"},"Logga in")));}}]);return LoginControl;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);LoginControl.register={name:"LoginControl"};LoginControl.wire=["Session","Events","EventBus"];

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LoginLogout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteCookies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LocalToggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ModeSelector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global_css__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Global_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Global_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var LoginLogout=function(_React$Component){_inherits(LoginLogout,_React$Component);function LoginLogout(){var _ref;var _temp,_this,_ret;_classCallCheck(this,LoginLogout);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=LoginLogout.__proto__||Object.getPrototypeOf(LoginLogout)).call.apply(_ref,[this].concat(args))),_this),_this.toggle=function(e){_this.Session.logout();e.preventDefault();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LoginLogout,[{key:'render',value:function render(){return this.Session.user!==""?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'',className:'globaltool',onClick:this.toggle},'Logga ut',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'bloat'},' '+this.Session.user)):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/login',className:'globaltool'},'Logga in');}}]);return LoginLogout;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);LoginLogout.register={name:"LoginLogout"};LoginLogout.wire=["Session"];var DeleteCookies=function(_React$Component2){_inherits(DeleteCookies,_React$Component2);function DeleteCookies(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,DeleteCookies);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=DeleteCookies.__proto__||Object.getPrototypeOf(DeleteCookies)).call.apply(_ref2,[this].concat(args))),_this2),_this2.delete=function(){_this2.Storage.delete();_this2.Registration.newRegistration();_this2.Registry.initialize();},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(DeleteCookies,[{key:'render',value:function render(){return this.Storage.get(this.Storage.keys.allowStorage)!==undefined&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'',className:'globaltool',onClick:this.delete},'Rensa',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{className:'bloat'},' sparad information'));}}]);return DeleteCookies;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);DeleteCookies.register={name:"DeleteCookies"};DeleteCookies.wire=["Storage","Registration","Registry"];var LocalToggle=function(_React$Component3){_inherits(LocalToggle,_React$Component3);function LocalToggle(props){_classCallCheck(this,LocalToggle);var _this3=_possibleConstructorReturn(this,(LocalToggle.__proto__||Object.getPrototypeOf(LocalToggle)).call(this,props));_this3.toggle=function(e){_this3.Server.setLocal(!_this3.Server.local);_this3.Session.logout();e.preventDefault();_this3.setState({});};_this3.state={show:false/*this.Storage.get(this.Storage.keys.toggleServerMode)*/};return _this3;}_createClass(LocalToggle,[{key:'render',value:function render(){return this.state.show?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'',className:'globaltool',onClick:this.toggle},this.Server.local?"Local":"Online"):null;}}]);return LocalToggle;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);LocalToggle.register={name:"LocalToggle"};LocalToggle.wire=["Server","Session","Storage"];var ModeSelector=function(_React$Component4){_inherits(ModeSelector,_React$Component4);function ModeSelector(props){_classCallCheck(this,ModeSelector);var _this4=_possibleConstructorReturn(this,(ModeSelector.__proto__||Object.getPrototypeOf(ModeSelector)).call(this,props));_this4.toggleMode=function(e){_this4.Configuration.setMode(_this4.Configuration.mode===__WEBPACK_IMPORTED_MODULE_3__models__["Mode"].computer?__WEBPACK_IMPORTED_MODULE_3__models__["Mode"].mobile:__WEBPACK_IMPORTED_MODULE_3__models__["Mode"].computer);e.preventDefault();_this4.setState({});};_this4.EventBus.manageEvents(_this4);_this4.subscribe(_this4.Events.modeChanged,function(){return _this4.setState({});});return _this4;}_createClass(ModeSelector,[{key:'render',value:function render(){return this.Configuration.mode===__WEBPACK_IMPORTED_MODULE_3__models__["Mode"].computer?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'slider globaltool'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'globaltool disabled right'},'Mobil'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'',className:'globaltool',onClick:this.toggleMode},'Dator')):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'slider globaltool'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'',className:'globaltool',onClick:this.toggleMode},'Mobil'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'globaltool disabled left'},'Dator'));}}]);return ModeSelector;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);ModeSelector.register={name:"ModeSelector"};ModeSelector.wire=["Configuration","Events","EventBus"];

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParticipantPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ParticipantPicker_css__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ParticipantPicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ParticipantPicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ParticipantPicker=function(_React$Component){_inherits(ParticipantPicker,_React$Component);function ParticipantPicker(props){_classCallCheck(this,ParticipantPicker);var _this=_possibleConstructorReturn(this,(ParticipantPicker.__proto__||Object.getPrototypeOf(ParticipantPicker)).call(this,props));_initialiseProps.call(_this);_this.state={visible:false};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.showParticipantPicker,function(){return _this.setState({visible:true});});return _this;}_createClass(ParticipantPicker,[{key:'render',value:function render(){var _this2=this;return!this.state.visible?null:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__general__["a" /* ModalDialog */],{title:'H\xE4mta deltagare',showClose:true,onClose:function onClose(e){return _this2.setState({visible:false});}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',{className:'picker'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'picker'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Namn'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Pistolskyttekort'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'F\xF6rening'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,this.Registry.competitors.sort(function(a,b){return a.name.localeCompare(b.name);}).map(function(p){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this2.Competitor,{key:p.competitionId,person:p,onClick:function onClick(e){_this2.setState({visible:false});_this2.Registration.addParticipant(p);}});}))));}}]);return ParticipantPicker;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);ParticipantPicker.register={name:"ParticipantPicker"};ParticipantPicker.wire=["Registration","Registry","EventBus","Events"];var _initialiseProps=function _initialiseProps(){var _this3=this;this.deleteCompetitor=function(e,id){e.stopPropagation();_this3.Registry.deleteCompetitor(id);_this3.setState({});};this.Competitor=function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{className:'picker',onClick:props.onClick},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,props.person.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,props.person.competitionId),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,props.person.organization),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'pp-delete'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button-close small red',onClick:function onClick(e){return _this3.deleteCompetitor(e,props.person.competitionId);}}))));};};

/***/ }),
/* 297 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Modal */
/* harmony export (immutable) */ __webpack_exports__["a"] = ModalDialog;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal_css__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Modal_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
function Modal(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-shadow'},props.children);}function ModalDialog(_ref){var className=_ref.className,title=_ref.title,children=_ref.children,onClose=_ref.onClose,showClose=_ref.showClose;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-shadow'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-box'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'modal-box-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,title),showClose&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button-close',onClick:onClose})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"modal-box-content"+(className?" "+className:"")},children)));}

/***/ }),
/* 299 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParticipantToolbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toolbar_css__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toolbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Toolbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_Tooltip_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_Tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__general_Tooltip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ParticipantToolbar=function(_React$Component){_inherits(ParticipantToolbar,_React$Component);function ParticipantToolbar(props){_classCallCheck(this,ParticipantToolbar);var _this=_possibleConstructorReturn(this,(ParticipantToolbar.__proto__||Object.getPrototypeOf(ParticipantToolbar)).call(this,props));_this.state={showDialog:false};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.registryUpdated,function(){return _this.setState({});});_this.Registry.initialize();return _this;}_createClass(ParticipantToolbar,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"buttons center content",style:{position:"relative",overflow:"visible"}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button",{className:"button",id:"addButton",onClick:function onClick(e){return _this2.Registration.addParticipant();}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"button button-add small green"})," L\xE4gg till deltagare"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button",{className:"button",id:"meButton",onClick:function onClick(e){return _this2.Registration.addMe();}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"button button-add small green"})," L\xE4gg till mig"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button",{className:this.Registry.competitors.length>0?"button":"button diabled",id:"getButton",onClick:function onClick(e){return _this2.fire(_this2.Events.showParticipantPicker);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"button button-recycle small green"})," H\xE4mta deltagare"));}}]);return ParticipantToolbar;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);ParticipantToolbar.register={name:"ParticipantToolbar"};ParticipantToolbar.wire=["Registration","Registry","Storage","EventBus","Events","Session"];

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegistrationForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Registration_css__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Registration_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Registration_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RegistrationRow__ = __webpack_require__(114);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegistrationForm=function(_React$Component){_inherits(RegistrationForm,_React$Component);function RegistrationForm(){var _ref;var _temp,_this,_ret;_classCallCheck(this,RegistrationForm);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RegistrationForm.__proto__||Object.getPrototypeOf(RegistrationForm)).call.apply(_ref,[this].concat(args))),_this),_this.MinorHeader=function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:props.name,style:{width:props.width+'px',paddingRight:10,verticalAlign:"bottom"},className:'minor'},props.name);},_this.OldRegistrationHeader=function(props){var majorHeaders=[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:'-1',className:'major',colSpan:'3'},'Skytt\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontSize:"x-small",verticalAlign:"top"}},'(* = obligatoriskt f\xE4lt)'))];var minorHeaders=_this.Competition.participantHeaders().map(function(h){return _this.MinorHeader({key:h.name,width:h.width,name:h.name});});if(_this.Competition.eventGroups.length>0){_this.Competition.eventGroups.forEach(function(group){_this.addHeadersFor(_this.Competition.eventList(group.id),group.name,majorHeaders,minorHeaders);});}else{_this.addEventHeadersFor(_this.props.events,majorHeaders,minorHeaders);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,majorHeaders),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,minorHeaders));},_this.RegistrationHeader=function(props){var majorHeaders=[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:'-1',className:'major',colSpan:'3'},'Skytt\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{style:{fontSize:"x-small",verticalAlign:"top"}},'(* = obligatoriskt f\xE4lt)'))];var minorHeaders=_this.Competition.participantHeaders().map(function(h){return _this.MinorHeader({key:h.name,width:h.width,name:h.name});});if(_this.Competition.eventGroups.length>0){_this.Competition.eventGroups.forEach(function(group){_this.addHeadersFor(_this.Competition.eventList(group.id),group.name,majorHeaders,minorHeaders);});}else{_this.addEventHeadersFor(_this.props.events,majorHeaders,minorHeaders);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,majorHeaders),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,minorHeaders));},_this.RegistrationRows=function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,_this.Registration.participants.map(function(p){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__RegistrationRow__["a" /* RegistrationRow */],Object.assign({key:p.id,participant:p,events:_this.props.events},props));}));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RegistrationForm,[{key:'addButtonHeader',value:function addButtonHeader(minorHeaders){minorHeaders.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:minorHeaders.length,className:'minor entry',style:{width:"20px"}},'\xA0'));}},{key:'addMinorHeadersFor',value:function addMinorHeadersFor(event,useEventName,minorHeaders){var initial=minorHeaders.length;if(event.classes&&this.Competition.classes(event.classes)){// Hack to handle nonexisting classGroups
minorHeaders.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:minorHeaders.length,className:'minor entry'},this.Competition.ClassGroups.find(function(c){return c.id===event.classes;}).header||"Klass"));}if(event.divisions&&this.Competition.divisions(event.divisions)){// Hack to handle nonexisting classGroups
minorHeaders.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:minorHeaders.length,className:'minor entry'},this.Competition.DivisionGroups.find(function(c){return c.id===event.divisions;}).header||"Vapengrupp"));}if(event.schedule){if(event.maxRegistrations>1){this.addButtonHeader(minorHeaders);}minorHeaders.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:minorHeaders.length,className:'minor entry'},'Starttid'));if(event.maxRegistrations>1){this.addButtonHeader(minorHeaders);}}if(initial===minorHeaders.length){if(useEventName){minorHeaders.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:minorHeaders.length,className:'minor entry vert'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,event.name.replace(/ /g,'\xA0'))));}else{minorHeaders.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:minorHeaders.length,className:'minor entry'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null)));}}}},{key:'addHeadersFor',value:function addHeadersFor(eventList,majorTitle,majorHeaders,minorHeaders){var _this2=this;var initial=minorHeaders.length;eventList.forEach(function(e){return _this2.addMinorHeadersFor(e,true,minorHeaders);});majorHeaders.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:majorTitle,className:'major',colSpan:minorHeaders.length-initial},majorTitle));}},{key:'addEventHeadersFor',value:function addEventHeadersFor(eventList,majorHeaders,minorHeaders){var _this3=this;eventList.forEach(function(e){var initial=minorHeaders.length;_this3.addMinorHeadersFor(e,false,minorHeaders);majorHeaders.push(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{key:e.id,className:'major',colSpan:minorHeaders.length-initial},e.name.replace(/ /g,'\xA0')));});}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'registration',className:'content',style:{overflow:"visible"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.RegistrationHeader,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.RegistrationRows,null)));}}]);return RegistrationForm;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);RegistrationForm.register={name:"RegistrationForm"};RegistrationForm.wire=["Competition","Registration"];

/***/ }),
/* 302 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = Label;
/* harmony export (immutable) */ __webpack_exports__["a"] = ButtonToolbar;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RegistrationToolbar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toolbar_css__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toolbar_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Toolbar_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_Tooltip_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__general_Tooltip_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__general_Tooltip_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function Label(_ref){var text=_ref.text,align=_ref.align,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"label-box ",style:{alignItems:align}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p",null,text),children);}function ButtonToolbar(_ref2){var className=_ref2.className,children=_ref2.children;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"toolbar "+className},children);}var RegistrationToolbar=function(_React$Component){_inherits(RegistrationToolbar,_React$Component);function RegistrationToolbar(props){_classCallCheck(this,RegistrationToolbar);var _this=_possibleConstructorReturn(this,(RegistrationToolbar.__proto__||Object.getPrototypeOf(RegistrationToolbar)).call(this,props));_this.deleteRegistration=function(act){if(act){_this.Registration.deleteRegistration();}_this.setState({showDialog:false});};_this.state={showDialog:false};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.registryUpdated,function(){return _this.setState({});});_this.Registry.initialize();return _this;}_createClass(RegistrationToolbar,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"buttons center content",style:{position:"relative",overflow:"visible"}},this.state.showDialog&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(this.YesNoDialog,{title:"Bekr\xE4fta avregistrering",text:"\xC4r du s\xE4ker p\xE5 att du vill ta bort anm\xE4lan?",action:this.deleteRegistration}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button",{className:this.Registration.participants.length===0?"button disabled tooltip":"button",id:"registerButton",onClick:function onClick(e){return _this2.fire(_this2.Events.registerForCompetition);},style:{position:"relative"},tooltip:"Klicka h\xE4r f\xF6r att anm\xE4la starter n\xE4r du har lagt till alla skyttar och starter du vill anm\xE4la","tooltip-position":"right"},this.Registration.token?"Uppdatera anmälan":"Anmäl starter"),this.Registration.token&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button",{className:"button unfocus",onClick:function onClick(e){return _this2.setState({showDialog:true});}},"Ta bort anm\xE4lan"),this.Registration.token&&this.Session.user!==""&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input",{type:"button",className:"button unfocus",onClick:this.Registration.newRegistration,value:"Rensa anm\xE4lan"}));}}]);return RegistrationToolbar;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);RegistrationToolbar.register={name:"RegistrationToolbar"};RegistrationToolbar.wire=["Registration","Registry","Storage","EventBus","Events","Session","YesNoDialog"];

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportIndicator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReportIndicator_css__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReportIndicator_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ReportIndicator_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportIndicator=function(_React$Component){_inherits(ReportIndicator,_React$Component);function ReportIndicator(props){_classCallCheck(this,ReportIndicator);var _this=_possibleConstructorReturn(this,(ReportIndicator.__proto__||Object.getPrototypeOf(ReportIndicator)).call(this,props));_this.clearQueue=function(){_this.Results.clearQueue();};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.resultsUpdated,function(){return _this.setState({});});return _this;}_createClass(ReportIndicator,[{key:'render',value:function render(){return this.Results.queue.length===0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'report-indicator button green'},'Inget i k\xF6'):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'report-indicator button red',onClick:this.clearQueue},'\xD7 ',this.Results.queue.length,' resultat i k\xF6');}}]);return ReportIndicator;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);ReportIndicator.register={name:"ReportIndicator"};ReportIndicator.wire=["EventBus","Events","Results"];

/***/ }),
/* 305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReportTable_css__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ReportTable_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ReportTable_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reportTables__ = __webpack_require__(308);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ReportTable=function(_React$Component){_inherits(ReportTable,_React$Component);function ReportTable(){_classCallCheck(this,ReportTable);return _possibleConstructorReturn(this,(ReportTable.__proto__||Object.getPrototypeOf(ReportTable)).apply(this,arguments));}_createClass(ReportTable,[{key:'render',value:function render(){var event=this.props.event;for(var t in __WEBPACK_IMPORTED_MODULE_2__reportTables__){if(typeof __WEBPACK_IMPORTED_MODULE_2__reportTables__[t]==="function"&&__WEBPACK_IMPORTED_MODULE_2__reportTables__[t].disciplines&&__WEBPACK_IMPORTED_MODULE_2__reportTables__[t].disciplines.includes(event.discipline)){var _ReportTable=__WEBPACK_IMPORTED_MODULE_2__reportTables__[t];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_ReportTable,this.props);}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Grenen st\xF6ds tyv\xE4rr inte!');}}]);return ReportTable;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);ReportTable.register={name:"ReportTable"};

/***/ }),
/* 307 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PrecisionReportTable__ = __webpack_require__(309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PrecisionReportTable", function() { return __WEBPACK_IMPORTED_MODULE_0__PrecisionReportTable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FieldReportTable__ = __webpack_require__(310);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldReportTable", function() { return __WEBPACK_IMPORTED_MODULE_1__FieldReportTable__["a"]; });


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrecisionReportTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function Redo(_ref){var stage=_ref.stage,participant=_ref.participant,onChange=_ref.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'participant'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:participant.redo>0,disabled:participant.redo>0&&participant.redo!==stage,onChange:onChange}));}function Note(_ref2){var participant=_ref2.participant,onChange=_ref2.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'participant'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:participant.note||"",onChange:onChange}));}var PrecisionReportTable=function(_React$Component){_inherits(PrecisionReportTable,_React$Component);function PrecisionReportTable(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,PrecisionReportTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=PrecisionReportTable.__proto__||Object.getPrototypeOf(PrecisionReportTable)).call.apply(_ref3,[this].concat(args))),_this),_this.setScore=function(stage,participant,target,value){if(value===""){participant.setScore(stage,target,undefined);}else if(value.toUpperCase()==="X"){participant.setScore(stage,target,"X");}else{value=parseInt(value,10);if(!isNaN(value)&&value>=0&&value<=10){participant.setScore(stage,target,value);}}_this.setState({});},_this.setRedo=function(p,v){p.redo=v;_this.setState({});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrecisionReportTable,[{key:'headers',value:function headers(){return PrecisionReportTable.shots.map(function(i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"hdr"+i,className:'header'},i);});}},{key:'computerTarget',value:function computerTarget(stage,participant,tgt,autoFocus){var _this2=this;var score=participant.getScore(stage,tgt);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{autoFocus:autoFocus,type:'text',className:'score-edit',value:score===undefined?"":score,onChange:function onChange(e){return _this2.setScore(stage,participant,tgt,e.target.value);}});}},{key:'mobileTarget',value:function mobileTarget(stage,participant,tgt){var _this3=this;var score=participant.getScore(stage,tgt);var selected=function selected(v){return score!==undefined&&score.toString()===v?" selected":"";};return PrecisionReportTable.shotValues.map(function(v){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{key:"tgt"+tgt+v,className:'score-button'+selected(v),type:'button',value:v,onClick:function onClick(e){return _this3.setScore(stage,participant,tgt,v);}});});}},{key:'participantClass',value:function participantClass(className,participant,position){return className+" participant"+(participant.error?" error":"")+(position!=null&&position%2===0?" even":"");}},{key:'targets',value:function targets(stage,participant,id){var _this4=this;return PrecisionReportTable.shots.map(function(num,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"tgt"+id+num,className:_this4.participantClass("input",participant,i)},_this4.props.mode===__WEBPACK_IMPORTED_MODULE_1__models__["Mode"].computer?_this4.computerTarget(stage,participant,i,id===0&&i===0):_this4.mobileTarget(stage,participant,i));});}},{key:'participantRow',value:function participantRow(stage,p,id){var _this5=this;var setNote=function setNote(p,v){p.note=v;_this5.setState({});};return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"pos"+id,className:this.participantClass("",p)},p.position),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"name"+id,className:this.participantClass("align-left",p)},p.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"sup"+id,className:this.participantClass("",p)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',disabled:true,tabIndex:'-1',checked:p.support===1})),[].concat(_toConsumableArray(this.targets(stage,p,id))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'participant',key:"t"+id},p.getPrecisionTotal(stage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Redo,{stage:stage,participant:p,key:"m"+id,onChange:function onChange(e){return _this5.setRedo(p,e.target.checked?stage:0);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Note,{participant:p,key:"n"+id,onChange:function onChange(e){return setNote(p,e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'align-left',key:"spc"+id},p.error)];}},{key:'render',value:function render(){var _this6=this;var _props=this.props,stage=_props.stage,scores=_props.scores;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"score-sheet field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},'Pos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header align-left'},'Namn'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},'St\xF6d'),this.headers(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},'Total'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},'Omskj.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header align-left'},'Anteckning'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'null align-left'}),scores.map(function(p,i){return _this6.participantRow(stage,p,i);}).flat());}}]);return PrecisionReportTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PrecisionReportTable.shots=[1,2,3,4,5];PrecisionReportTable.shotValues=["0","1","2","3","4","5","6","7","8","9","10","X"];PrecisionReportTable.disciplines=[__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].target];

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldReportTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function Redo(_ref){var stage=_ref.stage,participant=_ref.participant,onChange=_ref.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'participant'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:participant.redo>0,disabled:participant.redo>0&&participant.redo!==stage,onChange:onChange}));}function Note(_ref2){var participant=_ref2.participant,onChange=_ref2.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'participant'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'text',value:participant.note||"",onChange:onChange}));}var FieldReportTable=function(_React$Component){_inherits(FieldReportTable,_React$Component);function FieldReportTable(){var _ref3,_this2=this;var _temp,_this,_ret;_classCallCheck(this,FieldReportTable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=FieldReportTable.__proto__||Object.getPrototypeOf(FieldReportTable)).call.apply(_ref3,[this].concat(args))),_this),_this.setScore=function(stageDef,participant,target,value){value=parseInt(value,10);participant.setScore(stageDef.num,target,isNaN(value)?undefined:value);_this.setState({});},_this.setValue=function(participant,stageDef,value){value=parseInt(value,10);participant.setScore(stageDef.num,stageDef.targets,isNaN(value)?undefined:value);_this.setState({});},_this.MobileTarget=function(props){var stageDef=props.stageDef,participant=props.participant,tgt=props.tgt;var score=participant.getScore(stageDef.num,tgt);var selected=function selected(v){return score!==undefined&&score===v?" selected":"";};return FieldReportTable.targetValues.filter(function(v){return v<=stageDef.max;}).map(function(v){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{key:"tgt"+tgt+v,className:'score-button'+selected(v),type:'button',value:v,onClick:function onClick(e){return _this.setScore(stageDef,participant,tgt,v);}});});},_this.ComputerTarget=function(props){var stageDef=props.stageDef,participant=props.participant,tgt=props.tgt,autoFocus=props.autoFocus;var score=participant.getScore(stageDef.num,tgt);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{autoFocus:autoFocus,type:'text',className:'score-edit',value:score===undefined?"":score,onChange:function onChange(e){return _this.setScore(stageDef,participant,tgt,e.target.value);}});},_this.MobileValue=function(_ref4){var stageDef=_ref4.stageDef,participant=_ref4.participant,score=_ref4.score;var singles=score%10||0;var tens=Math.floor(score/10)*10||0;var i=0;var selected=function selected(s){return s?" selected":"";};var setValue=function setValue(v,present,other){return _this.setValue(participant,stageDef,(v===present?0:v)+other);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'mobile-target'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,FieldReportTable.tenValues.map(function(v){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{key:'v'+i++,className:'score-button'+selected(v===tens),type:'button',value:v,onClick:function onClick(){return setValue(v,tens,singles);}});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,FieldReportTable.singleValues.map(function(v){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{key:'v'+i++,className:'score-button'+selected(v===singles),type:'button',value:v,onClick:function onClick(){return setValue(v,singles,tens);}});})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{key:'v'+i++,className:'score-button'+selected(score!==undefined&&score===0),type:'button',value:0,onClick:function onClick(e){return _this.setValue(participant,stageDef,0);}})));},_this.ComputerValue=function(_ref5){var stageDef=_ref5.stageDef,participant=_ref5.participant,score=_ref5.score;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'score-text',type:'text',size:'2',value:score===undefined?"":score,onChange:function onChange(e){return _this.setValue(participant,stageDef,e.target.value);}});},_this.Value=function(_ref6){var stageDef=_ref6.stageDef,participant=_ref6.participant;if(!stageDef.value)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null);var score=participant.getScore(stageDef.num,stageDef.targets);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:_this.participantClass("input",participant,1)},_this.props.mode===__WEBPACK_IMPORTED_MODULE_1__models__["Mode"].computer?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.ComputerValue,{stageDef:stageDef,participant:participant,score:score}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.MobileValue,{stageDef:stageDef,participant:participant,score:score}));},_this.setNote=function(p,v){p.note=v;_this.setState({});},_this.setRedo=function(p,v){p.redo=v;_this.setState({});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FieldReportTable,[{key:'headers',value:function headers(stageDef){return FieldReportTable.fieldTargetIds.map(function(i){return stageDef!==undefined&&i<stageDef.targets?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"hdr"+i,className:'header'},FieldReportTable.fieldTargets[i]):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"hdr"+i,className:'null'});});}},{key:'participantClass',value:function participantClass(className,participant,position){return className+" participant"+(participant.error?" error":"")+(position!=null&&position%2===0?" even":"");}},{key:'targets',value:function targets(stageDef,participant,id,first){var _this3=this;return FieldReportTable.fieldTargetIds.map(function(i){return i<stageDef.targets?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"tgt"+id+i,className:_this3.participantClass("input",participant,i)},_this3.props.mode===__WEBPACK_IMPORTED_MODULE_1__models__["Mode"].computer?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this3.ComputerTarget,{stageDef:stageDef,participant:participant,tgt:i,autoFocus:first&&i===0}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this3.MobileTarget,{stageDef:stageDef,participant:participant,tgt:i})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"tgt"+id+i});});}},{key:'participantRow',value:function participantRow(stageDef,p,id,first){var _this4=this;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"pos"+id,className:this.participantClass("",p)},p.position),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"name"+id,className:this.participantClass("align-left",p)},p.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"sup"+id,className:this.participantClass("",p)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',disabled:true,tabIndex:'-1',checked:p.support===1})),[].concat(_toConsumableArray(this.targets(stageDef,p,id,first))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'participant',key:"t"+id},p.getStageTotal(stageDef)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.Value,{stageDef:stageDef,participant:p,key:"v"+id}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Redo,{stage:stageDef.num,participant:p,key:"m"+id,onChange:function onChange(e){return _this4.setRedo(p,e.target.checked?stageDef.num:0);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Note,{participant:p,key:"n"+id,onChange:function onChange(e){return _this4.setNote(p,e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'align-left',key:"spc"+id},p.error)];}},{key:'render',value:function render(){var _this5=this;var _props=this.props,event=_props.event,stage=_props.stage,scores=_props.scores;var stageDef=event.stages.find(function(s){return s.num===stage;});var id=0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"score-sheet field"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},'Pos'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header align-left'},'Namn'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},'St\xF6d'),this.headers(stageDef),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},'Total'),stageDef.value?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},'Po\xE4ng'):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'null'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header'},'Omskj.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'header align-left'},'Anteckning'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'null align-left'}),scores.map(function(p,i){return _this5.participantRow(stageDef,p,id++,i===0);}).flat());}}]);return FieldReportTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);FieldReportTable.fieldTargets=["1","2","3","4","5","6"];FieldReportTable.fieldTargetIds=[0,1,2,3,4,5];FieldReportTable.targetValues=[0,1,2,3,4,5,6];FieldReportTable.singleValues=[1,2,3,4,5,6,7,8,9];FieldReportTable.tenValues=[10,20,30];FieldReportTable.disciplines=[__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].fieldP,__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].fieldK,__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].scoredP,__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].scoredK];

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultsTable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
function Round({ participant, round, change }) {
	let rounds = [];
	for (let j = 0; j < participant.score[round].length; j++) {
		if (j > 0) {
			rounds.push(" / ");
		}
		rounds.push(<input key={j} className="score" value={participant.score[round][j]} size="2" onChange={e => change(round, j, e.target.value)} />);
	}
	return rounds;
}

function Scores({ participant, change }) {
	let scores = [];
	for (let i = 0; i < participant.score.length; i++) {
		scores.push(<td key={i} className="score">
			<Round participant={participant} round={i} change={change} />
		</td>);
	}
	return scores;
}

function Sum({ participant }) {
	return <td className="score">{participant.total.join("/")}</td>;
}
//*/function series(stages){return stages.map(function(s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{key:s.num,className:"stage"},s.num);});}var ResultsTable=function(_React$Component){_inherits(ResultsTable,_React$Component);function ResultsTable(){_classCallCheck(this,ResultsTable);return _possibleConstructorReturn(this,(ResultsTable.__proto__||Object.getPrototypeOf(ResultsTable)).apply(this,arguments));}_createClass(ResultsTable,[{key:"render",value:function render(){var _props=this.props,results=_props.results,squad=_props.squad;var scores=results.scores;if(squad){scores=scores.filter(function(s){return s.squad===squad;});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Namn"),series(results.stages),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Summa"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,scores.map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{key:p.id,className:p.dirty&&"dirty"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,p.name));})));}}]);return ResultsTable;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ResultsTable.register={name:"ResultsTable"};

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScheduleProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduleProperties_css__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScheduleProperties_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ScheduleProperties_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tables_css__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tables_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tables_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logic__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__general__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6____ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScheduleProperties=function(_React$Component){_inherits(ScheduleProperties,_React$Component);function ScheduleProperties(props){_classCallCheck(this,ScheduleProperties);var _this=_possibleConstructorReturn(this,(ScheduleProperties.__proto__||Object.getPrototypeOf(ScheduleProperties)).call(this,props));_this.schedules=[];_this.editSchedule=function(event){// Create new schedule if one doesn't exist
if(event.schedule===undefined){_this.Server.createSchedule(new __WEBPACK_IMPORTED_MODULE_4__models__["Schedule"]("2:00",event.divisions).toJson(),function(schedule){event.schedule=schedule.id;_this.loadScheduleInformation(event,schedule);_this.Competition.updateEvent(event);},_this.Footers.errorHandler("Kan inte skapa schema"));return;}// Test schedule to handle old data format; patch event if old format
var scheduleId=parseInt(event.schedule.toString(),10);if(isNaN(scheduleId)){var schedule=event.schedule;event.schedule=schedule.id;_this.loadScheduleInformation(event,schedule);return;}// Schedule exists; load and show it
_this.Server.loadSchedule(scheduleId,function(schedule){_this.loadScheduleInformation(event,schedule);},_this.Footers.errorHandler("Kan inte hämta schema"));};_this.updateSlots=function(v){var newVal=v;if(typeof v==='string'){newVal=parseInt(v,10);}if(isNaN(newVal)||newVal<0){return;}_this.setState({slots:newVal});};_this.updateInterval=function(e){var newInterval=parseInt(e.target.value,10);if(isNaN(newInterval)){return;}_this.setState({interval:newInterval});};_this.addSquad=function(){var _this$state=_this.state,startTime=_this$state.startTime,slots=_this$state.slots,selectedDivisions=_this$state.selectedDivisions,mixDivisions=_this$state.mixDivisions,interval=_this$state.interval;_this.state.schedule.addSquad(startTime,slots,selectedDivisions,mixDivisions);_this.setState({startTime:__WEBPACK_IMPORTED_MODULE_3__logic__["Time"].format(__WEBPACK_IMPORTED_MODULE_3__logic__["Time"].timeFromText(startTime)+interval)});};_this.deleteSquad=function(s){_this.state.schedule.deleteSquad(s);_this.setState({});};_this.updateSquadProperty=function(id,property,value){_this.state.schedule.updateSquadProperty(id,property,value);};_this.selectDivision=function(d){var newDivisions=_this.state.selectedDivisions;_this.setState({selectedDivisions:newDivisions.includes(d)?newDivisions.filter(function(x){return x!==d;}):newDivisions.concat([d])});};_this.onClose=function(){var schedule=_this.state.schedule;schedule.duration=_this.state.duration;schedule.divisionGroup=_this.state.event.divisions||0;_this.Server.updateSchedule(schedule.toJson(),function(){},_this.Footers.errorHandler("Kan inte spara schema"));_this.setState({schedule:undefined});};_this.onDelete=function(){_this.Server.deleteSchedule(_this.state.schedule.id,function(){_this.Competition.updateEvent(_this.state.event,"schedule",undefined);_this.setState({schedule:undefined});},_this.Footers.errorHandler("Kan inte ta bort schema"));};_this.state={};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.editSchedule,_this.editSchedule);return _this;}_createClass(ScheduleProperties,[{key:'allDivisions',value:function allDivisions(event){return event&&event.divisions?this.Competition.divisions(event.divisions).filter(function(d){return d.charAt(0)!=='!';}):undefined;}},{key:'newScheduleInformation',value:function newScheduleInformation(event,schedule){this.schedules[schedule.id]={slots:8,startTime:"8:00",interval:10,duration:schedule.duration,mixDivisions:true,selectedDivisions:this.allDivisions(event)||[],event:event,schedule:schedule};return this.schedules[schedule.id];}},{key:'loadScheduleInformation',value:function loadScheduleInformation(event,schedule){schedule=__WEBPACK_IMPORTED_MODULE_4__models__["Schedule"].fromJson(schedule);var newState=this.schedules[schedule.id]||this.newScheduleInformation(event,schedule);newState.duration=schedule.duration;var allDiv=this.allDivisions(event);newState.allDivisions=this.allDivisions(event);newState.schedule.squads.forEach(function(s){return s.divisions=s.divisions.filter(function(d){return allDiv&&allDiv.some(function(a){return a===d;});});});this.setState(newState);}},{key:'updateStartTime',value:function updateStartTime(t){if(!__WEBPACK_IMPORTED_MODULE_3__logic__["Time"].canSetTime(t)){return;}this.setState({startTime:t});}},{key:'blurStartTime',value:function blurStartTime(t){this.setState({startTime:__WEBPACK_IMPORTED_MODULE_3__logic__["Time"].format(__WEBPACK_IMPORTED_MODULE_3__logic__["Time"].timeFromText(t))});}},{key:'updateDuration',value:function updateDuration(t){if(!__WEBPACK_IMPORTED_MODULE_3__logic__["Time"].canSetTime(t)){return;}this.setState({duration:t});}},{key:'blurDuration',value:function blurDuration(t){this.setState({duration:__WEBPACK_IMPORTED_MODULE_3__logic__["Time"].format(__WEBPACK_IMPORTED_MODULE_3__logic__["Time"].durationFromText(t))});}},{key:'render',value:function render(){var _this2=this;if(this.state.schedule===undefined){return null;}var allDivisions=this.state.allDivisions;var rowWidth=11.0;if(allDivisions){// ToDo: update
rowWidth+=4;allDivisions.forEach(function(d){return rowWidth+=d.length+0.5;});}rowWidth=rowWidth+"em";return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__general__["a" /* ModalDialog */],{className:'schedule-properties',title:'Skjutlag/patruller',onClose:this.onClose,showClose:'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["ButtonToolbar"],{className:'schedule-tools'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["Label"],{text:'Starttid'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{className:'schedule-property',value:this.state.startTime,size:'5',onChange:function onChange(e){return _this2.updateStartTime(e.target.value);},onBlur:function onBlur(e){return _this2.blurStartTime(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["Label"],{text:'Platser',align:'center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["Spinner"],{className:'schedule-property',value:this.state.slots,onChange:this.updateSlots})),allDivisions&&allDivisions.map(function(d){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["Label"],{key:d,text:d,align:'center'},' ',__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'checkbox',checked:_this2.state.selectedDivisions.includes(d),onChange:function onChange(e){return _this2.selectDivision(d);}}));}),allDivisions&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["Label"],{text:'Blanda',align:'center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{type:'checkbox',checked:this.state.mixDivisions,onChange:function onChange(e){return _this2.setState({mixDivisions:e.target.checked});}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["Label"],{text:'Tid till n\xE4sta',align:'center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{className:'schedule-property',value:this.state.interval,onChange:this.updateInterval})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["Label"],{text:'Tids\xE5tg\xE5ng',align:'center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('input',{className:'schedule-property',value:this.state.duration,onChange:function onChange(e){return _this2.updateDuration(e.target.value);},onBlur:function onBlur(e){return _this2.blurDuration(e.target.value);}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["Label"],{text:'L\xE4gg till',align:'center'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'button-add green schedule-property',onClick:this.addSquad}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'schedule-table'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('table',{className:'table-light',style:{minWidth:rowWidth,maxWidth:rowWidth,width:rowWidth}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{className:'schedule-start-time'},'Tid'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{className:'schedule-slots'},'Platser'),allDivisions&&allDivisions.map(function(d){var w=d.length+0.5+"em";return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{key:d,className:'schedule-division',style:{minWidth:w,maxWidth:w,width:w}},d);}),allDivisions&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{className:'schedule-mix'},'Blanda'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{className:'schedule-delete'},'Radera'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{className:'schedule-pad'}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tbody',null,this.state.schedule.squads.map(function(s){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6____["SquadProperties"],{key:s.id,squad:s,divisions:allDivisions,onUpdate:_this2.updateSquadProperty,onDelete:_this2.deleteSquad});})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-buttons'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'button white',onClick:this.onDelete},'Radera'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'button',onClick:this.onClose},'OK')));}}]);return ScheduleProperties;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);ScheduleProperties.register={name:"ScheduleProperties"};ScheduleProperties.wire=["Events","EventBus","Competition","Server","Footers"];

/***/ }),
/* 313 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scorecard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Scorecard_css__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Scorecard_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Scorecard_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scorecards__ = __webpack_require__(316);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Scorecard=function(_React$Component){_inherits(Scorecard,_React$Component);function Scorecard(){_classCallCheck(this,Scorecard);return _possibleConstructorReturn(this,(Scorecard.__proto__||Object.getPrototypeOf(Scorecard)).apply(this,arguments));}_createClass(Scorecard,[{key:'render',value:function render(){var _props=this.props,competition=_props.competition,event=_props.event,show=_props.show,results=_props.results;results=results.flat();var participant=results.find(function(p){return p.id===show;});if(participant===undefined){return null;}for(var c in __WEBPACK_IMPORTED_MODULE_3__scorecards__){if(__WEBPACK_IMPORTED_MODULE_3__scorecards__[c].disciplines&&__WEBPACK_IMPORTED_MODULE_3__scorecards__[c].disciplines.includes(event.discipline)&&(competition.permissions>=__WEBPACK_IMPORTED_MODULE_2__models__["Permissions"].Admin?__WEBPACK_IMPORTED_MODULE_3__scorecards__[c].editable:!__WEBPACK_IMPORTED_MODULE_3__scorecards__[c].editable)){var Card=__WEBPACK_IMPORTED_MODULE_3__scorecards__[c];return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'scorecard-header'},participant.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Card,Object.assign({},this.props,{participant:participant})));}}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'scorecard-header'},participant.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Grenen st\xF6ds inte'));}}]);return Scorecard;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/***/ }),
/* 315 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EditFieldScorecard__ = __webpack_require__(317);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EditFieldScorecard", function() { return __WEBPACK_IMPORTED_MODULE_0__EditFieldScorecard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EditPrecisionScorecard__ = __webpack_require__(318);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EditPrecisionScorecard", function() { return __WEBPACK_IMPORTED_MODULE_1__EditPrecisionScorecard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FieldScorecard__ = __webpack_require__(319);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FieldScorecard", function() { return __WEBPACK_IMPORTED_MODULE_2__FieldScorecard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PrecisionScorecard__ = __webpack_require__(320);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PrecisionScorecard", function() { return __WEBPACK_IMPORTED_MODULE_3__PrecisionScorecard__["a"]; });


/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditFieldScorecard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Inputs__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditFieldScorecard=function(_React$Component){_inherits(EditFieldScorecard,_React$Component);function EditFieldScorecard(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,EditFieldScorecard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EditFieldScorecard.__proto__||Object.getPrototypeOf(EditFieldScorecard)).call.apply(_ref,[this].concat(args))),_this),_this.Header=function(){var i=1;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'Station'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'Totalt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'Po\xE4ng'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'Omskjutning')];},_this.updateValue=function(stage,tgt,value){var participant=_this.props.participant;participant.setScore(stage.num,tgt,value||0);_this.setState({});},_this.Target=function(_ref2){var stage=_ref2.stage,score=_ref2.score,tgt=_ref2.tgt;return tgt<=stage.targets?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:"2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Inputs__["e" /* TextInput */],{mask:'0123456',value:score===undefined?"":score,size:'1',style:{width:"2ex"},onChange:function onChange(e){return _this.updateValue(stage,tgt-1,parseInt(e.target.value,10));}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'unused'});},_this.Value=function(_ref3){var stage=_ref3.stage,score=_ref3.score;return stage.value?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{padding:"2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Inputs__["e" /* TextInput */],{mask:'0123456789',value:score.values[stage.targets]===undefined?"":score.values[stage.targets],onChange:function onChange(e){return _this.updateValue(stage,stage.targets,parseInt(e.target.value,10));},size:'2'})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'unused'});},_this.Stage=function(_ref4){var stage=_ref4.stage,participant=_ref4.participant;var i=1;var score=participant.scores.find(function(s){return s.stage===stage.num;})||[];return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:""+stage.num+i++},stage.num),EditFieldScorecard.targets.map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.Target,{key:""+stage.num+i++,stage:stage,tgt:t,score:score.values[t-1]});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:""+stage.num+i++},participant.getStageTotal(stage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.Value,{key:""+stage.num+i++,stage:stage,score:score}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:""+stage.num+i++},participant.redo===stage.num?"Ja":"")];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EditFieldScorecard,[{key:'render',value:function render(){var _this3=this;var _props=this.props,event=_props.event,participant=_props.participant;var stages=event.stages.sort(function(a,b){return a.num-b.num;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scorecard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.Header,null),stages.flatMap(function(s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this3.Stage,{key:"s"+s.num,stage:s,participant:participant});}));}}]);return EditFieldScorecard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);EditFieldScorecard.disciplines=[__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].fieldP,__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].fieldK,__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].scoredP,__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].scoredK];EditFieldScorecard.editable=true;EditFieldScorecard.targets=[1,2,3,4,5,6];

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EditPrecisionScorecard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Inputs__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EditPrecisionScorecard=function(_React$Component){_inherits(EditPrecisionScorecard,_React$Component);function EditPrecisionScorecard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EditPrecisionScorecard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EditPrecisionScorecard.__proto__||Object.getPrototypeOf(EditPrecisionScorecard)).call.apply(_ref,[this].concat(args))),_this),_this.Header=function(){var i=1;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'Station'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'Totalt')];},_this.updateValue=function(participant,stage,tgt,value){if(value===""){participant.setScore(stage,tgt,undefined);}else if(value.toUpperCase()==="X"){participant.setScore(stage,tgt,"X");}else{value=parseInt(value,10);if(!isNaN(value)&&value>=0&&value<=10){participant.setScore(stage,tgt,value);}}_this.setState({});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EditPrecisionScorecard,[{key:'stage',value:function stage(num,participant){var _this2=this;var score=participant.scores.find(function(s){return s.stage===num;})||[];return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"name"+num},num),EditPrecisionScorecard.targets.map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"shot"+num+"-"+i,style:{padding:"2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Inputs__["e" /* TextInput */],{mask:'0123456789xX',value:score.values[i]===undefined?"":score.values[i],size:'2',style:{width:"3ex"},onChange:function onChange(e){return _this2.updateValue(participant,num,i,e.target.value);}}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"tot"+num},participant.getPrecisionTotal(num))];}},{key:'render',value:function render(){var _this3=this;var _props=this.props,event=_props.event,participant=_props.participant;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scorecard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.Header,null),new Array(event.scores).fill(null).flatMap(function(n,i){return _this3.stage(i+1,participant);}));}}]);return EditPrecisionScorecard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);EditPrecisionScorecard.disciplines=[__WEBPACK_IMPORTED_MODULE_2__models__["Discipline"].target];EditPrecisionScorecard.editable=true;EditPrecisionScorecard.targets=[1,2,3,4,5];

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FieldScorecard; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FieldScorecard=function(_React$Component){_inherits(FieldScorecard,_React$Component);function FieldScorecard(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,FieldScorecard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FieldScorecard.__proto__||Object.getPrototypeOf(FieldScorecard)).call.apply(_ref,[this].concat(args))),_this),_this.Header=function(){var i=1;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'Station'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'6'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'Totalt'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'Po\xE4ng'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'Omskjutning')];},_this.Target=function(_ref2){var stage=_ref2.stage,score=_ref2.score,tgt=_ref2.tgt;return tgt<=stage.targets?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,score||""):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'unused'});},_this.Value=function(_ref3){var stage=_ref3.stage,score=_ref3.score;return stage.value?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,score.values[stage.targets]!==undefined?score.values[stage.targets]:""):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'unused'});},_this.Stage=function(_ref4){var stage=_ref4.stage,participant=_ref4.participant;var i=1;var score=participant.scores.find(function(s){return s.stage===stage.num;})||[];return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:""+stage.num+i++},stage.num),FieldScorecard.targets.map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.Target,{key:""+stage.num+i++,stage:stage,tgt:t,score:score.values[t-1]});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:""+stage.num+i++},participant.getStageTotal(stage)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.Value,{key:""+stage.num+i++,stage:stage,score:score}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:""+stage.num+i++},participant.redo===stage.num?"Ja":"")];},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FieldScorecard,[{key:'render',value:function render(){var _this3=this;var _props=this.props,event=_props.event,participant=_props.participant;var stages=event.stages.sort(function(a,b){return a.num-b.num;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scorecard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.Header,null),stages.flatMap(function(s){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this3.Stage,{key:"s"+s.num,stage:s,participant:participant});}));}}]);return FieldScorecard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);FieldScorecard.disciplines=[__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].fieldP,__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].fieldK,__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].scoredP,__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].scoredK];FieldScorecard.targets=[1,2,3,4,5,6];

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PrecisionScorecard; });
/* unused harmony export EditPrecisionScorecard */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Inputs__ = __webpack_require__(32);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var PrecisionScorecard=function(_React$Component){_inherits(PrecisionScorecard,_React$Component);function PrecisionScorecard(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PrecisionScorecard);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PrecisionScorecard.__proto__||Object.getPrototypeOf(PrecisionScorecard)).call.apply(_ref,[this].concat(args))),_this),_this.Target=function(num,i,participant,score){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"shot"+num+"-"+i},score||"");},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PrecisionScorecard,[{key:'Header',value:function Header(){var i=1;return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'Station'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'2'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'3'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'5'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"h"+i++,className:'header'},'Totalt')];}},{key:'stage',value:function stage(num){var _this2=this;var participant=this.props.participant;var score=participant.scores.find(function(s){return s.stage===num;})||[];return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"name"+num},num),PrecisionScorecard.targets.map(function(t,i){return _this2.Target(num,i,participant,score.values[i]===undefined?"":score.values[i]);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"tot"+num},participant.getPrecisionTotal(num))];}},{key:'render',value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'scorecard'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.Header,null),new Array(this.props.event.scores).fill(null).flatMap(function(n,i){return _this3.stage(i+1,_this3.props.participant);}));}}]);return PrecisionScorecard;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);PrecisionScorecard.disciplines=[__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].target];PrecisionScorecard.targets=[1,2,3,4,5];var EditPrecisionScorecard=function(_PrecisionScorecard){_inherits(EditPrecisionScorecard,_PrecisionScorecard);function EditPrecisionScorecard(){var _ref2;var _temp2,_this4,_ret2;_classCallCheck(this,EditPrecisionScorecard);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this4=_possibleConstructorReturn(this,(_ref2=EditPrecisionScorecard.__proto__||Object.getPrototypeOf(EditPrecisionScorecard)).call.apply(_ref2,[this].concat(args))),_this4),_this4.updateValue=function(participant,stage,tgt,value){if(value===""){participant.setScore(stage,tgt,undefined);}else if(value.toUpperCase()==="X"){participant.setScore(stage,tgt,"X");}else{value=parseInt(value,10);if(!isNaN(value)&&value>=0&&value<=10){participant.setScore(stage,tgt,value);}}_this4.setState({});},_this4.Target=function(num,i,participant,score){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:"shot"+num+"-"+i,style:{padding:"2px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Inputs__["e" /* TextInput */],{mask:'0123456789xX',value:score,size:'2',style:{width:"3ex"},onChange:function onChange(e){return _this4.updateValue(participant,num,i,e.target.value);}}));},_temp2),_possibleConstructorReturn(_this4,_ret2);}return EditPrecisionScorecard;}(PrecisionScorecard);EditPrecisionScorecard.disciplines=[__WEBPACK_IMPORTED_MODULE_1__models__["Discipline"].target];EditPrecisionScorecard.editable=true;

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SquadPicker; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SquadPicker_css__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SquadPicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__SquadPicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logic__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SquadPicker=function(_React$Component){_inherits(SquadPicker,_React$Component);function SquadPicker(props){_classCallCheck(this,SquadPicker);var _this=_possibleConstructorReturn(this,(SquadPicker.__proto__||Object.getPrototypeOf(SquadPicker)).call(this,props));_this.loadSchedules=function(scheduleIds,schedules,callback){if(scheduleIds.length>0){_this.Busy.setBusy("sqPick",true);var scheduleId=scheduleIds.pop();_this.Server.loadSchedule(scheduleId,function(json){_this.Server.loadParticipants(scheduleId,function(pJson){schedules.push(__WEBPACK_IMPORTED_MODULE_3__models__["Schedule"].fromJson(json,pJson));_this.loadSchedules(scheduleIds,schedules,callback);},_this.Footers.errorHandler("Kan inte hämta deltagare"));},_this.Footers.errorHandler("Kan inte hämta schema"));}else{_this.Busy.setBusy("sqPick",false);callback(schedules);}};_this.getDefaultDivision=function(eventDivisions){if(eventDivisions===undefined)return undefined;return _this.Competition.divisions(eventDivisions)[0];};_this.showSchedule=function(participant,event,round){_this.loadSchedules(_this.Competition.events.map(function(e){return e.schedule;}).filter(function(s){return s!==undefined;}),[],function(schedules){_this.setState({schedules:schedules,event:event,participant:participant,round:round,division:participant.getDivision(event.id,round)||_this.getDefaultDivision(event.divisions)});});};_this.selectSquad=function(squad){var _this$state=_this.state,participant=_this$state.participant,event=_this$state.event,round=_this$state.round;if(squad===undefined){_this.EventBus.fire(_this.Events.selectSquad,participant.id,event.id,round,null);_this.setState({participant:undefined});return;}if(!_this.canRegister(squad))return;_this.EventBus.fire(_this.Events.selectSquad,participant.id,event.id,round,squad);_this.setState({participant:undefined});};_this.getSchedule=function(scheduleId){return _this.state.schedules.find(function(s){return s.id===scheduleId;});};_this.toggleExpand=function(e,squad){e.stopPropagation();squad.expand=!squad.expand;_this.setState({});};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.showSchedule,_this.showSchedule);_this.subscribe(_this.Events.registrationUpdated,function(){return _this.setState({participant:undefined});});_this.state={};return _this;}_createClass(SquadPicker,[{key:'squadStatus',value:function squadStatus(squad){if(squad.slots===squad.participants.length){return"full";}if(squad.participants.length===0){return"empty";}return"partial";}},{key:'allowedDivisions',value:function allowedDivisions(squad){if(squad.mixed)return squad.divisions;if(squad.participants.length>0)return squad.divisions.filter(function(d){return squad.participants.some(function(p){return d.includes(p.division);});});return squad.divisions;}},{key:'timeFromSquad',value:function timeFromSquad(eventId,squadId){var event=this.Competition.event(eventId);var schedule=this.getSchedule(event.schedule);var startTime=__WEBPACK_IMPORTED_MODULE_2__logic__["Time"].timeFromText(schedule.squads.find(function(s){return s.id===squadId;}).startTime);return{from:startTime,to:startTime+__WEBPACK_IMPORTED_MODULE_2__logic__["Time"].timeFromText(schedule.duration),date:event.date};}},{key:'calculateStartTimes',value:function calculateStartTimes(){var _ref,_this2=this;var p=this.state.participant;var registeredSquads=(_ref=[]).concat.apply(_ref,_toConsumableArray(p.registrationInfo.map(function(ri){return ri.rounds.map(function(rd){return{event:ri.event,squad:rd.squad};});})));registeredSquads=registeredSquads.filter(function(s){return s.squad!==undefined;}).filter(function(s){return s.squad!==p.registrationInfo.filter(function(ri){return ri.event===_this2.state.event.id;}).map(function(ev){return ev.rounds[_this2.state.round].squad;}).find(function(s){return true;});})// Remove current registration from consideration
.map(function(st){return _this2.timeFromSquad(st.event,st.squad);}).filter(function(st){return st.date.valueOf()===_this2.state.event.date.valueOf();});return registeredSquads;}},{key:'allowedStartTime',value:function allowedStartTime(squad){var times=this.calculateStartTimes();var myTime=this.timeFromSquad(this.state.event.id,squad.id);return!times.some(function(t){return t.from>=myTime.from&&t.from<myTime.to||t.to<=myTime.to&&t.to>myTime.from||myTime.from>=t.from&&myTime.from<t.to||myTime.to<=t.to&&myTime.to>t.from;});}},{key:'canRegister',value:function canRegister(squad){var _this3=this;return this.squadStatus(squad)!=="full"&&this.allowedStartTime(squad)&&(this.state.division===undefined||this.allowedDivisions(squad).some(function(d){return d.includes(_this3.state.division);}));}},{key:'squadHeader',value:function squadHeader(squad){var _this4=this;var className=this.squadStatus(squad)+(this.canRegister(squad)?" selectable":" unavailable");return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:squad.id,className:className,onClick:function onClick(e){return _this4.selectSquad(squad);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'time'},squad.startTime),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,this.allowedDivisions(squad).join()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,squad.participants.length+' / '+squad.slots),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,squad.participants.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:squad.expand?"button-collapse small":"button-expand small",onClick:function onClick(e){return _this4.toggleExpand(e,squad);}})));}},{key:'renderParticipant',value:function renderParticipant(p){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',{key:p.id,className:'participant'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',{className:'time'},p.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,p.division),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,'\xA0'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('td',null,'\xA0'));}},{key:'renderSquad',value:function renderSquad(squad){var _this5=this;var rows=[];rows.push(this.squadHeader(squad));if(squad.expand&&squad.participants.length>0){rows=rows.concat(squad.participants.map(function(p){return _this5.renderParticipant(p);}));}return rows;}},{key:'render',value:function render(){var _this6=this;if(this.state.participant===undefined)return null;var schedule=this.getSchedule(this.state.event.schedule);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'squad-picker'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'squad-picker-header'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'Starttider'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button-close medium',onClick:function onClick(){return _this6.setState({participant:undefined});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{overflowY:"auto"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('table',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',{className:'time'},'Tid'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Vapengrupp'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null,'Platser'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('th',null))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('tbody',null,schedule&&schedule.squads&&schedule.squads.map(function(s){return _this6.renderSquad(s);})))),this.state.participant.getStartTime(this.state.event.id,this.state.round)!==undefined&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'center'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button small no-squad',onClick:function onClick(e){return _this6.selectSquad(undefined);}},'Ta bort starttid')));}}]);return SquadPicker;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);SquadPicker.register={name:"SquadPicker"};SquadPicker.wire=["EventBus","Events","Server","Competition","Footers","Busy"];

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SquadProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__logic__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SquadProperties=function(_React$Component){_inherits(SquadProperties,_React$Component);function SquadProperties(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SquadProperties);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SquadProperties.__proto__||Object.getPrototypeOf(SquadProperties)).call.apply(_ref,[this].concat(args))),_this),_this.selectDivision=function(d){var n=_this.props.squad.divisions;_this.updateSquadProperty("divisions",n.includes(d)?n.filter(function(x){return x!==d;}):n.concat([d]));_this.setState({});},_this.changeSlots=function(n){if(n===""||!n.match(/^\d*$/)){return;}var newVal=parseInt(n,10);if(isNaN(newVal)||newVal<0){return;}_this.updateSquadProperty("slots",newVal);_this.setState({});},_this.changeStartTime=function(t){if(!__WEBPACK_IMPORTED_MODULE_1__logic__["Time"].canSetTime(t)){return;}_this.updateSquadProperty("startTime",t);_this.setState({});},_this.onTimeBlur=function(){_this.updateSquadProperty("startTime",__WEBPACK_IMPORTED_MODULE_1__logic__["Time"].format(__WEBPACK_IMPORTED_MODULE_1__logic__["Time"].timeFromText(_this.props.squad.startTime)));_this.setState({});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SquadProperties,[{key:'updateSquadProperty',value:function updateSquadProperty(property,value){this.props.onUpdate(this.props.squad.id,property,value);this.setState({});}},{key:'render',value:function render(){var _this2=this;var _props$squad=this.props.squad,startTime=_props$squad.startTime,slots=_props$squad.slots,mixed=_props$squad.mixed;var selectedDivisions=this.props.squad.divisions;var divisions=this.props.divisions;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'schedule-start-time'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'inplace-edit schedule-start-time',value:startTime,onChange:function onChange(e){return _this2.changeStartTime(e.target.value);},onBlur:this.onTimeBlur})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'schedule-slots'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{className:'inplace-edit schedule-slots',value:slots,onChange:function onChange(e){return _this2.changeSlots(e.target.value);}})),divisions&&divisions.map(function(d){var w=d.length+0.5+"em";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{key:d,className:'schedule-division',style:{minWidth:w,maxWidth:w,width:w}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:selectedDivisions.includes(d),onChange:function onChange(x){return _this2.selectDivision(d);}}));}),divisions&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'schedule-mix'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:'checkbox',checked:mixed,onChange:function onChange(e){return _this2.updateSquadProperty("mixed",e.target.checked);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'schedule-delete'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button-close small red',onClick:function onClick(e){return _this2.props.onDelete(_this2.props.squad);}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('td',{className:'schedule-pad'}));}}]);return SquadProperties;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StageProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StageProperties_css__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StageProperties_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__StageProperties_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tables_css__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tables_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tables_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__general__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StageProperties=function(_React$Component){_inherits(StageProperties,_React$Component);function StageProperties(props){_classCallCheck(this,StageProperties);var _this=_possibleConstructorReturn(this,(StageProperties.__proto__||Object.getPrototypeOf(StageProperties)).call(this,props));_initialiseProps.call(_this);_this.state={visible:false,dirty:false};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.editStages,_this.editStages);return _this;}_createClass(StageProperties,[{key:'render',value:function render(){var _this2=this;var _state=this.state,visible=_state.visible,event=_state.event;if(!visible){return null;}var showShots=event.discipline===__WEBPACK_IMPORTED_MODULE_4__models__["Discipline"].fieldK;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__general__["a" /* ModalDialog */],{title:'Stationer',onClose:this.onClose,showClose:'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{id:'stages'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('table',{id:'stage-properties',className:'table-light'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(this.Header,{showShots:showShots}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tbody',null,event.stages.map(function(s){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(_this2.Stage,{key:s.num,stage:s,showShots:showShots});}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-buttons'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{id:'ok',className:'button',onClick:this.onClose},'OK'))));}}]);return StageProperties;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);StageProperties.register={name:"StageProperties"};StageProperties.wire=["EventBus","Events"];var _initialiseProps=function _initialiseProps(){var _this3=this;this.editStages=function(event){if(event.stages===undefined)event.stages=[];while(event.stages.length<event.scores){event.stages.push(new __WEBPACK_IMPORTED_MODULE_4__models__["StageDef"](event.stages.length));}while(event.stages.length>event.scores){event.stages.pop();}_this3.setState({visible:true,event:event});};this.onClose=function(e){_this3.setState({visible:false});if(_this3.state.dirty){_this3.fire(_this3.Events.updateCompetition);}};this.setVal=function(stage,property,min,max,val){val=parseInt(val,10);if(val>=min&&val<=max){stage[property]=val;_this3.setState({dirty:true});}};this.toggleValue=function(stage){stage.value=!stage.value;_this3.setState({dirty:true});};this.Header=function(props){var showShots=props.showShots;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{key:'hStn',className:'header'},'Station'),showShots&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{key:'hSh',className:'header'},'Skott'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{key:'hTgt',className:'header'},'Figurer'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{key:'hVal',className:'header'},'Po\xE4ng'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{key:'hMax',className:'header'},'Max'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',{key:'hMin',className:'header'},'Min')));};this.Stage=function(props){var stage=props.stage,showShots=props.showShots;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',{key:stage.num+"Stn"},stage.num),showShots&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["Spinner"],{key:stage.num+"Sh",value:stage.shots,onChange:function onChange(v){return _this3.setVal(stage,"shots",3,18,v);}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["Spinner"],{key:stage.num+"Tgt",value:stage.targets,onChange:function onChange(v){return _this3.setVal(stage,"targets",1,9,v);}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',{key:stage.num+"Val"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:"button small"+(stage.value?" green":""),onClick:function onClick(e){return _this3.toggleValue(stage);}},stage.value?"Ja":"Nej")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["Spinner"],{key:stage.num+"Max",value:stage.max,onChange:function onChange(v){return _this3.setVal(stage,"max",1,6,v);}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["Spinner"],{key:stage.num+"Min",value:stage.min,onChange:function onChange(v){return _this3.setVal(stage,"min",0,3,v);}})));};};

/***/ }),
/* 325 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StoreQuestion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StoreQuestion=function(_React$Component){_inherits(StoreQuestion,_React$Component);function StoreQuestion(props){_classCallCheck(this,StoreQuestion);var _this=_possibleConstructorReturn(this,(StoreQuestion.__proto__||Object.getPrototypeOf(StoreQuestion)).call(this,props));_this.state={visible:true};return _this;}_createClass(StoreQuestion,[{key:"hide",value:function hide(save){if(save){this.Storage.set(this.Storage.keys.allowStorage,true);}this.setState({visible:false});}},{key:"render",value:function render(){var _this2=this;return this.state.visible&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"storeQuestion"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"centered"},"Vill du att information du matar in ska sparas s\xE5 att det blir l\xE4ttare att anm\xE4la n\xE4sta g\xE5ng?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"button cookieButton",type:"button",value:"Nej",onClick:function onClick(){return _this2.hide(false);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{className:"button cookieButton",type:"button",value:"Ja",onClick:function onClick(){return _this2.hide(true);}}));}}]);return StoreQuestion;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);StoreQuestion.register={name:"StoreQuestion"};StoreQuestion.wire=["Storage"];

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Summary; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Summary_css__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Summary_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Summary_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Summary=function(_React$Component){_inherits(Summary,_React$Component);function Summary(){_classCallCheck(this,Summary);return _possibleConstructorReturn(this,(Summary.__proto__||Object.getPrototypeOf(Summary)).apply(this,arguments));}_createClass(Summary,[{key:'countEntries',value:function countEntries(participants){var entries=0;participants.forEach(function(p){p.registrationInfo.forEach(function(r){if(r)entries+=r.rounds.length;});});return entries;}},{key:'render',value:function render(){var participants=this.Registration.participants;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'summary',className:'center content'},'Antal deltagare: ',participants.length,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br',null),'Antal starter: ',this.countEntries(participants));}}]);return Summary;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);Summary.register={name:"Summary"};Summary.wire=["Registration"];

/***/ }),
/* 328 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamForm; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TeamForm=function(_React$Component){_inherits(TeamForm,_React$Component);function TeamForm(props){_classCallCheck(this,TeamForm);var _this=_possibleConstructorReturn(this,(TeamForm.__proto__||Object.getPrototypeOf(TeamForm)).call(this,props));_initialiseProps.call(_this);var teamDefs=props.teamDefs;var members=0,alternates=0;teamDefs.forEach(function(t,i){t.description=[t.event,t.division,t.class].filter(function(x){return x!==undefined&&x!=="";}).join(" - ");t.id=i;if(t.members>members){members=t.members;}if(t.alternates>alternates){alternates=t.alternates;}});_this.state={members:members,alternates:alternates};return _this;}_createClass(TeamForm,[{key:'render',value:function render(){var _this2=this;var teams=this.props.teams;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content team-registration-form'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.Header,null),teams.map(function(t,n){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this2.TeamRow,{key:n,team:t,index:n});}));}}]);return TeamForm;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this3=this;this.updateTeamDef=function(team,val){var _props=_this3.props,teams=_props.teams,teamDefs=_props.teamDefs;var def=teamDefs[parseInt(val,10)];teams[team].teamDef=val;teams[team].event=def.eventId;teams[team].index=def.index;teams[team].team_definition_id=def.id;_this3.setState({});};this.updateTeamName=function(team,value){var teams=_this3.props.teams;teams[team].name=value;_this3.setState({});};this.updateMember=function(team,member,value){var teams=_this3.props.teams;value=parseInt(value,10);value=value===0?undefined:value;teams[team].members[member]=value;_this3.setState({});};this.updateAlternate=function(team,alternate,value){var teams=_this3.props.teams;value=parseInt(value,10);value=value===0?undefined:value;teams[team].alternates[alternate]=value;_this3.setState({});};this.Header=function(props){var _state=_this3.state,members=_state.members,alternates=_state.alternates;var hdr=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'th1',className:'registration-header major-header',style:{gridColumnEnd:"span 2"}},'Lag\xA0',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',{className:'super'},'(* = obligatoriskt f\xE4lt)')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'th2',className:'registration-header major-header',style:{gridColumnEnd:'span '+(members+alternates)}},'Medlemmar'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'d1',style:{gridRow:1}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'th3',className:'team-name-header minor-header'},'Lagnamn*'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'th4',className:'team-selection-header minor-header'},'Grupp')];for(var i=0;i<members;){hdr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'tm-'+i,className:'team-member-header minor-header'},'Skytt '+ ++i+'*'));}for(var _i=0;_i<alternates;){hdr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'ta-'+_i,className:'team-member-header minor-header'},'Reserv '+ ++_i));}hdr.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'d2',style:{gridRow:2}}));// delete button
return hdr;};this.TeamRow=function(props){var _state2=_this3.state,members=_state2.members,alternates=_state2.alternates;var teamDefs=_this3.props.teamDefs;var participants=_this3.props.participants||[];var team=props.team,index=props.index;var teamDef=teamDefs[team.teamDef||0];participants=participants.filter(function(p){return p.eventName===teamDef.event;});// ToDo: use ID instead
if(teamDef.division!==undefined){participants=participants.filter(function(p){return p.division===teamDef.division;});}if(teamDef.class!==undefined){participants=participants.filter(function(p){return p.class===teamDef.class;});}participants=participants.map(function(p){return{id:p.id,description:p.name};});var row=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:'team-'+index,className:'team-header'},'Lag '+index),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["TextInput"],{id:'team-name-'+index,key:'team-name-'+index,name:'Lagnamn',placeholder:'Lagnamn',value:team.name,onChange:function onChange(e){return _this3.updateTeamName(index,e.target.value);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["Dropdown"],{id:'team-selection-'+index,key:'team-selection-'+index,name:'Lag',placeholder:'Lag',value:team.teamDef||0,list:teamDefs,onChange:function onChange(e){return _this3.updateTeamDef(index,e.target.value);}})];var _loop=function _loop(i){var id='member-'+index+'-'+i;if(i<teamDef.members){var name='Skytt '+(i+1);var _list=[{id:0,description:"Ingen",empty:true}].concat(participants.filter(function(p){return p.id===team.members[i]||!team.members.includes(p.id)&&!team.alternates.includes(p.id);}));row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["Dropdown"],{id:id,key:id,name:name,placeholder:name,value:team.members[i],list:_list,onChange:function onChange(e){return _this3.updateMember(index,i,e.target.value);}}));}else{row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id}));}};for(var i=0;i<members;i++){_loop(i);}var _loop2=function _loop2(i){var id='alt-'+index+'-'+i;var list=[{id:0,description:"Ingen",empty:true}].concat(participants.filter(function(p){return p.id===team.alternates[i]||!team.members.includes(p.id)&&!team.alternates.includes(p.id);}));if(i<teamDef.alternates){var name='Reserv '+(i+1);row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["Dropdown"],{id:id,key:id,name:name,placeholder:name,value:team.alternates[i],list:list,onChange:function onChange(e){return _this3.updateAlternate(index,i,e.target.value);}}));}else{row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{key:id}));}};for(var i=0;i<alternates;i++){_loop2(i);}row.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{key:'del-'+index,style:{margin:"2px 5px 0 0"},className:'button button-close small red',onClick:function onClick(e){return _this3.props.onDelete(index);}}));return row;};};

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamProperties; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventProperties_css__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventProperties_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__EventProperties_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tables_css__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tables_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Tables_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__general__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5____ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TeamProperties=function(_React$Component){_inherits(TeamProperties,_React$Component);function TeamProperties(props){var _this2=this;_classCallCheck(this,TeamProperties);var _this=_possibleConstructorReturn(this,(TeamProperties.__proto__||Object.getPrototypeOf(TeamProperties)).call(this,props));_this.onClose=function(){_this.setState({event:undefined});if(_this.state.dirty){_this.fire(_this.Events.updateCompetition);}};_this.addTeam=function(){_this.state.event.teams.push(new __WEBPACK_IMPORTED_MODULE_4__models__["TeamDef"](undefined,undefined,2,1));_this.setState({dirty:true});};_this.setMembers=function(team,value){if(value>0&&value!==team.members){team.members=value;_this.setState({dirty:true});}};_this.setAlternates=function(team,value){if(value>=0&&value!==team.alternates){team.alternates=value;_this.setState({dirty:true});}};_this.setDivision=function(team,value){value=value.target.value;if(value==="-1"){value=undefined;}if(value!==team.division){team.division=value;_this.setState({dirty:true});}};_this.setClass=function(team,value){value=value.target.value;if(value==="-1"){value=undefined;}if(value!==team.class){team.class=value;_this.setState({dirty:true});}};_this.setCost=function(team,cost){if(cost!==team.cost){team.cost=cost;_this.setState({dirty:true});}};_this.deleteTeam=function(team){var event=_this.state.event;event.teams=event.teams.filter(function(t){return t!==team;});_this.setState({dirty:true});};_this.Divisions=function(_ref){var team=_ref.team;var divisions=_this.state.event.divisions;if(divisions===undefined)return null;var divList=_this.DivisionGroups.find(function(dg){return dg.id===divisions;});var list=[{id:-1,description:"Alla"}].concat(divList.divisions.filter(function(d){return!d.includes('+');}).map(function(d){return{id:d,description:d};}));return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["Dropdown"],{value:team.division||"Alla",list:list,onChange:function onChange(d){return _this.setDivision(team,d);}}));};_this.Classes=function(_ref2){var team=_ref2.team;var classes=_this.state.event.classes;if(classes===undefined)return null;var clsList=_this.ClassGroups.find(function(cg){return cg.id===classes;});var list=[{id:-1,description:"Alla"}].concat(clsList.classes.map(function(c){return{id:c,description:c};}));return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["Dropdown"],{value:team.class||"Alla",list:list,onChange:function onChange(c){return _this.setClass(team,c);}}));};_this.TeamRow=function(_ref3){var team=_ref3.team;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(_this2.Divisions,{team:team}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(_this2.Classes,{team:team}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["Spinner"],{value:team.members,onChange:function onChange(m){return _this.setMembers(team,m);}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["Spinner"],{value:team.alternates,onChange:function onChange(a){return _this.setAlternates(team,a);}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5____["TextInput"],{name:'Startavgift',className:'fee',id:'fee',placeholder:'Avgift',mask:'1234567890',maxLength:'5',value:team.cost||0,onChange:function onChange(c){return _this.setCost(team,parseInt(c.target.value,10));}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('td',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'small red button-close',onClick:function onClick(e){return _this.deleteTeam(team);}})));};_this.DivHeader=function(){var divisions=_this.state.event.divisions;if(divisions===undefined){return null;}var divGrp=_this.DivisionGroups.find(function(dg){return dg.id===divisions;});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,divGrp.header||"Vapengrupp");};_this.ClsHeader=function(){var classes=_this.state.event.classes;if(classes===undefined){return null;}var clsGrp=_this.ClassGroups.find(function(cg){return cg.id===classes;});return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,clsGrp.header||"Klass");};_this.Header=function(){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('thead',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tr',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(_this2.DivHeader,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(_this2.ClsHeader,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Deltagare'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Reserver'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Avgift'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('th',null,'Radera')));};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.editTeams,function(e){return _this.setState({event:e});});_this.state={dirty:false};return _this;}_createClass(TeamProperties,[{key:'render',value:function render(){var _this3=this;if(this.state.event===undefined){return null;}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__general__["a" /* ModalDialog */],{title:'Lag',onClose:this.onClose,showClose:'true'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('table',{id:'team-definitions',className:'table-light'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(this.Header,null),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('tbody',null,this.state.event.teams.map(function(t,i){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(_this3.TeamRow,{key:i,team:t});}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'modal-buttons'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'button button-add green',onClick:this.addTeam}),'L\xE4gg till lag'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'spacer'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('button',{className:'button',onClick:this.onClose},'OK')));}}]);return TeamProperties;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);TeamProperties.register={name:"TeamProperties"};TeamProperties.wire=["EventBus","Events","Competition","DivisionGroups","ClassGroups"];

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return YesNoDialog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__YesNoDialog_css__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__YesNoDialog_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__YesNoDialog_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__general__ = __webpack_require__(29);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var YesNoDialog=function(_React$Component){_inherits(YesNoDialog,_React$Component);function YesNoDialog(){_classCallCheck(this,YesNoDialog);return _possibleConstructorReturn(this,(YesNoDialog.__proto__||Object.getPrototypeOf(YesNoDialog)).apply(this,arguments));}_createClass(YesNoDialog,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__general__["a" /* ModalDialog */],{title:this.props.title,className:'yes-no-dialog'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,this.props.text),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button small',onClick:function onClick(e){return _this2.props.action(true);}},'Ja'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button small',onClick:function onClick(e){return _this2.props.action(false);}},'Nej'));}}]);return YesNoDialog;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);YesNoDialog.register={name:"YesNoDialog"};

/***/ }),
/* 332 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WithLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoginView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginView_css__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LoginView_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__LoginView_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2____ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var WithLogin=function(_React$Component){_inherits(WithLogin,_React$Component);function WithLogin(props){_classCallCheck(this,WithLogin);var _this=_possibleConstructorReturn(this,(WithLogin.__proto__||Object.getPrototypeOf(WithLogin)).call(this,props));_this.EventBus.manageEvents(_this);_this.subscribe(__WEBPACK_IMPORTED_MODULE_2____["Events"].userChanged,function(){_this.setState({});});return _this;}_createClass(WithLogin,[{key:'render',value:function render(){return this.Session.user===""?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.LoginControl,this.props):this.props.children;}}]);return WithLogin;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);WithLogin.register={name:"WithLogin"};WithLogin.wire=["EventBus","Session","LoginControl"];var LoginView=function(_React$Component2){_inherits(LoginView,_React$Component2);function LoginView(){_classCallCheck(this,LoginView);return _possibleConstructorReturn(this,(LoginView.__proto__||Object.getPrototypeOf(LoginView)).apply(this,arguments));}_createClass(LoginView,[{key:'GoBack',value:function GoBack(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,props.history.goBack());}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.WithLogin,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.GoBack,this.props));}}]);return LoginView;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);LoginView.register={name:"LoginView"};LoginView.wire=["WithLogin"];

/***/ }),
/* 334 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompetitionList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompetitionList_css__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CompetitionList_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CompetitionList_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4____ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompetitionList=function(_React$Component){_inherits(CompetitionList,_React$Component);function CompetitionList(props){var _this2=this;_classCallCheck(this,CompetitionList);var _this=_possibleConstructorReturn(this,(CompetitionList.__proto__||Object.getPrototypeOf(CompetitionList)).call(this,props));_this.loadCompetitions=function(){_this.Server.loadCompetitionList(function(json){return _this.setState({competitions:json.map(function(c){if(c.name.includes("$")){var parts=c.name.split("$");if(parts.length>2){c.group=parts[0];c.name=parts[1];c.subtitle=parts[2];}else{c.group=c.group||"";c.name=parts[0];c.subtitle=parts[1];}}return Object.assign({},c,{status:c.status?parseInt(c.status.toString(),10):__WEBPACK_IMPORTED_MODULE_3__models__["Status"].Open,permissions:c.permissions?parseInt(c.permissions.toString(),10):_this.Session.user===""?__WEBPACK_IMPORTED_MODULE_3__models__["Permissions"].Any:__WEBPACK_IMPORTED_MODULE_3__models__["Permissions"].Own});}),groups:_this.CompetitionGroups.groups});},_this.Footers.errorHandler(CompetitionList.E_CANNOT_LOAD));};_this.deleteCompetition=function(act){if(act){_this.Server.deleteCompetition(_this.state.deleteCompetition.id,_this.loadCompetitions,_this.Footers.errorHandler("Kan inte ta bort tävling"));}_this.setState({deleteCompetition:undefined});};_this.Competition=function(_ref){var competition=_ref.competition;console.log("List",competition);var links=Object(__WEBPACK_IMPORTED_MODULE_4____["competitionTabs"])().map(function(t){return t.tabInfo;}).filter(function(o){return o.show(competition);});if(competition.name==="Testtävling SM"){var reg=Object(__WEBPACK_IMPORTED_MODULE_4____["competitionTabs"])().map(function(t){return t.tabInfo;}).find(function(i){return i.path==="register";});console.log("Register",competition.name,reg.show(competition),reg);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:competition.id,className:"competition-tile "+_this.getState(competition)},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'event-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:'competition-link',to:'/competition/'+competition.id},competition.name.split("$")[0]),_this.canDelete(competition)&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button-close small red',onClick:function onClick(e){return _this.setState({deleteCompetition:competition});}})),competition.subtitle!==""&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subtitle'},competition.subtitle),links.map(function(l){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',{key:l.name},'\xA0',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/competition/'+competition.id+'/'+l.path},l.name),'\xA0');}));};_this.Group=function(_ref2){var group=_ref2.group;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'competition-tile open competition-group'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{style:{width:"40px"}},group.iconPath&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('img',{src:group.iconPath,className:'group-icon',alt:group.icon})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'group-text'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'event-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:'competition-link',to:'/group/'+group.label},group.name)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'subtitle'},group.description)));};_this.Groups=function(_ref3){var group_id=_ref3.group_id;if(group_id===undefined||group_id===""){var Group=_this.Group;return _this.state.groups.filter(function(g){return _this.Session.isAdmin()||g.status!==__WEBPACK_IMPORTED_MODULE_3__models__["Status"].Hidden;}).map(function(g){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Group,{key:g.label,group:g});});}return null;};_this.Competitions=function(_ref4){var competitions=_ref4.competitions,loggedIn=_ref4.loggedIn;if(competitions.length===0)return null;var Competition=_this.Competition;return competitions.map(function(c){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Competition,{key:c.id,competition:c});});};_this.CreateCompetition=function(_ref5){var competitions=_ref5.competitions;if(_this.Session.user===""){if(competitions.length===0)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,'Inga t\xE4vlingar att visa - logga in f\xF6r att skapa en t\xE4vling');return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'create-competition competition-tile'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{className:'competition-link',to:'/create'},'Skapa ny t\xE4vling'));};_this.DeleteCompetitionDialog=function(){if(!_this.state.deleteCompetition)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this2.YesNoDialog,{title:'Bekr\xE4fta borttagning',text:'\xC4r du s\xE4ker p\xE5 att du vill ta bort '+_this.state.deleteCompetition.name+'?',action:function action(act){return _this.deleteCompetition(act);}});};_this.state={competitions:[],groups:[]};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.userChanged,_this.loadCompetitions);_this.subscribe(_this.Events.serverChanged,_this.loadCompetitions);_this.subscribe(_this.Events.competitionGroupsUpdated,function(){return _this.setState({groups:_this.CompetitionGroups.groups});});return _this;}_createClass(CompetitionList,[{key:'componentDidMount',value:function componentDidMount(){this.EventBus.fire(this.Events.changeTitle,"Anmälningssystem Gävle PK");this.loadCompetitions();// Needs to be done here to avoid calling setState before the component is mounted when using local code/storage
}},{key:'getToken',value:function getToken(c){var tokens=this.Storage.get("Tokens");if(!tokens){return undefined;}return tokens[c.id];}},{key:'getState',value:function getState(competition){return competition.status===__WEBPACK_IMPORTED_MODULE_3__models__["Status"].Hidden?"hidden":competition.status===__WEBPACK_IMPORTED_MODULE_3__models__["Status"].Closed?"closed":"open";}},{key:'canDelete',value:function canDelete(competition){return competition.permissions===__WEBPACK_IMPORTED_MODULE_3__models__["Permissions"].Own||competition.permissions===__WEBPACK_IMPORTED_MODULE_3__models__["Permissions"].Admin;}},{key:'groupName',value:function groupName(group_id){if(group_id===undefined||this.state.groups===undefined)return"";var group=this.state.groups.find(function(g){return g.label===group_id;});return group?" "+group.name:"";}},{key:'componentDidUpdate',value:function componentDidUpdate(){var group_id=this.props.match.params.group_id;var group=this.CompetitionGroups.findGroup(group_id);this.CompetitionGroups.setGroup(group);this.EventBus.fire(this.Events.changeTitle,group.description);}},{key:'render',value:function render(){var _this3=this;var group_id=this.props.match.params.group_id;// ToDo: fix filtering of hidden competitions in server
var competitions=this.state.competitions.filter(function(h){return h.status!==__WEBPACK_IMPORTED_MODULE_3__models__["Status"].Hidden||h.permissions===__WEBPACK_IMPORTED_MODULE_3__models__["Permissions"].Own||_this3.Session.isAdmin();});if(group_id){competitions=competitions.filter(function(c){return c.group===group_id;});}else if(this.Session.isAdmin()){competitions=competitions.filter(function(c){return c.group===undefined||!_this3.state.groups.some(function(g){return g.label===c.group;});});}else{competitions=competitions.filter(function(c){return c.group===undefined||c.group==="";});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'competitions',className:'content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.DeleteCompetitionDialog,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'T\xE4vlingar',this.groupName(group_id),this.Server.local&&" (felsökning)"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:competitions.length>10?'competition-list-compact':'competition-list'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.Groups,{group_id:group_id}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.Competitions,{competitions:competitions}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.CreateCompetition,{competitions:competitions})));}}]);return CompetitionList;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);CompetitionList.register={name:"CompetitionList"};CompetitionList.wire=["Server","Session","Storage","EventBus","Events","Footers","YesNoDialog","CompetitionGroups"];CompetitionList.E_CANNOT_LOAD="Kan inte hämta tävlingar";

/***/ }),
/* 336 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompetitionView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs_css__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompetitionView_css__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CompetitionView_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__CompetitionView_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__competitiontabs__ = __webpack_require__(57);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompetitionView=function(_React$Component){_inherits(CompetitionView,_React$Component);function CompetitionView(props){_classCallCheck(this,CompetitionView);var _this=_possibleConstructorReturn(this,(CompetitionView.__proto__||Object.getPrototypeOf(CompetitionView)).call(this,props));_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.competitionUpdated,function(){return _this.setState({});});_this.subscribe(_this.Events.modeChanged,function(){return _this.setState({});});_this.subscribe(_this.Events.serverChanged,function(){return _this.Competition.load(props.match.params.id);});_this.Competition.load(props.match.params.id);return _this;}_createClass(CompetitionView,[{key:"componentDidUpdate",value:function componentDidUpdate(){this.CompetitionGroups.setGroup(this.CompetitionGroups.findGroup(this.Competition.group));}},{key:"render",value:function render(){var _this2=this;var _props$match$params=this.props.match.params,id=_props$match$params.id,operation=_props$match$params.operation;// Wait; competition is loading
if(this.Competition.id!==id){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p",null,"H\xE4mtar t\xE4vling..."));}var group=this.CompetitionGroups.findGroup(this.Competition.group);var tabs=Object(__WEBPACK_IMPORTED_MODULE_5__competitiontabs__["competitionTabs"])().map(function(t){return t.tabInfo;}).filter(function(t){return t.show(_this2.Competition);});if(tabs.length===0){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{to:"/"});}// Handle links to the competition in general
if(operation===undefined){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{to:"/competition/"+this.Competition.id+"/"+tabs[0].path});}var Content=Object(__WEBPACK_IMPORTED_MODULE_5__competitiontabs__["competitionTabs"])().find(function(t){return t.tabInfo.path===operation;});if(Content===null){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["c" /* Redirect */],{to:"/"});}return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,this.Configuration.mode===__WEBPACK_IMPORTED_MODULE_4__models__["Mode"].computer&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"tabs",style:{backgroundColor:group.background}},tabs.length>1&&tabs.map(function(t){return operation===t.path?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p",{key:t.path,className:"tab"},t.name):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{key:t.path,className:"tab",to:"/competition/"+_this2.Competition.id+"/"+t.path},t.name);}),group.url&&group.url.startsWith("http")&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a",{key:"homepage",className:"tab",href:group.url},"Tillbaka till hemsidan >")),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Content,this.props));}}]);return CompetitionView;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);CompetitionView.register={name:"CompetitionView"};CompetitionView.wire=["Competition","Events","EventBus","Configuration","CompetitionGroups"];

/***/ }),
/* 338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = competitionTabs;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0____ = __webpack_require__(57);
function competitionTabs(){var tabs=[];for(var t in __WEBPACK_IMPORTED_MODULE_0____){if(typeof __WEBPACK_IMPORTED_MODULE_0____[t]==="function"&&__WEBPACK_IMPORTED_MODULE_0____[t].tabInfo){tabs.push(__WEBPACK_IMPORTED_MODULE_0____[t]);}}return tabs.sort(function(a,b){return a.tabInfo.order-b.tabInfo.order;});}

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExcelTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExcelTab=function(_React$Component){_inherits(ExcelTab,_React$Component);function ExcelTab(){_classCallCheck(this,ExcelTab);return _possibleConstructorReturn(this,(ExcelTab.__proto__||Object.getPrototypeOf(ExcelTab)).apply(this,arguments));}_createClass(ExcelTab,[{key:'componentDidMount',value:function componentDidMount(){this.EventBus.fire(this.Events.changeTitle,'Listor f\xF6r '+this.Competition.name);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Deltagare'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.Configuration.baseUrl+'/excel/'+this.Competition.id+'/division',download:'true'},'Alla deltagare (vapenkontroll)'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.Configuration.baseUrl+'/excel/'+this.Competition.id+'/team',download:'true'},'Alla lag'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:this.Configuration.baseUrl+'/excel/'+this.Competition.id+'/allt',download:'true'},'All information'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),this.Competition.events.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:'d'+e.id,href:_this2.Configuration.baseUrl+'/excel/'+e.id+'/list',download:'true'},'Deltagare i '+(e.name||_this2.Competition.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Starttider'),this.Competition.events.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:'s'+e.id,href:_this2.Configuration.baseUrl+'/excel/'+e.id+'/squad',download:'true'},'Starttider i '+(e.name||_this2.Competition.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Resultat'),this.Competition.events.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:'r'+e.id,href:_this2.Configuration.baseUrl+'/excel/result/'+e.id,download:'true'},'Resultat f\xF6r ',e.name||_this2.Competition.name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Lagresultat'),this.Competition.events.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{key:'s'+e.id,href:_this2.Configuration.baseUrl+'/excel/result/team/'+e.id,download:'true'},'Lagresultat f\xF6r '+(e.name||_this2.Competition.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null));}));}}]);return ExcelTab;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ExcelTab.register={name:"ListsTab"};ExcelTab.wire=["Events","EventBus","Configuration","Competition"];ExcelTab.tabInfo=new __WEBPACK_IMPORTED_MODULE_1__models__["TabInfo"]("Excel","excel",203,__WEBPACK_IMPORTED_MODULE_1__models__["Permissions"].Admin);

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegAdminTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RegAdmin_css__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RegAdmin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__RegAdmin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/** List of registrations (one registration may contain several entries) */var RegAdminTab=function(_React$Component){_inherits(RegAdminTab,_React$Component);function RegAdminTab(props){var _this2=this;_classCallCheck(this,RegAdminTab);var _this=_possibleConstructorReturn(this,(RegAdminTab.__proto__||Object.getPrototypeOf(RegAdminTab)).call(this,props));_this.resendMail=function(reg){_this.Server.sendNewToken({competition:_this.Competition.id,email:reg.email},function(json){_this.Footers.addFooter("Nytt mail skickas","info");});};_this.Reg=function(_ref){var reg=_ref.reg;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'registration-link'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'registration-button tooltip',tooltip:'Skicka ny bekr\xE4ftelse','tooltip-position':'right',onClick:function onClick(){return _this.resendMail(reg);}},'\u21BB'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('a',{className:'registration-button tooltip',tooltip:'Skicka mail till anm\xE4laren','tooltip-position':'right',href:'mailto:'+reg.email},'\u2709'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:'/competition/'+_this.Competition.id+'/register/'+reg.token},reg.contact,', ',reg.organization,' <',reg.email,'>'));};_this.Registrations=function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Anm\xE4lningar'),_this.state.registrations.map(function(r){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this2.Reg,{reg:r,key:r.token});}));};_this.state={registrations:[]};_this.Server.getRegistrations(_this.Competition.id,function(json){_this.setState({registrations:json});});_this.EventBus.manageEvents(_this);return _this;}_createClass(RegAdminTab,[{key:'componentDidMount',value:function componentDidMount(){this.fire(this.Events.changeTitle,'Administrera anm\xE4lningar till '+this.Competition.name);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.Registrations,null));}}]);return RegAdminTab;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);RegAdminTab.register={name:"RegAdminTab"};RegAdminTab.wire=["Server","Competition","Configuration","Events","EventBus","Footers"];RegAdminTab.tabInfo=new __WEBPACK_IMPORTED_MODULE_3__models__["TabInfo"]("Administrera anmälningar","registrations",201,__WEBPACK_IMPORTED_MODULE_3__models__["Permissions"].Admin);

/***/ }),
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegistrationTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Registration_css__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Registration_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Registration_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegistrationTab=function(_React$Component){_inherits(RegistrationTab,_React$Component);function RegistrationTab(props){_classCallCheck(this,RegistrationTab);var _this=_possibleConstructorReturn(this,(RegistrationTab.__proto__||Object.getPrototypeOf(RegistrationTab)).call(this,props));_initialiseProps.call(_this);var _props$match$params=props.match.params,id=_props$match$params.id,p1=_props$match$params.p1;_this.state={dates:[].concat(_toConsumableArray(new Set(_this.Competition.events.map(function(e){return RegistrationTab.dateFormat.format(e.date);})))),selected:RegistrationTab.dateFormat.format(_this.Competition.events[0].date)};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.registrationUpdated,function(){return _this.setState({});});_this.subscribe(_this.Events.deleteParticipant,function(id){return _this.showDeleteDialog(id);});console.log("Mounting registration tab",id,p1,_this.Registration.token);_this.Registration.load(id,p1);return _this;}_createClass(RegistrationTab,[{key:'componentDidMount',value:function componentDidMount(){this.fire(this.Events.changeTitle,"Anmälan till "+this.Competition.name);}},{key:'render',value:function render(){var _this2=this;var _Registration$contact=this.Registration.contact,name=_Registration$contact.name,organization=_Registration$contact.organization,email=_Registration$contact.email,account=_Registration$contact.account;console.log("Registration tab",this.Registration);console.log("Registration tab",this.Registration.token,this.props.match.params.p1);if(this.Registration.token===undefined&&this.props.match.params.p1!==undefined){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/competition/'+this.props.match.params.id+'/register'});}if(this.Registration.token!==undefined&&this.props.match.params.p1===undefined){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/competition/'+this.props.match.params.id+'/register/'+this.Registration.token});}var events=this.Competition.events.filter(function(e){return RegistrationTab.dateFormat.format(e.date)===_this2.state.selected;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.SquadPicker,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["Description"],{value:this.Competition.description}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["NewRegistrationContact"],{name:name,organization:organization,email:email,account:account,showAccount:this.Competition.rules.includes("show-acct"),onChange:this.onChangeContact}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.EventFilter,{dates:this.state.dates,selected:this.state.selected}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.RegistrationForm,{events:events}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.ParticipantToolbar,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.Summary,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.RegistrationToolbar,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.ParticipantPicker,null),this.state.deleteParticipant!==undefined&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.YesNoDialog,{title:'Bekr\xE4fta borttagning',text:'\xC4r du s\xE4ker p\xE5 att du vill radera deltagaren?',action:function action(act){return _this2.deleteParticipant(act);}}));}}]);return RegistrationTab;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);RegistrationTab.register={name:"RegistrationTab"};RegistrationTab.wire=["Competition","EventBus","Events","Registration","ParticipantPicker","RegistrationToolbar","RegistrationForm","Summary","SquadPicker","Server","YesNoDialog","ParticipantToolbar"];RegistrationTab.dateFormat=new Intl.DateTimeFormat('sv-SV');RegistrationTab.tabInfo=new __WEBPACK_IMPORTED_MODULE_3__models__["TabInfo"]("Anmälan","register",1,__WEBPACK_IMPORTED_MODULE_3__models__["Permissions"].Any,__WEBPACK_IMPORTED_MODULE_3__models__["Status"].Open);var _initialiseProps=function _initialiseProps(){var _this3=this;this.showDeleteDialog=function(id){_this3.setState({deleteParticipant:id});};this.deleteParticipant=function(act){if(act)_this3.Registration.deleteParticipant(_this3.state.deleteParticipant);_this3.setState({deleteParticipant:undefined});};this.EventFilter=function(_ref){var dates=_ref.dates,selected=_ref.selected;if(dates==null||dates.length<2){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content'},[].concat(_toConsumableArray(dates)).map(function(d){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{key:d,className:"button"+(selected===d?"":" white"),onClick:function onClick(){return _this3.setState({selected:d});}},d);}));};this.onChangeContact=function(prop,value){_this3.fire(_this3.Events.setRegistrationInfo,prop,value);};};

/***/ }),
/* 344 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ReportTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Report_css__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Report_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Report_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function EventSelector(_ref){var events=_ref.events,event=_ref.event,changeEvent=_ref.changeEvent;if(events.length<2){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'event-selector'},'Resultat f\xF6r delt\xE4vling:',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{value:event.id,onChange:function onChange(e){return changeEvent(e.target.value);}},events.map(function(e){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:e.id,value:e.id},e.name);})));}function SquadSelector(_ref2){var schedule=_ref2.schedule,squad=_ref2.squad,setSquad=_ref2.setSquad;if(schedule===undefined){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'squad-selector'},'Skjutlag/patrull:',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{value:squad.id,onChange:function onChange(e){return setSquad(e.target.value);}},schedule.squads.map(function(s){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:s.id,value:s.id},s.startTime.split(':').slice(0,2).join(':'));})));}function StageSelector(_ref3){var stage=_ref3.stage,stages=_ref3.stages,setStage=_ref3.setStage;if(stages===0){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'stage-selector'},'Serie/station:',__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('select',{value:stage,onChange:function onChange(e){return setStage(parseInt(e.target.value,10));}},new Array(stages).fill(null).map(function(a,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('option',{key:i,value:i+1},i+1);})));}function StageInfo(_ref4){var stage=_ref4.stage,event=_ref4.event;if(!__WEBPACK_IMPORTED_MODULE_3__models__["Discipline"].hasStages.includes(event.discipline)){return null;}if(event.stages==null||event.stages.length===0){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Fel! Inga serier/stationer!');}var stageDef=event.stages.find(function(s){return s.num===stage;});return[stageDef&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'sifig'},'Figurer: ',stageDef.targets),stageDef&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'simax'},'Maxtr\xE4ff: ',stageDef.max),stageDef&&stageDef.min>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'simin'},'Min: ',stageDef.min),stageDef&&stageDef.values&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'sipts'},'Po\xE4ngr\xE4kning')];}var ReportTab=function(_React$Component){_inherits(ReportTab,_React$Component);function ReportTab(props){var _this2=this;_classCallCheck(this,ReportTab);var _this=_possibleConstructorReturn(this,(ReportTab.__proto__||Object.getPrototypeOf(ReportTab)).call(this,props));_this.updateCompetition=function(){_this.setTitle();_this.setState({schedule:null});};_this.updateResults=function(){_this.setState({});};_this.updateSchedule=function(schedule){schedule=__WEBPACK_IMPORTED_MODULE_3__models__["Schedule"].fromJson(schedule);_this.setState({schedule:schedule});};_this.updateParticipants=function(participants){_this.setState({participants:participants});};_this.changeSquad=function(squadId){squadId=parseInt(squadId,10);_this.setState({squad:_this.state.schedule.squads.find(function(s){return s.id===squadId;})});};_this.next=function(){var _this$props$match$par=_this.props.match.params,id=_this$props$match$par.id,p1=_this$props$match$par.p1,p2=_this$props$match$par.p2,p3=_this$props$match$par.p3;p1=parseInt(p1,10);p2=parseInt(p2,10);p3=parseInt(p3,10);var schedule=_this.state.schedule;var event=_this.Competition.events.find(function(e){return e.id===p1;});var squad=schedule.squads.find(function(s){return s.id===p2;});if(!_this.hasErrors()){_this.Results.report(event,squad,p3);var newSquad=__WEBPACK_IMPORTED_MODULE_3__models__["Discipline"].hasStages.includes(event.discipline)?schedule.squads[(schedule.squads.findIndex(function(s){return s===squad;})+1)%schedule.squads.length].id:squad.id;var newStage=__WEBPACK_IMPORTED_MODULE_3__models__["Discipline"].hasStages.includes(event.discipline)?p3:p3%event.scores+1;_this.props.history.replace('/competition/'+id+'/report/'+p1+'/'+newSquad+'/'+newStage);_this.Results.load(id,p1,true);}else{_this.setState({});}};_this.NextButton=function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{type:'button',id:'next-button',className:'button',onClick:_this.next},'N\xE4sta >');};_this.QueueButton=function(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'queue-button'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this2.ReportIndicator,null));};_this.setSquad=function(squadId){var _this$props$match$par2=_this.props.match.params,id=_this$props$match$par2.id,p1=_this$props$match$par2.p1,p3=_this$props$match$par2.p3;_this.props.history.replace('/competition/'+id+'/report/'+p1+'/'+squadId+'/'+p3);};_this.setStage=function(stage){var _this$props$match$par3=_this.props.match.params,id=_this$props$match$par3.id,p1=_this$props$match$par3.p1,p2=_this$props$match$par3.p2;_this.props.history.replace('/competition/'+id+'/report/'+p1+'/'+p2+'/'+stage);};_this.state={eventList:[],schedule:null,squad:null,participants:null};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.competitionUpdated,_this.updateCompetition);_this.subscribe(_this.Events.resultsUpdated,_this.updateResults);if(_this.Competition.id===props.match.params.id){_this.setTitle();}return _this;}_createClass(ReportTab,[{key:'setTitle',value:function setTitle(){this.fire(this.Events.changeTitle,'Registrera resultat f\xF6r '+this.Competition.name);}},{key:'changeEvent',value:function changeEvent(newEvent){newEvent=parseInt(newEvent,10);newEvent=this.Competition.events.find(function(e){return e.id===newEvent;});this.setEvent(newEvent);}},{key:'setEvent',value:function setEvent(event){this.setState({schedule:null});if(event!==null){this.Results.load(this.Competition.id,event.id);}this.props.history.push('/competition/'+this.Competition.id+'/report/'+event.id);}},{key:'hasErrors',value:function hasErrors(){var _props$match$params=this.props.match.params,p1=_props$match$params.p1,p2=_props$match$params.p2,p3=_props$match$params.p3;p1=parseInt(p1,10);p2=parseInt(p2,10);p3=parseInt(p3,10);var event=this.Competition.events.find(function(e){return e.id===p1;});var scoring=__WEBPACK_IMPORTED_MODULE_3__models__["ScoringModels"].getModel(event.discipline);if(scoring===null){console.log("No scoring model for discupline");return true;}var participants=this.Results.getScores(p2);var squad=this.state.schedule.squads.find(function(s){return s.id===p2;});var errors=participants.filter(function(p){return p.squad===squad.id;}).filter(function(p){return!scoring.validateScore(p,event,p3);});if(errors.length>0){console.log(errors);}return errors.length>0;}},{key:'render',value:function render(){var _props$match$params2=this.props.match.params,id=_props$match$params2.id,p1=_props$match$params2.p1,p2=_props$match$params2.p2,p3=_props$match$params2.p3;var schedule=this.state.schedule;if(id===undefined){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Fel! Ingen t\xE4vling angiven!');}if(this.Competition.id!==id){this.Competition.load(this.props.match.params.id);return null;}if(this.Competition.permissions<__WEBPACK_IMPORTED_MODULE_3__models__["Permissions"].Admin){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,'Du har inte beh\xF6righet att mata in resultat'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Har du loggat in? Blivit automatiskt utloggad?')));}var events=this.Competition.events;if(p1===undefined){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/competition/'+id+'/report/'+events[0].id});}p1=parseInt(p1,10);if(this.Results.event!==p1){this.Results.load(id,p1);return null;}var event=events.find(function(e){return e.id===p1;});if(event===undefined){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Fel! Hittar inte delt\xE4vling ',p1,'!');}if(schedule===null||schedule.id!==event.schedule){if(event.schedule!==0&&event.schedule!==undefined){this.Server.loadSchedule(event.schedule,this.updateSchedule,this.Footers.errorHandler("Kan inte hämta startlista för tävlingen"));return null;}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Fel! Inget schema f\xF6r delt\xE4vlingen!');}}if(p2===undefined||p3===undefined){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/competition/'+id+'/report/'+p1+'/'+schedule.squads[0].id+'/1'});}p2=parseInt(p2,10);p3=parseInt(p3,10);var squad=schedule.squads.find(function(s){return s.id===p2;});var scores=this.Results.getScores(squad.id);scores=scores.sort(function(a,b){return a.position-b.position;});scores.forEach(function(s,i){return s.position=i+1;});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'results',className:'content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'selections'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EventSelector,{events:events,event:event,changeEvent:this.changeEvent}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SquadSelector,{schedule:schedule,squad:squad,setSquad:this.setSquad}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StageSelector,{stages:event.scores,stage:p3,setStage:this.setStage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(StageInfo,{stage:p3,event:event,results:this.Results}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'spacer',style:{flexGrow:1}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.ReportTable,{mode:this.Configuration.mode,event:event,stage:p3,scores:scores}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.NextButton,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.QueueButton,null));}}]);return ReportTab;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);ReportTab.register={name:"ReportTab"};ReportTab.wire=["fire","Competition","Registration","Results","Server","ReportTable","EventBus","Events","Footers","Configuration","ReportIndicator"];ReportTab.tabInfo=new __WEBPACK_IMPORTED_MODULE_3__models__["TabInfo"]("Rapportera","report",200,__WEBPACK_IMPORTED_MODULE_3__models__["Permissions"].Admin);

/***/ }),
/* 346 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResultTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Result_css__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Result_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Result_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ResultTab=function(_React$Component){_inherits(ResultTab,_React$Component);function ResultTab(props){_classCallCheck(this,ResultTab);var _this=_possibleConstructorReturn(this,(ResultTab.__proto__||Object.getPrototypeOf(ResultTab)).call(this,props));_initialiseProps.call(_this);var params=_this.props.match.params;_this.state={division:params.p2,filter:""};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.competitionUpdated,function(){_this.updateTitle();_this.loadTeams();_this.setState({});});_this.loadResults();_this.subscribe(_this.Events.resultsUpdated,_this.updateResults);return _this;}_createClass(ResultTab,[{key:'updateTitle',value:function updateTitle(){var title='Resultat f\xF6r '+this.Competition.name;var event=this.Competition.event(parseInt(this.props.match.params.p1,10));if(event!=null&&event.name!==''){title+=' / '+event.name;}this.fire(this.Events.changeTitle,title);}},{key:'componentDidMount',value:function componentDidMount(){this.updateTitle();this.interval=setInterval(this.loadResults,5*60*1000);}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.updateTitle();}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.interval);}},{key:'eventClass',value:function eventClass(e){return e.id===parseInt(this.props.match.params.p1,10)?"button":"button white";}},{key:'updateEvent',value:function updateEvent(event){this.Results.load(this.Competition.id,event);}},{key:'divisionList',value:function divisionList(event){if(event===undefined||event.divisions===undefined){return[];}var divs=this.DivisionGroups.find(function(g){return g.id===event.divisions;});if(divs==null)return[];return divs.divisions.filter(function(d){return!d.includes('+');}).filter(function(d){return!d.match(/^!/);});}},{key:'separateScores',value:function separateScores(event,scores){if(event.classes===undefined){return[scores];}var result={};scores.forEach(function(s){if(result[s.class]===undefined){result[s.class]=[];}result[s.class].push(s);});return Object.keys(result).map(function(k){return result[k];});}},{key:'filterScores',value:function filterScores(event,division){return event.divisions===undefined||division===undefined?this.separateScores(event,this.Results.scores):this.separateScores(event,this.Results.scores.filter(function(s){return s.division===division;}));}},{key:'render',value:function render(){var _this2=this;var _props$match$params=this.props.match.params,id=_props$match$params.id,p1=_props$match$params.p1,p2=_props$match$params.p2,p3=_props$match$params.p3;var competition=this.Competition;if(id===undefined){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,'Fel - ingen t\xE4vling angiven!');}if(competition.id!==id){competition.load(id);return null;}if(p1===undefined){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/competition/'+competition.id+'/results/'+competition.events[0].id});}p1=parseInt(p1,10);var event=competition.event(p1);if(this.Results.event!==event.id){this.Results.load(id,p1);return null;}if(p2===undefined){if(event.divisions){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/competition/'+this.Competition.id+'/results/'+p1+'/'+this.divisionList(event)[0]});}}if(this.Results.scores===undefined){return null;}var results=this.filterScores(event,p2);var scorecard=parseInt(p3,10)||parseInt(p2,10);if(!isNaN(scorecard)){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'result',className:'content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["Scorecard"],{competition:competition,event:event,show:scorecard,results:results}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'globaltool',onClick:function onClick(){return _this2.props.history.replace('/competition/'+id+'/results/'+p1+(p2&&isNaN(p2)?'/'+p2:""));}},'< Tillbaka'),competition.permissions>=__WEBPACK_IMPORTED_MODULE_3__models__["Permissions"].Admin&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'globaltool',onClick:this.updateScorecard},'Spara'));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'result',className:'content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'result-tools'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'result-filter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{id:'filter-label'},'S\xF6ktext'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{id:'filter-input',value:this.state.filter,onChange:function onChange(e){return _this2.setState({filter:e.target.value});}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.EventSelector,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.DivisionSelector,{event:event,active:p2})),// Custom code for SM 2022
parseInt(competition.id,10)===205&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('i',null,'Resultatlistorna \xE4r prelimin\xE4ra och resultat kan saknas f\xF6r skyttar som \xE4nnu inte skjutit klart, de slutgiltiga resultatlistorna kommer att publiceras p\xE5 SM-sidan.')),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["ParticipantResult"],{competition:competition,event:event,results:results,division:p2,filter:this.state.filter}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["TeamResult"],{competition:competition,event:event,results:results,division:p2,teams:this.state.teams,filter:this.state.filter}));}}]);return ResultTab;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);ResultTab.register={name:"ResultTab"};ResultTab.wire=["Server","EventBus","Events","Competition","Results","DivisionGroups"];ResultTab.tabInfo=new __WEBPACK_IMPORTED_MODULE_3__models__["TabInfo"]("Resultat","results",4,__WEBPACK_IMPORTED_MODULE_3__models__["Permissions"].Any,__WEBPACK_IMPORTED_MODULE_3__models__["Status"].Closed);var _initialiseProps=function _initialiseProps(){var _this3=this;this.loadResults=function(){var params=_this3.props.match.params;if(params.token!==undefined){_this3.Results.load(params.id,params.token);}};this.updateResults=function(){_this3.setState({});};this.loadTeams=function(){var _props$match$params2=_this3.props.match.params,id=_props$match$params2.id,p1=_props$match$params2.p1;var callback=function callback(json){_this3.setState({teams:json});};var error=function error(){};_this3.Server.loadTeams(id,p1,callback,error);};this.EventSelector=function(props){if(_this3.Competition.events.length<2){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'event-selector'},_this3.Competition.events.map(function(e){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{key:e.id,className:_this3.eventClass(e),onClick:function onClick(){return _this3.updateEvent(e.id);},to:'/competition/'+_this3.Competition.id+'/results/'+e.id},e.name);}));};this.DivisionSelector=function(props){var event=props.event,active=props.active;if(active===undefined){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'division-selector'},_this3.divisionList(event).sort().map(function(d){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{key:d,className:d===active?"button":"button white",to:'/competition/'+_this3.Competition.id+'/results/'+event.id+'/'+d},d);}));};this.updateScorecard=function(){var _props$match$params3=_this3.props.match.params,p1=_props$match$params3.p1,p2=_props$match$params3.p2,p3=_props$match$params3.p3;var scorecard=parseInt(p2,10)||parseInt(p3,10);if(!isNaN(scorecard)){var event=_this3.Competition.events.find(function(e){return e.id===parseInt(p1,10);});var participant=_this3.Results.scores.find(function(s){return s.id===scorecard;});var model=__WEBPACK_IMPORTED_MODULE_3__models__["ScoringModels"].getModel(event.discipline);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=participant.scores[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var score=_step.value;console.log("ResultTab::updateScorecard",score);if(!model.validateScore(participant,event,score.stage)){alert('Station/serie '+score.stage+' - '+participant.error);participant.error=undefined;return;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}_this3.Results.updateScore(parseInt(p1,10),scorecard);}};};

/***/ }),
/* 348 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RosterTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Roster_css__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Roster_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Roster_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function Participant(_ref){var participant=_ref.participant,allowDrag=_ref.allowDrag,_onDragStart=_ref.onDragStart;return[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'rv-participant',key:'n',draggable:allowDrag,onDragStart:function onDragStart(e){return _onDragStart(e,participant);}},' ',participant.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'rv-participant',key:'o'},participant.organization),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'rv-participant rv-class',key:'d'},participant.division?participant.division.replace(/^!/gm,''):null)];}function SquadHeader(_ref2){var squad=_ref2.squad,dropTarget=_ref2.dropTarget;var headerClass="rv-squad-header";if(squad.slots!==undefined){if(squad.participants.length>squad.slots)headerClass="rv-squad-header over-capacity";if(squad.participants.length===squad.slots)headerClass="rv-squad-header full";}// if (squad === this.dropTarget) headerClass = "rv-squad-header drop-target";
if(dropTarget){headerClass+=" drop-target";}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:headerClass},squad.startTime?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,squad.startTime):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,squad.name),squad.slots&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span',null,squad.participants.length,'/',squad.slots));}function Spacer(){var style={gridRow:1};return[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'h1',style:style}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'h2',style:style}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:'h3',style:style})];}var Squad=function(_React$Component){_inherits(Squad,_React$Component);function Squad(props){_classCallCheck(this,Squad);var _this=_possibleConstructorReturn(this,(Squad.__proto__||Object.getPrototypeOf(Squad)).call(this,props));_this.state={dropTarget:false};_this.dropCount=0;return _this;}_createClass(Squad,[{key:'render',value:function render(){var _this2=this;var _props=this.props,squad=_props.squad,members=_props.members,allowDrag=_props.allowDrag,dropTarget=_props.dropTarget,onDragStart=_props.onDragStart,onDrag=_props.onDrag,_onDrop=_props.onDrop;if(members.length===0){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'rv-squad',onDragEnter:function onDragEnter(e){onDrag(e,squad);if(dropTarget&&_this2.dropCount++===0){_this2.setState({dropTarget:true});}},onDragOver:function onDragOver(e){e.preventDefault();e.dataTransfer.dropEffect="move";},onDragLeave:function onDragLeave(e){if(dropTarget&&--_this2.dropCount===0){_this2.setState({dropTarget:false});}},onDrop:function onDrop(e){_this2.setState({dropTarget:false});_onDrop(e.dataTransfer.getData("text/json"),squad.id);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SquadHeader,{squad:squad,dropTarget:this.state.dropTarget}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'rv-squad-list'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Spacer,null),members.sort(function(a,b){return a.position-b.position;}).flatMap(function(p,i){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Participant,{key:p.id||i,index:p.id||i,participant:p,allowDrag:allowDrag,onDragStart:onDragStart});})));}}]);return Squad;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var RosterTab=function(_React$Component2){_inherits(RosterTab,_React$Component2);function RosterTab(props){_classCallCheck(this,RosterTab);var _this3=_possibleConstructorReturn(this,(RosterTab.__proto__||Object.getPrototypeOf(RosterTab)).call(this,props));_this3.loadSchedules=function(){_this3.state.events.forEach(function(e){if(e.scheduleId===undefined){var i=0;_this3.Server.loadRoster(_this3.Competition.id,function(json){e.schedule={squads:[{id:i++,name:"Deltagare",participants:json}]};_this3.setState({});},_this3.Footers.errorHandler(RosterTab.E_CANNOT_LOAD_PARTICIPANTS));}else{_this3.Server.loadSchedule(e.scheduleId,function(json){_this3.Server.loadParticipants(e.scheduleId,function(pJson){var schedule={};__WEBPACK_IMPORTED_MODULE_2__models__["Schedule"].fromJson(json,pJson).squads.forEach(function(s){if(schedule[s.startTime]==null){schedule[s.startTime]=s;}else{schedule[s.startTime].participants=schedule[s.startTime].participants.concat(s.participants);schedule[s.startTime].slots+=s.slots;}});e.schedule={squads:Object.values(schedule)};_this3.setState({});},_this3.Footers.errorHandler(RosterTab.E_CANNOT_LOAD_PARTICIPANTS));},_this3.Footers.errorHandler(RosterTab.E_CANNOT_LOAD_SCHEDULE));}});};_this3.dragStart=function(e,participant){e.dataTransfer.setData("text/json",JSON.stringify(participant));var event=_this3.state.events.find(function(e){return e.schedule!==undefined&&e.schedule.squads.some(function(s){return s.participants.some(function(p){return p.id===participant.id;});});});_this3.setState({dragEvent:event});};_this3.moveTo=function(json,squadId){var participant=JSON.parse(json);// participant = Participant.fromJson({ participant: participant });  Gah!!!  FIX!!!
participant.dirty=true;_this3.state.events.forEach(function(e){if(e.schedule){var from=e.schedule.squads.find(function(s){return s.participants.some(function(p){return p.id===participant.id;});});var to=e.schedule.squads.find(function(s){return s.id===squadId;});if(from&&to){from.participants=from.participants.filter(function(p){return p.id!==participant.id;});to.participants.push(participant);from.dirty=true;to.dirty=true;}}});_this3.dropTarget=null;_this3.setState({dragEvent:null});// this.setState({ dropTarget: null });
};_this3.saveChanges=function(){_this3.state.events.forEach(function(e){if(e.schedule){var changed=[];e.schedule.squads.forEach(function(s){if(s.dirty){s.dirty=false;var position=1;s.participants.forEach(function(p){return changed.push({position:position++,id:parseInt(p.id,10),squad_id:s.id});});}});if(changed.length>0){console.log("Updating schedule",e,changed);_this3.Server.updateParticipants(e.scheduleId,changed,function(){return alert('Schedule '+e.scheduleId+' updated successfully!');},function(err){return alert('Problem updating '+e.scheduleId+': '+err.message);});}}});};_this3.match=function(s){return s.toUpperCase().includes(_this3.state.filter.toUpperCase());};_this3.Event=function(_ref3){var event=_ref3.event;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'rv-event'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,event.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'subtitle'},event.schedule===undefined?0:event.schedule.squads.map(function(c){return c.participants.length;}).reduce(function(a,c){return a+c;},0),' starter'),event.schedule&&event.schedule.squads.map(function(s){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Squad,{key:s.id,squad:s,members:s.participants.filter(function(p){return _this3.match(p.name)||_this3.match(p.organization);}),allowDrag:_this3.Session.user!=="",dropTarget:event===_this3.state.dragEvent,onDragStart:_this3.dragStart,onDrag:function onDrag(e){return _this3.dropTarget=s;},onDrop:_this3.moveTo});}));};_this3.state={events:_this3.constructEvents(),filter:""};_this3.loadSchedules();_this3.EventBus.manageEvents(_this3);return _this3;}_createClass(RosterTab,[{key:'componentDidMount',value:function componentDidMount(){this.fire(this.Events.changeTitle,'Startlista f\xF6r '+this.Competition.name);}},{key:'constructEvents',value:function constructEvents(){var _this4=this;var events=this.Competition.events.map(function(e){return{name:e.name!==""?e.name:_this4.Competition.name,scheduleId:e.schedule};});// .filter(e => e.scheduleId !== undefined);
if(events.length===1&&events[0].name==="")events[0].name=this.Competition.name;return events;}},{key:'render',value:function render(){var _this5=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'roster-view',className:'content roster'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'roster-filter'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{id:'filter-label'},'S\xF6ktext'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{id:'filter-input',value:this.state.filter,onChange:function onChange(e){return _this5.setState({filter:e.target.value});}})),this.Session.user!==""&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'globaltool',onClick:this.saveChanges},'Spara'),this.state.events.map(function(e){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this5.Event,{event:e,key:e.name});}));}}]);return RosterTab;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);RosterTab.register={name:"RosterTab"};RosterTab.wire=["Competition","Server","Footers","Session","EventBus","Events"];RosterTab.tabInfo=new __WEBPACK_IMPORTED_MODULE_2__models__["TabInfo"]("Startlista","roster",3,__WEBPACK_IMPORTED_MODULE_2__models__["Permissions"].Any);RosterTab.E_CANNOT_LOAD_SCHEDULE="Kan inte hämta starttider";RosterTab.E_CANNOT_LOAD_PARTICIPANTS="Kan inte hämta deltagare";

/***/ }),
/* 350 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamAdminTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TeamAdminTabInfo=function(_TabInfo){_inherits(TeamAdminTabInfo,_TabInfo);function TeamAdminTabInfo(){_classCallCheck(this,TeamAdminTabInfo);return _possibleConstructorReturn(this,(TeamAdminTabInfo.__proto__||Object.getPrototypeOf(TeamAdminTabInfo)).apply(this,arguments));}_createClass(TeamAdminTabInfo,[{key:'show',value:function show(competition){return false;// Tab is deprecated
}}]);return TeamAdminTabInfo;}(__WEBPACK_IMPORTED_MODULE_2__models__["TabInfo"]);var TeamAdminTab=function(_React$Component){_inherits(TeamAdminTab,_React$Component);function TeamAdminTab(props){var _this3=this;_classCallCheck(this,TeamAdminTab);var _this2=_possibleConstructorReturn(this,(TeamAdminTab.__proto__||Object.getPrototypeOf(TeamAdminTab)).call(this,props));_this2.resendMail=function(reg){_this2.Server.sendNewToken({competition:_this2.Competition.id,email:reg.email},function(json){_this2.Footers.addFooter("Nytt mail skickas","info");});};_this2.Reg=function(_ref){var reg=_ref.reg;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'registration-link'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'registration-button tooltip',tooltip:'Skicka ny bekr\xE4ftelse','tooltip-position':'right',onClick:function onClick(){return _this2.resendMail(reg);}},'\u21BB'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{className:'registration-button tooltip',tooltip:'Skicka mail till anm\xE4laren','tooltip-position':'right',href:'mailto:'+reg.email},'\u2709'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/competition/'+_this2.Competition.id+'/teams/'+reg.token},reg.organization,' <',reg.email,'>'));};_this2.Registrations=function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Laganm\xE4lningar'),_this2.state.registrations.map(function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(_this3.Reg,{reg:r,key:r.token});}));};_this2.state={registrations:[]};_this2.Server.getTeamRegistrations(_this2.Competition.id,function(json){_this2.setState({registrations:json});});_this2.EventBus.manageEvents(_this2);return _this2;}_createClass(TeamAdminTab,[{key:'componentDidMount',value:function componentDidMount(){this.fire(this.Events.changeTitle,'Administrera lag till '+this.Competition.name);}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.Registrations,null));}}]);return TeamAdminTab;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);TeamAdminTab.register={name:"TeamAdminTab"};TeamAdminTab.wire=["Server","Competition","Configuration","Events","EventBus","Footers"];TeamAdminTab.tabInfo=new TeamAdminTabInfo("Administrera lag","teamadmin",202,__WEBPACK_IMPORTED_MODULE_2__models__["Permissions"].Admin);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TeamTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Team_css__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Team_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Team_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TeamTabInfo=function(_TabInfo){_inherits(TeamTabInfo,_TabInfo);function TeamTabInfo(){_classCallCheck(this,TeamTabInfo);return _possibleConstructorReturn(this,(TeamTabInfo.__proto__||Object.getPrototypeOf(TeamTabInfo)).apply(this,arguments));}_createClass(TeamTabInfo,[{key:'show',value:function show(competition){return _get(TeamTabInfo.prototype.__proto__||Object.getPrototypeOf(TeamTabInfo.prototype),'show',this).call(this,competition)&&competition.events&&competition.events.some(function(e){return e.teams&&e.teams.length>0;});}}]);return TeamTabInfo;}(__WEBPACK_IMPORTED_MODULE_3__models__["TabInfo"]);var TeamTab=function(_React$Component){_inherits(TeamTab,_React$Component);function TeamTab(props){_classCallCheck(this,TeamTab);var _this2=_possibleConstructorReturn(this,(TeamTab.__proto__||Object.getPrototypeOf(TeamTab)).call(this,props));_this2.onRegistrationUpdated=function(){var teamDefs=_this2.state.teamDefs;_this2.Registration.teams.forEach(function(team){teamDefs.forEach(function(def,index){if(def.eventId===team.event&&def.index===team.index){team.teamDef=index.toString();}});});_this2.setState({});_this2.Busy.setBusy(TeamTab.BUSY_LOAD_REGISTRATION,false);};_this2.onChangeContact=function(prop,value){_this2.fire(_this2.Events.setRegistrationInfo,prop,value);};_this2.addTeam=function(){var teamDefs=_this2.state.teamDefs;_this2.Registration.teams.push(new __WEBPACK_IMPORTED_MODULE_3__models__["Team"]('Lag '+(_this2.Registration.teams.length+1),teamDefs[0].eventId,teamDefs[0].index,teamDefs[0].id));_this2.setState({});};_this2.deleteTeam=function(idx){_this2.Registration.teams=_this2.Registration.teams.filter(function(v,i){return i!==idx;});_this2.setState({});};_this2.state={teams:[],teamDefs:_this2.teamDefs()};_this2.EventBus.manageEvents(_this2);_this2.subscribe(_this2.Events.competitionUpdated,function(){_this2.setState({});_this2.fire(_this2.Events.changeTitle,'Laganm\xE4lan f\xF6r '+_this2.Competition.name);});_this2.subscribe(_this2.Events.registrationUpdated,_this2.onRegistrationUpdated);var _props$match$params=props.match.params,id=_props$match$params.id,p1=_props$match$params.p1;if(id){_this2.Competition.load(parseInt(id,10));_this2.Busy.setBusy(TeamTab.BUSY_LOAD_PARTICIPANTS,true);_this2.Server.getCompetitionParticipants(id,function(json){_this2.setState({participants:json.map(function(j){return __WEBPACK_IMPORTED_MODULE_3__models__["ParticipantScore"].fromJson(j);})});_this2.Busy.setBusy(TeamTab.BUSY_LOAD_PARTICIPANTS,false);},_this2.Footers.errorHandler("Kan inte hämta deltagare!"));if(p1){_this2.Busy.setBusy(TeamTab.BUSY_LOAD_REGISTRATION);_this2.Registration.load(id,p1);}}return _this2;}_createClass(TeamTab,[{key:'componentDidMount',value:function componentDidMount(){this.fire(this.Events.changeTitle,'Laganm\xE4lan f\xF6r '+this.Competition.name);}},{key:'teamDefs',value:function teamDefs(){return this.Competition.events.flatMap(function(e){return e.teams.map(function(t,i){return Object.assign({},t,{event:e.name,eventId:e.id,index:i});});});}},{key:'render',value:function render(){var _this3=this;var _props$match$params2=this.props.match.params,id=_props$match$params2.id,p1=_props$match$params2.p1;if(!p1&&this.Registration.token){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/competition/'+id+'/teams/'+this.Registration.token});}var _state=this.state,participants=_state.participants,teamDefs=_state.teamDefs;var _Registration$contact=this.Registration.contact,name=_Registration$contact.name,organization=_Registration$contact.organization,email=_Registration$contact.email,account=_Registration$contact.account;if(participants!==undefined){participants=participants.filter(function(p){return p.organization===organization;});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["Description"],{value:this.Competition.description}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["NewRegistrationContact"],{name:name,organization:organization,email:email,account:account,showAccount:'true',onChange:this.onChangeContact}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["TeamForm"],{competition:this.Competition,teamDefs:teamDefs,teams:this.Registration.teams,participants:participants,onDelete:function onDelete(idx){return _this3.deleteTeam(idx);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button',onClick:this.addTeam},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'button small green button-add'}),' L\xE4gg till lag'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{type:'button',className:'button',value:'Anm\xE4l lag',onClick:function onClick(){return _this3.Registration.registerTeams();}})));}}]);return TeamTab;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);TeamTab.register={name:"TeamTab"};TeamTab.wire=["EventBus","Events","Server","Busy","Competition","Footers","Registration","TeamRegistration","Busy"];TeamTab.tabInfo=new TeamTabInfo("Laganmälan","teams",2,__WEBPACK_IMPORTED_MODULE_3__models__["Permissions"].Any,__WEBPACK_IMPORTED_MODULE_3__models__["Status"].Open);TeamTab.BUSY_LOAD_PARTICIPANTS="loadTeamParticipants";TeamTab.BUSY_LOAD_REGISTRATION="loadTeamRegistration";

/***/ }),
/* 353 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TiebreakerTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(7);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var sum=function sum(a,b){return a+b;};var tgt=function tgt(x){return x>0;};var sort=function sort(a,b){var pos=0;while(pos<a.length&&pos<b.length){if(a[pos]===b[pos]){pos++;}else{return b[pos]-a[pos];}}return 0;};var TiebreakerTab=function(_React$Component){_inherits(TiebreakerTab,_React$Component);function TiebreakerTab(props){_classCallCheck(this,TiebreakerTab);var _this=_possibleConstructorReturn(this,(TiebreakerTab.__proto__||Object.getPrototypeOf(TiebreakerTab)).call(this,props));_initialiseProps.call(_this);var p2=_this.props.match.params.p2;_this.state={division:p2,filter:""};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.competitionUpdated,function(){_this.updateTitle();_this.setState({});});_this.loadResults();_this.subscribe(_this.Events.resultsUpdated,_this.updateResults);return _this;}_createClass(TiebreakerTab,[{key:'updateTitle',value:function updateTitle(){var title='Resultat f\xF6r '+this.Competition.name;var event=this.Competition.event(parseInt(this.props.match.params.p1,10));if(event!=null&&event.name!==''){title+=' / '+event.name;}this.fire(this.Events.changeTitle,title);}},{key:'componentDidMount',value:function componentDidMount(){this.updateTitle();this.interval=setInterval(this.loadResults,5*60*1000);}},{key:'componentDidUpdate',value:function componentDidUpdate(){this.updateTitle();}},{key:'componentWillUnmount',value:function componentWillUnmount(){clearInterval(this.interval);}},{key:'eventClass',value:function eventClass(e){return e.id===parseInt(this.props.match.params.token,10)?"button":"button white";}},{key:'updateEvent',value:function updateEvent(event){this.Results.load(this.Competition.id,event);}},{key:'divisionList',value:function divisionList(event){if(event===undefined||event.divisions===undefined){return[];}var divs=this.DivisionGroups.find(function(g){return g.id===event.divisions;});if(divs==null)return[];return divs.divisions.filter(function(d){return!d.includes('+');}).filter(function(d){return!d.match(/^!/);});}},{key:'separateScores',value:function separateScores(event,scores){if(event.classes===undefined){return[scores];}var result={};scores.forEach(function(s){if(result[s.class]===undefined){result[s.class]=[];}result[s.class].push(s);});return Object.keys(result).map(function(k){return result[k];});}},{key:'filterScores',value:function filterScores(event,division){return event.divisions===undefined||division===undefined?this.separateScores(event,this.Results.scores):this.separateScores(event,this.Results.scores.filter(function(s){return s.division===division;}));}},{key:'calculateScores',value:function calculateScores(event,results){var stages=[];event.stages.forEach(function(s){return stages[s.num]=s;});var participants=results.map(function(p){var scores=[],targets=[],value=0;for(var i=0;i<event.scores;i++){scores[i]=0;targets[i]=0;}p.scores.forEach(function(s){if(s.stage<=event.scores){var score=[].concat(_toConsumableArray(s.values));if(stages[s.stage].value){value+=score.pop();}scores[s.stage-1]=score.reduce(sum);targets[s.stage-1]=score.filter(tgt).length;}});return{id:p.id,name:p.name,organization:p.organization,scores:scores,targets:targets,class:p.class,total:[scores.reduce(sum),targets.reduce(sum),value]};});return participants.sort(function(a,b){return sort(a.total,b.total);});}},{key:'render',value:function render(){var _props$match$params=this.props.match.params,id=_props$match$params.id,eventId=_props$match$params.eventId;if(id===undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,'Fel - ingen t\xE4vling angiven!');}if(this.Competition.id!==id){this.Competition.load(id);return null;}if(eventId===undefined){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */],{to:'/tiebreaker/'+this.Competition.id+'/'+this.Competition.events[0].id});}eventId=parseInt(eventId,10);var event=this.Competition.events.find(function(e){return e.id===eventId;});if(this.Results.event!==event.id){this.Results.load(id,eventId);return null;}if(this.Results.scores===undefined){return null;}var results=this.filterScores(event);results=this.calculateScores(event,this.Results.scores);var ties=[],i=0;while(i<3){console.log("compare",results[i].total[0],results[i+1].total[0]);if(results[i].total[0]===results[i+1].total[0]){ties.push(results[i++]);while(results[i].total[0]===results[i-1].total[0]){ties.push(results[i++]);}}else{i++;}}console.log(ties);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'result',className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.EventSelector,null),ties.map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{key:p.id},p.name,' ',p.total[0]);}));}}]);return TiebreakerTab;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);TiebreakerTab.register={name:"TiebreakerView"};TiebreakerTab.wire=["Events","EventBus","Competition","Results"];var _initialiseProps=function _initialiseProps(){var _this2=this;this.loadResults=function(){var params=_this2.props.match.params;if(params.token!==undefined){_this2.Results.load(params.id,params.token);}};this.updateResults=function(){_this2.setState({});};this.EventSelector=function(props){if(_this2.Competition.events.length<2){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{id:'event-selector'},_this2.Competition.events.map(function(e){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{key:e.id,className:_this2.eventClass(e),onClick:function onClick(){return _this2.updateEvent(e.id);},to:'/competition/'+_this2.Competition.id+'/results/'+e.id},e.name);}));};this.DivisionSelector=function(props){var event=props.event,active=props.active;if(active===undefined){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'toolbar'},_this2.divisionList(event).sort().map(function(d){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{key:d,className:d===active?"button":"button white",to:'/competition/'+_this2.Competition.id+'/results/'+event.id+'/'+d},d);}));};this.updateScorecard=function(){var _props$match$params2=_this2.props.match.params,p1=_props$match$params2.p1,p2=_props$match$params2.p2,p3=_props$match$params2.p3;var scorecard=parseInt(p2,10)||parseInt(p3,10);if(!isNaN(scorecard)){var event=_this2.Competition.events.find(function(e){return e.id===parseInt(p1,10);});var participant=_this2.Results.scores.find(function(s){return s.id===scorecard;});var _loop=function _loop(score){var stageDef=event.stages.find(function(s){return s.num===score.stage;});if(!participant.validateScore(stageDef)){alert('Station '+score.stage+' - '+participant.error);participant.error=undefined;return{v:void 0};}};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=participant.scores[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var score=_step.value;var _ret=_loop(score);if((typeof _ret==='undefined'?'undefined':_typeof(_ret))==="object")return _ret.v;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}_this2.Results.updateScore(parseInt(p1,10),scorecard);}};};

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompetitionAdminTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CompetitionAdminTab=function(_React$Component){_inherits(CompetitionAdminTab,_React$Component);function CompetitionAdminTab(props){_classCallCheck(this,CompetitionAdminTab);var _this=_possibleConstructorReturn(this,(CompetitionAdminTab.__proto__||Object.getPrototypeOf(CompetitionAdminTab)).call(this,props));_this.state={};_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.competitionUpdated,function(){_this.setState({});_this.fire(_this.Events.changeTitle,'Inst\xE4llningar f\xF6r '+_this.Competition.name);});return _this;}_createClass(CompetitionAdminTab,[{key:'componentDidMount',value:function componentDidMount(){this.fire(this.Events.changeTitle,'Inst\xE4llningar f\xF6r '+this.Competition.name);}},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:this.Competition.dirty?"button":"button disabled",onClick:function onClick(){return _this2.Competition.saveCompetition();}},'Spara'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.CompetitionProperties,null));}}]);return CompetitionAdminTab;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);CompetitionAdminTab.register={name:"CompetitionAdminTab"};CompetitionAdminTab.wire=["fire","Events","EventBus","Server","CompetitionProperties","Competition","Footers"];CompetitionAdminTab.tabInfo=new __WEBPACK_IMPORTED_MODULE_1__models__["TabInfo"]("Inställningar","admin",204,__WEBPACK_IMPORTED_MODULE_1__models__["Permissions"].Admin);

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateCompetition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateCompetition_css__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateCompetition_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__CreateCompetition_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CreateCompetition=function(_React$Component){_inherits(CreateCompetition,_React$Component);function CreateCompetition(props){_classCallCheck(this,CreateCompetition);var _this=_possibleConstructorReturn(this,(CreateCompetition.__proto__||Object.getPrototypeOf(CreateCompetition)).call(this,props));_this.createCompetition=function(){if(_this.Competition.name===""){_this.Footers.addFooter("Tävlingen måste ha ett namn!");return;}_this.Server.createCompetition(_this.Competition.toJson(),function(response){// ToDo: unsub?
_this.Storage.set(_this.Storage.keys.newCompetition,null);_this.setState({redirect:response.id});},_this.Footers.errorHandler("Kan inte skapa tävling"));};_this.clearForm=function(){_this.Competition.initialize();_this.Storage.set(_this.Storage.keys.newCompetition,null);_this.setState({});};_this.state={};var data=_this.Storage.get(_this.Storage.keys.newCompetition);if(data){if(data.events){// patch to compendate for debug service
data.events.forEach(function(e){if(e.schedule&&e.schedule.id){e.schedule=e.schedule.id;}});// deserialize date strings
data.events.map(function(e){return __WEBPACK_IMPORTED_MODULE_3__models__["Event"].fromJson(e);});}else{data.events=[];}// handle old format
if(data.event&&data.events.length===0){data.events.push(new __WEBPACK_IMPORTED_MODULE_3__models__["Event"](1,data.event.name,new Date(data.event.date)));_this.Competition.nextNewEvent=2;}if(data.events.length===0){data.events.push(new __WEBPACK_IMPORTED_MODULE_3__models__["Event"](1,"",new Date()));_this.Competition.nextNewEvent=2;}}_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.competitionUpdated,function(){if(_this.state.redirect===undefined){_this.Storage.set(_this.Storage.keys.newCompetition,_this.Competition.toJson());}else{if(window._debug)console.log("Suppressing store due to redirect");}});_this.Competition.initialize();_this.Competition.fromJson(data);return _this;}_createClass(CreateCompetition,[{key:'componentDidMount',value:function componentDidMount(){this.EventBus.fire(this.Events.changeTitle,"Skapa ny tävling");}},{key:'render',value:function render(){if(this.state.redirect){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/competition/'+this.state.redirect+'/admin'});}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:'saveButton',className:'createTool button',onClick:this.createCompetition},'Skapa t\xE4vling'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{id:'clearButton',className:'createTool button',onClick:this.clearForm},'Rensa formul\xE4r'),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.CompetitionProperties,null));}}]);return CreateCompetition;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);CreateCompetition.register={name:"CreateCompetition"};CreateCompetition.wire=["Storage","Competition","CompetitionProperties","EventBus","Events","Server","Footers"];

/***/ }),
/* 357 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ComponentTest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var divisionGroups=[{id:1,description:"SPSF Precision",divisions:["A","B","C"]},{id:2,description:"SPSF Fält",divisions:["A","B","C","R","A+R"]}];var schedule=new __WEBPACK_IMPORTED_MODULE_1__models__["Schedule"]();schedule.addSquad("8:30",20,["A"],false);schedule.addSquad("9:00",10,["C"],false);schedule.addSquad("9:30",15,["C","B","A"],true);schedule.addSquad("10:00",20,["C","B","A"],false);schedule.squads[1].participants.push(new __WEBPACK_IMPORTED_MODULE_1__models__["Participant"](new __WEBPACK_IMPORTED_MODULE_1__models__["Person"]("Patrik Manlig",1,"Gävle PK")));schedule.squads[1].participants.push(new __WEBPACK_IMPORTED_MODULE_1__models__["Participant"](new __WEBPACK_IMPORTED_MODULE_1__models__["Person"]("Johan Söderberg",2,"Gävle PK")));schedule.squads[1].participants.push(new __WEBPACK_IMPORTED_MODULE_1__models__["Participant"](new __WEBPACK_IMPORTED_MODULE_1__models__["Person"]("Tor Kangas",3,"Gävle PK")));schedule.squads[1].participants.push(new __WEBPACK_IMPORTED_MODULE_1__models__["Participant"](new __WEBPACK_IMPORTED_MODULE_1__models__["Person"]("Åsa Juhlén",4,"Gävle PK")));var ComponentTest=function(_React$Component){_inherits(ComponentTest,_React$Component);function ComponentTest(props){_classCallCheck(this,ComponentTest);var _this=_possibleConstructorReturn(this,(ComponentTest.__proto__||Object.getPrototypeOf(ComponentTest)).call(this,props));_this.state={showDialog:true};var registration={competition:"1",contact:{name:"Patrik Manlig",email:"ordforande@gavlepistol.se",organization:"Gävle PK",account:"344085-6"},registration:[{participant:{name:"Patrik Manlig",id:"28283",organization:"Gävle PK"},entries:[{event:3,rounds:[{}]}]}]};_this.Server.sendRegistration(registration,function(res){console.log("OK:");console.log(res);},function(error){console.log("Error:");console.log(error);});return _this;}_createClass(ComponentTest,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-close small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-add small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-previous small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-next small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-expand small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-collapse small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-down small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-up small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-left small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-right small'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-close'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-add'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-previous'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-next'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-expand'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-collapse'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-down'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-up'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-right'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-close large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-add large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-previous large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-next large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-expand large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-collapse large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-down large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-up large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-left large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-right large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-close x-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-add x-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-previous x-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-next x-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-expand x-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-collapse x-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-down x-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-up x-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-left x-large'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'button button-right x-large'}),this.state.showDialog&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.ScheduleProperties,{schedule:schedule,divisions:divisionGroups[1],onClose:function onClose(e){return _this2.setState({showDialog:false});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(this.SquadPicker,{schedule:schedule}));}}]);return ComponentTest;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);ComponentTest.wire=["ScheduleProperties","SquadPicker","Server"];

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AboutView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var AboutView=function(_React$Component){_inherits(AboutView,_React$Component);function AboutView(){_classCallCheck(this,AboutView);return _possibleConstructorReturn(this,(AboutView.__proto__||Object.getPrototypeOf(AboutView)).apply(this,arguments));}_createClass(AboutView,[{key:"componentDidMount",value:function componentDidMount(){this.EventBus.fire(this.Events.changeTitle,"Om systemet");}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{id:"about",className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",null,"Om t\xE4vlingsanm\xE4lan G\xE4vle PK"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Det h\xE4r anm\xE4lningssystemet \xE4r framtaget f\xF6r att hantera f\xF6ranm\xE4lningar till skyttet\xE4vlingar. Vi vet att det finns flera andra system, men n\xE4r vi b\xF6rjade fanns det inget system som vi enkelt kunde anv\xE4nda f\xF6r v\xE5ra egna t\xE4vlingar. D\xE4rf\xF6r b\xF6rjade vi att g\xF6ra ett eget system runt 2014. N\xE4r vi b\xF6rjade best\xE4mde vi oss f\xF6r att g\xF6ra ett system som i framtiden \xE4ven skulle kunna anv\xE4ndas av andra som kanske skulle finna sig sj\xE4lva i samma sits som vi var i n\xE4r vi b\xF6rjade. I skrivande stund finns det andra system som liksom det h\xE4r systemet \xE4r m\xF6jligt f\xF6r andra att anv\xE4nda, men vi kommer \xE4nd\xE5 att forts\xE4tta utveckla det h\xE4r systemet och g\xF6ra det s\xE5 bra som m\xF6jligt!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"V\xE5ra m\xE5l med systemet \xE4r att det ska:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"G\xE5 att anv\xE4nda av andra \xE4n oss sj\xE4lva - vilken annan f\xF6rening som helst ska kunna administrera sina t\xE4vlingar i systemet."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"St\xF6dja alla typer av t\xE4vlingar oavsett om det \xE4r en t\xE4vling i Precision, F\xE4lt, PPC, IPSC eller n\xE5gon annan gren. Vilka vapengrupper/divisioner som g\xE5r att v\xE4lja i respektive gren ska vara konfigurerbart s\xE5 att systemet kan hantera vilken gren som helst."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Vara modernt och smidigt att anv\xE4nda. Systemet ska inte kr\xE4va att anv\xE4ndare skapar n\xE5gon inloggning och h\xE5ller r\xE4tt p\xE5 ett l\xF6senord.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Funktionalitet som vi h\xE5ller p\xE5 att l\xE4gga till inf\xF6r SM F\xE4lt 2022:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Resultathantering"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Mobilanpassning")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Systemet \xE4r skrivet i ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://reactjs.org/"},"React")," och ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"http://www.php.net/"},"PHP"),". Vi som har utvecklat systemet heter ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:ordforande@gavlepistol.se"},"Patrik Manlig")," (anv\xE4ndargr\xE4nssnitt) och Johan S\xF6derberg (tj\xE4nster och databas)."));}}]);return AboutView;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);AboutView.register={name:"AboutView"};AboutView.wire=["EventBus","Events"];

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Diagnostics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagnostics_css__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Diagnostics_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Diagnostics_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rxjs__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__test__ = __webpack_require__(116);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TestReport=function(_React$Component){_inherits(TestReport,_React$Component);function TestReport(props){_classCallCheck(this,TestReport);var _this=_possibleConstructorReturn(this,(TestReport.__proto__||Object.getPrototypeOf(TestReport)).call(this,props));_this.state={};props.bus.subscribe(function(_ref){var test=_ref.test,result=_ref.result;if(test===props.test)_this.setState({result:result});});return _this;}_createClass(TestReport,[{key:'className',value:function className(){return this.state.result===undefined?"running":this.state.result?"success":"fail";}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:"testResult "+this.className()},this.className()),this.props.description);}}]);return TestReport;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var Diagnostics=function(_React$Component2){_inherits(Diagnostics,_React$Component2);function Diagnostics(props){_classCallCheck(this,Diagnostics);var _this2=_possibleConstructorReturn(this,(Diagnostics.__proto__||Object.getPrototypeOf(Diagnostics)).call(this,props));_this2.runTests=function(tests){if(!tests){_this2.runTests(_this2.tests.concat([]));return;}var t=tests.shift();t.test().then(function(v){_this2.bus.next({test:t.test,result:v});_this2.runTests(tests);});};_this2.testLogin=function(){return new Promise(function(resolve){return _this2.Server.login("patrik","pangpang",function(s){return resolve(true);},function(e){return resolve(false);});});};_this2.testLogout=function(){return new Promise(function(resolve){return _this2.Server.logout(function(s){return resolve(true);},function(e){return resolve(false);});});};_this2.bus=new __WEBPACK_IMPORTED_MODULE_2_rxjs__["a" /* Subject */]();_this2.tests=[{test:_this2.testLogin,description:"Login"}].concat(new __WEBPACK_IMPORTED_MODULE_3__test__["ClassesTests"]().tests(),new __WEBPACK_IMPORTED_MODULE_3__test__["DivisionsTests"]().tests(),new __WEBPACK_IMPORTED_MODULE_3__test__["CompetitionTests"]().tests(),new __WEBPACK_IMPORTED_MODULE_3__test__["ScheduleTests"]().tests(),[{test:_this2.testLogout,description:"Logout"}]);window.setTimeout(_this2.runTests,10);return _this2;}_createClass(Diagnostics,[{key:'render',value:function render(){var _this3=this;var i=1;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'Diagnostics'),this.tests.map(function(t){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TestReport,{key:i++,test:t.test,bus:_this3.bus,description:t.description});}));}}]);return Diagnostics;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);Diagnostics.register={name:"Diagnostics"};Diagnostics.wire=["Server"];

/***/ }),
/* 361 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompetitionTests; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var CompetitionTests=function(){function CompetitionTests(){var _this=this;_classCallCheck(this,CompetitionTests);this.testCreateCompetition=function(){_this.testCompetition={name:"__TestTävlingen__",description:"Automattest",status:0,events:[{name:"",date:Date.now(),maxRegistrations:1,id:1}]};return new Promise(function(resolve){return _this.Server.createCompetition(_this.testCompetition,function(s){_this.testCompetition.id=s.id;resolve(true);},function(e){console.log(e.message);resolve(false);});});};this.testLoadCreatedCompetition=function(){return new Promise(function(resolve){return _this.Server.loadCompetition(_this.testCompetition.id,function(s){_this.testCompetition=s;console.log("Loaded competition");console.log(JSON.parse(JSON.stringify(_this.testCompetition)));resolve(_this.testCompetition.events[0].classes===undefined&&_this.testCompetition.events[0].divisions===undefined&&_this.testCompetition.events[0].divisionGroup===undefined);},function(e){console.log(e);resolve(false);});});};this.testLoadChangedCompetition=function(){return new Promise(function(resolve){return _this.Server.loadCompetition(_this.testCompetition.id,function(s){_this.testCompetition=s;resolve(parseInt(_this.testCompetition.events[0].classes.toString(),10)===1144&&parseInt(_this.testCompetition.events[0].divisions.toString(),10)===1170&&_this.testCompetition.events[0].divisionGroup===undefined);},function(e){console.log(e);resolve(false);});});};this.testUpdateCompetition=function(){_this.testCompetition.events[0].classes=1144;_this.testCompetition.events[0].divisions=1170;return new Promise(function(resolve){return _this.Server.updateCompetition(_this.testCompetition,function(s){return resolve(true);},function(e){console.log("Cannot update");console.log(e);resolve(false);});});};this.testDeleteCompetition=function(){return new Promise(function(resolve){return _this.Server.deleteCompetition(_this.testCompetition.id,function(s){return resolve(true);},function(e){return resolve(false);});});};this.testGetCompetitions=function(){return new Promise(function(resolve){return _this.Server.loadCompetitionList(function(s){_this.competitionList=s;resolve(true);},function(e){return resolve(false);});});};this.verifyCompetitionList=function(){return new Promise(function(resolve){return _this.Server.loadCompetitionList(function(s){resolve(_this.competitionList.length===s.length);},function(e){return resolve(false);});});};this.testCompetitionIsDeleted=function(){return new Promise(function(resolve){return _this.Server.loadCompetitionList(function(s){console.log("Success");console.log(s);resolve(s.every(function(c){return c.id!==_this.testCompetition.id;}));},function(e){console.log("Error");console.log(e);resolve(false);});});};}_createClass(CompetitionTests,[{key:"tests",value:function tests(){return[{test:this.testCreateCompetition,description:"Skapa tävling"},{test:this.testLoadCreatedCompetition,description:"Hämta skapad tävling"},{test:this.testGetCompetitions,description:"Hämta tävlingar"},{test:this.testUpdateCompetition,description:"Uppdatera tävling"},{test:this.verifyCompetitionList,description:"Kontrollera tävlingar"},{test:this.testLoadChangedCompetition,description:"Hämta ändrad tävling"},{test:this.testDeleteCompetition,description:"Radera tävling"},{test:this.testCompetitionIsDeleted,description:"Kontrollerar att tävling raderades"}];}}]);return CompetitionTests;}();CompetitionTests.wire=["Server"];

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScheduleTests; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var ScheduleTests=function(){function ScheduleTests(){var _this=this;_classCallCheck(this,ScheduleTests);this.testCreateSchedule=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.testSchedule=new __WEBPACK_IMPORTED_MODULE_1__models__["Schedule"]();_context.next=3;return _this.createSchedule(_this.testSchedule);case 3:res=_context.sent;if(!(res===null)){_context.next=6;break;}return _context.abrupt("return",false);case 6:_this.testSchedule.id=res.id;return _context.abrupt("return",true);case 8:case"end":return _context.stop();}}},_callee,_this);}));this.testUpdateSchedule=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this.testSchedule.addSquad("8:00",10,["C","B","A","R"],true);return _context2.abrupt("return",_this.updateSchedule(_this.testSchedule));case 2:case"end":return _context2.stop();}}},_callee2,_this);}));this.testLoadSchedule=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var schedule;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.next=2;return _this.loadSchedule(_this.testSchedule.id);case 2:schedule=_context3.sent;return _context3.abrupt("return",schedule!==null);case 4:case"end":return _context3.stop();}}},_callee3,_this);}));this.testMultipleUpdate=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.next=2;return _this.loadSchedule(_this.testSchedule.id);case 2:_this.testSchedule=_context4.sent;_context4.next=5;return _this.updateSchedule(__WEBPACK_IMPORTED_MODULE_1__models__["Schedule"].fromJson(_this.testSchedule));case 5:res=_context4.sent;if(res){_context4.next=8;break;}return _context4.abrupt("return",false);case 8:_context4.next=10;return _this.loadSchedule(_this.testSchedule.id);case 10:_this.testSchedule=_context4.sent;_context4.next=13;return _this.updateSchedule(__WEBPACK_IMPORTED_MODULE_1__models__["Schedule"].fromJson(_this.testSchedule));case 13:res=_context4.sent;if(res){_context4.next=16;break;}return _context4.abrupt("return",false);case 16:_context4.next=18;return _this.loadSchedule(_this.testSchedule.id);case 18:_this.testSchedule=_context4.sent;if(!(_this.testSchedule.squads[0].divisions.length!==4)){_context4.next=22;break;}console.log("Error! Multiples of divisions created: ["+_this.testSchedule.squads[0].divisions.join()+"] Expected: [C, B, A, R]");return _context4.abrupt("return",false);case 22:return _context4.abrupt("return",true);case 23:case"end":return _context4.stop();}}},_callee4,_this);}));this.testDeleteSchedule=function(){return _this.deleteSchedule(_this.testSchedule.id);};}_createClass(ScheduleTests,[{key:"tests",value:function tests(){return[{test:this.testCreateSchedule,description:"Skapa startlista"},{test:this.testLoadSchedule,description:"Ladda startlista"},{test:this.testUpdateSchedule,description:"Uppdatera startlista"},{test:this.testMultipleUpdate,description:"Uppdatera startlista flera gånger"},{test:this.testDeleteSchedule,description:"Radera startlista"}];}},{key:"createSchedule",value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(schedule){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:return _context5.abrupt("return",new Promise(function(resolve){return _this2.Server.createSchedule(schedule.toJson(),function(res){return resolve(res);},function(err){console.log("Could not create schedule: "+JSON.stringify(err));resolve(null);});}));case 1:case"end":return _context5.stop();}}},_callee5,this);}));function createSchedule(_x){return _ref5.apply(this,arguments);}return createSchedule;}()},{key:"loadSchedule",value:function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(id){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:return _context6.abrupt("return",new Promise(function(resolve){return _this3.Server.loadSchedule(id,function(s){return resolve(s);},function(e){console.log("Could not get schedule: "+JSON.stringify(e));resolve(null);});}));case 1:case"end":return _context6.stop();}}},_callee6,this);}));function loadSchedule(_x2){return _ref6.apply(this,arguments);}return loadSchedule;}()},{key:"updateSchedule",value:function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(schedule){var _this4=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:return _context7.abrupt("return",new Promise(function(resolve){return _this4.Server.updateSchedule(schedule.toJson(),function(s){return resolve(true);},function(e){console.log("Could not update schedule: "+JSON.stringify(e));resolve(false);});}));case 1:case"end":return _context7.stop();}}},_callee7,this);}));function updateSchedule(_x3){return _ref7.apply(this,arguments);}return updateSchedule;}()},{key:"deleteSchedule",value:function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(id){var _this5=this;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:return _context8.abrupt("return",new Promise(function(resolve){return _this5.Server.deleteSchedule(id,function(s){return resolve(true);},function(e){console.log("Could not delete schedule: "+JSON.stringify(e));resolve(false);});}));case 1:case"end":return _context8.stop();}}},_callee8,this);}));function deleteSchedule(_x4){return _ref8.apply(this,arguments);}return deleteSchedule;}()}]);return ScheduleTests;}();ScheduleTests.wire=["Server"];

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DivisionsTests; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var DivisionsTests=function(){function DivisionsTests(){var _this=this;_classCallCheck(this,DivisionsTests);this.testReadDivisions=function(){return new Promise(function(resolve){return _this.Server.loadDivisionGroups(function(s){resolve(true);},function(e){console.log(e.message);resolve(false);});});};this.testCreateDivisions=function(){var divisionGroup={"description":"SPSF PPC","divisions":["SR2,75\"","SR4\"","SSA","Dist. Revolver","Dist. Pistol","Open","R1500","P1500"]};// this.Server.createDivisionGroup(prec, s => { }, e => { });
return new Promise(function(resolve){return _this.Server.createDivisionGroup(divisionGroup,function(s){_this.testID=s.id;resolve(true);},function(e){console.log(e.message);resolve(false);});});};this.testDeleteDivisions=function(){// this.Server.deleteDivisionGroup(1172, s => { }, e => { });
return new Promise(function(resolve){return _this.Server.deleteDivisionGroup(_this.testID,function(s){return resolve(true);},function(e){return resolve(false);});});};}_createClass(DivisionsTests,[{key:"tests",value:function tests(){return[{test:this.testReadDivisions,description:"Läser vapengrupper"},{test:this.testCreateDivisions,description:"Skapar vapengrupper"},{test:this.testDeleteDivisions,description:"Raderar vapengrupper"}];}}]);return DivisionsTests;}();DivisionsTests.wire=["Server"];

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClassesTests; });
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*let full = {
	description: "SPSF full klassindelning",
	classes: ["1", "2", "3", "Dam/1", "Dam/2", "Dam/3", "Jun/1", "Jun/2", "Jun/3", "VetY/1", "VetY/2", "VetY/3", "VetÄ/1", "VetÄ/2", "VetÄ/3"]
};*/var ClassesTests=function(){function ClassesTests(){var _this=this;_classCallCheck(this,ClassesTests);this.testReadClasses=function(){return new Promise(function(resolve){return _this.Server.loadClassGroups(function(s){resolve(true);},function(e){console.log(e.message);resolve(false);});});};this.testCreateClasses=function(){var classGroup={"description":"PPC","classes":["Marksman","Sharpshooter","Expert","Master","High Master"]};// this.Server.createClassGroup(full, s => { }, e => { });
return new Promise(function(resolve){return _this.Server.createClassGroup(classGroup,function(s){_this.testID=s.id;resolve(true);},function(e){console.log(e.message);resolve(false);});});};this.testDeleteClasses=function(){// this.Server.deleteClassGroup(1101, s => { }, e => { });
return new Promise(function(resolve){return _this.Server.deleteClassGroup(_this.testID,function(s){return resolve(true);},function(e){return resolve(false);});});};}_createClass(ClassesTests,[{key:"tests",value:function tests(){return[{test:this.testReadClasses,description:"Läser klassindelningar"},{test:this.testCreateClasses,description:"Skapar klassindelning"},{test:this.testDeleteClasses,description:"Raderar klassindelning"}];}}]);return ClassesTests;}();ClassesTests.wire=["Server"];

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelpView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var HelpView=function(_React$Component){_inherits(HelpView,_React$Component);function HelpView(props){_classCallCheck(this,HelpView);var _this=_possibleConstructorReturn(this,(HelpView.__proto__||Object.getPrototypeOf(HelpView)).call(this,props));_this.state={qa:[]};fetch('/qa.json').then(function(res){return res.json();}).then(function(json){return _this.setState({qa:json});});return _this;}_createClass(HelpView,[{key:"componentDidMount",value:function componentDidMount(){this.EventBus.fire(this.Events.changeTitle,"Hjälp?");}},{key:"link",value:function link(_link){if(!_link.includes("~"))return _link;var parts=_link.split("~");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:parts[0]},parts[1]);}},{key:"linkify",value:function linkify(text){var _this2=this;return text.split("\n").map(function(p,k){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{key:k},p.split("$").map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{key:i},_this2.link(t));}));});}},{key:"render",value:function render(){var _this3=this;var qaId=1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Vi g\xF6r v\xE5rt b\xE4sta f\xF6r att alla funktioner i systemet ska vara intuitiva och sj\xE4lvf\xF6rklarande, men om vi misslyckas med det kan du hitta svar p\xE5 de vanligaste fr\xE5gorna p\xE5 den h\xE4r sidan."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Hittar du inte svaret p\xE5 det du undrar \xF6ver? Kontakta oss via mail: ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"mailto:anmalan@xkretsen.se"},"anmalan@xkretsen.se")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Hur anm\xE4ler jag mig?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Klicka p\xE5 en t\xE4vling p\xE5 startsidan. Fyll i dina egna uppgifter under \"Anm\xE4lare\" och klicka sedan p\xE5 \"L\xE4gg till deltagare\" f\xF6r att l\xE4gga till en eller flera deltagare som du vill anm\xE4la."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"F\xF6r varje deltagare v\xE4ljer du vilken klass deltagaren tillh\xF6r. Om du vill anm\xE4la deltagaren till fler \xE4n en start kan du l\xE4gga till fler starter genom att klicka p\xE5 knappen ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"button-add small"}),". V\xE4lj sedan en vapengrupp f\xF6r varje start och klicka p\xE5 knappen ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"scheduleButton"},"V\xE4lj starttid")," s\xE5 kommer en lista \xF6ver starttider att visas. Du v\xE4ljer en starttid genom att klicka p\xE5 rubriken f\xF6r ett skjutlag/patrull."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Listan \xF6ver starttider hj\xE4lper dig att v\xE4lja starttider som inte krockar. Om en starttid inte g\xE5r att v\xE4lja f\xF6r att den krockar med en starttid du redan har valt, kommer den starttiden att visas \"dimmad\" och inte g\xE5 att klicka p\xE5. Om en starttid \xE4r full kommer den att vara r\xF6d och g\xE5r inte heller att klicka p\xE5. Du kan allts\xE5 bara v\xE4lja starttider som inte krockar med redan valda starttider."),this.state.qa.map(function(qa){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:qaId++},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,qa.q),_this3.linkify(qa.a));}));}}]);return HelpView;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);HelpView.register={name:"HelpView"};HelpView.wire=["Events","EventBus"];

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdminView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs_css__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Tabs_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3____ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function adminTabs(){var tabs=[];for(var t in __WEBPACK_IMPORTED_MODULE_3____){if(typeof __WEBPACK_IMPORTED_MODULE_3____[t]==="function"&&__WEBPACK_IMPORTED_MODULE_3____[t].adminTab){tabs.push(__WEBPACK_IMPORTED_MODULE_3____[t]);}}return tabs;}var AdminView=function(_React$Component){_inherits(AdminView,_React$Component);function AdminView(){_classCallCheck(this,AdminView);return _possibleConstructorReturn(this,(AdminView.__proto__||Object.getPrototypeOf(AdminView)).apply(this,arguments));}_createClass(AdminView,[{key:'render',value:function render(){var operation=this.props.match.params.operation;var tabs=adminTabs();if(operation===undefined){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* Redirect */],{to:'/admin/'+tabs[0].adminTab.path});}var Content=tabs.find(function(t){return t.adminTab.path===operation;});if(Content===undefined){return null;}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,tabs.length>0&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'tabs'},tabs.map(function(t){return t.adminTab;}).map(function(t){return operation===t.path?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{key:t.path,className:'tab'},t.name):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{key:t.path,className:'tab',to:'/admin/'+t.path},t.name);})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Content,null));}}]);return AdminView;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);AdminView.register={name:"AdminView"};AdminView.wire=["fire","Events","ClassGroups","DivisionGroups","YesNoDialog"];

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListAdminTab__ = __webpack_require__(369);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ListAdminTab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GroupAdminTab__ = __webpack_require__(371);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__GroupAdminTab__["a"]; });


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListAdminTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListAdmin_css__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListAdmin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ListAdmin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ListAdminTab=function(_React$Component){_inherits(ListAdminTab,_React$Component);function ListAdminTab(props){_classCallCheck(this,ListAdminTab);var _this=_possibleConstructorReturn(this,(ListAdminTab.__proto__||Object.getPrototypeOf(ListAdminTab)).call(this,props));_this.drag=function(e,item){e.dataTransfer.setData(item.listName,item.id.toString());};_this.allowDrop=function(e,item){if(e.dataTransfer.getData(item.listName)!==undefined)e.preventDefault();};_this.drop=function(e,item){var data=e.dataTransfer.getData(item.listName);e.preventDefault();if(item.classes){var draggedItem=_this.state.classGroups.find(function(cg){return cg.id.toString()===data;});var newList=_this.state.classGroups.filter(function(cg){return cg!==draggedItem;});newList.splice(newList.findIndex(function(cg){return cg===item;}),0,draggedItem);_this.setState({classGroups:newList,dirty:true});}if(item.divisions){var _draggedItem=_this.state.divisionGroups.find(function(cg){return cg.id.toString()===data;});var _newList=_this.state.divisionGroups.filter(function(dg){return dg!==_draggedItem;});_newList.splice(_newList.findIndex(function(dg){return dg===item;}),0,_draggedItem);_this.setState({divisionGroups:_newList,dirty:true});}};_this.updateText=function(e){if(_this.state.selected.classes){var newCG=_this.state.classGroups.find(function(x){return x.id===_this.state.selected.id;});newCG.classes=e.target.value.replace(/^\n+/g,'').replace(/\n+$/,'\n').split("\n");_this.setState({selected:newCG,dirty:true});}if(_this.state.selected.divisions){var newDG=_this.state.divisionGroups.find(function(x){return x.id===_this.state.selected.id;});newDG.divisions=e.target.value.split("\n");_this.setState({selected:newDG,dirty:true});}};_this.addClassGroup=function(){var newCG=new __WEBPACK_IMPORTED_MODULE_2__models__["ClassGroup"](_this.state.classGroups.filter(function(g){return g.id<1000;}).length+1);_this.setState({classGroups:_this.state.classGroups.concat([newCG]),selected:newCG,dirty:true});};_this.addDivisionGroup=function(){var newDG=new __WEBPACK_IMPORTED_MODULE_2__models__["DivisionGroup"](_this.state.divisionGroups.filter(function(g){return g.id<1000;}).length+1);_this.setState({divisionGroups:_this.state.divisionGroups.concat([newDG]),selected:newDG,dirty:true});};_this.updateProperty=function(name,val){_this.setState({classGroups:_this.state.classGroups.map(function(cg){if(cg===_this.state.selected){cg[name]=val;}return cg;}),divisionGroups:_this.state.divisionGroups.map(function(dg){if(dg===_this.state.selected){dg[name]=val;}return dg;}),dirty:true});};_this.deleteItem=function(act){if(act){_this.setState({classGroups:_this.state.classGroups.filter(function(g){return g!==_this.state.deleteItem;}),divisionGroups:_this.state.divisionGroups.filter(function(g){return g!==_this.state.deleteItem;}),deleteItem:undefined,dirty:true});}else{_this.setState({deleteItem:undefined});}};_this.save=function(){_this.ClassGroups.save(_this.state.classGroups);_this.DivisionGroups.save(_this.state.divisionGroups);_this.setState({dirty:false});};_this.state={classGroups:[],divisionGroups:[]};return _this;}_createClass(ListAdminTab,[{key:'componentDidMount',value:function componentDidMount(){var _this2=this;this.fire(this.Events.changeTitle,"Administrera klasser och vapengrupper");this.ClassGroups.load(function(g){return _this2.setState({classGroups:g});});this.DivisionGroups.load(function(g){return _this2.setState({divisionGroups:g});});}},{key:'selectedText',value:function selectedText(){if(!this.state.selected)return"";if(this.state.selected.classes)return this.state.selected.classes.join("\n");if(this.state.selected.divisions)return this.state.selected.divisions.join("\n");return"";}},{key:'renderGroup',value:function renderGroup(item){var _this3=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:item.id,className:item===this.state.selected?"item select selected":"item select"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{draggable:'true',onDragStart:function onDragStart(e){return _this3.drag(e,item);},onDragOver:function onDragOver(e){return _this3.allowDrop(e,item);},onDrop:function onDrop(e){return _this3.drop(e,item);},onClick:function onClick(e){return _this3.setState({selected:item});}},item.description),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button-close small red',onClick:function onClick(e){return _this3.setState({deleteItem:item});}}));}},{key:'render',value:function render(){var _this4=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content'},this.state.deleteItem&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.YesNoDialog,{title:'Bekr\xE4fta borttagning',text:'\xC4r du s\xE4ker p\xE5 att du vill radera '+this.state.deleteItem.description+'?',action:function action(act){return _this4.deleteItem(act);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'list-admin'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Klassindelningar'),this.state.classGroups.map(function(cg){return _this4.renderGroup(cg);}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'add item',onClick:this.addClassGroup},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button-add small'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'add'},'Skapa ny lista'))),this.state.selected&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'detail'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{className:'textbox-name',value:this.state.selected.description,onChange:function onChange(e){return _this4.updateProperty("description",e.target.value);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input',{className:'textbox-header',value:this.state.selected.header||"",placeholder:'Rubrik',onChange:function onChange(e){return _this4.updateProperty("header",e.target.value);}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('textarea',{rows:'20',cols:'50',multiline:'true',value:this.selectedText(),onChange:this.updateText})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Vapengruppsindelningar'),this.state.divisionGroups.map(function(dg){return _this4.renderGroup(dg);}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'add item',onClick:this.addDivisionGroup},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button-add small'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'add'},'Skapa ny lista'))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:"button"+(this.state.dirty?"":" disabled"),onClick:this.save},'Spara')));}}]);return ListAdminTab;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);ListAdminTab.register={name:"ListAdminView"};ListAdminTab.wire=["fire","Events","ClassGroups","DivisionGroups","YesNoDialog"];ListAdminTab.adminTab=new __WEBPACK_IMPORTED_MODULE_2__models__["TabInfo"]("Listor","lists",1);

/***/ }),
/* 370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GroupAdminTab; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GroupAdmin_css__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GroupAdmin_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__GroupAdmin_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logic__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function GroupList(_ref){var groups=_ref.groups,selected=_ref.selected,onSelect=_ref.onSelect;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',null,'Grupper'),groups.map(function(g){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{key:g.id,className:"item select"+(g===selected?" selected":""),onClick:function onClick(e){return onSelect(g);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',null,g.name),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button-close small red',onClick:function onClick(e){}}));}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'add item',onClick:function onClick(e){}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:'button-add small'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{className:'add'},'Skapa ny grupp')));}var GroupAdminTab=function(_React$Component){_inherits(GroupAdminTab,_React$Component);function GroupAdminTab(props){_classCallCheck(this,GroupAdminTab);var _this=_possibleConstructorReturn(this,(GroupAdminTab.__proto__||Object.getPrototypeOf(GroupAdminTab)).call(this,props));_this.changeGroup=function(group,prop,value){_this.CompetitionGroups.updateGroup(group,prop,value);_this.setState({dirty:true});};_this.save=function(){_this.CompetitionGroups.save();_this.setState({dirty:false});};_this.state={dirty:false};_this.EventBus.manageEvents(_this);_this.subscribe(__WEBPACK_IMPORTED_MODULE_3__logic__["Events"].competitionGroupsUpdated,function(){return _this.setState({});});return _this;}_createClass(GroupAdminTab,[{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{id:'group-admin',className:'content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(GroupList,{groups:this.CompetitionGroups.groups,selected:this.state.selected,onSelect:function onSelect(g){return _this2.setState({selected:g});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["GroupProperties"],{groups:this.CompetitionGroups,selected:this.state.selected,onChange:this.changeGroup}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{className:"button"+(this.state.dirty?"":" disabled"),onClick:this.save},'Spara'));}}]);return GroupAdminTab;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);GroupAdminTab.register={name:"GroupAdminView"};GroupAdminTab.wire=["EventBus","Server","CompetitionGroups"];GroupAdminTab.adminTab=new __WEBPACK_IMPORTED_MODULE_2__models__["TabInfo"]("Grupper","groups",2);

/***/ }),
/* 372 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views__ = __webpack_require__(30);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_React$Component){_inherits(App,_React$Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.EventBus.manageEvents(_this);_this.subscribe(_this.Events.configurationLoaded,function(){_this.setState({});});return _this;}_createClass(App,[{key:'render',value:function render(){var _this2=this;if(!this.Configuration.loaded)return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content'},'H\xE4mtar konfiguration...');if(this.Storage.get(this.Storage.keys.allowStorage)===undefined){this.Footers.addCustomFooter(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.StoreQuestion,{key:'cookieAlert',storage:this.Storage}));}// console.log(`Public URL: ${process.env.PUBLIC_URL}`);
// Necessary to use WithLogin here, otherwise title won't update correctly
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["a" /* BrowserRouter */],{basename:''+""},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'App'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.BusyIndicator,null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.AppHeader,{title:'Anm\xE4lningssystem G\xE4vle PK'}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/login',component:this.LoginView}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/group/:group_id',component:this.CompetitionList}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/competition/:id/:operation/:p1/:p2/:p3',component:this.CompetitionView}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/competition/:id/:operation/:p1/:p2',component:this.CompetitionView}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/competition/:id/:operation/:p1',component:this.CompetitionView}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/competition/:id/:operation',component:this.CompetitionView}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/competition/:id',component:this.CompetitionView}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/report/:id',component:this.ReportTab}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/tiebreaker/:id/:eventId/:divisionId',component:this.TiebreakerView}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/tiebreaker/:id/:eventId',component:this.TiebreakerView}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/tiebreaker/:id',component:this.TiebreakerView}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/create',component:function component(p){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this2.WithLogin,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this2.CreateCompetition,null));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/about',component:this.AboutView}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/help',component:this.HelpView}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/admin/:operation',component:function component(p){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this2.WithLogin,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this2.AdminView,p));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/admin',component:function component(p){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this2.WithLogin,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(_this2.AdminView,p));}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/test',component:__WEBPACK_IMPORTED_MODULE_3__views__["ComponentTest"]}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/diagnostic',component:this.Diagnostics}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{exact:true,path:'/',component:this.CompetitionList}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Route */],{path:'/',component:function component(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h1',null,'404 - Den h\xE4r sidan finns inte'));}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(this.Footer,null)));}}]);return App;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);App.register={name:"App"};App.wire=["AppHeader","BusyIndicator","Footers","Footer","StoreQuestion","Storage","CompetitionList","LoginView","CompetitionView","ReportTab","CreateCompetition","AboutView","WithLogin","HelpView","Diagnostics","Configuration","EventBus","Events","AdminView","TiebreakerView"];

/***/ }),
/* 374 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.6f51b888.js